export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `BigInt` scalar type represents non-fractional signed whole numeric
   * values. BigInt can represent values between -(2^63) and 2^63 - 1.
   */
  BigInt: { input: any; output: any; }
  /** A date in the format Y-m-d (e.g., 2026-02-17) */
  Date: { input: any; output: any; }
  /** A date interval in the ISO 8601 format. */
  DateInterval: { input: any; output: any; }
  DateLimited: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  /** A duration in the HH:MM:SS format. */
  Duration: { input: any; output: any; }
  Json: { input: any; output: any; }
  Rating: { input: any; output: any; }
};

export type AccesLibreData = {
  __typename?: 'AccesLibreData';
  /** The url theater matched from API AccesLibre. */
  url?: Maybe<Scalars['String']['output']>;
  /** The uuid theater matched from API AccesLibre. */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** All accessibilities available in theater, showtime or screen. */
export enum Accessibility {
  Accessible = 'ACCESSIBLE',
  AssistedListening = 'ASSISTED_LISTENING',
  AudioDescription = 'AUDIO_DESCRIPTION',
  AudioLoopCinema = 'AUDIO_LOOP_CINEMA',
  AudioLoopPatron = 'AUDIO_LOOP_PATRON',
  AutismFriendly = 'AUTISM_FRIENDLY',
  CineConnectSennheiserAccessibility = 'CINE_CONNECT_SENNHEISER_ACCESSIBILITY',
  ClosedCaption = 'CLOSED_CAPTION',
  DolbyAccessibility = 'DOLBY_ACCESSIBILITY',
  Fidelio = 'FIDELIO',
  Greta = 'GRETA',
  HearingImpaired = 'HEARING_IMPAIRED',
  Inaccessible = 'INACCESSIBLE',
  ListenEverywhere = 'LISTEN_EVERYWHERE',
  OpenCaption = 'OPEN_CAPTION',
  SennheiserAccessibility = 'SENNHEISER_ACCESSIBILITY',
  SensoryFriendly = 'SENSORY_FRIENDLY',
  SonyAccessibility = 'SONY_ACCESSIBILITY',
  Subtitled = 'SUBTITLED',
  Twavox = 'TWAVOX'
}

export type AddUserCollectionInput = {
  /** The collection description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The array of entities graphQl ids to be added to the collection. */
  id_entities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The collection name. */
  name: Scalars['String']['input'];
  /** The collection visibility. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgeFacet = FacetValue & {
  __typename?: 'AgeFacet';
  /** The age which type match. */
  age?: Maybe<Tag>;
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

export enum AltProvider {
  Canalplus = 'CANALPLUS',
  Disney = 'DISNEY',
  Eidr = 'EIDR',
  Imdb = 'IMDB',
  Isan = 'ISAN',
  Netflix = 'NETFLIX',
  Primevideo = 'PRIMEVIDEO'
}

/** An analogy between two entities. */
export type Analogy = {
  __typename?: 'Analogy';
  /** The number of visits that are shared between the entity and the target. */
  commonVisits?: Maybe<Scalars['Int']['output']>;
  /** Also called the "target", it is the entity that has a match. */
  entity?: Maybe<Node>;
  /** The score of the analogy, the higher is the better. */
  score?: Maybe<Scalars['Float']['output']>;
};

export enum AnalogyType {
  Movie = 'MOVIE',
  Series = 'SERIES'
}

/** An Allocine Application Token. */
export type ApplicationToken = {
  __typename?: 'ApplicationToken';
  /** The application name which is bound to this token. */
  applicationName?: Maybe<Scalars['String']['output']>;
  /** The date when this Application token will expire. */
  expiration?: Maybe<Scalars['DateTime']['output']>;
  /** The raw/encoded value of the token. */
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The username which is bound to this token. */
  username?: Maybe<Scalars['String']['output']>;
};

export enum AspectRatio {
  /** 2.35:1 Cinemascope */
  Cinemascope = 'CINEMASCOPE',
  /** 2.6:1 Cinerama */
  Cinerama = 'CINERAMA',
  /** 2.75:1 MGM camera 65 */
  MgmCamera_65 = 'MGM_CAMERA_65',
  /** 2.55:1 */
  OriginalCinemascope = 'ORIGINAL_CINEMASCOPE',
  /** 1.19:1 */
  R_1_19 = 'R_1_19',
  /** 1.20:1 */
  R_1_20 = 'R_1_20',
  /** 1.33:1, also known as 4:3. */
  R_1_33 = 'R_1_33',
  /** 1.37:1 */
  R_1_37 = 'R_1_37',
  /** 1.44:1 */
  R_1_44 = 'R_1_44',
  /** 1.66:1 */
  R_1_66 = 'R_1_66',
  /** 1.77:1, also considered to be 16:9. */
  R_1_77 = 'R_1_77',
  /** 1.78:1, also considered to be 16:9. */
  R_1_78 = 'R_1_78',
  /** 1.85:1 */
  R_1_85 = 'R_1_85',
  /** 2:1 */
  R_2 = 'R_2',
  /** 2.00:1 */
  R_2_00 = 'R_2_00',
  /** 2.2:1 */
  R_22 = 'R_22',
  /** 2.76:1 Ultra Panavision 70 */
  UltraPanavision_70 = 'ULTRA_PANAVISION_70',
  Widescreen = 'WIDESCREEN'
}

/** The audience of an episode/season or series. */
export type Audience = {
  __typename?: 'Audience';
  /** The original channel that broadcasted the series. */
  channel?: Maybe<Company>;
  /** The country of the audience. */
  country?: Maybe<Country>;
  /** The number of viewers on this episode. */
  value?: Maybe<Scalars['Int']['output']>;
};

/** The audio of the movie. */
export enum AudioFormat {
  Dolby = 'DOLBY',
  Dolbya = 'DOLBYA',
  DolbyAtmos = 'DOLBY_ATMOS',
  DolbyDigital = 'DOLBY_DIGITAL',
  DolbyDigitalDts = 'DOLBY_DIGITAL_DTS',
  DolbyDigitalEx = 'DOLBY_DIGITAL_EX',
  DolbySr = 'DOLBY_SR',
  DolbySrd = 'DOLBY_SRD',
  DolbySrdDtsEx = 'DOLBY_SRD_DTS_EX',
  DolbySrDdts = 'DOLBY_SR_DDTS',
  DolbySrDigitalDtsDigital = 'DOLBY_SR_DIGITAL_DTS_DIGITAL',
  DolbySrDigitalSrDdtsAmpSdds = 'DOLBY_SR_DIGITAL_SR_DDTS_AMP_SDDS',
  DolbySrDolbySrDtsAmpSdds = 'DOLBY_SR_DOLBY_SR_DTS_AMP_SDDS',
  DolbyStereo = 'DOLBY_STEREO',
  Drs = 'DRS',
  Dts = 'DTS',
  DtsStereo = 'DTS_STEREO',
  Ex = 'EX',
  Mono = 'MONO',
  Sdds = 'SDDS',
  SonicsDdp = 'SONICS_DDP',
  Srddts = 'SRDDTS',
  Stereo = 'STEREO'
}

/** An Allociné author */
export type Author = Node & {
  __typename?: 'Author';
  /** The full biography of the author. */
  biography?: Maybe<BodyJson>;
  data?: Maybe<AuthorData>;
  /** The date when the author stopped working for Allociné */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the author. */
  id: Scalars['ID']['output'];
  /** The internal id of the author. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The name of the author. */
  name: Scalars['String']['output'];
  /** The nickname of the author. */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The avatar of the author */
  picture?: Maybe<InternalImage>;
  /** The position of the author (redactor, ...). */
  position?: Maybe<Scalars['String']['output']>;
  /** The short biography of the author. */
  shortBiography: Scalars['String']['output'];
  /** The social User of the author */
  socialUser?: Maybe<User>;
  /** The date when the author started working for Allociné */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  stats?: Maybe<AuthorStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type AuthorByEntityLeaf = {
  __typename?: 'AuthorByEntityLeaf';
  /** The author of the entity. */
  author?: Maybe<Author>;
  signature?: Maybe<AuthorSignature>;
};

/** A connection to a list of items. */
export type AuthorByEntityListConnection = {
  __typename?: 'AuthorByEntityListConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AuthorByEntityListEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AuthorByEntityListEdge = {
  __typename?: 'AuthorByEntityListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AuthorByEntityLeaf>;
};

/** Author data */
export type AuthorData = {
  __typename?: 'AuthorData';
  seo?: Maybe<Seo>;
  /** List of author's social links. */
  socialLinks?: Maybe<SocialLinks>;
};

/** Author and signature data */
export type AuthorSignature = {
  __typename?: 'AuthorSignature';
  author: Author;
  body?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Author stats */
export type AuthorStats = {
  __typename?: 'AuthorStats';
  /** Total number of movie news written by the author. */
  totalMovieNews: Scalars['Int']['output'];
  /** Total number of news written by the author. */
  totalNews: Scalars['Int']['output'];
  /** Total number of series news written by the author. */
  totalSeriesNews: Scalars['Int']['output'];
};

/** Sorting criteria for Award */
export enum AwardsSorting {
  /** Award sorted by id asc. */
  IdAsc = 'ID_ASC',
  /** Award sorted by id desc. */
  IdDesc = 'ID_DESC'
}

/** An object used for seo. */
export type Backlink = {
  __typename?: 'Backlink';
  /** The linking text. */
  label?: Maybe<Scalars['String']['output']>;
  /** The backlink's url. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum BaseReleaseType {
  ComingSoon = 'COMING_SOON',
  ComingSoonTheater = 'COMING_SOON_THEATER',
  ComingSoonWithoutDate = 'COMING_SOON_WITHOUT_DATE',
  HasTheaterRelease = 'HAS_THEATER_RELEASE',
  NowPlaying = 'NOW_PLAYING',
  Released = 'RELEASED',
  VodRelease = 'VOD_RELEASE',
  VodReleaseWithProduct = 'VOD_RELEASE_WITH_PRODUCT'
}

/** An object containing all the informations needed to display a body_json */
export type BodyJson = {
  __typename?: 'BodyJson';
  /** The body_json field itself. */
  body?: Maybe<Scalars['Json']['output']>;
  /** The related entities of the body_json */
  relatedEntities?: Maybe<Array<Maybe<Node>>>;
};

export type BookingFacet = FacetValue & {
  __typename?: 'BookingFacet';
  /** The booking value as boolean. */
  booking?: Maybe<Scalars['Boolean']['output']>;
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

/** A boxoffice. */
export type BoxOffice = {
  __typename?: 'BoxOffice';
  /** The country of the box-office. */
  country?: Maybe<Country>;
  /** The total between the first period range and this one. */
  cumulative?: Maybe<Scalars['Int']['output']>;
  /** The period range. */
  range?: Maybe<DateTimeRange>;
  /** The boxoffice's value during the period range. */
  value?: Maybe<Scalars['Int']['output']>;
};

/** All periods related to boxoffice. */
export enum BoxOfficePeriod {
  /** For a day. */
  Day = 'DAY',
  /** For the day of theater release. */
  ReleaseDay = 'RELEASE_DAY',
  /** For a week. */
  Week = 'WEEK',
  /** Only during weekend (counts Wednesday to Sunday in France). */
  Weekend = 'WEEKEND'
}

/** All different boxoffice possible. */
export enum BoxOfficeType {
  /** BoxOffice will be based on entries. */
  Entry = 'ENTRY',
  /** BoxOffice will be base on profits (in USD). */
  Profit = 'PROFIT'
}

/** An Allociné brand. */
export type Brand = {
  __typename?: 'Brand';
  /** The country for this brand. */
  country?: Maybe<Country>;
  /** The country id for this brand. */
  countryId?: Maybe<Scalars['Int']['output']>;
  /** The id of the brand. */
  id?: Maybe<Scalars['String']['output']>;
  /** The locale for this brand. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The name of the brand. */
  name?: Maybe<Scalars['String']['output']>;
  /** The brand website URL. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Branded content of a Movie. */
export type BrandedContent = {
  __typename?: 'BrandedContent';
  tabs?: Maybe<Array<Maybe<BrandedContentTab>>>;
};

/** A custom tab of a branded content. */
export type BrandedContentTab = {
  __typename?: 'BrandedContentTab';
  /** Content of the tab in html format. */
  content_html?: Maybe<Scalars['String']['output']>;
  /** Content of the tab in json format. */
  content_json?: Maybe<BodyJson>;
  /** Index of the tab. */
  index?: Maybe<Scalars['Int']['output']>;
  /** Title of the tab. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A broadcast. */
export type Broadcast = {
  __typename?: 'Broadcast';
  /** The hour when the episode is broadcasted. */
  broadcastTime?: Maybe<Scalars['String']['output']>;
  /** The original channel that broadcasted the episode. */
  channel?: Maybe<Company>;
  /** The date when the episode is broadcasted. */
  date?: Maybe<Scalars['DateLimited']['output']>;
  /** The episode which is broadcasted. */
  episode?: Maybe<Episode>;
  /** The type of the release. */
  type?: Maybe<Scalars['String']['output']>;
};

/** An Allociné Carousel. */
export type Carousel = Node & {
  __typename?: 'Carousel';
  /** The brand of the carousel. */
  brand?: Maybe<Brand>;
  /** The id of the carousel. */
  id: Scalars['ID']['output'];
  /** The internal id of the carousel. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The items of the carousel. */
  items?: Maybe<Array<Maybe<CarouselItem>>>;
  /** The publication informations. */
  publication?: Maybe<Publication>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

/** An item of a carousel. */
export type CarouselItem = {
  __typename?: 'CarouselItem';
  /** The body of the carousel item. */
  body?: Maybe<Scalars['String']['output']>;
  /** Different information about an url. */
  link?: Maybe<Url>;
  /** Show special operations on carousel item. */
  operations?: Maybe<SpecialOperation>;
  /** The image of the movie. */
  poster?: Maybe<InternalImage>;
  /** The position of the item in the carousel. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The related entities of the carousel item */
  relatedEntity?: Maybe<Node>;
  /** The title of the carousel item. */
  title?: Maybe<Scalars['String']['output']>;
};

export enum CastActivity {
  Actor = 'ACTOR',
  OriginalVoiceActor = 'ORIGINAL_VOICE_ACTOR',
  VoiceActor = 'VOICE_ACTOR'
}

/** A person playing in a series/movie. */
export type CastMember = {
  __typename?: 'CastMember';
  /** The person that is part of the cast. */
  actor?: Maybe<Person>;
  /** The entity the person is playing in. */
  entity?: Maybe<Node>;
  /** The person that is part of the cast. */
  originalVoiceActor?: Maybe<Person>;
  /**
   * The person that is part of the cast.
   * @deprecated Use actor instead
   */
  person?: Maybe<Person>;
  /** The rank of the cast member. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The role on screen of the cast member. */
  role?: Maybe<Scalars['String']['output']>;
  /** The person that is part of the cast. */
  voiceActor?: Maybe<Person>;
};

/** A certificate given by the CNC. */
export type Certificate = {
  __typename?: 'Certificate';
  /** The certificate's code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The certificate's definition. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Certification rating statuses. */
export enum CertificationRatingStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** An Allociné city. */
export type City = {
  __typename?: 'City';
  /** The coordinates of the city. */
  coordinates?: Maybe<Coordinates>;
  /** The country of the city. */
  country?: Maybe<Country>;
  /** The id of the city. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the city. */
  name?: Maybe<Scalars['String']['output']>;
  /** The zip code of the city. */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Sorting criteria for cities */
export enum CitySorting {
  /** Sorted by city name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort with the closest in space first. */
  Closest = 'CLOSEST',
  /** No sort is applied. */
  None = 'NONE',
  /** Sort by score the matching result. */
  Score = 'SCORE'
}

/** The color of the movie. */
export enum Color {
  BlackWhite = 'BLACK_WHITE',
  Color = 'COLOR',
  ColorBlackWhite = 'COLOR_BLACK_WHITE'
}

/** All comfort available in theater, showtime or screen. */
export enum Comfort {
  AirConditioning = 'AIR_CONDITIONING',
  CuddleSeating = 'CUDDLE_SEATING',
  ElectricReclinerSeats = 'ELECTRIC_RECLINER_SEATS',
  LuxurySeats = 'LUXURY_SEATS',
  Recliners = 'RECLINERS',
  ReservedSeating = 'RESERVED_SEATING',
  StadiumSeating = 'STADIUM_SEATING'
}

export type ComfortFacet = FacetValue & {
  __typename?: 'ComfortFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

/** A comment, written by a user. */
export type Comment = {
  __typename?: 'Comment';
  /** The user that wrote the comment. */
  author?: Maybe<Scalars['String']['output']>;
  /** The content of the comment. */
  body?: Maybe<Scalars['String']['output']>;
  /** The date this comment was submitted. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A comment, written by a user. */
export type CommentBodyArgs = {
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An Allociné company. */
export type Company = Node & {
  __typename?: 'Company';
  /** The activities of the company. */
  activities?: Maybe<CompanyActivitiesCollection>;
  /** The country of the company. */
  country?: Maybe<Country>;
  /** The localized description of the company. */
  description?: Maybe<Scalars['String']['output']>;
  /** The id of the company. */
  id: Scalars['ID']['output'];
  /** The internal id of the company. */
  internalId?: Maybe<Scalars['Int']['output']>;
  legacyId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The name of the company. */
  name?: Maybe<Scalars['String']['output']>;
  /** The image of the company. */
  poster?: Maybe<InternalImage>;
  /** The list of the press reviews of this Company. */
  pressReviews?: Maybe<PressReviewsConnection>;
  /** Differents fields for seo purposes. */
  seo?: Maybe<Seo>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the company. */
  tags?: Maybe<TagCollection>;
  /** Return a list of theaters if the company is a theater's network. */
  theaters?: Maybe<TheaterConnection>;
};


/** An Allociné company. */
export type CompanyPressReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PressReviewsOrder>>;
  type?: InputMaybe<Array<NodeTypePressReviews>>;
};


/** An Allociné company. */
export type CompanyTheatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterSortingLight>>>;
};

/** A collection of activities. */
export type CompanyActivitiesCollection = {
  __typename?: 'CompanyActivitiesCollection';
  /** The list of the activities which are in this collection. */
  list?: Maybe<Array<CompanyActivity>>;
};

export enum CompanyActivity {
  Agents = 'AGENTS',
  AnimationStudio = 'ANIMATION_STUDIO',
  CoProduction = 'CO_PRODUCTION',
  DigitalEffects = 'DIGITAL_EFFECTS',
  DistributionCompanies = 'DISTRIBUTION_COMPANIES',
  DistributionCoordination = 'DISTRIBUTION_COORDINATION',
  ExecutiveProducerCompanies = 'EXECUTIVE_PRODUCER_COMPANIES',
  FilmExhibitor = 'FILM_EXHIBITOR',
  ForeignDistributor = 'FOREIGN_DISTRIBUTOR',
  FrenchDisributor = 'FRENCH_DISRIBUTOR',
  InternationalDistributionExports = 'INTERNATIONAL_DISTRIBUTION_EXPORTS',
  MusicalSupervisorCompanies = 'MUSICAL_SUPERVISOR_COMPANIES',
  NetworkServiceProvider = 'NETWORK_SERVICE_PROVIDER',
  PostProduction = 'POST_PRODUCTION',
  Press = 'PRESS',
  Production = 'PRODUCTION',
  ProviderDvd = 'PROVIDER_DVD',
  ProviderReplay = 'PROVIDER_REPLAY',
  ProviderSvod = 'PROVIDER_SVOD',
  ProviderVod = 'PROVIDER_VOD',
  PrAgency = 'PR_AGENCY',
  SoundEditorCompanies = 'SOUND_EDITOR_COMPANIES',
  SpecialEffectsCompanies = 'SPECIAL_EFFECTS_COMPANIES',
  TvChannel = 'TV_CHANNEL',
  VideoProvider = 'VIDEO_PROVIDER',
  VisualEffects = 'VISUAL_EFFECTS'
}

/** Retrieve an entity by another id than Allocine, like IMDB, Gaumont, eidr, isan, orange, hubble, legacy, Pathé Alex */
export type ComposedIdType = {
  /** The id of the entity. */
  id: Scalars['String']['input'];
  /** The provider of the id. */
  provider: Provider;
};

export type CoordinateType = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  /** The distance between the coordinates and the from argument. */
  distance?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


export type CoordinatesDistanceArgs = {
  from?: InputMaybe<CoordinateType>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** An Allociné country. */
export type Country = {
  __typename?: 'Country';
  /** The country code (alpha 2). */
  alpha2?: Maybe<Scalars['String']['output']>;
  /** The country code (alpha 3). */
  alpha3?: Maybe<Scalars['String']['output']>;
  /** List of country weekly box office data */
  boxOffice?: Maybe<Array<Maybe<CountryBoxOffice>>>;
  /** Technical data about country. */
  data?: Maybe<CountryData>;
  /** The id of the country. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The localized name of the country. */
  localizedName?: Maybe<Scalars['String']['output']>;
  /** The name of the country. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of theater week starts dates */
  theaterShowtimeWeeks?: Maybe<Array<Maybe<Scalars['DateTime']['output']>>>;
  /** The top movie by box office global data. */
  topMovieBoxOffice?: Maybe<MoviesConnection>;
};


/** An Allociné country. */
export type CountryBoxOfficeArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  period?: InputMaybe<BoxOfficePeriod>;
};


/** An Allociné country. */
export type CountryTheaterShowtimeWeeksArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** An Allociné country. */
export type CountryTopMovieBoxOfficeArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  editorialRating?: InputMaybe<FilterRangeRating>;
  editorialRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludeGenres?: InputMaybe<Array<InputMaybe<Genre>>>;
  excludeTypes?: InputMaybe<Array<InputMaybe<MovieType>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<MovieFlagsType>;
  forChildren?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Genre>>>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  localization?: InputMaybe<Scalars['Int']['input']>;
  minTheaters?: InputMaybe<Scalars['Int']['input']>;
  minTheatersProductFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  minTheatersTwoFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<MovieSorting>>>;
  physicalFlags?: InputMaybe<Array<PhysicalProductType>>;
  pressRating?: InputMaybe<FilterRangeRating>;
  pressRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  productionDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productionYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  releaseDateType?: InputMaybe<MovieReleaseDateFilterType>;
  releaseFilter?: InputMaybe<ReleaseFilterType>;
  releaseFlags?: InputMaybe<Array<BaseReleaseType>>;
  releaseFrom?: InputMaybe<Scalars['DateTime']['input']>;
  releaseFromUs?: InputMaybe<Scalars['DateTime']['input']>;
  releaseTo?: InputMaybe<Scalars['DateTime']['input']>;
  releaseToUs?: InputMaybe<Scalars['DateTime']['input']>;
  runtime?: InputMaybe<IntRangeFilter>;
  scoreRating?: InputMaybe<FilterRangeRating>;
  scoreRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  specialFilter?: InputMaybe<MovieSpecialFilter>;
  svodFlags?: InputMaybe<Array<SvodFlags>>;
  svodProviders?: InputMaybe<Array<SvodProviders>>;
  tag?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InputMaybe<MovieType>>>;
  visaNumber?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Adjectives used in the country. */
export type CountryAdjective = {
  __typename?: 'CountryAdjective';
  /** The female adjective in the country already localized. */
  female?: Maybe<Scalars['String']['output']>;
  /** The male adjective in the country already localized. */
  male?: Maybe<Scalars['String']['output']>;
};

/** Week box office data. */
export type CountryBoxOffice = {
  __typename?: 'CountryBoxOffice';
  /** Cumulative boxoffice value since first period. */
  cumulative?: Maybe<Scalars['Int']['output']>;
  /** First day of the time period */
  from?: Maybe<Scalars['DateTime']['output']>;
  /** The movie. */
  movie?: Maybe<Movie>;
  /** Last day of the time period */
  to?: Maybe<Scalars['DateTime']['output']>;
  /** Unit for values (ENTRY, PROFIT) */
  unit?: Maybe<BoxOfficeType>;
  /** The boxoffice's value. */
  value?: Maybe<Scalars['Int']['output']>;
  /** Week number since first period */
  weekNumber?: Maybe<Scalars['Int']['output']>;
};

export enum CountryCode {
  Afghanistan = 'AFGHANISTAN',
  Albania = 'ALBANIA',
  Algeria = 'ALGERIA',
  Andorra = 'ANDORRA',
  Angola = 'ANGOLA',
  AntiguaAndBarbuda = 'ANTIGUA_AND_BARBUDA',
  Argentina = 'ARGENTINA',
  Armenia = 'ARMENIA',
  Australia = 'AUSTRALIA',
  Austria = 'AUSTRIA',
  Azerbaidjan = 'AZERBAIDJAN',
  Bahamas = 'BAHAMAS',
  Bahrein = 'BAHREIN',
  Bangladesh = 'BANGLADESH',
  Barbados = 'BARBADOS',
  Belgium = 'BELGIUM',
  Belize = 'BELIZE',
  Benin = 'BENIN',
  Bermuda = 'BERMUDA',
  Bhutan = 'BHUTAN',
  Bolivia = 'BOLIVIA',
  Bosnia = 'BOSNIA',
  Botswana = 'BOTSWANA',
  Brazil = 'BRAZIL',
  BruneiDarussalam = 'BRUNEI_DARUSSALAM',
  Bulgaria = 'BULGARIA',
  BurkinaFaso = 'BURKINA_FASO',
  Burma = 'BURMA',
  Burundi = 'BURUNDI',
  Byelorussia = 'BYELORUSSIA',
  Cambodia = 'CAMBODIA',
  Cameroon = 'CAMEROON',
  Canada = 'CANADA',
  CapeVerde = 'CAPE_VERDE',
  Chad = 'CHAD',
  Chili = 'CHILI',
  China = 'CHINA',
  Colombia = 'COLOMBIA',
  Comoros = 'COMOROS',
  CongoCod = 'CONGO_COD',
  CongoCog = 'CONGO_COG',
  CostaRica = 'COSTA_RICA',
  Croatia = 'CROATIA',
  Cuba = 'CUBA',
  Cyprus = 'CYPRUS',
  Czechoslovakia = 'CZECHOSLOVAKIA',
  CzechRepublic = 'CZECH_REPUBLIC',
  Denmark = 'DENMARK',
  Djibouti = 'DJIBOUTI',
  Dominica = 'DOMINICA',
  DominicanRepublic = 'DOMINICAN_REPUBLIC',
  EastGermany = 'EAST_GERMANY',
  EcuadoGuinea = 'ECUADO_GUINEA',
  Egypt = 'EGYPT',
  Equator = 'EQUATOR',
  Eritrea = 'ERITREA',
  Estonia = 'ESTONIA',
  Ethiopia = 'ETHIOPIA',
  Finland = 'FINLAND',
  France = 'FRANCE',
  Gabon = 'GABON',
  Georgia = 'GEORGIA',
  Germany = 'GERMANY',
  Ghana = 'GHANA',
  Greece = 'GREECE',
  Grenada = 'GRENADA',
  Guambia = 'GUAMBIA',
  Guatemala = 'GUATEMALA',
  Guinea = 'GUINEA',
  GuineaBissau = 'GUINEA_BISSAU',
  Guyana = 'GUYANA',
  Haiti = 'HAITI',
  Honduras = 'HONDURAS',
  Hongkong = 'HONGKONG',
  Hungaria = 'HUNGARIA',
  Iceland = 'ICELAND',
  India = 'INDIA',
  Indonesia = 'INDONESIA',
  Iran = 'IRAN',
  Iraq = 'IRAQ',
  Ireland = 'IRELAND',
  Israel = 'ISRAEL',
  Italy = 'ITALY',
  IvoryCoast = 'IVORY_COAST',
  Jamaica = 'JAMAICA',
  Japan = 'JAPAN',
  Jordan = 'JORDAN',
  Kazakhstan = 'KAZAKHSTAN',
  Kenya = 'KENYA',
  Kirghizistan = 'KIRGHIZISTAN',
  Kiribati = 'KIRIBATI',
  Korea = 'KOREA',
  Kosovo = 'KOSOVO',
  Kuwait = 'KUWAIT',
  Laos = 'LAOS',
  Latvia = 'LATVIA',
  Lebanon = 'LEBANON',
  Lesotho = 'LESOTHO',
  Liberia = 'LIBERIA',
  Libia = 'LIBIA',
  Liechtenstein = 'LIECHTENSTEIN',
  Lithuania = 'LITHUANIA',
  Luxembourg = 'LUXEMBOURG',
  Macedonia = 'MACEDONIA',
  Madagascar = 'MADAGASCAR',
  Malawi = 'MALAWI',
  Malaysia = 'MALAYSIA',
  Maldives = 'MALDIVES',
  Mali = 'MALI',
  Malta = 'MALTA',
  Mauritania = 'MAURITANIA',
  Mauritius = 'MAURITIUS',
  Mexico = 'MEXICO',
  Micronesia = 'MICRONESIA',
  Moldavia = 'MOLDAVIA',
  Monaco = 'MONACO',
  Mongolia = 'MONGOLIA',
  Montenegro = 'MONTENEGRO',
  Morocco = 'MOROCCO',
  Mozambic = 'MOZAMBIC',
  Namibia = 'NAMIBIA',
  Nepal = 'NEPAL',
  Netherlands = 'NETHERLANDS',
  NewZealand = 'NEW_ZEALAND',
  Nicaragua = 'NICARAGUA',
  Niger = 'NIGER',
  Nigeria = 'NIGERIA',
  NorthKorea = 'NORTH_KOREA',
  Norway = 'NORWAY',
  Oman = 'OMAN',
  Pakistan = 'PAKISTAN',
  Palestine = 'PALESTINE',
  Panama = 'PANAMA',
  PapuaNewGuinea = 'PAPUA_NEW_GUINEA',
  Paraguay = 'PARAGUAY',
  Peru = 'PERU',
  Philippines = 'PHILIPPINES',
  Poland = 'POLAND',
  PortoRico = 'PORTO_RICO',
  Portugal = 'PORTUGAL',
  Qatar = 'QATAR',
  Romania = 'ROMANIA',
  Russia = 'RUSSIA',
  Rwanda = 'RWANDA',
  SaintLucia = 'SAINT_LUCIA',
  SaintVincentAndTheGrenadines = 'SAINT_VINCENT_AND_THE_GRENADINES',
  Salvador = 'SALVADOR',
  Samoa = 'SAMOA',
  SaoTomeAndPrincipe = 'SAO_TOME_AND_PRINCIPE',
  SaudiArabia = 'SAUDI_ARABIA',
  Senegal = 'SENEGAL',
  Serbia = 'SERBIA',
  Seychelles = 'SEYCHELLES',
  SierraLeone = 'SIERRA_LEONE',
  Singapor = 'SINGAPOR',
  Slovakia = 'SLOVAKIA',
  Slovenia = 'SLOVENIA',
  Somalia = 'SOMALIA',
  SouthAfrica = 'SOUTH_AFRICA',
  SouthKorea = 'SOUTH_KOREA',
  Spain = 'SPAIN',
  SriLanka = 'SRI_LANKA',
  Sudan = 'SUDAN',
  Suriname = 'SURINAME',
  Swaziland = 'SWAZILAND',
  Sweden = 'SWEDEN',
  Switzerland = 'SWITZERLAND',
  Syria = 'SYRIA',
  Taiwan = 'TAIWAN',
  Tajikistan = 'TAJIKISTAN',
  Tanzania = 'TANZANIA',
  Thailand = 'THAILAND',
  TimorLeste = 'TIMOR_LESTE',
  Togo = 'TOGO',
  Tonga = 'TONGA',
  TrinidadAndTobago = 'TRINIDAD_AND_TOBAGO',
  Tunisia = 'TUNISIA',
  Turkey = 'TURKEY',
  Turkmenistan = 'TURKMENISTAN',
  Tuvalu = 'TUVALU',
  Uganda = 'UGANDA',
  Ukrainia = 'UKRAINIA',
  UnitedArabEmirates = 'UNITED_ARAB_EMIRATES',
  UnitedKingdom = 'UNITED_KINGDOM',
  Uruguay = 'URUGUAY',
  Usa = 'USA',
  Ussr = 'USSR',
  Uzbekistan = 'UZBEKISTAN',
  Vanuatu = 'VANUATU',
  Venezuela = 'VENEZUELA',
  Vietnam = 'VIETNAM',
  WestGermany = 'WEST_GERMANY',
  Yemen = 'YEMEN',
  Yugoslavia = 'YUGOSLAVIA',
  Zaire = 'ZAIRE',
  Zambia = 'ZAMBIA',
  Zimbabwe = 'ZIMBABWE'
}

/** Technical data about country. */
export type CountryData = {
  __typename?: 'CountryData';
  /** Adjectives used in the country. */
  adjective?: Maybe<CountryAdjective>;
  /** The day when movies are releases in the country. */
  showtimeReleaseDay?: Maybe<Scalars['String']['output']>;
};

export type CountryFacet = FacetValue & {
  __typename?: 'CountryFacet';
  /** The country which type match. */
  country?: Maybe<Country>;
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

/** A person working for a series/movie. */
export type CreditsMember = {
  __typename?: 'CreditsMember';
  /** The person that is in the credits. */
  person?: Maybe<Person>;
  /** The job of the person in the credits. */
  position?: Maybe<Position>;
  /** The rank of the cast member. */
  rank?: Maybe<Scalars['Int']['output']>;
};

/** special releases for a movie or a series with social action. */
export enum CustomReleaseType {
  ComingSoon = 'COMING_SOON',
  /** @deprecated Use non-provider based types instead. */
  ComingSoonOnNetflix = 'COMING_SOON_ON_NETFLIX',
  HasOnlineProduct = 'HAS_ONLINE_PRODUCT',
  HasOnlineRelease = 'HAS_ONLINE_RELEASE',
  HasRelease = 'HAS_RELEASE',
  HasSvodRelease = 'HAS_SVOD_RELEASE',
  HasTheaterRelease = 'HAS_THEATER_RELEASE',
  NowPlaying = 'NOW_PLAYING',
  /** @deprecated Use non-provider based types instead. */
  OnlyOnNetflix = 'ONLY_ON_NETFLIX',
  ToDvd = 'TO_DVD',
  ToVod = 'TO_VOD'
}

export type CustomType = {
  __typename?: 'CustomType';
  /** The type id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The type name. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum DatePrecision {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** An object of range between two dates. */
export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  /** The date at which the publication ends. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** If true, that indicate to get the date in range. */
  includeEndsAt?: Maybe<Scalars['Boolean']['output']>;
  /** If true, that indicate to get the date in range. */
  includeStartsAt?: Maybe<Scalars['Boolean']['output']>;
  /** The date at which the publication starts. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeleteUserCollectionInput = {
  /** The collection description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The collection GraphQL id. Used to update or delete a collection. */
  id: Scalars['String']['input'];
  /** The collection name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The collection visibility. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteUserOpinionInput = {
  /** GraphQL entity Id. */
  id_entity: Scalars['String']['input'];
};

/** a deleted entity, and it's potential replacement entity */
export type DeletedEntity = {
  __typename?: 'DeletedEntity';
  /** the date when the entity was deleted. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** the replacement entity. */
  replacedBy?: Maybe<Node>;
};

export type Disk = {
  __typename?: 'Disk';
  /** An album of tracks. */
  tracks?: Maybe<Array<Maybe<Track>>>;
};


export type DiskTracksArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** An Allociné editorial review. */
export type EditorialReview = Node & {
  __typename?: 'EditorialReview';
  /** The author name of the editorial review. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** The body text of the editorial review. */
  body?: Maybe<Scalars['String']['output']>;
  /** The content of the editorial review on json format. */
  body_json?: Maybe<BodyJson>;
  /** The newest comments added on this editorial review, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** the date when the editorial review was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The editorial review data. */
  data?: Maybe<Scalars['Json']['output']>;
  /** The id of the editorial review. */
  id: Scalars['ID']['output'];
  /** The internal id of the editorial review. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The publication information. */
  publication?: Maybe<Publication>;
  /** The rating of the editorial review. */
  rating?: Maybe<Scalars['Rating']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The title of the editorial review. */
  title?: Maybe<Scalars['String']['output']>;
};


/** An Allociné editorial review. */
export type EditorialReviewCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Alternative IDs for an entity from various providers. */
export type EntityAlternativeIds = {
  __typename?: 'EntityAlternativeIds';
  /** Canal+ ID. */
  canalplus?: Maybe<Scalars['String']['output']>;
  /** Disney+ ID. */
  disney?: Maybe<Scalars['String']['output']>;
  /** The universal unique identifier. */
  eidr?: Maybe<Scalars['String']['output']>;
  /** IMDb ID. */
  imdb?: Maybe<Scalars['String']['output']>;
  /** The international standard audiovisual number. */
  isan?: Maybe<Scalars['String']['output']>;
  /** German MoviePilot ID. */
  moviepilot?: Maybe<Scalars['String']['output']>;
  /** Netflix ID. */
  netflix?: Maybe<Scalars['String']['output']>;
  /** Amazon Prime Video ID. */
  primevideo?: Maybe<Scalars['String']['output']>;
};

/** A brand entity club (club300, etc.). */
export type EntityClub = Node & {
  __typename?: 'EntityClub';
  /** True if the movie is approved in the club 300; */
  approved?: Maybe<Scalars['Boolean']['output']>;
  /** The code of the club. */
  code?: Maybe<Scalars['String']['output']>;
  /** The id of the club. */
  id: Scalars['ID']['output'];
  /** The internal id of the club. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The name of the club. */
  name?: Maybe<Scalars['String']['output']>;
  /** The rating of the movie in the club 300. */
  rating?: Maybe<EntityClubRating>;
  /** True if the movie is seen in the club 300. */
  seen?: Maybe<Scalars['Boolean']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type EntityClubFlagType = {
  /** Filter entities list (movies or series) that have been approved by Club300 */
  club300?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter entities list (movies or series) that have been approved by the Scream Club */
  scream?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntityClubRating = {
  __typename?: 'EntityClubRating';
  average?: Maybe<Scalars['Float']['output']>;
  bad?: Maybe<Scalars['Float']['output']>;
  excellent?: Maybe<Scalars['Float']['output']>;
  good?: Maybe<Scalars['Float']['output']>;
};

/** An Allociné relation between an entity and a company. */
export type EntityCompany = {
  __typename?: 'EntityCompany';
  /** The activity of the company. */
  activity?: Maybe<Scalars['String']['output']>;
  /** The company. */
  company?: Maybe<Company>;
};

/** Sorting criteria for images. */
export enum EntityImageSorting {
  /** Images sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Images are sorted by added date. */
  Latest = 'LATEST',
  /** Images sorted by rank in ascending order. */
  Rank = 'RANK',
  /** Images sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL'
}

/** Metadata on an entity. */
export type EntityMetadata = {
  __typename?: 'EntityMetadata';
  active: Scalars['Boolean']['output'];
  gid: Scalars['String']['output'];
};

export type EntityRatingRules = {
  __typename?: 'EntityRatingRules';
  /** True if the entity is at risk. */
  at_risk?: Maybe<Scalars['Boolean']['output']>;
  /** True if enforce review from the user when rating entities */
  has_mandatory_review?: Maybe<Scalars['Boolean']['output']>;
  /** True if rating is displayable. */
  has_rating?: Maybe<Scalars['Boolean']['output']>;
  /** True if warning message is displayable. */
  has_warning_message?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityRules = {
  __typename?: 'EntityRules';
  /** Ruling linked to user reviews */
  rating?: Maybe<EntityRatingRules>;
};

export enum EntityType {
  /** An anthology film is a subgenre of films consisting of several different short films, often tied together by only a single theme, premise, or brief interlocking event (often a turning point). Sometimes each one is directed by a different director. */
  AnthologyFilm = 'ANTHOLOGY_FILM',
  BrandContent = 'BRAND_CONTENT',
  Commercial = 'COMMERCIAL',
  Episode = 'EPISODE',
  /** A feature film is a film (also called a movie, motion picture or just film) with a running time long enough to be considered the principal or sole film to fill a program. */
  FeatureFilm = 'FEATURE_FILM',
  Manga = 'MANGA',
  /** A medium length film is a film that has a running time of 30 to 59 minutes. In a lot of countries this term is not officially recognized. */
  MediumLengthFilm = 'MEDIUM_LENGTH_FILM',
  Miniseries = 'MINISERIES',
  /** A serial, film serial, movie serial or chapter play, is a motion picture form popular during the first half of the 20th century, consisting of a series of short subjects exhibited in consecutive order at one theater, generally advancing weekly, until the series is completed. */
  Serial = 'SERIAL',
  Series = 'SERIES',
  /** A short film, is a cinema format, denoting any film not long enough to be considered a feature film. */
  ShortFilm = 'SHORT_FILM',
  SpecialEvent = 'SPECIAL_EVENT',
  /** A television film is a feature-length motion picture that is produced for, and originally distributed by or to, a television network, in contrast to theatrical films, which are made explicitly for initial showing in movie theaters. */
  TvMovie = 'TV_MOVIE'
}

/** Update dates for an entity tracking global and nearby related changes. */
export type EntityUpdateDate = {
  __typename?: 'EntityUpdateDate';
  /** The date when the entity or its directly related content was last updated. */
  global?: Maybe<Scalars['DateTime']['output']>;
  /** The date when any nearby related entity was last updated. */
  nearby?: Maybe<Scalars['DateTime']['output']>;
};

/** Sorting criteria for videos. */
export enum EntityVideoSorting {
  /** Video sorted by popularity (all time). */
  AllTimePopularity = 'ALL_TIME_POPULARITY',
  /** Videos sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Videos sorted by the selection of cms. */
  CmsRank = 'CMS_RANK',
  /** This order will display the trailers first, then the teasers, then the clips, and then the other types. */
  CustomVideoType = 'CUSTOM_VIDEO_TYPE',
  /** Videos sorted by popularity on a daily J-1. */
  DailyPopularity = 'DAILY_POPULARITY',
  /** Videos are sorted by added date desc. */
  Latest = 'LATEST',
  /** Videos sorted by popularity on a monthly basis. */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** Videos are sorted by added date. */
  Oldest = 'OLDEST',
  /** Videos sorted by rank in ascending order. */
  Rank = 'RANK',
  /** Videos sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Videos sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** An Allociné series or program episode */
export type Episode = Node & {
  __typename?: 'Episode';
  /** The audiences of the episode per country. */
  audience?: Maybe<Array<Maybe<Audience>>>;
  /** The people playing in the series this season. */
  cast?: Maybe<CastMemberConnection>;
  /** The newest comments added on this episode, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The people working on the series this season. */
  credits?: Maybe<CreditsConnection>;
  /** The id of the episode */
  id: Scalars['ID']['output'];
  /** The list of the images for this episode. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The internal id of the episode */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the series */
  keywords?: Maybe<Scalars['String']['output']>;
  /** News that are related to the current one. Up to 10. */
  news?: Maybe<Array<Maybe<News>>>;
  /** The total amount of news this episode has. */
  newsCount?: Maybe<Scalars['Int']['output']>;
  /** The number of the episode in its season */
  number?: Maybe<Scalars['Int']['output']>;
  /** The number of the episode in the whole series */
  numberInSeries?: Maybe<Scalars['Int']['output']>;
  /** Informations about the broadcast of the episode. */
  originalBroadcast?: Maybe<SeriesEpisodeOriginalBroadcast>;
  /** The original title of the episode */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /**
   * !!!!! DEPRECATED !!!!! Use relatedProducts instead.
   * @deprecated Use relatedProducts instead
   */
  products?: Maybe<Array<Maybe<Product>>>;
  /** The products related to this episode. */
  relatedProducts?: Maybe<ProductsConnection>;
  /** The season of the episode */
  season?: Maybe<Season>;
  /** The series of the episode, it is equivalent as getting the series from the season. */
  series?: Maybe<Series>;
  /** All stats for the episode. */
  stats?: Maybe<EpisodeStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the episode, can be short or long (short by default). */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the episode, on json format. */
  synopsis_json?: Maybe<BodyJson>;
  /** The title of the episode */
  title?: Maybe<Scalars['String']['output']>;
  /** The update dates for this episode. */
  updatedAt?: Maybe<EntityUpdateDate>;
  /** The list of videos related to this episode. */
  videos?: Maybe<Array<Maybe<Video>>>;
};


/** An Allociné series or program episode */
export type EpisodeCastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series or program episode */
export type EpisodeCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series or program episode */
export type EpisodeCreditsArgs = {
  activity?: InputMaybe<PersonActivity>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series or program episode */
export type EpisodeImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
  type?: InputMaybe<Array<ImageType>>;
};


/** An Allociné series or program episode */
export type EpisodeNewsArgs = {
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
};


/** An Allociné series or program episode */
export type EpisodeProductsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
};


/** An Allociné series or program episode */
export type EpisodeRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  relatedCompanies?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
};


/** An Allociné series or program episode */
export type EpisodeSynopsisArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program episode */
export type EpisodeVideosArgs = {
  externalVideo?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
};

/** Sorting criteria for episode */
export enum EpisodeSorting {
  /** Episode sorted by number asc. */
  NumberAsc = 'NUMBER_ASC',
  /** Episode sorted by number desc. */
  NumberDesc = 'NUMBER_DESC'
}

/** All stats about the episode. */
export type EpisodeStats = {
  __typename?: 'EpisodeStats';
  /** Stats about ratings given by the users. */
  userRating?: Maybe<UserRatingsStats>;
  /** Stats about reviews given by the users. Note that ratings related to reviews are already aggregated into the userRating field */
  userReview?: Maybe<UserReviewsStats>;
};

/** All experiences available in theater, showtime or screen. */
export enum Experience {
  AtmosExperience = 'ATMOS_EXPERIENCE',
  ButtKicker = 'BUTT_KICKER',
  Dbox = 'DBOX',
  DolbyAtmos = 'DOLBY_ATMOS',
  DolbyCinema = 'DOLBY_CINEMA',
  DolbyVisionAtmos = 'DOLBY_VISION_ATMOS',
  EclairColor = 'ECLAIR_COLOR',
  E_4Dx = 'E_4DX',
  E_4DEmotion = 'E_4D_EMOTION',
  GrandLarge = 'GRAND_LARGE',
  Ice = 'ICE',
  Infinite = 'INFINITE',
  Jumbo = 'JUMBO',
  LaserUltra = 'LASER_ULTRA',
  LightVibes = 'LIGHT_VIBES',
  Mx4D = 'MX4D',
  OnyxLed = 'ONYX_LED',
  Platinum = 'PLATINUM',
  Plf = 'PLF',
  Premium = 'PREMIUM',
  ScreenX = 'SCREEN_X',
  TraditionalAuditorium = 'TRADITIONAL_AUDITORIUM',
  TremorFx = 'TREMOR_FX'
}

export type ExperienceFacet = FacetValue & {
  __typename?: 'ExperienceFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

/** An external link contains information to generate links for a given locale. */
export type ExternalLink = {
  __typename?: 'ExternalLink';
  brand?: Maybe<Brand>;
  /** The id of the entity in the targeted locale. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The locale of the external link. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The title of the external link. */
  title?: Maybe<Scalars['String']['output']>;
};

/** External data provider of a video. */
export type ExternalVideoProvider = {
  __typename?: 'ExternalVideoProvider';
  /** The embed code of the provider. */
  embed?: Maybe<Scalars['String']['output']>;
  /** The id of the provider. */
  id?: Maybe<Scalars['String']['output']>;
};

export type ExtraProviderFlags = {
  __typename?: 'ExtraProviderFlags';
  replay_exclusive?: Maybe<Company>;
  replay_originals?: Maybe<Company>;
  svod_exclusive?: Maybe<Company>;
  svod_originals?: Maybe<Company>;
};

export enum FacetFieldShowtimeValue {
  Comfort = 'COMFORT',
  Experience = 'EXPERIENCE',
  Picture = 'PICTURE',
  Projection = 'PROJECTION',
  Service = 'SERVICE',
  Sound = 'SOUND',
  Version = 'VERSION'
}

export enum FacetFieldSoundtrackValue {
  Decades = 'DECADES',
  Year = 'YEAR'
}

export enum FacetFieldTheaterShowtimeValue {
  Booking = 'BOOKING',
  Comfort = 'COMFORT',
  Experience = 'EXPERIENCE',
  LoyaltyCards = 'LOYALTY_CARDS',
  Picture = 'PICTURE',
  Projection = 'PROJECTION',
  Service = 'SERVICE',
  Sound = 'SOUND',
  Version = 'VERSION'
}

export enum FacetFieldValue {
  Age = 'AGE',
  Countries = 'COUNTRIES',
  Decades = 'DECADES',
  FirstChar = 'FIRST_CHAR',
  Genres = 'GENRES',
  PhysicalProduct = 'PHYSICAL_PRODUCT',
  Theme = 'THEME',
  ThemeTag = 'THEME_TAG',
  Type = 'TYPE',
  Version = 'VERSION',
  Year = 'YEAR'
}

/** Sorting criteria for facets */
export enum FacetSorting {
  /** Facets sorted by name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Facets sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Facets sorted by reversed count. */
  ReverseTotalCount = 'REVERSE_TOTAL_COUNT',
  /** Facets sorted by count. */
  TotalCount = 'TOTAL_COUNT'
}

export type FacetValue = {
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

export type Facets = {
  __typename?: 'Facets';
  /** The facet name. It's the ES filter name. */
  name: Scalars['String']['output'];
  /** The values aggregation. */
  values?: Maybe<Array<Maybe<FacetValue>>>;
};

export type FacetsMovieShowtimeType = {
  /** The aggregation field name. */
  field: FacetFieldShowtimeValue;
  /** When provide will return the number count of facets. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When provide will order aggregation keys. */
  order?: InputMaybe<Array<InputMaybe<FacetSorting>>>;
};

export type FacetsSoundtrackType = {
  /** The aggregation field name. */
  field: FacetFieldSoundtrackValue;
  /** When provide will return the number count of facets. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When provide will order aggregation keys. */
  order?: InputMaybe<Array<InputMaybe<FacetSorting>>>;
};

export type FacetsTheaterShowtimeType = {
  /** The aggregation field name. */
  field: FacetFieldTheaterShowtimeValue;
  /** When provide will return the number count of facets. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When provide will order aggregation keys. */
  order?: InputMaybe<Array<InputMaybe<FacetSorting>>>;
};

export type FacetsType = {
  /** The aggregation field name. */
  field: FacetFieldValue;
  /** When provide will return the number count of facets. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** When provide will order aggregation keys. */
  order?: InputMaybe<Array<InputMaybe<FacetSorting>>>;
};

/** A social action done by a user. */
export type Fan = SocialActionInterface & {
  __typename?: 'Fan';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** An Allociné festival. */
export type Festival = Node & {
  __typename?: 'Festival';
  /** The awards of the festival. */
  awards?: Maybe<Array<Maybe<FestivalAward>>>;
  /** The paginated awards of the festival. */
  awardsList?: Maybe<FestivalAwardConnection>;
  /** The competitions of the festival. */
  competitions?: Maybe<Array<Maybe<FestivalCompetition>>>;
  /** The country where the festival is. */
  country?: Maybe<Country>;
  /** The number of edition existing in database. */
  editionCount?: Maybe<Scalars['Int']['output']>;
  /** The paginated editions of the festival. */
  editionList?: Maybe<FestivalEditionConnection>;
  /** The editions of the festival. */
  editions?: Maybe<Array<Maybe<FestivalEdition>>>;
  /** The id of the festival. */
  id: Scalars['ID']['output'];
  /** The list of the images for this festival. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The internal id of the festival. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The localation where the festival is. */
  location?: Maybe<Location>;
  /** The name of the festival. */
  name?: Maybe<Scalars['String']['output']>;
  /** The list of the news related to this festival. */
  news?: Maybe<NewsConnection>;
  /** The image of the festival. */
  poster?: Maybe<InternalImage>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The localized synopsis of the festival. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The theme of the festival. */
  theme?: Maybe<FestivalTheme>;
  /** The type of the festival. */
  type?: Maybe<FestivalType>;
  /** The list of videos related to this festival. */
  videos?: Maybe<Array<Maybe<Video>>>;
};


/** An Allociné festival. */
export type FestivalAwardsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<AwardsSorting>>>;
};


/** An Allociné festival. */
export type FestivalEditionListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<FilterDate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalEditionSorting>>>;
  startDate?: InputMaybe<FilterDate>;
};


/** An Allociné festival. */
export type FestivalEditionsArgs = {
  endDate?: InputMaybe<FilterDate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalEditionSorting>>>;
  startDate?: InputMaybe<FilterDate>;
};


/** An Allociné festival. */
export type FestivalImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
  type?: InputMaybe<Array<ImageType>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné festival. */
export type FestivalNewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
};


/** An Allociné festival. */
export type FestivalVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An Allociné festival award. */
export type FestivalAward = {
  __typename?: 'FestivalAward';
  /** The festival itself. */
  festival?: Maybe<Festival>;
  /** The id of the festival award. */
  id: Scalars['ID']['output'];
  /** The internal id of the festival award. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The name of the festival award. */
  name?: Maybe<Scalars['String']['output']>;
  /** WIP - The selections for this award. */
  selection?: Maybe<FestivalSelectionConnection>;
  /** The selections in this festival award */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
  /** The synopsis of the festival award. */
  synopsis?: Maybe<Scalars['String']['output']>;
};


/** An Allociné festival award. */
export type FestivalAwardSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};


/** An Allociné festival award. */
export type FestivalAwardSelectionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};

/** A connection to a list of items. */
export type FestivalAwardConnection = {
  __typename?: 'FestivalAwardConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FestivalAwardEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FestivalAwardEdge = {
  __typename?: 'FestivalAwardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FestivalAward>;
};

/** An Allociné festival competition. */
export type FestivalCompetition = {
  __typename?: 'FestivalCompetition';
  /** The festival itself. */
  festival?: Maybe<Festival>;
  /** The id of the festival competition. */
  id: Scalars['ID']['output'];
  /** The internal id of the festival competition. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The name of the festival competition. */
  name?: Maybe<Scalars['String']['output']>;
  /** The selections in this festival competition */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
};


/** An Allociné festival competition. */
export type FestivalCompetitionSelectionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};

/** An Allociné festival edition. */
export type FestivalEdition = Node & {
  __typename?: 'FestivalEdition';
  /** The end date of the edition. */
  endsAt?: Maybe<Scalars['DateLimited']['output']>;
  /** The festival itself. */
  festival?: Maybe<Festival>;
  /** The id of the festival edition. */
  id: Scalars['ID']['output'];
  /** The list of the images for this festival edition. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The internal id of the festival edition. */
  internalId?: Maybe<Scalars['Int']['output']>;
  juries?: Maybe<Array<Maybe<FestivalJury>>>;
  /** The name of the festival edition. */
  name?: Maybe<Scalars['String']['output']>;
  /** The news related to this edition. */
  news?: Maybe<NewsConnection>;
  /** The edition number. */
  number?: Maybe<Scalars['Int']['output']>;
  /** The image of the festival edition. */
  poster?: Maybe<InternalImage>;
  /** The selections the person was selected in. */
  selection?: Maybe<FestivalSelectionConnection>;
  /**
   * !!!!! DEPRECATED !!!!! The selections in this festival competition
   * @deprecated Use selection instead
   */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
  /** The start date of the edition. */
  startsAt?: Maybe<Scalars['DateLimited']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The list of videos related to this festival edition. */
  videos?: Maybe<VideosConnection>;
  /** The year of the edition. */
  year?: Maybe<Scalars['Int']['output']>;
};


/** An Allociné festival edition. */
export type FestivalEditionImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
  type?: InputMaybe<Array<ImageType>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné festival edition. */
export type FestivalEditionNewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<NewsType>>>;
};


/** An Allociné festival edition. */
export type FestivalEditionSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};


/** An Allociné festival edition. */
export type FestivalEditionSelectionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};


/** An Allociné festival edition. */
export type FestivalEditionVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
};

/** A connection to a list of items. */
export type FestivalEditionConnection = {
  __typename?: 'FestivalEditionConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FestivalEditionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FestivalEditionEdge = {
  __typename?: 'FestivalEditionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FestivalEdition>;
};

/** Sorting criteria for editions */
export enum FestivalEditionSorting {
  /** Editions are sorted by year desc. */
  Latest = 'LATEST',
  /** Editions are sorted by year asc. */
  Oldest = 'OLDEST'
}

export type FestivalJury = {
  __typename?: 'FestivalJury';
  competition?: Maybe<FestivalCompetition>;
  edition?: Maybe<FestivalEdition>;
  festival?: Maybe<Festival>;
  /** The person that is part of the jury. */
  person?: Maybe<Person>;
  /** Role on the festival (!!! still in development, data can be incomplete !!!) */
  role?: Maybe<Scalars['String']['output']>;
};

/** An Allocine festival selection. */
export type FestivalSelection = {
  __typename?: 'FestivalSelection';
  /** The festival award related to this selection. */
  award?: Maybe<FestivalAward>;
  /** The festival competition related to this selection. */
  competition?: Maybe<FestivalCompetition>;
  /** The festival edition related to this selection. */
  edition?: Maybe<FestivalEdition>;
  /** The festival. */
  festival?: Maybe<Festival>;
  /** Wether or not the nominee has won. */
  hasWon?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the festival selection. */
  id: Scalars['ID']['output'];
  /** The internal id of the festival selection. */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** The nominated entity. */
  nominees?: Maybe<Array<Maybe<Node>>>;
};

/** A connection to a list of items. */
export type FestivalSelectionConnection = {
  __typename?: 'FestivalSelectionConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FestivalSelectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FestivalSelectionEdge = {
  __typename?: 'FestivalSelectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FestivalSelection>;
};

/** Sorting criteria for toto */
export enum FestivalSelectionSorting {
  /** Selections are sorted by award rank. */
  AwardRank = 'AWARD_RANK',
  /** Selections are sorted by competition rank. */
  CompetitionRank = 'COMPETITION_RANK',
  /** Editions are sorted by year desc. */
  Latest = 'LATEST',
  /** Editions are sorted by year asc. */
  Oldest = 'OLDEST',
  /** Selections are sorted by winner first. */
  Winner = 'WINNER'
}

/** Sorting criteria for festivals */
export enum FestivalSorting {
  /** Festivals sorted by name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Festivals sorted by their rank. */
  Rank = 'RANK',
  /** Festivals sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Festivals sorted by in reverse rank order. */
  ReverseRank = 'REVERSE_RANK'
}

export enum FestivalTheme {
  FestivalCinemaTelevision = 'FESTIVAL_CINEMA_TELEVISION',
  FestivalCourtMetrage = 'FESTIVAL_COURT_METRAGE',
  FestivalLongEtCourtMetrage = 'FESTIVAL_LONG_ET_COURT_METRAGE',
  FestivalLongMetrage = 'FESTIVAL_LONG_METRAGE',
  FestivalTelevision = 'FESTIVAL_TELEVISION',
  Webtv = 'WEBTV'
}

export enum FestivalType {
  CyclesNuit = 'CYCLES_NUIT',
  FestivalInternational = 'FESTIVAL_INTERNATIONAL',
  FestivalItinerant = 'FESTIVAL_ITINERANT',
  FestivalNational = 'FESTIVAL_NATIONAL',
  Prix = 'PRIX',
  Rencontres = 'RENCONTRES',
  Retrospective = 'RETROSPECTIVE'
}

export enum FilmGauge {
  Dv = 'DV',
  Hd = 'HD',
  Standard_16Mm = 'STANDARD_16MM',
  Standard_35Mm = 'STANDARD_35MM',
  Standard_70Mm = 'STANDARD_70MM',
  Super_8 = 'SUPER_8',
  Super_16Mm = 'SUPER_16MM',
  Super_35Mm = 'SUPER_35MM'
}

/** The activity of a person, from playing in a movie/series to being in the technical crew. */
export type FilmographyActivity = CastMember | CreditsMember;

export enum FilmographyEntityStatus {
  MovieComingInTheater = 'MOVIE_COMING_IN_THEATER',
  MovieInTheater = 'MOVIE_IN_THEATER',
  SeriesInProgress = 'SERIES_IN_PROGRESS'
}

export enum FilmographyEntityType {
  Movie = 'MOVIE',
  Series = 'SERIES'
}

/** This items represents the work of a person on a single movie/series/program/season/episode. */
export type FilmographyEntry = {
  __typename?: 'FilmographyEntry';
  /** What the person did. */
  activity?: Maybe<FilmographyActivity>;
  extra?: Maybe<FilmographyExtraData>;
  /** On what the person worked. */
  work?: Maybe<Node>;
  /** The year the person worked on this. On a movie it's the production year. On a series or a season it's the start date. When it is an episode, the corresponding season start date is used. */
  year?: Maybe<Scalars['Int']['output']>;
};

/** Extra filmography information */
export type FilmographyExtraData = {
  __typename?: 'FilmographyExtraData';
  /** List of the episodes numbers */
  season_episodes?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

/** Technical flags about video to have rapid information */
export type FilmographyFlags = {
  /** When true will only returns the filmography elements that have dvd/vod products. */
  has_product?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true will only returns the filmography elements that have streaming products (avod/replay/svod). */
  has_streaming_product?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true will only returns the top filmography elements (based on ranking, awards, etc.). */
  is_top_filmography?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sorting criteria for person filmography */
export enum FilmographySorting {
  /** Entities sorted by top filmography criterias (ranking, awards, etc.). */
  TopFilmographyRank = 'TOP_FILMOGRAPHY_RANK',
  /** Entities sorted by year asc. */
  YearAsc = 'YEAR_ASC',
  /** Entities sorted by year desc. */
  YearDesc = 'YEAR_DESC'
}

/** Filmography list with total count */
export type FilmographyStats = {
  __typename?: 'FilmographyStats';
  /** Count aggregation of filmography items with physical or VOD/VODEST products for Movie type entities */
  movieProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of filmography items of Movie type having upcoming showtimes */
  moviesComingInTheatersCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of filmography items of Movie type having playing showtimes */
  moviesInTheatersCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of filmography items with streaming products (SVOD/AVOD/Replay) */
  onlineProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of filmography items with physical or VOD/VODEST products */
  physicalProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of filmography items with physical or VOD/VODEST products for Series/Season/Episode type entities */
  seriesProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of top filmography items */
  topFilmographyCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of top filmography items of Movie type */
  topFilmographyMoviesCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of top filmography items of Series/Season/Episode type */
  topFilmographySeriesCount?: Maybe<Scalars['Int']['output']>;
  /** Count aggregation of all filmography items */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** To filter elements between two dates. */
export type FilterDate = {
  /** If provide will create a pattern of date after selected date */
  after?: InputMaybe<Scalars['DateLimited']['input']>;
  /** If provide will create a pattern of date before selected date */
  before?: InputMaybe<Scalars['DateLimited']['input']>;
};

export type FilterRangeRating = {
  /** If provide will create a pattern of rating after selected float value. */
  after?: InputMaybe<Scalars['Float']['input']>;
  /** If provide will create a pattern of rating before selected float value. */
  before?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterRangeRatingCounter = {
  /** If provide will create a pattern of rating after selected integer value. */
  after?: InputMaybe<Scalars['Int']['input']>;
  /** If provide will create a pattern of rating before selected integer value. */
  before?: InputMaybe<Scalars['Int']['input']>;
};

/** A follow action done by a user. */
export type Follow = SocialActionInterface & {
  __typename?: 'Follow';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  /**
   * !!!!! DEPRECATED !!!!! Use relatedEntity instead.
   * @deprecated Use relatedEntity instead.
   */
  relatedUser?: Maybe<User>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FollowCollectionInput = {
  /** The collection id. */
  id_collection: Scalars['String']['input'];
};

/** The gender of a person. */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GenericFacet = FacetValue & {
  __typename?: 'GenericFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

export enum Genre {
  Action = 'ACTION',
  Adventure = 'ADVENTURE',
  Animation = 'ANIMATION',
  Ballet = 'BALLET',
  Biopic = 'BIOPIC',
  Bollywood = 'BOLLYWOOD',
  Cartoon = 'CARTOON',
  Classic = 'CLASSIC',
  Comedy = 'COMEDY',
  ComedyDrama = 'COMEDY_DRAMA',
  Concert = 'CONCERT',
  Detective = 'DETECTIVE',
  Divers = 'DIVERS',
  Documentary = 'DOCUMENTARY',
  Drama = 'DRAMA',
  Erotic = 'EROTIC',
  Experimental = 'EXPERIMENTAL',
  Family = 'FAMILY',
  Fantasy = 'FANTASY',
  Historical = 'HISTORICAL',
  HistoricalEpic = 'HISTORICAL_EPIC',
  Horror = 'HORROR',
  Judicial = 'JUDICIAL',
  KoreanDrama = 'KOREAN_DRAMA',
  MartialArts = 'MARTIAL_ARTS',
  Medical = 'MEDICAL',
  Mobisode = 'MOBISODE',
  MovieNight = 'MOVIE_NIGHT',
  Music = 'MUSIC',
  Musical = 'MUSICAL',
  Opera = 'OPERA',
  Performance = 'PERFORMANCE',
  Romance = 'ROMANCE',
  ScienceFiction = 'SCIENCE_FICTION',
  Soap = 'SOAP',
  SportEvent = 'SPORT_EVENT',
  Spy = 'SPY',
  Thriller = 'THRILLER',
  Warmovie = 'WARMOVIE',
  WebSeries = 'WEB_SERIES',
  Western = 'WESTERN'
}

export type GenreFacet = FacetValue & {
  __typename?: 'GenreFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The genre which type match. */
  genre?: Maybe<GenreType>;
  /** The aggregation value name. */
  key: Scalars['String']['output'];
};

export type GenrePercentage = {
  __typename?: 'GenrePercentage';
  /** The top four movie genres the person took part in. */
  genre?: Maybe<Genre>;
  /** The genre percentage. */
  percentage?: Maybe<Scalars['Int']['output']>;
};

export type GenreType = {
  __typename?: 'GenreType';
  /** The genre id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The genre name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Global boxoffice. */
export type GlobalBoxOffice = {
  __typename?: 'GlobalBoxOffice';
  /** Unit */
  unit?: Maybe<BoxOfficeType>;
  /** The boxoffice's value. */
  value?: Maybe<Scalars['Int']['output']>;
};

/** Filter by entity last modification date */
export type GlobalUpdatedAtFilterType = {
  /** The date to start the range from (default: current date). */
  dateFrom: Scalars['DateTime']['input'];
  /** If true, will only select nearby entities, else will also select related entities. (default: false) */
  nearbyOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A group. */
export type Group = {
  __typename?: 'Group';
  /** Return list of children theater group ordered by path length and rank. */
  children?: Maybe<GroupConnection>;
  /** The group id. */
  id: Scalars['ID']['output'];
  /** The group internal id. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The group name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The parents group ordered by path length. */
  parents?: Maybe<Array<Maybe<LinkedGroup>>>;
  /** The group path. */
  path?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Related theaters in the group. */
  theaters?: Maybe<TheaterConnection>;
};


/** A group. */
export type GroupChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterGroupSorting>>>;
};


/** A group. */
export type GroupTheatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A social action done by a user. */
export type Helpful = SocialActionInterface & {
  __typename?: 'Helpful';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Image = {
  /** The full url to the image */
  url?: Maybe<Scalars['String']['output']>;
};


export type ImageUrlArgs = {
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderWidth?: InputMaybe<Scalars['Int']['input']>;
  crop?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cropCenter?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  format?: InputMaybe<ImageFormat>;
  overlayImage?: InputMaybe<Scalars['String']['input']>;
  overlayOffset?: InputMaybe<Scalars['Int']['input']>;
  overlayPosition?: InputMaybe<ImageOverlayPosition>;
  resize?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Technical data about images. */
export type ImageData = {
  __typename?: 'ImageData';
  /** The owner of the image. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Informations about the file. */
  file?: Maybe<ImageFile>;
};

/** Different information about the file. */
export type ImageFile = {
  __typename?: 'ImageFile';
  /** The height of the image in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The mime type of the image. */
  mime?: Maybe<Scalars['String']['output']>;
  /** The size of the image in octets. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The width of the image in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** All formats available to convert the image type. */
export enum ImageFormat {
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG'
}

/** All positions available for the overlay. */
export enum ImageOverlayPosition {
  Center = 'CENTER',
  East = 'EAST',
  North = 'NORTH',
  NorthEast = 'NORTH_EAST',
  NorthWest = 'NORTH_WEST',
  South = 'SOUTH',
  SouthEast = 'SOUTH_EAST',
  SouthWest = 'SOUTH_WEST',
  West = 'WEST'
}

/** Sorting criteria for images */
export enum ImageSorting {
  /** Images sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Images are sorted by added date. */
  Latest = 'LATEST',
  /** Images sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL'
}

/** All types of images available. */
export enum ImageType {
  Photo = 'PHOTO',
  Poster = 'POSTER',
  SocialUserAvatar = 'SOCIAL_USER_AVATAR',
  SocialUserBanner = 'SOCIAL_USER_BANNER',
  VignetteMagazine = 'VIGNETTE_MAGAZINE'
}

/** Filter on a range */
export type IntRangeFilter = {
  /** The number to start the range from. */
  from?: InputMaybe<Scalars['Int']['input']>;
  /** The number to end the range to. */
  to?: InputMaybe<Scalars['Int']['input']>;
};

/** An Allociné internal image. It has some properties on top of the url, like the file size and its id. */
export type InternalImage = Image & Node & {
  __typename?: 'InternalImage';
  /** Technical data about images. */
  data?: Maybe<ImageData>;
  /** A description of the image. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date of the image usage. */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** The id of the image */
  id: Scalars['ID']['output'];
  /** The internal id of the image */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** The path of the image */
  path?: Maybe<Scalars['String']['output']>;
  /** The publication date. */
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The related entities of the image */
  relatedEntities?: Maybe<Array<Maybe<Node>>>;
  /** The start date of the image usage. */
  startDate?: Maybe<Scalars['Date']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the movie */
  tags?: Maybe<TagCollection>;
  /** The full url of the image. */
  url?: Maybe<Scalars['String']['output']>;
};


/** An Allociné internal image. It has some properties on top of the url, like the file size and its id. */
export type InternalImageRelatedEntitiesArgs = {
  type?: InputMaybe<Array<InputMaybe<MediaRelatedEntityTypes>>>;
};


/** An Allociné internal image. It has some properties on top of the url, like the file size and its id. */
export type InternalImageUrlArgs = {
  borderColor?: InputMaybe<Scalars['String']['input']>;
  borderWidth?: InputMaybe<Scalars['Int']['input']>;
  crop?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cropCenter?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  format?: InputMaybe<ImageFormat>;
  overlayImage?: InputMaybe<Scalars['String']['input']>;
  overlayOffset?: InputMaybe<Scalars['Int']['input']>;
  overlayPosition?: InputMaybe<ImageOverlayPosition>;
  resize?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum Language {
  AboriginalLanguage = 'ABORIGINAL_LANGUAGE',
  AfricanDialect = 'AFRICAN_DIALECT',
  Afrikaans = 'AFRIKAANS',
  Albanian = 'ALBANIAN',
  Algerian = 'ALGERIAN',
  Amharic = 'AMHARIC',
  Arabic = 'ARABIC',
  Aramaic = 'ARAMAIC',
  Armenian = 'ARMENIAN',
  Azeri = 'AZERI',
  Bambara = 'BAMBARA',
  Bengali = 'BENGALI',
  Bosnian = 'BOSNIAN',
  Briton = 'BRITON',
  Bulgarian = 'BULGARIAN',
  Burmese = 'BURMESE',
  Cantonese = 'CANTONESE',
  Catalan = 'CATALAN',
  Chinese = 'CHINESE',
  Creole = 'CREOLE',
  Czech = 'CZECH',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Estonian = 'ESTONIAN',
  Euskera = 'EUSKERA',
  Farsi = 'FARSI',
  Filipino = 'FILIPINO',
  Finnish = 'FINNISH',
  Flemish = 'FLEMISH',
  French = 'FRENCH',
  Gaelic = 'GAELIC',
  Gallego = 'GALLEGO',
  Georgian = 'GEORGIAN',
  German = 'GERMAN',
  Greek = 'GREEK',
  Guarani = 'GUARANI',
  Hebrew = 'HEBREW',
  Hindi = 'HINDI',
  Hokkien = 'HOKKIEN',
  Hungarian = 'HUNGARIAN',
  Icelandic = 'ICELANDIC',
  Indonesian = 'INDONESIAN',
  Inuktitut = 'INUKTITUT',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Kannada = 'KANNADA',
  Kazakh = 'KAZAKH',
  Khmer = 'KHMER',
  Kirgizian = 'KIRGIZIAN',
  Klingon = 'KLINGON',
  Korean = 'KOREAN',
  Kurdish = 'KURDISH',
  Latin = 'LATIN',
  Latvian = 'LATVIAN',
  Lingala = 'LINGALA',
  Lithuanian = 'LITHUANIAN',
  Macedonian = 'MACEDONIAN',
  Malagasy = 'MALAGASY',
  Malay = 'MALAY',
  Malayalam = 'MALAYALAM',
  Mandarin = 'MANDARIN',
  Marathi = 'MARATHI',
  Maya = 'MAYA',
  Mongolese = 'MONGOLESE',
  Norwegian = 'NORWEGIAN',
  Other = 'OTHER',
  Pashto = 'PASHTO',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  Punjabi = 'PUNJABI',
  Romanian = 'ROMANIAN',
  Romany = 'ROMANY',
  Russian = 'RUSSIAN',
  Serb = 'SERB',
  SerboCroat = 'SERBO_CROAT',
  SignLanguage = 'SIGN_LANGUAGE',
  Silent = 'SILENT',
  Slovak = 'SLOVAK',
  Slovenian = 'SLOVENIAN',
  Somali = 'SOMALI',
  Sotho = 'SOTHO',
  Spanish = 'SPANISH',
  Swahili = 'SWAHILI',
  Swedish = 'SWEDISH',
  SwissGerman = 'SWISS_GERMAN',
  Tadzhik = 'TADZHIK',
  Tamil = 'TAMIL',
  Telugu = 'TELUGU',
  Thai = 'THAI',
  Tibetan = 'TIBETAN',
  Turkish = 'TURKISH',
  Ukrainian = 'UKRAINIAN',
  UndeterminedLanguage = 'UNDETERMINED_LANGUAGE',
  Urdu = 'URDU',
  Valenciano = 'VALENCIANO',
  Vietnamese = 'VIETNAMESE',
  Wolof = 'WOLOF',
  Yiddish = 'YIDDISH',
  Zanskari = 'ZANSKARI',
  Zulu = 'ZULU'
}

/** A parent group. */
export type LinkedGroup = {
  __typename?: 'LinkedGroup';
  /** The group id. */
  id: Scalars['ID']['output'];
  /** The group internal id. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The group name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The group path. */
  path?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Related theaters in the group. */
  theaters?: Maybe<TheaterConnection>;
};


/** A parent group. */
export type LinkedGroupTheatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum Locale {
  De = 'DE',
  Es = 'ES',
  Fr = 'FR',
  Pt = 'PT',
  Tr = 'TR'
}

export enum Locales {
  DeDe = 'de_DE',
  EnAu = 'en_AU',
  EnCa = 'en_CA',
  EnGb = 'en_GB',
  EnNz = 'en_NZ',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  EsMx = 'es_MX',
  FrCa = 'fr_CA',
  FrFr = 'fr_FR',
  PtBr = 'pt_BR',
  TrTr = 'tr_TR'
}

/** The localization object. */
export type Localization = {
  __typename?: 'Localization';
  /** The children localizations ordered by path (City/County/Country/). */
  childrenLocalization?: Maybe<LocalizationConnection>;
  /** The localization code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The coordinates of the localization. */
  coordinates?: Maybe<Coordinates>;
  /** The localization id. */
  id: Scalars['ID']['output'];
  /** The localization internal id. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The localization name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The parents localizations ordered by path (City/County/Country/). */
  parentsLocalization?: Maybe<Array<Maybe<Localization>>>;
  /** The localization path. */
  path?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Return a list of theaters. */
  theaters?: Maybe<TheaterConnection>;
  /** The localization type. */
  type?: Maybe<LocalizationTypeValue>;
};


/** The localization object. */
export type LocalizationChildrenLocalizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeParentType?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTheater?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizationSortingLight>>>;
  type?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
};


/** The localization object. */
export type LocalizationParentsLocalizationArgs = {
  excludeParentType?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTheater?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizationSortingLight>>>;
  type?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
};


/** The localization object. */
export type LocalizationTheatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  movie?: InputMaybe<Scalars['String']['input']>;
  nextProductSlidingWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  nextTwoSlidingWeeks?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterSortingLight>>>;
};

/** Sorting criteria for localizations */
export enum LocalizationSorting {
  /** Sorted by localization name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort with the closest in space first. */
  Closest = 'CLOSEST',
  /** No sort is applied. */
  None = 'NONE',
  /** Sort by number of parent localization ascendant. */
  ParentNumber = 'PARENT_NUMBER',
  /** Sort by number of parent localization ascendant. */
  ReverseParentNumber = 'REVERSE_PARENT_NUMBER',
  /** Sort descendant by number of screen attached to the localization's theaters. */
  ReverseScreenCount = 'REVERSE_SCREEN_COUNT',
  /** Sort by number of theaters linked to the localization descendant. */
  ReverseTheaterCount = 'REVERSE_THEATER_COUNT',
  /** Sort by score the matching result. */
  Score = 'SCORE',
  /** Sort ascendant by number of screen attached to the localization's theaters. */
  ScreenCount = 'SCREEN_COUNT',
  /** Sort by number of theaters linked to the localization ascendant. */
  TheaterCount = 'THEATER_COUNT',
  /** Sort by number of theaters that display the movie. Need movieDisplayed. */
  TheaterForMovieCounter = 'THEATER_FOR_MOVIE_COUNTER',
  /** Sort by number of theaters that display the movie in the next sliding weeks (number defined by product). Need movieDisplayedWithinProductSlidingWeeks. */
  TheaterForMovieCounterWithinProductSlidingWeeks = 'THEATER_FOR_MOVIE_COUNTER_WITHIN_PRODUCT_SLIDING_WEEKS',
  /**
   * Sort by number of theaters that display the movie in the next sliding weeks (number defined by product). Need movieDisplayedWithinTwoSlidingWeeks.
   * @deprecated Use THEATER_FOR_MOVIE_COUNTER_WITHIN_PRODUCT_SLIDING_WEEKS instead
   */
  TheaterForMovieCounterWithinTwoSlidingWeeks = 'THEATER_FOR_MOVIE_COUNTER_WITHIN_TWO_SLIDING_WEEKS'
}

/** Sorting criteria for localizations */
export enum LocalizationSortingLight {
  /** Sorted by localization name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** No sort is applied. */
  None = 'NONE',
  /** Sort by number of parent localization ascendant. */
  ParentNumber = 'PARENT_NUMBER',
  /** Sort by number of parent localization ascendant. */
  ReverseParentNumber = 'REVERSE_PARENT_NUMBER',
  /** Sort descendant by number of screen attached to the localization's theaters. */
  ReverseScreenCount = 'REVERSE_SCREEN_COUNT',
  /** Sort by number of theaters linked to the localization descendant. */
  ReverseTheaterCount = 'REVERSE_THEATER_COUNT',
  /** Sort ascendant by number of screen attached to the localization's theaters. */
  ScreenCount = 'SCREEN_COUNT',
  /** Sort by number of theaters linked to the localization ascendant. */
  TheaterCount = 'THEATER_COUNT'
}

export enum LocalizationTypeValue {
  Area = 'AREA',
  Borough = 'BOROUGH',
  Country = 'COUNTRY',
  County = 'COUNTY',
  Localarea = 'LOCALAREA',
  Region = 'REGION'
}

/** A location object defined by it full address. */
export type Location = {
  __typename?: 'Location';
  /** The number & street of the address. */
  address?: Maybe<Scalars['String']['output']>;
  /** The city of the address. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the address. */
  country?: Maybe<Scalars['String']['output']>;
  /** The theater localizations ordered by path (City/County/Country/). */
  localizations?: Maybe<Array<Maybe<Localization>>>;
  /** The region of the address. */
  region?: Maybe<Scalars['String']['output']>;
  /** The zip of the address. */
  zip?: Maybe<Scalars['String']['output']>;
};


/** A location object defined by it full address. */
export type LocationLocalizationsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizationSortingLight>>>;
  type?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
};

/** All loyalty cards. */
export enum LoyaltyCard {
  Ccu = 'CCU',
  Cinecheque = 'CINECHEQUE',
  Cinepass = 'CINEPASS',
  CineCarteCip = 'CINE_CARTE_CIP',
  Grac = 'GRAC',
  LePass = 'LE_PASS',
  UgcIllimite = 'UGC_ILLIMITE'
}

export type LoyaltyCardFacet = FacetValue & {
  __typename?: 'LoyaltyCardFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

/** An Allociné main release. */
export type MainReleaseInfo = {
  __typename?: 'MainReleaseInfo';
  /** The associated release */
  release?: Maybe<ReleaseInterface>;
  /** The main release type */
  type?: Maybe<CustomReleaseType>;
};

/** Show information about a main special operations on entity. */
export type MainSpecialOperation = {
  __typename?: 'MainSpecialOperation';
  /** The main operation code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The main operation data. */
  data?: Maybe<Scalars['Json']['output']>;
  /** The main operation end date. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The entity focused on the main operation. */
  entity?: Maybe<Node>;
  /** The main operation id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The main operation name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The main operation start date. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The target operations. */
  target?: Maybe<Array<Maybe<TargetSpecialOperation>>>;
};

/** A wrapper object to get information about the current session. */
export type Me = {
  __typename?: 'Me';
  /** Information about the current API session. */
  token?: Maybe<ApplicationToken>;
  /** Information about the user for the current API session. Can be null. */
  user?: Maybe<User>;
};

/** Available types for video entities. */
export enum MediaRelatedEntityTypes {
  Episode = 'EPISODE',
  Festival = 'FESTIVAL',
  FestivalEdition = 'FESTIVAL_EDITION',
  Movie = 'MOVIE',
  Person = 'PERSON',
  Program = 'PROGRAM',
  ProgramEpisode = 'PROGRAM_EPISODE',
  ProgramSeason = 'PROGRAM_SEASON',
  Season = 'SEASON',
  Series = 'SERIES'
}

/** Metadata of a person. */
export type MetadataPerson = {
  __typename?: 'MetadataPerson';
  /** The person birth date precision */
  birthDatePrecision: DatePrecision;
  /** Person career duration in years. */
  careerYears?: Maybe<Scalars['Int']['output']>;
  /** The person death date precision */
  deathDatePrecision?: Maybe<DatePrecision>;
  /** The top four movie genres the person took part in. */
  topFourGenres?: Maybe<Array<Maybe<GenrePercentage>>>;
  /** Total awards */
  totalAwards: Scalars['Int']['output'];
  /** Total box office */
  totalBoxOffice?: Maybe<Scalars['Int']['output']>;
  /** Total of movies */
  totalMovies: Scalars['Int']['output'];
  /** Total nominations */
  totalNominations: Scalars['Int']['output'];
  /** Total of series */
  totalSeries: Scalars['Int']['output'];
};

/** An Allociné movie */
export type Movie = Node & {
  __typename?: 'Movie';
  /** The best affinities of the movie (based on the users, with social action (like it, seen it, etc...)). */
  affinities?: Maybe<AnalogyConnection>;
  /** The series' spotify albums */
  albums?: Maybe<Array<Maybe<Soundtrack>>>;
  backlink?: Maybe<Backlink>;
  /** The movie's boxoffice by week. */
  boxOffice?: Maybe<Array<Maybe<BoxOffice>>>;
  /** The people playing on this movie. */
  cast?: Maybe<CastMemberConnection>;
  /** The list of clubs related to this movie. */
  clubs?: Maybe<Array<Maybe<EntityClub>>>;
  /** The newest comments added on this movie, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The list of companies who worked in this production. */
  companies?: Maybe<Array<Maybe<MovieCompany>>>;
  /** The list of nationalities to which this movie is related to. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The people working on this movie. */
  credits?: Maybe<CreditsConnection>;
  /** Technical data about movies. */
  data?: Maybe<MovieData>;
  /** Reviews written by the website itself. */
  editorialReviews?: Maybe<Array<Maybe<EditorialReview>>>;
  /** An array of ExternalLink. */
  externalLinks?: Maybe<Array<Maybe<ExternalLink>>>;
  /** The festival editions the movie was selected in. */
  festivalEdition?: Maybe<FestivalEditionConnection>;
  /** Technical flags about movie to have rapid information */
  flags?: Maybe<MovieFlags>;
  /** Contains informations about the video and audio format of the movie. */
  format?: Maybe<MovieFormat>;
  /** The genres of the movies, extracted from the tags property. */
  genres?: Maybe<Array<Maybe<Genre>>>;
  /** The movie's global boxoffice for a country. */
  globalBoxOffice?: Maybe<GlobalBoxOffice>;
  /** The id of the movie. */
  id: Scalars['ID']['output'];
  /** The list of the images for this movie. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The total amount of images this movie has. */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** The internal id of the movie. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the movie */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The original language(s) of the movie. */
  languages?: Maybe<Array<Maybe<Language>>>;
  /** The main Movie Release according to the defined priorities. */
  mainRelease?: Maybe<MainReleaseInfo>;
  /** The list of the news related to this movie. */
  news?: Maybe<Array<Maybe<News>>>;
  /** The total amount of news this movie has. */
  newsCount?: Maybe<Scalars['Int']['output']>;
  /** Show special operations on movie. */
  operation?: Maybe<SpecialOperation>;
  /** The title of the movie in the language of the producing country. */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** The image of the movie. */
  poster?: Maybe<InternalImage>;
  /** The list of the press reviews of this Movie. */
  pressReviews?: Maybe<PressReviewsConnection>;
  /** The amount of theaters that will be playing this movie in the next floating weeks (number fixed by product). */
  productFloatingWeeksTheatersCount?: Maybe<Scalars['Int']['output']>;
  /**
   * !!!!! DEPRECATED !!!!! Use relatedProducts instead.
   * @deprecated Use relatedProducts instead
   */
  products?: Maybe<Array<Maybe<Product>>>;
  /** The products related to this movie. */
  relatedProducts?: Maybe<ProductsConnection>;
  /** The related tags of the movie. */
  relatedTags?: Maybe<Array<Tag>>;
  /** The list of movies/series/seasons/... this movie relates to. */
  relations?: Maybe<Array<Maybe<Relation>>>;
  releaseFlags?: Maybe<ReleaseFlags>;
  /** The list of the releases of this movie. */
  releases?: Maybe<Array<Maybe<MovieRelease>>>;
  /**
   * The duration of the movie (format: hh:mm:ss).
   * @deprecated Please use the 'runtime' field (which use the ISO 8601 format).
   */
  runTime?: Maybe<Scalars['Duration']['output']>;
  /** The duration of the movie (format: ISO 8601). */
  runtime?: Maybe<Scalars['DateInterval']['output']>;
  /** The selections the movie was selected in. */
  selection?: Maybe<FestivalSelectionConnection>;
  /**
   * !!!!! DEPRECATED !!!!! Use selection instead.
   * @deprecated Use selection instead
   */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
  /** Show all showtimes dates for this movie. */
  showtimesDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fixed similar entities. */
  similar?: Maybe<Array<Node>>;
  /** The best similarities of the movie (based on metas of movie (genre, actors, country, etc...)). */
  similarities?: Maybe<AnalogyConnection>;
  /**
   * The movie's spotify soundtracks
   * @deprecated No longer used. You need to get the real architecture on albums endpoint. Will be remove soon.
   */
  soundtracks?: Maybe<Soundtrack>;
  /** All stats about the movie. */
  stats?: Maybe<MovieStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the movie, can be short or long (short by default). */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the movie, on json format. */
  synopsis_json?: Maybe<BodyJson>;
  /** The tags of the movie */
  tags?: Maybe<TagCollection>;
  /** The amount of theaters that will play this movie, from now to the far future. */
  theatersCount?: Maybe<Scalars['Int']['output']>;
  /** The title of the movie. */
  title?: Maybe<Scalars['String']['output']>;
  /** The trivias of the movie. */
  trivias?: Maybe<TriviasConnection>;
  /**
   * The amount of theaters that will be playing this movie in the next floating weeks (number fixed by product).
   * @deprecated No longer used. Will be removed soon. Use productFloatingWeeksTheatersCount instead.
   */
  twoFloatingWeeksTheatersCount?: Maybe<Scalars['Int']['output']>;
  /** The type of the movie. */
  type?: Maybe<MovieType>;
  /** The update dates for this movie. */
  updatedAt?: Maybe<EntityUpdateDate>;
  userAffinity?: Maybe<MovieUserAffinity>;
  /** The list of the user reviews of this Movie. */
  userReviews?: Maybe<UserReviewsConnection>;
  /** The aggregated counts list of the user reviews of this Movie. */
  userReviewsCount?: Maybe<UserReviewCounts>;
  /** The list of videos related to this movie. */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The total amount of videos this movie has. */
  videosCount?: Maybe<Scalars['Int']['output']>;
  /** The amount of theaters that will be playing or have played this movie in the current week. */
  weeklyTheatersCount?: Maybe<Scalars['Int']['output']>;
};


/** An Allociné movie */
export type MovieAffinitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  released?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Array<InputMaybe<AnalogyType>>>;
  videoFilter?: InputMaybe<Array<InputMaybe<VideoType>>>;
  videoFilterOperator?: InputMaybe<Operator>;
};


/** An Allociné movie */
export type MovieAlbumsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SoundtrackSorting>>>;
};


/** An Allociné movie */
export type MovieBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};


/** An Allociné movie */
export type MovieBoxOfficeArgs = {
  country?: InputMaybe<CountryCode>;
  period?: InputMaybe<BoxOfficePeriod>;
  type: BoxOfficeType;
};


/** An Allociné movie */
export type MovieCastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  castActivity?: InputMaybe<CastActivity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné movie */
export type MovieCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné movie */
export type MovieCreditsArgs = {
  activity?: InputMaybe<PersonActivity>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné movie */
export type MovieFestivalEditionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<FilterDate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalEditionSorting>>>;
  startDate?: InputMaybe<FilterDate>;
};


/** An Allociné movie */
export type MovieGlobalBoxOfficeArgs = {
  idCountry: Scalars['Int']['input'];
};


/** An Allociné movie */
export type MovieImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
};


/** An Allociné movie */
export type MovieNewsArgs = {
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An Allociné movie */
export type MoviePressReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PressReviewsOrder>>;
};


/** An Allociné movie */
export type MovieProductFloatingWeeksTheatersCountArgs = {
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  location?: InputMaybe<CoordinateType>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An Allociné movie */
export type MovieProductsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
};


/** An Allociné movie */
export type MovieRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
};


/** An Allociné movie */
export type MovieReleasesArgs = {
  country?: InputMaybe<CountryCode>;
  filter?: InputMaybe<Array<InputMaybe<ReleaseMovieFilterType>>>;
  type?: InputMaybe<Array<InputMaybe<MovieReleaseType>>>;
};


/** An Allociné movie */
export type MovieSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné movie */
export type MovieSelectionsArgs = {
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné movie */
export type MovieShowtimesDatesArgs = {
  analyzer?: InputMaybe<Locale>;
  city?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comfort?: InputMaybe<Array<InputMaybe<Comfort>>>;
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  format?: InputMaybe<Array<InputMaybe<ProjectionFormat>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hasFutureReleaseSoon?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<CoordinateType>;
  loyaltyCard?: InputMaybe<Array<InputMaybe<LoyaltyCard>>>;
  picture?: InputMaybe<Array<InputMaybe<Picture>>>;
  projection?: InputMaybe<Array<InputMaybe<Projection>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Array<InputMaybe<TheaterService>>>;
  sound?: InputMaybe<Array<InputMaybe<Sound>>>;
  techno?: InputMaybe<Array<InputMaybe<TechnoFlag>>>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
};


/** An Allociné movie */
export type MovieSimilaritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<InputMaybe<AnalogyType>>>;
};


/** An Allociné movie */
export type MovieSynopsisArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné movie */
export type MovieTheatersCountArgs = {
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  location?: InputMaybe<CoordinateType>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An Allociné movie */
export type MovieTriviasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriviaSorting>>>;
};


/** An Allociné movie */
export type MovieTwoFloatingWeeksTheatersCountArgs = {
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  location?: InputMaybe<CoordinateType>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** An Allociné movie */
export type MovieUserReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  ratingList?: InputMaybe<Array<InputMaybe<ReviewRatingFloat>>>;
  sentiment?: InputMaybe<ReviewSentimentFilter>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An Allociné movie */
export type MovieUserReviewsCountArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
};


/** An Allociné movie */
export type MovieVideosArgs = {
  excludeTypes?: InputMaybe<Array<InputMaybe<VideoType>>>;
  externalVideo?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
};


/** An Allociné movie */
export type MovieWeeklyTheatersCountArgs = {
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  location?: InputMaybe<CoordinateType>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MovieByTheaterLeaf = {
  __typename?: 'MovieByTheaterLeaf';
  /** The movies broadcasted in the theater. */
  movie?: Maybe<Movie>;
};

export type MovieCompany = {
  __typename?: 'MovieCompany';
  /** The activity of the company. */
  activity?: Maybe<Scalars['String']['output']>;
  /** The company. */
  company?: Maybe<Company>;
  /** The rank of the company for this movie. */
  rank?: Maybe<Scalars['Int']['output']>;
};

/** Technical data about movies. */
export type MovieData = {
  __typename?: 'MovieData';
  /** List of alternative ids for the movie. */
  alternativeIds?: Maybe<EntityAlternativeIds>;
  /** Branded content information. */
  brandedContent?: Maybe<BrandedContent>;
  /** The money spent on this movie. It is expressed as a string with currency included. */
  budget?: Maybe<Scalars['String']['output']>;
  /** The universal unique identifier. */
  eidr?: Maybe<Scalars['String']['output']>;
  /** IMDb ID. */
  imdb?: Maybe<Scalars['String']['output']>;
  /** The international standard audiovisual number. */
  isan?: Maybe<Scalars['String']['output']>;
  /** German MoviePilot ID. */
  moviepilot?: Maybe<Scalars['String']['output']>;
  /** The year the movie was produced. */
  productionYear?: Maybe<Scalars['Int']['output']>;
  /** An advice of the redaction. */
  recommendation?: Maybe<Recommendation>;
  /** The rules of the movie. */
  rules?: Maybe<MovieRules>;
  /** Differents fields for seo purposes. */
  seo?: Maybe<Seo>;
};

/** Technical flags about movie to have rapid information */
export type MovieFlags = {
  __typename?: 'MovieFlags';
  /** True if the movie is coming soon on netflix. */
  comingSoonOnNetflix?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has some awards or nominations. */
  hasAwards?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if the movie has at least one news with tag 'club 300'.
   * @deprecated Use hasClubNews.club300 instead.
   */
  hasClub300News?: Maybe<Scalars['Boolean']['output']>;
  /** The list of clubs having a news related to the movie. */
  hasClubNews?: Maybe<Scalars['Json']['output']>;
  /** True if the movie has dvd release. */
  hasDvdRelease?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has at least one news. */
  hasNews?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has vod, svod or vodest. */
  hasOnlineProduct?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has vod release. */
  hasOnlineRelease?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has bluray or dvd. */
  hasPhysicalProduct?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has a preview at least in one theater. */
  hasPreview?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has future showtime. */
  hasShowtime?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has soundtrack. */
  hasSoundtrack?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has at least one related video of Teaser type. */
  hasTeaser?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie is outing in theater. */
  hasTheaterRelease?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has at least one related video of Teaser type. */
  hasTrailer?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has some trivia. */
  hasTrivia?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has vodest. */
  hasVodProduct?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if the movie is approved by the 'club 300'.
   * @deprecated Use isClubApproved.club300 instead.
   */
  isClub300Approved?: Maybe<Scalars['Boolean']['output']>;
  /** The list of clubs that approved the movie. */
  isClubApproved?: Maybe<Scalars['Json']['output']>;
  /** True if the movie is coming soon without release dates. */
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie is tagged by 'Incontestable'. */
  isIncontestable?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie is tagged by 'Art & Essai'. */
  isLesIndes?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie is played at least in one theater in the next 7 days. */
  isPlayingNow?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie is only on netflix. */
  onlyNetflix?: Maybe<Scalars['Boolean']['output']>;
  /** True if the movie has tv release. */
  tvRelease?: Maybe<Scalars['Boolean']['output']>;
};

export type MovieFlagsType = {
  /** Filter movies list that have an editorial review */
  has_editorial_review?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has a physical product. */
  has_physical_product?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have a preview */
  has_preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have a rerun release */
  has_rerun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has a soundtrack. */
  has_soundtrack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list that have at least one trailer or teaser */
  has_trailer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has some trivia. */
  has_trivia?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have at least one video */
  has_video?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided will list amazon prime's entities */
  is_amazon?: InputMaybe<Scalars['Boolean']['input']>;
  /** !!! Deprecated : Use is_club_approved flag instead !!! */
  is_club_300_approved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have been approved by a brand Club (Club300, Scream Club, etc.) */
  is_club_approved?: InputMaybe<EntityClubFlagType>;
  /** Filter movies list that have tag 'Art & Essai' */
  is_les_indes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains informations about the video and audio format of the movie. */
export type MovieFormat = {
  __typename?: 'MovieFormat';
  /** The aspect ratio of an image describes the proportional relationship between its width and its height. It is commonly expressed as two numbers separated by a colon, as in 16:9. */
  aspectRatios?: Maybe<Array<Maybe<AspectRatio>>>;
  /** The audio format of the movie. Can have multiple values. */
  audio?: Maybe<Array<Maybe<AudioFormat>>>;
  /** The color of the movie. */
  color?: Maybe<Color>;
  /** Film gauge is a physical property of photographic or motion picture film stock which defines its width. */
  filmGauges?: Maybe<Array<Maybe<FilmGauge>>>;
};

export type MovieRatingRules = {
  __typename?: 'MovieRatingRules';
  /** True if the movie is at risk. */
  at_risk?: Maybe<Scalars['Boolean']['output']>;
  /** True if enforce review from the user when rating entities */
  has_mandatory_review?: Maybe<Scalars['Boolean']['output']>;
  /** True if rating is displayable. */
  has_rating?: Maybe<Scalars['Boolean']['output']>;
  /** True if warning message is displayable. */
  has_warning_message?: Maybe<Scalars['Boolean']['output']>;
};

export enum MovieRecommendationAlgo {
  MovieRelease = 'MOVIE_RELEASE'
}

/** An Allociné release for a movie. */
export type MovieRelease = Node & ReleaseInterface & {
  __typename?: 'MovieRelease';
  /** An advice of the redaction. */
  advice?: Maybe<Scalars['String']['output']>;
  /** The area for this release */
  area?: Maybe<Scalars['String']['output']>;
  /** The official recommendation of CNC. */
  certificate?: Maybe<Certificate>;
  /** The list of companies who worked in this production. */
  companies: Array<EntityCompany>;
  /** The company for which this release is limited to. */
  companyLimitation?: Maybe<Company>;
  /** The country of the release. */
  country?: Maybe<Country>;
  /** Some data related to this release. */
  data?: Maybe<Scalars['Json']['output']>;
  /**
   * The date of the release.
   * @deprecated No longer used. Will be remove soon. Use releaseDate instead.
   */
  date?: Maybe<Scalars['DateLimited']['output']>;
  /** The id of the release. */
  id: Scalars['ID']['output'];
  /** The internal id of the release. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of the release.
   * @deprecated Please use the 'releaseTags' field instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The date of the release. */
  releaseDate?: Maybe<PartialDate>;
  releaseTags?: Maybe<ReleaseTag>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The Visa number for this release */
  visaNumber?: Maybe<Scalars['String']['output']>;
};


/** An Allociné release for a movie. */
export type MovieReleaseCompaniesArgs = {
  activity: Array<CompanyActivity>;
};

/** releaseFrom and releaseTo filters date types for a movie. */
export enum MovieReleaseDateFilterType {
  Theater = 'THEATER',
  Vod = 'VOD',
  VodFirstRelease = 'VOD_FIRST_RELEASE'
}

/** All differents releases for a movie. */
export enum MovieReleaseType {
  AvodRelease = 'AVOD_RELEASE',
  BluRayRelease = 'BLU_RAY_RELEASE',
  ComingSoon = 'COMING_SOON',
  /** @deprecated Use non-provider based types instead. */
  ComingSoonOnNetflix = 'COMING_SOON_ON_NETFLIX',
  ComingSoonTheater = 'COMING_SOON_THEATER',
  ComingSoonWithoutDate = 'COMING_SOON_WITHOUT_DATE',
  DirectToTv = 'DIRECT_TO_TV',
  DirectToVod = 'DIRECT_TO_VOD',
  DvdBdOfficialReleaseDate = 'DVD_BD_OFFICIAL_RELEASE_DATE',
  DvdRelease = 'DVD_RELEASE',
  Ecinema = 'ECINEMA',
  Filming = 'FILMING',
  HasTheaterRelease = 'HAS_THEATER_RELEASE',
  LimitedTheaterRelease = 'LIMITED_THEATER_RELEASE',
  NowPlaying = 'NOW_PLAYING',
  /** @deprecated Use non-provider based types instead. */
  OnlyOnCanalplay = 'ONLY_ON_CANALPLAY',
  /** @deprecated Use non-provider based types instead. */
  OnlyOnItunes = 'ONLY_ON_ITUNES',
  /** @deprecated Use non-provider based types instead. */
  OnlyOnNetflix = 'ONLY_ON_NETFLIX',
  /** @deprecated Use non-provider based types instead. */
  OnlyOnOcs = 'ONLY_ON_OCS',
  Outline = 'OUTLINE',
  PlatformTheaterRelease = 'PLATFORM_THEATER_RELEASE',
  PostProduction = 'POST_PRODUCTION',
  Released = 'RELEASED',
  ReReleased = 'RE_RELEASED',
  SpecialAdvanceScreening = 'SPECIAL_ADVANCE_SCREENING',
  SvodRelease = 'SVOD_RELEASE',
  VodestRelease = 'VODEST_RELEASE',
  VodRelease = 'VOD_RELEASE',
  VodReleaseWithProduct = 'VOD_RELEASE_WITH_PRODUCT'
}

export type MovieRules = {
  __typename?: 'MovieRules';
  /** Ruling linked to user reviews */
  rating?: Maybe<MovieRatingRules>;
};

/** Will get a movies and showtimes aggregation by selected theater. */
export type MovieShowtimeLeaf = {
  __typename?: 'MovieShowtimeLeaf';
  /** The movies broadcasted in the theater. */
  movie?: Maybe<Movie>;
  /** The showtimes screened for the movie. */
  showtimes?: Maybe<Array<Maybe<Showtime>>>;
};


/** Will get a movies and showtimes aggregation by selected theater. */
export type MovieShowtimeLeafShowtimesArgs = {
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
};

/** Sorting criteria for movies */
export enum MovieShowtimeSorting {
  /** No sort is applied. */
  None = 'NONE',
  /** Sort by weekly popularity descending. */
  Popularity = 'POPULARITY',
  /** Sort by release date of the movie. */
  ReleaseDate = 'RELEASE_DATE',
  /** Sort by release date of the movie descending. */
  ReverseReleaseDate = 'REVERSE_RELEASE_DATE'
}

/** Sorting criteria for movies */
export enum MovieSorting {
  /** Movies sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Movies sorted by popularity on a daily basis. */
  DailyPopularity = 'DAILY_POPULARITY',
  /** Movies sorted by their editorial rank, best rating on movies first. */
  Editorial = 'EDITORIAL',
  /** Movies sorted by their editorial review date, recent to oldest. */
  EditorialLatest = 'EDITORIAL_LATEST',
  /** Movies having a release with a past release date will be sorted first. */
  HasPastReleaseFirst = 'HAS_PAST_RELEASE_FIRST',
  /** Movies sorted by their first theatrical release dates, most recent releases first. */
  LatestFirstReleases = 'LATEST_FIRST_RELEASES',
  /** Movies sorted by their first DVD/BR release dates, most recent releases first. */
  LatestFirstReleasesPhysical = 'LATEST_FIRST_RELEASES_PHYSICAL',
  /** Movies sorted by their release dates, most recent releases first. */
  LatestReleases = 'LATEST_RELEASES',
  /** Movies sorted by their DVD/BR release dates, most recent releases first. */
  LatestReleasesPhysical = 'LATEST_RELEASES_PHYSICAL',
  /** Movies sorted by their VOD release dates, most recent releases first. */
  LatestReleasesVod = 'LATEST_RELEASES_VOD',
  /** Movies sorted by the most recent video (TEASER and TRAILER). */
  LatestTrailers = 'LATEST_TRAILERS',
  /** Movies sorted by popularity on a monthly basis. */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** Movies sorted by the amount of theaters playing them during the current week. */
  MostPlayingTheaters = 'MOST_PLAYING_THEATERS',
  /** No sort is applied. */
  None = 'NONE',
  /** Movies sorted by their first DVD/BR release dates, oldest releases first. */
  OldestFirstReleasesPhysical = 'OLDEST_FIRST_RELEASES_PHYSICAL',
  /** Movies sorted by their release dates, oldest releases first. */
  OldestReleases = 'OLDEST_RELEASES',
  /** Movies sorted by their DVD/BR release dates, oldest releases first. */
  OldestReleasesPhysical = 'OLDEST_RELEASES_PHYSICAL',
  /** Movies sorted by their VOD release dates, oldest releases first. */
  OldestReleasesVod = 'OLDEST_RELEASES_VOD',
  /** Movies sorted by their latest release dates, most recent releases first. */
  OrderLatestLastReleases = 'ORDER_LATEST_LAST_RELEASES',
  /** Movies sorted by their latest release dates, oldest releases first. */
  OrderOldestLastReleases = 'ORDER_OLDEST_LAST_RELEASES',
  /** Movies sorted by their press rank, best rating on movies first. */
  Press = 'PRESS',
  /** Movies sorted by popularity on a three-monthly basis. */
  QuarterlyPopularity = 'QUARTERLY_POPULARITY',
  /** Movies sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Movies sorted by their rank, best movies first. */
  Score = 'SCORE',
  /** Movies sorted by their rank, worst movies first. */
  ScoreWorst = 'SCORE_WORST',
  /** Movies sorted by the sum of the views on their video (TEASER and TRAILER). */
  VideosViewsCount = 'VIDEOS_VIEWS_COUNT',
  /** Movies sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** Some custom movie filters with complexs algorithms. */
export enum MovieSpecialFilter {
  /** Selects the best movies that are available in theaters. This algorithm is based on the amount of theaters on a given period. */
  BestPlaying = 'BEST_PLAYING'
}

/** All stats about the movie. */
export type MovieStats = {
  __typename?: 'MovieStats';
  commentsCount?: Maybe<Scalars['Int']['output']>;
  /** An array of metrics for a given entity. */
  metric?: Maybe<StatsMetric>;
  /** Stats about reviews given by the press. */
  pressReview?: Maybe<PressReviewsStats>;
  /** Stats about ratings given by the users. */
  userRating?: Maybe<UserRatingsStats>;
  /** Stats about reviews given by the users. Note that ratings related to reviews are already aggregated into the userRating field */
  userReview?: Maybe<UserReviewsStats>;
  wantToSeeCount: Scalars['Int']['output'];
};

/** User movie status. */
export enum MovieStatus {
  NotInterested = 'NOT_INTERESTED',
  Rating = 'RATING',
  Seen = 'SEEN',
  WantToSee = 'WANT_TO_SEE'
}

export enum MovieType {
  /** An anthology film is a subgenre of films consisting of several different short films, often tied together by only a single theme, premise, or brief interlocking event (often a turning point). Sometimes each one is directed by a different director. */
  AnthologyFilm = 'ANTHOLOGY_FILM',
  BrandContent = 'BRAND_CONTENT',
  Commercial = 'COMMERCIAL',
  Episode = 'EPISODE',
  /** A feature film is a film (also called a movie, motion picture or just film) with a running time long enough to be considered the principal or sole film to fill a program. */
  FeatureFilm = 'FEATURE_FILM',
  /** A medium length film is a film that has a running time of 30 to 59 minutes. In a lot of countries this term is not officially recognized. */
  MediumLengthFilm = 'MEDIUM_LENGTH_FILM',
  /** A serial, film serial, movie serial or chapter play, is a motion picture form popular during the first half of the 20th century, consisting of a series of short subjects exhibited in consecutive order at one theater, generally advancing weekly, until the series is completed. */
  Serial = 'SERIAL',
  /** A short film, is a cinema format, denoting any film not long enough to be considered a feature film. */
  ShortFilm = 'SHORT_FILM',
  SpecialEvent = 'SPECIAL_EVENT',
  /** A television film is a feature-length motion picture that is produced for, and originally distributed by or to, a television network, in contrast to theatrical films, which are made explicitly for initial showing in movie theaters. */
  TvMovie = 'TV_MOVIE'
}

/** Movie affinity score for current user. */
export type MovieUserAffinity = {
  __typename?: 'MovieUserAffinity';
  affinityScore?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Array<UserAffinityScoreReason>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addNotification?: Maybe<Notification>;
  /** To add a collection to/from user collections list. */
  addUserCollection?: Maybe<UserCollection>;
  /** To add elements into a collection. */
  addUserCollectionEntities?: Maybe<UserCollection>;
  /** To add a new friend to follow. */
  addUserFollowUser: Follow;
  /** To add a rating/review. */
  addUserOpinion: MutationOutput;
  /** To add a clicked social action (like Fan, SeenIt, WantToSee). */
  addUserSocialAction: Array<MutationOutput>;
  /** To add a theater to user theaters list. */
  addUserTheater?: Maybe<Theater>;
  /** To verify that a user rating is certified with a ticket. */
  certifyUserTicket: MutationOutput;
  /** To delete a collection to/from user collections list. */
  deleteUserCollection?: Maybe<UserCollection>;
  /** To delete elements from a collection. */
  deleteUserCollectionEntities?: Maybe<UserCollection>;
  /** To delete a new friend to follow. */
  deleteUserFollowUser: Follow;
  /** To delete a rating/review. */
  deleteUserOpinion: MutationOutput;
  /** To delete a clicked social action (like Fan, SeenIt, WantToSee). */
  deleteUserSocialAction: Array<MutationOutput>;
  /** To delete a theater from user theaters list. */
  deleteUserTheater?: Maybe<Theater>;
  /** To follow a user collection. */
  followUserCollection?: Maybe<UserCollection>;
  removeNotification?: Maybe<Notification>;
  /** To reorder user collection entities. */
  reorderUserCollectionEntities?: Maybe<UserCollection>;
  /** To add/update/delete activities from a user sharing preferences. */
  sendPreferences?: Maybe<UserSharingPreferences>;
  /** Define a social medias (AVATAR or BANNER) account to a user. */
  setUserSocialCustomization: User;
  /** To follow a user collection. */
  unfollowUserCollection?: Maybe<UserCollection>;
  /** To update a collection to/from user collections list. */
  updateUserCollection?: Maybe<UserCollection>;
  /** To update a rating/review. */
  updateUserOpinion: MutationOutput;
  /** Update social user preferences. */
  updateUserPreferences: User;
};


export type MutationAddNotificationArgs = {
  title: Scalars['String']['input'];
  type: NotificationType;
};


export type MutationAddUserCollectionArgs = {
  input: AddUserCollectionInput;
};


export type MutationAddUserCollectionEntitiesArgs = {
  input: UserCollectionEntitiesInput;
};


export type MutationAddUserFollowUserArgs = {
  input: UserFollowUserInput;
};


export type MutationAddUserOpinionArgs = {
  input: UserOpinionInput;
};


export type MutationAddUserSocialActionArgs = {
  input: UserSocialActionInput;
};


export type MutationAddUserTheaterArgs = {
  input: UserTheaterInput;
};


export type MutationCertifyUserTicketArgs = {
  input: UserTicketCertificationInput;
};


export type MutationDeleteUserCollectionArgs = {
  input: DeleteUserCollectionInput;
};


export type MutationDeleteUserCollectionEntitiesArgs = {
  input: UserCollectionEntitiesInput;
};


export type MutationDeleteUserFollowUserArgs = {
  input: UserFollowUserInput;
};


export type MutationDeleteUserOpinionArgs = {
  input: DeleteUserOpinionInput;
};


export type MutationDeleteUserSocialActionArgs = {
  input: UserSocialActionInput;
};


export type MutationDeleteUserTheaterArgs = {
  input: UserTheaterInput;
};


export type MutationFollowUserCollectionArgs = {
  input: FollowCollectionInput;
};


export type MutationRemoveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReorderUserCollectionEntitiesArgs = {
  input: UserCollectionReorderInput;
};


export type MutationSendPreferencesArgs = {
  input: UserSharingPreferencesInput;
};


export type MutationSetUserSocialCustomizationArgs = {
  input: UserSocialMediaInput;
};


export type MutationUnfollowUserCollectionArgs = {
  input: FollowCollectionInput;
};


export type MutationUpdateUserCollectionArgs = {
  input: UpdateUserCollectionInput;
};


export type MutationUpdateUserOpinionArgs = {
  input: UserOpinionInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input: UserPreferencesInput;
};

export type MutationOutput = {
  __typename?: 'MutationOutput';
  /** An entity on which the user interacted. */
  userEntityLeaf?: Maybe<UserEntityLeafInterface>;
};

/** An Allociné News. */
export type News = Node & {
  __typename?: 'News';
  /**
   * The name of the person who wrote the news.
   * @deprecated Use the 'authors' field instead.
   */
  author?: Maybe<Scalars['String']['output']>;
  /** The authors who wrote the news. */
  authors?: Maybe<AuthorByEntityListConnection>;
  /** The brand of the news. */
  brand?: Maybe<Brand>;
  /** The categories of the news. */
  categories?: Maybe<Array<Maybe<NewsCategory>>>;
  /** The newest comments added on this news, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** Technical data about news. */
  data?: Maybe<NewsData>;
  /** The long title of the news. */
  headline?: Maybe<Scalars['String']['output']>;
  /** The id of the news. */
  id: Scalars['ID']['output'];
  /** The internal id of the news. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the movie */
  keywords?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Show special operations on news. */
  operations?: Maybe<SpecialOperation>;
  /** The number of pages this news has. */
  pageCount?: Maybe<Scalars['Int']['output']>;
  /** The pages of the news. This is were the readable content is stored. */
  pages?: Maybe<Array<NewsPage>>;
  /** The image of the news. */
  picture?: Maybe<InternalImage>;
  /** The publication information. */
  publication?: Maybe<Publication>;
  /** The related entities of the news */
  relatedEntities?: Maybe<Array<Maybe<Node>>>;
  /** News that are related to the current one. Up to 10. */
  relatedNews?: Maybe<Array<Maybe<News>>>;
  /** The related tags of the news. */
  relatedTags?: Maybe<Array<Tag>>;
  /** The slides of the news. */
  slides?: Maybe<Array<NewsSlide>>;
  /** All stats about the news. */
  stats?: Maybe<NewsStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the news. */
  tags?: Maybe<TagCollection>;
  /** The short title of the news. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the news. */
  type?: Maybe<NewsType>;
  /** The universes of the news. */
  universes?: Maybe<Array<Maybe<NewsUniverse>>>;
  /** The date when the news was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An Allociné News. */
export type NewsAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné News. */
export type NewsCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné News. */
export type NewsPagesArgs = {
  number?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné News. */
export type NewsRelatedEntitiesArgs = {
  excludedTypes?: InputMaybe<Array<InputMaybe<NewsRelatedEntityTypes>>>;
  types?: InputMaybe<Array<InputMaybe<NewsRelatedEntityTypes>>>;
};


/** An Allociné News. */
export type NewsRelatedNewsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** An AlloCiné News Category. */
export enum NewsCategory {
  AmigosDeSensacine = 'AMIGOS_DE_SENSACINE',
  /** A category about news which were released elsewhere on the web. */
  AsSeenOnTheWeb = 'AS_SEEN_ON_THE_WEB',
  AsSeenOnTheWebFeature = 'AS_SEEN_ON_THE_WEB_FEATURE',
  Berlinale = 'BERLINALE',
  /** A category for box office news. */
  Business = 'BUSINESS',
  BusinessFeature = 'BUSINESS_FEATURE',
  /** A category for news about celebrities. */
  Celebrities = 'CELEBRITIES',
  CelebritiesFeature = 'CELEBRITIES_FEATURE',
  CelebritiesProject = 'CELEBRITIES_PROJECT',
  /** A category for news which are related to the Comic Con. */
  ComicCon = 'COMIC_CON',
  /** A category for news which are related to competitions and previews. */
  ConcursosYPreestrenos = 'CONCURSOS_Y_PREESTRENOS',
  DossiersCourtsMetrages = 'DOSSIERS_COURTS_METRAGES',
  DossierGalleriePhotoDie = 'DOSSIER_GALLERIE_PHOTO_DIE',
  DossierGalleriePhotoListenListenListen = 'DOSSIER_GALLERIE_PHOTO_LISTEN_LISTEN_LISTEN',
  DossierGalleriePhotoPortraitDeStarSeries = 'DOSSIER_GALLERIE_PHOTO_PORTRAIT_DE_STAR_SERIES',
  DossierGalleriePhotoTvTipps = 'DOSSIER_GALLERIE_PHOTO_TV_TIPPS',
  DvdBooks = 'DVD_BOOKS',
  EmissionsMags = 'EMISSIONS_MAGS',
  Features = 'FEATURES',
  /** A category for news related to festival awards and compatible with AMP. */
  FestivalsAmpAwards = 'FESTIVALS_AMP_AWARDS',
  /** A category for news related to festival awards. */
  FestivalsAwards = 'FESTIVALS_AWARDS',
  FestivalsAwardsFeature = 'FESTIVALS_AWARDS_FEATURE',
  FilmsAsSeenOnTheWeb = 'FILMS_AS_SEEN_ON_THE_WEB',
  FilmsInProduction = 'FILMS_IN_PRODUCTION',
  FilmsPeople = 'FILMS_PEOPLE',
  /** A category for news related to film trailers. */
  FilmsTrailerVideos = 'FILMS_TRAILER_VIDEOS',
  /** A category for news related to independant theaters. */
  Indie = 'INDIE',
  /** A category for news about unusual stuff. */
  Insolite = 'INSOLITE',
  /** A category for news related to interviews. */
  Interviews = 'INTERVIEWS',
  InterviewsFeature = 'INTERVIEWS_FEATURE',
  InterviewsSeries = 'INTERVIEWS_SERIES',
  Itunes = 'ITUNES',
  ListeGenerique = 'LISTE_GENERIQUE',
  /** A category for news about movies broadcasted on TV. */
  MoviesOnTv = 'MOVIES_ON_TV',
  MovieDidYouKnow = 'MOVIE_DID_YOU_KNOW',
  MovieEvent = 'MOVIE_EVENT',
  /** A category for news related to a movie launch. */
  MovieLaunch = 'MOVIE_LAUNCH',
  MovieLaunchFeature = 'MOVIE_LAUNCH_FEATURE',
  /** A category for news related to a movie. */
  MovieNews = 'MOVIE_NEWS',
  /** A category for news for national theater event. */
  NationalEventTheater = 'NATIONAL_EVENT_THEATER',
  NewsPhotos = 'NEWS_PHOTOS',
  /** A category for news related to soundtracks. */
  NewsSoundtrack = 'NEWS_SOUNDTRACK',
  /** A category for news about film making of. */
  NowFilming = 'NOW_FILMING',
  NowFilmingFeature = 'NOW_FILMING_FEATURE',
  OnTv = 'ON_TV',
  /** A category for news about videos selected by our team. */
  OurVideoPicks = 'OUR_VIDEO_PICKS',
  PersonalStuffMovie = 'PERSONAL_STUFF_MOVIE',
  PersonalStuffSeries = 'PERSONAL_STUFF_SERIES',
  Report = 'REPORT',
  RetrospectiveNews = 'RETROSPECTIVE_NEWS',
  SeriesAsSeenOnTheWeb = 'SERIES_AS_SEEN_ON_THE_WEB',
  SeriesDidYouKnow = 'SERIES_DID_YOU_KNOW',
  SeriesInProduction = 'SERIES_IN_PRODUCTION',
  SeriesNews = 'SERIES_NEWS',
  SeriesQuiz = 'SERIES_QUIZ',
  SeriesStreaming = 'SERIES_STREAMING',
  ShoppingBuyingGuides = 'SHOPPING_BUYING_GUIDES',
  ShoppingGoodDeals = 'SHOPPING_GOOD_DEALS',
  ShoppingTests = 'SHOPPING_TESTS',
  /** A category for news about short movies. */
  ShortFilms = 'SHORT_FILMS',
  /** A category for news about short movie videos. */
  ShortFilmsVideo = 'SHORT_FILMS_VIDEO',
  Streaming = 'STREAMING',
  Telerealite = 'TELEREALITE',
  TopsFlopsSeries = 'TOPS_FLOPS_SERIES',
  /** A category for news related to tv shows. */
  TvSeries = 'TV_SERIES',
  TvSeriesBusiness = 'TV_SERIES_BUSINESS',
  /** A category for news related to tv shows. */
  TvSeriesChannels = 'TV_SERIES_CHANNELS',
  TvSeriesFeatures = 'TV_SERIES_FEATURES',
  TvSeriesFeaturesBestOf = 'TV_SERIES_FEATURES_BEST_OF',
  TvSeriesFeaturesFocusOn = 'TV_SERIES_FEATURES_FOCUS_ON',
  TvSeriesFeaturesTalkBack = 'TV_SERIES_FEATURES_TALK_BACK',
  /** A category for news related to series being currently broadcasted. */
  TvSeriesFeaturesWhatSOn = 'TV_SERIES_FEATURES_WHAT_S_ON',
  /** A category for news about people who have played in a series a long time ago. */
  TvSeriesFeaturesWhereAreTheyNow = 'TV_SERIES_FEATURES_WHERE_ARE_THEY_NOW',
  TvSeriesFestivals = 'TV_SERIES_FESTIVALS',
  /** A category for news related to tv show interviews. */
  TvSeriesInterviews = 'TV_SERIES_INTERVIEWS',
  /** A category for news related to people playing in tv shows. */
  TvSeriesPeople = 'TV_SERIES_PEOPLE',
  /** A category for news about series press roundup. */
  TvSeriesPressRoundup = 'TV_SERIES_PRESS_ROUNDUP',
  /** A category for news about series statistics. */
  TvSeriesRatings = 'TV_SERIES_RATINGS',
  TvSeriesSpoilers = 'TV_SERIES_SPOILERS',
  TvSeriesTopFeatures = 'TV_SERIES_TOP_FEATURES',
  VideoBuzz = 'VIDEO_BUZZ',
  VideoGamesFeature = 'VIDEO_GAMES_FEATURE',
  /** A category for news about video games. */
  VideoGamesNews = 'VIDEO_GAMES_NEWS'
}

/** Technical data about news. */
export type NewsData = {
  __typename?: 'NewsData';
  /** Differents fields for seo purposes. */
  seo?: Maybe<SeoNews>;
  /** Differents fields for tracking purposes. */
  tracking?: Maybe<TrackingData>;
};

/** A page of a news, this is where the news content lives. */
export type NewsPage = {
  __typename?: 'NewsPage';
  /** The content of the page. */
  body?: Maybe<Scalars['String']['output']>;
  /** The content of the page on json format. */
  body_json?: Maybe<BodyJson>;
  /** The news this page belongs to. */
  news: News;
  /** The page number, from 1 to +Inf. */
  number: Scalars['Int']['output'];
  /** The title of the page. */
  title?: Maybe<Scalars['String']['output']>;
  /** The video attached to this news. This is the player that appears at the top of the news on the website. */
  video?: Maybe<Video>;
};

/** Available types for video entities. */
export enum NewsRelatedEntityTypes {
  Festival = 'FESTIVAL',
  FestivalEdition = 'FESTIVAL_EDITION',
  Movie = 'MOVIE',
  News = 'NEWS',
  Person = 'PERSON',
  Series = 'SERIES',
  SeriesEpisode = 'SERIES_EPISODE',
  SeriesSeason = 'SERIES_SEASON'
}

/** Related entities type on news. */
export enum NewsRelatedType {
  /** Filter news by related entities type movie. */
  Movie = 'MOVIE',
  /** Filter news by related entities type person. */
  Person = 'PERSON',
  /** Filter news by related entities type series. */
  Series = 'SERIES'
}

/** A slide of a news, this is where the news content lives. */
export type NewsSlide = {
  __typename?: 'NewsSlide';
  /** The content of the slide. */
  body?: Maybe<Scalars['String']['output']>;
  /** The content of the slide on json format. */
  body_json?: Maybe<BodyJson>;
  /** The image attached to this slide. */
  image?: Maybe<InternalImage>;
  /** The news this page belongs to. */
  news: News;
  /** The slide number, from 1 to +Inf. */
  number: Scalars['Int']['output'];
  /** The title of the slide. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Sorting criteria for news */
export enum NewsSorting {
  /** News sorted by shortTitle in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** News sorted by the popularity of the last day. */
  DailyPopularity = 'DAILY_POPULARITY',
  /** News are sorted by reverse edition date. */
  LatestEdition = 'LATEST_EDITION',
  /** News are sorted by reverse publication date. */
  LatestPublication = 'LATEST_PUBLICATION',
  /** News sorted by the popularity of the last month. */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** News sorted by shortTitle in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** News sorted by the popularity of the last three days. */
  ThreeDaysPopularity = 'THREE_DAYS_POPULARITY',
  /** News sorted by the popularity of the last week. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** All stats about the news. */
export type NewsStats = {
  __typename?: 'NewsStats';
  /** A list of metrics for a given entity. */
  metric?: Maybe<StatsMetric>;
};

/** All formats of Allocine news. */
export enum NewsType {
  /** This type is a global news type. */
  Actualite = 'ACTUALITE',
  /** This type represent news with different pages. */
  Diaporama = 'DIAPORAMA',
  /** This type represent a news with different pages witch has a video launch in autoplay. */
  Jukebox = 'JUKEBOX',
  /** This type represent an old news will be remove in perfect world. */
  OldFolder = 'OLD_FOLDER',
  /** This type represent a news with different videos in one page. */
  Playlist = 'PLAYLIST',
  /** The type represent a news with audio song. */
  Podcast = 'PODCAST'
}

/** An AlloCiné News Universes. */
export enum NewsUniverse {
  GenericIvoryCoast = 'GENERIC_IVORY_COAST',
  GenericShopping = 'GENERIC_SHOPPING',
  GenericTvactu = 'GENERIC_TVACTU',
  Movie = 'MOVIE',
  Person = 'PERSON',
  Series = 'SERIES',
  ShortFilm = 'SHORT_FILM',
  Soundtrack = 'SOUNDTRACK',
  Theater = 'THEATER',
  Video = 'VIDEO',
  VideoGame = 'VIDEO_GAME'
}

/** Fetches an object given its ID. */
export type Node = {
  id: Scalars['ID']['output'];
  stringValue?: Maybe<Scalars['String']['output']>;
};

/** Available types for generic node. */
export enum NodeType {
  /** An Allociné series or program episode. */
  Episode = 'EPISODE',
  /** An Allociné festival. */
  Festival = 'FESTIVAL',
  /** An Allociné festival edition. */
  Festivaledition = 'FESTIVALEDITION',
  /** An Allociné movie. */
  Movie = 'MOVIE',
  /** An Allociné News. */
  News = 'NEWS',
  /** An Allociné person. */
  Person = 'PERSON',
  /** An Allociné program. */
  Program = 'PROGRAM',
  /** An Allociné program episode. */
  Programepisode = 'PROGRAMEPISODE',
  /** An Allociné program season. */
  Programseason = 'PROGRAMSEASON',
  /** An Allociné series or program season. */
  Season = 'SEASON',
  /** An Allociné series. */
  Series = 'SERIES',
  /** An Allociné User */
  User = 'USER',
  /** An Allociné user review. */
  Userreview = 'USERREVIEW',
  /** An Allociné Video. */
  Video = 'VIDEO'
}

export enum NodeTypePressReviews {
  Movie = 'MOVIE',
  Series = 'SERIES'
}

export enum NodeTypeProducts {
  Episode = 'EPISODE',
  Movie = 'MOVIE',
  Season = 'SEASON',
  Series = 'SERIES'
}

export enum NodeTypeSoundtracks {
  Movie = 'MOVIE',
  Series = 'SERIES'
}

/** A social action done by a user. */
export type NotInterested = SocialActionInterface & {
  __typename?: 'NotInterested';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<NotificationType>;
};

export enum NotificationType {
  Error = 'ERROR',
  Information = 'INFORMATION'
}

export type OpeningHours = {
  __typename?: 'OpeningHours';
  beginHour?: Maybe<Scalars['String']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  endHour?: Maybe<Scalars['String']['output']>;
};

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

/** A opinion done by a user. */
export type Opinion = SocialActionInterface & {
  __typename?: 'Opinion';
  /** An Allociné user review. */
  content?: Maybe<OpinionReview>;
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A review done by a user. */
export type OpinionReview = {
  __typename?: 'OpinionReview';
  /** Whether the rating is certified or not. */
  certificationRating?: Maybe<CertificationRatingStatus>;
  /** The date when the review was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** If this opinion contains a review, this field give the number of users whom find this review helpful. */
  helpfulCount?: Maybe<Scalars['Int']['output']>;
  /** The rating, out of 10 by default, given by the user. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** The content of the review. */
  review?: Maybe<Scalars['String']['output']>;
  /** The status of the review. */
  status?: Maybe<ReviewStatus>;
  /** If this opinion contains a review, this field give the number of users whom find this review unhelpful. */
  unhelpfulCount?: Maybe<Scalars['Int']['output']>;
  /** The date when the review was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A review done by a user. */
export type OpinionReviewRatingArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A date can be partial, we return too its precision */
export type PartialDate = {
  __typename?: 'PartialDate';
  /** The date like it's formated in database */
  date?: Maybe<Scalars['String']['output']>;
  /** 3 values possible, day(YYYY-MM-DD), month(YYYY-MM) or year(YYYY) */
  precision?: Maybe<Scalars['String']['output']>;
};

/** An Allociné person */
export type Person = Node & {
  __typename?: 'Person';
  /** Some stats about the total amount of series/movies where the person appears in. */
  appearanceStats?: Maybe<PersonAppearanceStats>;
  backlink?: Maybe<Backlink>;
  /** The biography of this person, can be short or long (short by default). */
  biography?: Maybe<Scalars['String']['output']>;
  /** The biography of this person on json format. */
  biography_json?: Maybe<BodyJson>;
  /** The birth date of the person. */
  birthDate?: Maybe<Scalars['DateLimited']['output']>;
  /** The place of birth of the person. */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** The list of collobaration (order by number desc) */
  collaboration?: Maybe<PersonsCollaborationConnection>;
  /** The newest comments added on this person, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The list of nationalities to which this person is related to. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The cause of the death of the person. */
  deathCause?: Maybe<Scalars['String']['output']>;
  /** The birth date of the person. */
  deathDate?: Maybe<Scalars['DateLimited']['output']>;
  /** The place of death of the person. */
  deathPlace?: Maybe<Scalars['String']['output']>;
  /** The movies/series/programs this person took part in. */
  filmography?: Maybe<Array<Maybe<FilmographyEntry>>>;
  /** The movies/series/programs this person took part in. */
  filmographyPaginated?: Maybe<FilmographyConnection>;
  /** The stats of list movies/series/programs this person took part in. */
  filmographyStats?: Maybe<FilmographyStats>;
  /** The first name of the person. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The formal name of the person. */
  formalName?: Maybe<Scalars['String']['output']>;
  /** The gender of this person. */
  gender?: Maybe<Gender>;
  /** The id of the person */
  id: Scalars['ID']['output'];
  /** The list of the images for this person. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The total amount of images this person has. */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** The internal id of the person. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the person */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The last name of the person. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The last video related to the person if it exists, else the last movie related video (ordered by descending production date) */
  lastVideo?: Maybe<Video>;
  /** metadata about the person. */
  metadata?: Maybe<MetadataPerson>;
  /** The list of the news related to this movie. */
  news?: Maybe<Array<Maybe<News>>>;
  /** The total amount of news this movie has. */
  newsCount?: Maybe<Scalars['Int']['output']>;
  /** The nicknames of the person. */
  nicknames?: Maybe<Array<Maybe<PersonNickname>>>;
  /** The image of the person. */
  picture?: Maybe<InternalImage>;
  /** The known positions this person has occupied. Sorted by most frequent first. */
  positions?: Maybe<Array<Maybe<Position>>>;
  /** The related tags of the person. */
  relatedTags?: Maybe<Array<Tag>>;
  /** The selections the person was selected in. */
  selection?: Maybe<FestivalSelectionConnection>;
  /**
   * !!!!! DEPRECATED !!!!! Use selection instead.
   * @deprecated Use selection instead
   */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
  /** Differents fields for seo purposes. */
  seo?: Maybe<Seo>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the person */
  tags?: Maybe<TagCollection>;
  /**
   * The best movies for the person.
   * @deprecated Use Person.filmography or Person.filmographyPaginated instead
   */
  topMovies?: Maybe<MoviesConnection>;
  /**
   * The best series for the person.
   * @deprecated Use Person.filmography or Person.filmographyPaginated instead
   */
  topSeries?: Maybe<SeriesConnection>;
  /** The update dates for this person. */
  updatedAt?: Maybe<EntityUpdateDate>;
  /** The list of videos related to this person. */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The total amount of videos this person has. */
  videosCount?: Maybe<Scalars['Int']['output']>;
};


/** An Allociné person */
export type PersonAppearanceStatsArgs = {
  allActivities?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné person */
export type PersonBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};


/** An Allociné person */
export type PersonBiographyArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné person */
export type PersonCollaborationArgs = {
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné person */
export type PersonCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné person */
export type PersonFilmographyArgs = {
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  collapseTopFilmography?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<PositionDepartment>;
  entityStatus?: InputMaybe<Array<InputMaybe<FilmographyEntityStatus>>>;
  entityType?: InputMaybe<Array<InputMaybe<FilmographyEntityType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<FilmographyFlags>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FilmographySorting>>>;
  withEpisodes?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné person */
export type PersonFilmographyPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  collapseParent?: InputMaybe<Scalars['Boolean']['input']>;
  collapseTopFilmography?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<PositionDepartment>;
  entityStatus?: InputMaybe<Array<InputMaybe<FilmographyEntityStatus>>>;
  entityType?: InputMaybe<Array<InputMaybe<FilmographyEntityType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<FilmographyFlags>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FilmographySorting>>>;
  withEpisodes?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné person */
export type PersonImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
};


/** An Allociné person */
export type PersonNewsArgs = {
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
};


/** An Allociné person */
export type PersonSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};


/** An Allociné person */
export type PersonSelectionsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné person */
export type PersonTopMoviesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  releaseFlag?: InputMaybe<PersonMovieReleaseFlags>;
};


/** An Allociné person */
export type PersonTopSeriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné person */
export type PersonVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
};

export enum PersonActivity {
  ActingCoaching = 'ACTING_COACHING',
  ActionDirector = 'ACTION_DIRECTOR',
  Actor = 'ACTOR',
  AdaptedBy = 'ADAPTED_BY',
  AdditionalMusic = 'ADDITIONAL_MUSIC',
  AdditionalMusicComposer = 'ADDITIONAL_MUSIC_COMPOSER',
  AdjunctExecutiveDirector = 'ADJUNCT_EXECUTIVE_DIRECTOR',
  Agents = 'AGENTS',
  AirRecording = 'AIR_RECORDING',
  AnimalHandler = 'ANIMAL_HANDLER',
  Animatic = 'ANIMATIC',
  AnimationAndVisualEffectsSupervisor = 'ANIMATION_AND_VISUAL_EFFECTS_SUPERVISOR',
  AnimationStudio = 'ANIMATION_STUDIO',
  Animator = 'ANIMATOR',
  ArtisticConsultant = 'ARTISTIC_CONSULTANT',
  ArtisticProducer = 'ARTISTIC_PRODUCER',
  ArtDirector = 'ART_DIRECTOR',
  ArtSupervisor = 'ART_SUPERVISOR',
  AssistantCostumeDesigner = 'ASSISTANT_COSTUME_DESIGNER',
  AssistantDirector = 'ASSISTANT_DIRECTOR',
  AssistantEditor = 'ASSISTANT_EDITOR',
  AssistantFightChoreographer = 'ASSISTANT_FIGHT_CHOREOGRAPHER',
  AssistantProduction = 'ASSISTANT_PRODUCTION',
  AssistantProductionCoOrdinator = 'ASSISTANT_PRODUCTION_CO_ORDINATOR',
  AssistantSetDecorator = 'ASSISTANT_SET_DECORATOR',
  AssistantSetDresser = 'ASSISTANT_SET_DRESSER',
  AssistantStuntCoordinator = 'ASSISTANT_STUNT_COORDINATOR',
  AssistantTechnicalAdvisor = 'ASSISTANT_TECHNICAL_ADVISOR',
  AssistantToArtDirector = 'ASSISTANT_TO_ART_DIRECTOR',
  AssistantUnitManager = 'ASSISTANT_UNIT_MANAGER',
  AssociateEditor = 'ASSOCIATE_EDITOR',
  AssociateProducer = 'ASSOCIATE_PRODUCER',
  Author = 'AUTHOR',
  BasedOn = 'BASED_ON',
  BoomOperator = 'BOOM_OPERATOR',
  Businessman = 'BUSINESSMAN',
  BCamera = 'B_CAMERA',
  CameraAssistant = 'CAMERA_ASSISTANT',
  CameraOperator = 'CAMERA_OPERATOR',
  CastingDirector = 'CASTING_DIRECTOR',
  CastingDirectorChildren = 'CASTING_DIRECTOR_CHILDREN',
  CastingProducer = 'CASTING_PRODUCER',
  CgSupervisor = 'CG_SUPERVISOR',
  CharacterAnimationSupervisor = 'CHARACTER_ANIMATION_SUPERVISOR',
  CharacterEffects = 'CHARACTER_EFFECTS',
  CharacterGraphicCreation = 'CHARACTER_GRAPHIC_CREATION',
  CharacterPaintingSupervisor = 'CHARACTER_PAINTING_SUPERVISOR',
  CharacterSpecialEffects = 'CHARACTER_SPECIAL_EFFECTS',
  CharacterTechnicalDirector = 'CHARACTER_TECHNICAL_DIRECTOR',
  ChildrenSCoach = 'CHILDREN_S_COACH',
  Choreographer = 'CHOREOGRAPHER',
  CollaborationToTheScenario = 'COLLABORATION_TO_THE_SCENARIO',
  Colorist = 'COLORIST',
  CompositingSupervisor = 'COMPOSITING_SUPERVISOR',
  ConceptArtist = 'CONCEPT_ARTIST',
  Consultant = 'CONSULTANT',
  CostumeDesigner = 'COSTUME_DESIGNER',
  CostumeSupervisor = 'COSTUME_SUPERVISOR',
  CoDirector = 'CO_DIRECTOR',
  CoProducer = 'CO_PRODUCER',
  CoProduction = 'CO_PRODUCTION',
  CoScreenwriter = 'CO_SCREENWRITER',
  Creator = 'CREATOR',
  CreatorShowrunner = 'CREATOR_SHOWRUNNER',
  Crowd = 'CROWD',
  Dancer = 'DANCER',
  DialogueCoach = 'DIALOGUE_COACH',
  DialogueEditor = 'DIALOGUE_EDITOR',
  DialogueEditorSupervisor = 'DIALOGUE_EDITOR_SUPERVISOR',
  DialogueWriter = 'DIALOGUE_WRITER',
  DigitalEffects = 'DIGITAL_EFFECTS',
  Director = 'DIRECTOR',
  DirectorOfCommunications = 'DIRECTOR_OF_COMMUNICATIONS',
  DirectorOfPhotography = 'DIRECTOR_OF_PHOTOGRAPHY',
  DirectorOfPhotographyAssistant = 'DIRECTOR_OF_PHOTOGRAPHY_ASSISTANT',
  DistributionCompanies = 'DISTRIBUTION_COMPANIES',
  DistributionCoordination = 'DISTRIBUTION_COORDINATION',
  DubbingAssistant = 'DUBBING_ASSISTANT',
  Editor = 'EDITOR',
  EditorInChief = 'EDITOR_IN_CHIEF',
  Electricians = 'ELECTRICIANS',
  ExecutiveCoProducer = 'EXECUTIVE_CO_PRODUCER',
  ExecutiveDirector = 'EXECUTIVE_DIRECTOR',
  ExecutiveProducer = 'EXECUTIVE_PRODUCER',
  ExecutiveProducerCompanies = 'EXECUTIVE_PRODUCER_COMPANIES',
  Explorer = 'EXPLORER',
  ExtrasCasting = 'EXTRAS_CASTING',
  FightChoreographer = 'FIGHT_CHOREOGRAPHER',
  FightCoordinator = 'FIGHT_COORDINATOR',
  FilmExhibitor = 'FILM_EXHIBITOR',
  FilmPosterBy = 'FILM_POSTER_BY',
  FirstAssistantDirector = 'FIRST_ASSISTANT_DIRECTOR',
  FirstCameraAssistant = 'FIRST_CAMERA_ASSISTANT',
  FoleyArtist = 'FOLEY_ARTIST',
  FoleyEditor = 'FOLEY_EDITOR',
  FoleyRecordist = 'FOLEY_RECORDIST',
  ForeignDistributor = 'FOREIGN_DISTRIBUTOR',
  FrenchDisributor = 'FRENCH_DISRIBUTOR',
  Gaffer = 'GAFFER',
  Gagman = 'GAGMAN',
  GeneralRepresentative = 'GENERAL_REPRESENTATIVE',
  GraphicDesigner = 'GRAPHIC_DESIGNER',
  Hair = 'HAIR',
  HairdresserSupervisor = 'HAIRDRESSER_SUPERVISOR',
  HeadCostumer = 'HEAD_COSTUMER',
  Illustrator = 'ILLUSTRATOR',
  InternationalDistributionExports = 'INTERNATIONAL_DISTRIBUTION_EXPORTS',
  Intertitles = 'INTERTITLES',
  Journalist = 'JOURNALIST',
  KeyGrip = 'KEY_GRIP',
  Lawyer = 'LAWYER',
  Layout = 'LAYOUT',
  LayoutSupervisor = 'LAYOUT_SUPERVISOR',
  LeadMan = 'LEAD_MAN',
  LegalAdvisor = 'LEGAL_ADVISOR',
  Lighting = 'LIGHTING',
  LightingDirector = 'LIGHTING_DIRECTOR',
  LineProducer = 'LINE_PRODUCER',
  LocationAssistantAssistant = 'LOCATION_ASSISTANT_ASSISTANT',
  LocationManager = 'LOCATION_MANAGER',
  LocationScout = 'LOCATION_SCOUT',
  Lyricist = 'LYRICIST',
  MakeUp = 'MAKE_UP',
  MakeUpAssistant = 'MAKE_UP_ASSISTANT',
  MakeUpSupervisor = 'MAKE_UP_SUPERVISOR',
  MakeUpVisualEffects = 'MAKE_UP_VISUAL_EFFECTS',
  MakingOfBy = 'MAKING_OF_BY',
  MattePainter = 'MATTE_PAINTER',
  Modelling = 'MODELLING',
  ModelMaker = 'MODEL_MAKER',
  MusicalConsultant = 'MUSICAL_CONSULTANT',
  MusicalSupervisor = 'MUSICAL_SUPERVISOR',
  MusicalSupervisorCompanies = 'MUSICAL_SUPERVISOR_COMPANIES',
  Musician = 'MUSICIAN',
  MusicComposer = 'MUSIC_COMPOSER',
  MusicComposerThemeSong = 'MUSIC_COMPOSER_THEME_SONG',
  MusicCoordinator = 'MUSIC_COORDINATOR',
  MusicEditor = 'MUSIC_EDITOR',
  MusicMixing = 'MUSIC_MIXING',
  MusicProducer = 'MUSIC_PRODUCER',
  NetworkServiceProvider = 'NETWORK_SERVICE_PROVIDER',
  None = 'NONE',
  OriginalCharactersBy = 'ORIGINAL_CHARACTERS_BY',
  OriginalCompositionBy = 'ORIGINAL_COMPOSITION_BY',
  OriginalIdea = 'ORIGINAL_IDEA',
  OriginalScriptBy = 'ORIGINAL_SCRIPT_BY',
  Painter = 'PAINTER',
  Photographer = 'PHOTOGRAPHER',
  PictureRestoration = 'PICTURE_RESTORATION',
  Poet = 'POET',
  Politician = 'POLITICIAN',
  PostProduction = 'POST_PRODUCTION',
  PostProductionCoordinator = 'POST_PRODUCTION_COORDINATOR',
  PostProductionDirector = 'POST_PRODUCTION_DIRECTOR',
  PostProductionProducer = 'POST_PRODUCTION_PRODUCER',
  PostProductionSupervisor = 'POST_PRODUCTION_SUPERVISOR',
  Presenter = 'PRESENTER',
  PressAgent = 'PRESS_AGENT',
  Producer = 'PRODUCER',
  Production = 'PRODUCTION',
  ProductionAdministrator = 'PRODUCTION_ADMINISTRATOR',
  ProductionAssistant = 'PRODUCTION_ASSISTANT',
  ProductionCoordinator = 'PRODUCTION_COORDINATOR',
  ProductionCoordinatorDirector = 'PRODUCTION_COORDINATOR_DIRECTOR',
  ProductionCoOrdinator = 'PRODUCTION_CO_ORDINATOR',
  ProductionCrew = 'PRODUCTION_CREW',
  ProductionDesigner = 'PRODUCTION_DESIGNER',
  ProductionDirector = 'PRODUCTION_DIRECTOR',
  ProductionManager = 'PRODUCTION_MANAGER',
  ProductionSecretary = 'PRODUCTION_SECRETARY',
  ProductionSupervisor = 'PRODUCTION_SUPERVISOR',
  ProductionSupervisorManager = 'PRODUCTION_SUPERVISOR_MANAGER',
  PropMaster = 'PROP_MASTER',
  PropWrangler = 'PROP_WRANGLER',
  PrAgencyCompanies = 'PR_AGENCY_COMPANIES',
  Psychiatrist = 'PSYCHIATRIST',
  PublicRelations = 'PUBLIC_RELATIONS',
  Puppeteer = 'PUPPETEER',
  Research = 'RESEARCH',
  SalesAgent = 'SALES_AGENT',
  ScanningLaser3D = 'SCANNING_LASER3D',
  Scientist = 'SCIENTIST',
  Screenwriter = 'SCREENWRITER',
  Script = 'SCRIPT',
  SecondAssistantDirector = 'SECOND_ASSISTANT_DIRECTOR',
  SecondCameraAssistant = 'SECOND_CAMERA_ASSISTANT',
  SecondUnitCinematographer = 'SECOND_UNIT_CINEMATOGRAPHER',
  SecondUnitDirector = 'SECOND_UNIT_DIRECTOR',
  SecondUnitStuntCoordinator = 'SECOND_UNIT_STUNT_COORDINATOR',
  SetDecorator = 'SET_DECORATOR',
  SetDecoratorAssembler = 'SET_DECORATOR_ASSEMBLER',
  SetDecoratorChef = 'SET_DECORATOR_CHEF',
  SetInColor = 'SET_IN_COLOR',
  Showrunner = 'SHOWRUNNER',
  Singer = 'SINGER',
  SingerSongsFromTheFilmFrenchVersion = 'SINGER_SONGS_FROM_THE_FILM_FRENCH_VERSION',
  SoundAssistant = 'SOUND_ASSISTANT',
  SoundCreation = 'SOUND_CREATION',
  SoundDesign = 'SOUND_DESIGN',
  SoundDesigner = 'SOUND_DESIGNER',
  SoundEditor = 'SOUND_EDITOR',
  SoundEditorCompanies = 'SOUND_EDITOR_COMPANIES',
  SoundEffectsEditor = 'SOUND_EFFECTS_EDITOR',
  SoundEffectsEngineer = 'SOUND_EFFECTS_ENGINEER',
  SoundEngineer = 'SOUND_ENGINEER',
  SoundMixing = 'SOUND_MIXING',
  SoundRestoration = 'SOUND_RESTORATION',
  SpecialEffects = 'SPECIAL_EFFECTS',
  SpecialEffects_2D = 'SPECIAL_EFFECTS_2D',
  SpecialEffectsCompanies = 'SPECIAL_EFFECTS_COMPANIES',
  Sportsman = 'SPORTSMAN',
  SportsCoach = 'SPORTS_COACH',
  Stagehand = 'STAGEHAND',
  StereographicAnimation = 'STEREOGRAPHIC_ANIMATION',
  StereoscopicSupervisor = 'STEREOSCOPIC_SUPERVISOR',
  StillsPhotographer = 'STILLS_PHOTOGRAPHER',
  Story = 'STORY',
  StoryboardArtist = 'STORYBOARD_ARTIST',
  StoryEditor = 'STORY_EDITOR',
  Stunts = 'STUNTS',
  StuntsRigger = 'STUNTS_RIGGER',
  StuntCoordinator = 'STUNT_COORDINATOR',
  StuntCoordinatorChef = 'STUNT_COORDINATOR_CHEF',
  Stylist = 'STYLIST',
  SubmarinePhotography = 'SUBMARINE_PHOTOGRAPHY',
  Subtitles = 'SUBTITLES',
  Supervisor_3D = 'SUPERVISOR_3D',
  SupportAdditionalLocationAssistant = 'SUPPORT_ADDITIONAL_LOCATION_ASSISTANT',
  SupportAdditionalLocationAssistantChef = 'SUPPORT_ADDITIONAL_LOCATION_ASSISTANT_CHEF',
  Tamer = 'TAMER',
  TechnicalAdvisor = 'TECHNICAL_ADVISOR',
  TechnicalDirector = 'TECHNICAL_DIRECTOR',
  TechnicalSupervisor = 'TECHNICAL_SUPERVISOR',
  Texturing = 'TEXTURING',
  ThemeSongPerformer = 'THEME_SONG_PERFORMER',
  ThirdAssistantDirector = 'THIRD_ASSISTANT_DIRECTOR',
  TitleSequenceDesigner = 'TITLE_SEQUENCE_DESIGNER',
  TitleSoundtrack = 'TITLE_SOUNDTRACK',
  TvChannel = 'TV_CHANNEL',
  TvProducer = 'TV_PRODUCER',
  UnitManager = 'UNIT_MANAGER',
  UnknownCredits = 'UNKNOWN_CREDITS',
  VideoProvider = 'VIDEO_PROVIDER',
  VisualDevelopment = 'VISUAL_DEVELOPMENT',
  VisualEffects = 'VISUAL_EFFECTS',
  VisualEffectsCinematographer = 'VISUAL_EFFECTS_CINEMATOGRAPHER',
  VisualEffectsCoordinator = 'VISUAL_EFFECTS_COORDINATOR',
  VisualEffectsDirector = 'VISUAL_EFFECTS_DIRECTOR',
  VisualEffectsEditor = 'VISUAL_EFFECTS_EDITOR',
  VisualEffectsSupervisor = 'VISUAL_EFFECTS_SUPERVISOR',
  VisualEffectsSupervisorProduction = 'VISUAL_EFFECTS_SUPERVISOR_PRODUCTION',
  VoiceCoaching = 'VOICE_COACHING',
  Wardrobe = 'WARDROBE',
  WeaponsMaster = 'WEAPONS_MASTER',
  WildlifePhotography = 'WILDLIFE_PHOTOGRAPHY',
  WritingDirector = 'WRITING_DIRECTOR',
  Yelmo = 'YELMO'
}

/** List of stats about person's appearance in each types of content. */
export type PersonAppearanceStats = {
  __typename?: 'PersonAppearanceStats';
  /** Total of appearances in a movie. */
  totalMovies: Scalars['Int']['output'];
  /** Total of appearances in a series. */
  totalSeries: Scalars['Int']['output'];
};

/** All persons and entities related aggregated by selected person. */
export type PersonCollaboration = {
  __typename?: 'PersonCollaboration';
  /** The list of entities (movie or series) where the collaboration took place. */
  entities?: Maybe<Array<Node>>;
  /** A person who worked with the current person. */
  person: Person;
  /** The number of collaboration. */
  totalCollaboration: Scalars['Int']['output'];
};

export enum PersonMovieReleaseFlags {
  /** Retrieve all movies */
  All = 'ALL',
  /** Retrieve all movies currently in theaters */
  InTheaters = 'IN_THEATERS',
  /** Retrieve all movies to be released in the future */
  Upcoming = 'UPCOMING'
}

/** A nickname of a person. */
export type PersonNickname = {
  __typename?: 'PersonNickname';
  /** The gender of this person. */
  gender?: Maybe<Gender>;
  /** The nickname of the person. */
  nickname?: Maybe<Scalars['String']['output']>;
};

/** Sorting criteria for person */
export enum PersonSorting {
  /** Persons sorted by popularity on a all time basis. */
  AllTimePopularity = 'ALL_TIME_POPULARITY',
  /** Persons sorted by 'first_name._.last_name' in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Persons sorted by popularity on a daily basis. */
  DailyPopularity = 'DAILY_POPULARITY',
  /** Persons sorted by latest image updated. */
  LastImageUpdated = 'LAST_IMAGE_UPDATED',
  /** No sort is applied. */
  None = 'NONE',
  /** Persons sorted by popularity on a monthly basis. */
  OrderMonthlyPopularity = 'ORDER_MONTHLY_POPULARITY',
  /** Persons sorted by 'first_name._.last_name' in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Persons sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

export type PhysicalProductFacet = FacetValue & {
  __typename?: 'PhysicalProductFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** Physical product which type match. That facet type cannot be ordered. */
  product?: Maybe<PhysicalProductFacetType>;
};

export type PhysicalProductFacetType = {
  __typename?: 'PhysicalProductFacetType';
  /** The physical product genre name. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum PhysicalProductType {
  BluRay = 'BLU_RAY',
  Dvd = 'DVD',
  Global = 'GLOBAL'
}

/** All picture formats. */
export enum Picture {
  Laser = 'LASER',
  P_70Mm = 'P_70MM',
  RealD = 'REAL_D'
}

export type PictureFacet = FacetValue & {
  __typename?: 'PictureFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

export type Position = {
  __typename?: 'Position';
  /** The department related to the position. */
  department?: Maybe<PositionDepartment>;
  /** The position name. */
  name?: Maybe<PersonActivity>;
};

export enum PositionDepartment {
  /** Persons that play in the series/movie. */
  Acting = 'ACTING',
  /** Persons representing a company. */
  Companies = 'COMPANIES',
  /** Persons that were part of the technical film crew. */
  Crew = 'CREW',
  /** Persons that directed the series/movie (Showrunner, Director...). */
  Direction = 'DIRECTION',
  /** Persons that distributed the series/movie. */
  Distribution = 'DISTRIBUTION',
  /** Persons that worked on the soundtrack. */
  MusicDepartment = 'MUSIC_DEPARTMENT',
  /** Persons that did uncategorizable things. */
  Others = 'OTHERS',
  /** Persons that procuded the series/movie. */
  ProductionDepartment = 'PRODUCTION_DEPARTMENT',
  /** Persons that took part in the creation of the story. */
  Storyline = 'STORYLINE',
  /** Persons that did uncategorizable things. */
  Unknown = 'UNKNOWN'
}

/** An Allociné press review. */
export type PressReview = Node & {
  __typename?: 'PressReview';
  /** The author name of the press review. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** The body text of the press review. */
  body?: Maybe<Scalars['String']['output']>;
  /** The body of the press review on json format. */
  body_json?: Maybe<BodyJson>;
  /** The company to which the press review is related to. */
  company?: Maybe<Company>;
  /** The id of the press review. */
  id: Scalars['ID']['output'];
  /** The internal id of the press review. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The rating of the press review. */
  rating?: Maybe<Scalars['Rating']['output']>;
  /** The related entity of the review (Series or Movie) */
  relatedEntity?: Maybe<Node>;
  /** The short body text of the press review. */
  shortBody?: Maybe<Scalars['String']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The URL of the press review. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Sorting reviews */
export enum PressReviewsOrder {
  /** Reviews ordered by company name asc. */
  CompanyName = 'COMPANY_NAME',
  /** Reviews ordered by creation_date desc. */
  CreatedAt = 'CREATED_AT',
  /** Reviews ordered by rating desc. */
  Note = 'NOTE',
  /** Reviews ordered by company name desc. */
  ReverseCompanyName = 'REVERSE_COMPANY_NAME',
  /** Reviews ordered by creation_date asc. */
  ReverseCreatedAt = 'REVERSE_CREATED_AT',
  /** Reviews ordered by rating asc. */
  ReverseNote = 'REVERSE_NOTE'
}

/** Aggregated press statistics, used for statistical purpose. */
export type PressReviewsStats = {
  __typename?: 'PressReviewsStats';
  /** The amount of ratings for a given score range (default from min to max). */
  count?: Maybe<Scalars['Int']['output']>;
  /** The score given by the press. */
  score?: Maybe<Scalars['Float']['output']>;
};


/** Aggregated press statistics, used for statistical purpose. */
export type PressReviewsStatsScoreArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
};

/** An Allociné product */
export type Product = Node & {
  __typename?: 'Product';
  /** A localized text explaining what the product includes. */
  content?: Maybe<Scalars['String']['output']>;
  /** The country the product is available in. */
  country?: Maybe<Country>;
  /** Additional data about the product. */
  data?: Maybe<ProductData>;
  /** The video's quality. */
  definition?: Maybe<ProductQuality>;
  /** Some informations about audio and video format. */
  format?: Maybe<ProductFormat>;
  /** The id of the product. */
  id: Scalars['ID']['output'];
  /** The image used to represent this product. The source can be external. In that case the image will not be editable on the fly. */
  image?: Maybe<Image>;
  /** The internal id of the product. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The language(s) of the product. */
  languages?: Maybe<Array<Maybe<Language>>>;
  /** The name of the product */
  name?: Maybe<Scalars['String']['output']>;
  /** A list of Allocine product offer. */
  offers?: Maybe<Array<Maybe<ProductOffer>>>;
  /** The related entities of the product */
  relatedEntities?: Maybe<Array<Node>>;
  /** The date at which the product was released. */
  releasedAt?: Maybe<Scalars['DateLimited']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the product */
  tags?: Maybe<TagCollection>;
  /** The type of the product (blu-ray, dvd...) */
  type?: Maybe<ProductType>;
};


/** An Allociné product */
export type ProductRelatedEntitiesArgs = {
  type?: InputMaybe<Array<NodeTypeProducts>>;
};

/** Various additional informations about a product. */
export type ProductData = {
  __typename?: 'ProductData';
  /** If the product is a dvd, tells its region. */
  dvdRegion?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The EAN code (European Article Number) for the product. */
  eanCode?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The name of the editor of the product. */
  editor?: Maybe<Scalars['String']['output']>;
  /** Technical data about the product, like the number of discs, the recommended age for users, etc... */
  specification?: Maybe<Scalars['String']['output']>;
};

/** Format informations about a product. */
export type ProductFormat = {
  __typename?: 'ProductFormat';
  /** The audio format of the product. */
  audio?: Maybe<Scalars['String']['output']>;
  /** The subtitles available for the product (if applicable). */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The video format of the product. */
  video?: Maybe<Scalars['String']['output']>;
};

/** An Allocine product offer. */
export type ProductOffer = {
  __typename?: 'ProductOffer';
  /** The company which make the offer. */
  company?: Maybe<Company>;
  /** The country in which is the offer. */
  country?: Maybe<Country>;
  /** The currency in which is the price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The price with it currency. */
  displayPrice?: Maybe<Scalars['String']['output']>;
  /** The price of the offer. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The product(BR, DVD, VOD) related to this offer. */
  product?: Maybe<Product>;
  /** The url of the offer. */
  url?: Maybe<Scalars['String']['output']>;
};

/** All product's qualities. */
export enum ProductQuality {
  /** High definition (1080 px) */
  Fhd = 'FHD',
  /** Ultra high definition (4000 px). */
  F_4K = 'F_4K',
  /** The lowest high definition (720 px) */
  HighDefinition = 'HighDefinition',
  /** A vertical resolution of 576 px with a horizontal resolution of 768, 720 or 704 px. */
  P_576 = 'P_576',
  /** High definition (1080 px) */
  P_1080 = 'P_1080',
  /** Very high definition (2160 px) */
  P_2160 = 'P_2160',
  /** Simple definition (480 px) */
  Standard = 'Standard'
}

/** Sorting criteria for products */
export enum ProductSorting {
  /** Products sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Products sorted by release date with the newer products first. */
  Latest = 'LATEST',
  /** Products sorted by offers lowest price first. */
  MinPrice = 'MIN_PRICE',
  /** Products sorted by release date with the older products first. */
  Oldest = 'OLDEST',
  /** Products sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL'
}

/** All formats of product. */
export enum ProductType {
  /** Advertising video on demand (AVOD) is a type of service that allows users to watch videos for free but in exchange for watching ads. */
  Avod = 'AVOD',
  /** Blu-ray or Blu-ray Disc (BD) is a digital optical disc data storage format. It was designed to supersede the DVD format, in that it is capable of storing high-definition (720p and 1080p) and ultra high-definition video resolution (2160p). */
  BluRay = 'BLU_RAY',
  /** VD (an abbreviation of "digital versatile disc"[4][5] or "digital video disc"[6]) is a digital optical disc storage format invented and developed by Panasonic, Philips, Sony and Toshiba in 1995. */
  Dvd = 'DVD',
  /** This represent a poster (a picture) product. */
  Poster = 'POSTER',
  /** Replay services allow the user to watch movie or series in streaming without any subscription. */
  Replay = 'REPLAY',
  /** Subscription VOD (SVOD) services use a subscription business model, where subscribers are charged a monthly fee to access unlimited programs. */
  Svod = 'SVOD',
  /** Transactional video on demand (TVOD) is a distribution method by which customers pay for each individual piece of video on demand content. */
  Tvod = 'TVOD',
  /** Video on demand (display) (VOD) are systems which allow users to select and watch/listen to video or audio content such as movies and TV shows when they choose to, rather than having to watch at a specific broadcast time. */
  Vod = 'VOD',
  /** Video on demand electronic sales through (VODEST) which allow users to buy the video definitively. */
  Vodest = 'VODEST'
}

/** An Allocine User Profile. */
export type Profile = {
  __typename?: 'Profile';
  /**
   * !!!!! DEPRECATED !!!!! Use mainAvatar instead.
   * @deprecated Use mainAvatar instead.
   */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The birth date of the user. */
  birthDate?: Maybe<Scalars['DateLimited']['output']>;
  /** Check if CGU are validated */
  isCguValidated?: Maybe<Scalars['Boolean']['output']>;
  /** Email has been validated by the user. */
  isEmailValidated?: Maybe<Scalars['Boolean']['output']>;
};

/** An Allociné program. */
export type Program = Node & {
  __typename?: 'Program';
  /** The newest comments added on this program, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The number of episodes existing in database */
  computedEpisodeCount?: Maybe<Scalars['Int']['output']>;
  /** The number of seasons existing in database */
  computedSeasonCount?: Maybe<Scalars['Int']['output']>;
  /** The cover of the program */
  cover?: Maybe<InternalImage>;
  /** The people working on this program. */
  credits?: Maybe<Array<Maybe<CreditsMember>>>;
  /** The number of known episodes (existing and coming). */
  episodeCount?: Maybe<Scalars['Int']['output']>;
  /** The usual length of an episode. Special episodes can be shorter/longer. */
  episodeLength?: Maybe<Scalars['Duration']['output']>;
  /** The id of the program. */
  id: Scalars['ID']['output'];
  /** The internal id of the program. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the program. */
  keywords?: Maybe<Scalars['String']['output']>;
  /** Informations about the first broadcast of the program. */
  originalBroadcast?: Maybe<ProgramOriginalBroadcast>;
  /** The original title of the program. */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** The poster of the season. */
  poster?: Maybe<InternalImage>;
  /** The list of the releases of this program. */
  releases?: Maybe<Array<Maybe<SeriesRelease>>>;
  /** The number of known seasons (existing and coming). */
  seasonCount?: Maybe<Scalars['Int']['output']>;
  /** The paginated seasons of the program. */
  seasons?: Maybe<ProgramSeasonsConnection>;
  /** Some stats about metric, userRating, userReview and pressReview. */
  stats?: Maybe<SeriesStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the program, can be short or long (short by default). */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The tags of the program. */
  tags?: Maybe<TagCollection>;
  /** The title of the program. */
  title?: Maybe<Scalars['String']['output']>;
  /** The list of the user reviews of this Program. */
  userReviews?: Maybe<UserReviewsConnection>;
  /** The aggregated counts list of the user reviews of this program. */
  userReviewsCount?: Maybe<UserReviewCounts>;
  /** The list of videos related to this program. */
  videos?: Maybe<Array<Maybe<Video>>>;
};


/** An Allociné program. */
export type ProgramCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program. */
export type ProgramCreditsArgs = {
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program. */
export type ProgramReleasesArgs = {
  country?: InputMaybe<CountryCode>;
};


/** An Allociné program. */
export type ProgramSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeasonSorting>>>;
};


/** An Allociné program. */
export type ProgramSynopsisArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné program. */
export type ProgramUserReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  ratingList?: InputMaybe<Array<InputMaybe<ReviewRatingFloat>>>;
  sentiment?: InputMaybe<ReviewSentimentFilter>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné program. */
export type ProgramUserReviewsCountArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné program. */
export type ProgramVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An Allociné program episode */
export type ProgramEpisode = Node & {
  __typename?: 'ProgramEpisode';
  /** The people playing in the program this season. */
  cast?: Maybe<Array<Maybe<CastMember>>>;
  /** The people working on the program this season. */
  credits?: Maybe<Array<Maybe<CreditsMember>>>;
  /** The id of the episode */
  id: Scalars['ID']['output'];
  /** The internal id of the episode */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the program */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The number of the episode in its season */
  number?: Maybe<Scalars['Int']['output']>;
  /** The number of the episode in the whole prigram */
  numberInProgram?: Maybe<Scalars['Int']['output']>;
  /** The original title of the episode */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** The program of the episode, it is equivalent as getting the program from the season. */
  program?: Maybe<Program>;
  /** The season of the episode */
  season?: Maybe<ProgramSeason>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The title of the episode */
  title?: Maybe<Scalars['String']['output']>;
  /** The list of videos related to this program. */
  videos?: Maybe<Array<Maybe<Video>>>;
};


/** An Allociné program episode */
export type ProgramEpisodeCastArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program episode */
export type ProgramEpisodeCreditsArgs = {
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program episode */
export type ProgramEpisodeVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
};

/** An Allociné program. */
export type ProgramOriginalBroadcast = {
  __typename?: 'ProgramOriginalBroadcast';
  /** The original channel that broadcasted the program. */
  channel?: Maybe<Company>;
  /** The date at which the first episode was broadcasted. */
  firstAired?: Maybe<PartialDate>;
  /** The date at which the last episode was broadcasted. */
  lastAired?: Maybe<PartialDate>;
};

/** An Allociné program season. */
export type ProgramSeason = Node & {
  __typename?: 'ProgramSeason';
  /** The people playing on this season. */
  cast?: Maybe<Array<Maybe<CastMember>>>;
  /** The people working on this season. */
  credits?: Maybe<Array<Maybe<CreditsMember>>>;
  /** Technical informations about the season. */
  data?: Maybe<SeasonData>;
  /** The end date of the season. */
  endsAt?: Maybe<Scalars['DateLimited']['output']>;
  /** The list of episodes in that season. */
  episodes?: Maybe<ProgramEpisodesConnection>;
  /** The id of the season. */
  id: Scalars['ID']['output'];
  /** The internal id of the season. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The number of the season. */
  number?: Maybe<Scalars['Int']['output']>;
  /** The poster of the season. */
  poster?: Maybe<InternalImage>;
  /** The program of the season. */
  program?: Maybe<Program>;
  /** The list of the releases of this program season. */
  releases?: Maybe<Array<Maybe<SeasonRelease>>>;
  /** The start date of the season. */
  startsAt?: Maybe<Scalars['DateLimited']['output']>;
  /** All stats for the season. */
  stats?: Maybe<SeasonStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the season. */
  tags?: Maybe<TagCollection>;
  /** The list of videos related to this program. */
  videos?: Maybe<Array<Maybe<Video>>>;
};


/** An Allociné program season. */
export type ProgramSeasonCastArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program season. */
export type ProgramSeasonCreditsArgs = {
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné program season. */
export type ProgramSeasonEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EpisodeSorting>>>;
};


/** An Allociné program season. */
export type ProgramSeasonReleasesArgs = {
  country?: InputMaybe<CountryCode>;
};


/** An Allociné program season. */
export type ProgramSeasonVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sorting criteria for program */
export enum ProgramSorting {
  /** Program sorted by popularity on (all time). */
  AllTimePopularity = 'ALL_TIME_POPULARITY',
  /** Program sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Program sorted by the latest video created. */
  LatestVideo = 'LATEST_VIDEO',
  /** No sort is applied. */
  None = 'NONE',
  /** Program sorted by their press rank, best best rating on program first. */
  Press = 'PRESS',
  /** Program sorted by title in alphabetical reversed order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Program sorted by user rating score. */
  Score = 'SCORE',
  /** Program sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** All projections formats. */
export enum Projection {
  Analog = 'ANALOG',
  Digital = 'DIGITAL',
  F_2D = 'F_2D',
  F_3D = 'F_3D',
  F_3D70Mm = 'F_3D70MM',
  F_3Dhfr = 'F_3DHFR',
  F_4K = 'F_4K',
  F_4K3D = 'F_4K3D',
  F_35Mm = 'F_35MM',
  F_70Mm = 'F_70MM',
  FAtmos = 'F_ATMOS',
  Hfr = 'HFR',
  Imax = 'IMAX',
  Imax_3D = 'IMAX_3D',
  Imax_3DHfr = 'IMAX_3D_HFR',
  Imax_70Mm = 'IMAX_70MM',
  Laser = 'LASER',
  Reald_3D = 'REALD_3D'
}

export type ProjectionFacet = FacetValue & {
  __typename?: 'ProjectionFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

/** All projections formats. */
export enum ProjectionFormat {
  Analog = 'ANALOG',
  Atmos = 'ATMOS',
  Digital = 'DIGITAL',
  F_2D = 'F_2D',
  F_3D = 'F_3D',
  F_4K = 'F_4K',
  F_4K3D = 'F_4K3D',
  F_35Mm = 'F_35MM',
  F_70Mm = 'F_70MM',
  Imax = 'IMAX',
  Imax3D = 'IMAX3D',
  Imax70Mm = 'IMAX70MM',
  Laser = 'LASER',
  Macroxe = 'MACROXE',
  Reald3D = 'REALD3D'
}

export enum Provider {
  Canalplus = 'CANALPLUS',
  Cinemasource = 'CINEMASOURCE',
  Disney = 'DISNEY',
  Eidr = 'EIDR',
  Gaumont = 'GAUMONT',
  Hubble = 'HUBBLE',
  Imdb = 'IMDB',
  Isan = 'ISAN',
  Legacy = 'LEGACY',
  Moviepilot = 'MOVIEPILOT',
  Netflix = 'NETFLIX',
  Orange = 'ORANGE',
  Pathealex = 'PATHEALEX',
  Primevideo = 'PRIMEVIDEO'
}

/** A publication range with a start and an end date. */
export type Publication = {
  __typename?: 'Publication';
  /** The date at which the publication ends. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The original date at which the publication ends. */
  originalEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The original date at which the publication starts. */
  originalStartsAt?: Maybe<Scalars['DateTime']['output']>;
  /** An object of range between two dates. */
  publicationRange?: Maybe<Array<Maybe<DateTimeRange>>>;
  /** The date at which the publication starts. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Query = {
  __typename?: 'Query';
  author?: Maybe<Author>;
  /** Retrieves a list of festival awards */
  award?: Maybe<FestivalAward>;
  /** Return the elements of the carousel defined by the cms. */
  carousel?: Maybe<Carousel>;
  /** Retrieves a list of Cities. */
  cityList?: Maybe<CityConnection>;
  /** Show the closest restaurants near the coordinates. */
  closestRestaurants?: Maybe<Array<Maybe<TheaterClosestRestaurants>>>;
  /** Return a company (ex: AMC, Warner, etc..). */
  company?: Maybe<Company>;
  /** Will get a company list. */
  companyList?: Maybe<CompanyConnection>;
  country?: Maybe<Country>;
  /** A deleted entity. */
  deletedEntity?: Maybe<DeletedEntity>;
  /** An episode of season. */
  episode?: Maybe<Episode>;
  /** A list of episodes. */
  episodeList?: Maybe<EpisodesConnection>;
  /** A festival (ex: oscar, golden globe, ...). */
  festival?: Maybe<Festival>;
  /** An edition of a festival. */
  festivalEdition?: Maybe<FestivalEdition>;
  /** Retrieves a list of Festivals. */
  festivalList?: Maybe<FestivalConnection>;
  /** Selected movies, series and persons for a festival and an edition. */
  festivalSelection?: Maybe<FestivalSelection>;
  /** Get an image of an entity. */
  image?: Maybe<InternalImage>;
  /** A list of images related to an entity. */
  imageList?: Maybe<ImagesConnection>;
  /** A localization (ex: city, county, country ...). */
  localization?: Maybe<Localization>;
  /** Retrieves a list of Localizations. */
  localizationList?: Maybe<LocalizationConnection>;
  /** Will get a movie list by localization. */
  localizationMovieList?: Maybe<MoviesConnection>;
  /** Some informations about the current user. */
  me?: Maybe<Me>;
  /** Get the metadata of an entity. */
  metadata?: Maybe<EntityMetadata>;
  movie?: Maybe<Movie>;
  /** Will get movies aggregated by selected theaters */
  movieByTheaterList?: Maybe<MoviesByTheaterListConnection>;
  /** A list of movie. */
  movieList?: Maybe<MoviesConnection>;
  movieRelease?: Maybe<MovieRelease>;
  /** Will get a movies and showtimes aggregation by selected theater. */
  movieShowtimeList?: Maybe<MovieShowtimeByTheaterListConnection>;
  /** A news Allocine. */
  news?: Maybe<News>;
  /** A list of news Allocine. */
  newsList?: Maybe<NewsConnection>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** Show special operation for a specific code. */
  operation?: Maybe<SpecialOperation>;
  /** A person related to a movie, series or program. */
  person?: Maybe<Person>;
  /** A list of person. */
  personList?: Maybe<PersonsConnection>;
  /** A product of type vod, dvd or br. */
  product?: Maybe<Product>;
  /** Return a list of product(dvd, br, vod, etc). */
  productList?: Maybe<ProductsConnection>;
  /** An Allocine creation program. */
  program?: Maybe<Program>;
  /** A list of Allocine creation program. */
  programList?: Maybe<ProgramConnection>;
  /** A recommended list of movies. */
  recoMovieList?: Maybe<RecoMovieConnection>;
  /** To search a movie, series or person. */
  search?: Maybe<SearchResultsConnection>;
  /** Aggregated search result */
  searchTopList?: Maybe<SearchTopListResult>;
  /** A season of series. */
  season?: Maybe<Season>;
  /** A list of seasons. */
  seasonList?: Maybe<SeasonsConnection>;
  /** A series or manga. */
  series?: Maybe<Series>;
  /** A list of series or manga. */
  seriesList?: Maybe<SeriesConnection>;
  showtime?: Maybe<ShowtimeWithParentsId>;
  /** Social media links of an entity. */
  socialMediaCategory?: Maybe<SocialMediaCategory>;
  /** Social media links of an entity. */
  socialMediaCategoryList?: Maybe<ImagesSocialMediaCategoryConnection>;
  /** Return a list of soundtracks. */
  soundtrackList?: Maybe<SoundtrackConnection>;
  /** A tag. */
  tag?: Maybe<Tag>;
  /** A list of tags. */
  tagList?: Maybe<TagConnection>;
  /** Return some informations about a theater. */
  theater?: Maybe<Theater>;
  /** Return a list of companies. */
  theaterCircuitList?: Maybe<CompanyConnection>;
  /** Return the theater group by id. */
  theaterGroup?: Maybe<Group>;
  /** Return list of theater group ordered by path length and rank. */
  theaterGroupList?: Maybe<GroupConnection>;
  /** Return a list of theaters. */
  theaterList?: Maybe<TheaterConnection>;
  /** Will get a theater and showtimes aggregation by selected movie. */
  theaterShowtimeList?: Maybe<TheaterShowtimeByMovieListConnection>;
  /** Some informations about an user. */
  user?: Maybe<User>;
  /** A video related to an entity. */
  video?: Maybe<Video>;
  /** A list of videos related to an entity. */
  videoList?: Maybe<VideosConnection>;
};


export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAwardArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCarouselArgs = {
  target?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  analyzer?: InputMaybe<Locale>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTheater?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<CoordinateType>;
  order?: InputMaybe<Array<InputMaybe<CitySorting>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClosestRestaurantsArgs = {
  location: CoordinateType;
  radius?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCompanyArgs = {
  composedId?: InputMaybe<ComposedIdType>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyListArgs = {
  activities?: InputMaybe<Array<InputMaybe<CompanyActivity>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryArgs = {
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDeletedEntityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEpisodeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEpisodeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EpisodeSorting>>>;
  seasonId?: InputMaybe<Scalars['Int']['input']>;
  seriesId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalEditionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  editionEndDate?: InputMaybe<FilterDate>;
  editionStartDate?: InputMaybe<FilterDate>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameFirstChar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<FestivalSorting>>>;
  theme?: InputMaybe<Array<InputMaybe<FestivalTheme>>>;
  type?: InputMaybe<Array<InputMaybe<FestivalType>>>;
};


export type QueryFestivalSelectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImageArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QueryImageListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ImageSorting>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<ImageType>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocalizationArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocalizationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  analyzer?: InputMaybe<Locale>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTheater?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<CoordinateType>;
  movieDisplayed?: InputMaybe<Scalars['Int']['input']>;
  movieDisplayedWithinProductSlidingWeeks?: InputMaybe<Scalars['Int']['input']>;
  movieDisplayedWithinTwoSlidingWeeks?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<LocalizationSorting>>>;
  parents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<InputMaybe<LocalizationTypeValue>>>;
  withCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocalizationMovieListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinateType;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  radius: Scalars['Float']['input'];
};


export type QueryMetadataArgs = {
  entityType: NodeType;
  internalId: Scalars['String']['input'];
};


export type QueryMovieArgs = {
  composedId?: InputMaybe<ComposedIdType>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMovieByTheaterListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<MovieShowtimeSorting>>>;
  theater: Array<InputMaybe<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMovieListArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  editorialRating?: InputMaybe<FilterRangeRating>;
  editorialRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludeGenres?: InputMaybe<Array<InputMaybe<Genre>>>;
  excludeTypes?: InputMaybe<Array<InputMaybe<MovieType>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<MovieFlagsType>;
  forChildren?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Genre>>>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  localization?: InputMaybe<Scalars['Int']['input']>;
  minTheaters?: InputMaybe<Scalars['Int']['input']>;
  minTheatersProductFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  minTheatersTwoFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<MovieSorting>>>;
  physicalFlags?: InputMaybe<Array<PhysicalProductType>>;
  pressRating?: InputMaybe<FilterRangeRating>;
  pressRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  productionDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productionYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  releaseDateType?: InputMaybe<MovieReleaseDateFilterType>;
  releaseFilter?: InputMaybe<ReleaseFilterType>;
  releaseFlags?: InputMaybe<Array<BaseReleaseType>>;
  releaseFrom?: InputMaybe<Scalars['DateTime']['input']>;
  releaseFromUs?: InputMaybe<Scalars['DateTime']['input']>;
  releaseTo?: InputMaybe<Scalars['DateTime']['input']>;
  releaseToUs?: InputMaybe<Scalars['DateTime']['input']>;
  runtime?: InputMaybe<IntRangeFilter>;
  scoreRating?: InputMaybe<FilterRangeRating>;
  scoreRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  specialFilter?: InputMaybe<MovieSpecialFilter>;
  svodFlags?: InputMaybe<Array<SvodFlags>>;
  svodProviders?: InputMaybe<Array<SvodProviders>>;
  tag?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InputMaybe<MovieType>>>;
  visaNumber?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMovieReleaseArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMovieShowtimeListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comfort?: InputMaybe<Array<InputMaybe<Comfort>>>;
  displayPreview?: InputMaybe<Scalars['Boolean']['input']>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsMovieShowtimeType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Array<InputMaybe<ProjectionFormat>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  hasFutureReleaseSoon?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreview?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  movie?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<InputMaybe<ShowtimeSorting>>>;
  picture?: InputMaybe<Array<InputMaybe<Picture>>>;
  projection?: InputMaybe<Array<InputMaybe<Projection>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Array<InputMaybe<TheaterService>>>;
  showtimeGetData?: InputMaybe<Scalars['Boolean']['input']>;
  sound?: InputMaybe<Array<InputMaybe<Sound>>>;
  techno?: InputMaybe<Array<InputMaybe<TechnoFlag>>>;
  theater?: InputMaybe<Scalars['String']['input']>;
  theaters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
};


export type QueryNewsArgs = {
  composedId?: InputMaybe<ComposedIdType>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  excludeCategory?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  excludeGenericUniverses?: InputMaybe<Scalars['Boolean']['input']>;
  excludeId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludeTag?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeType?: InputMaybe<Array<InputMaybe<NewsType>>>;
  excludeUniverse?: InputMaybe<Array<InputMaybe<NewsUniverse>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forChildren?: InputMaybe<Scalars['Boolean']['input']>;
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeSeoHidden?: InputMaybe<Scalars['Boolean']['input']>;
  insertSponsored?: InputMaybe<Scalars['Boolean']['input']>;
  isFolder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<Array<InputMaybe<SpecialOperationCode>>>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishedTo?: InputMaybe<Scalars['DateTime']['input']>;
  relatedType?: InputMaybe<Array<InputMaybe<NewsRelatedType>>>;
  svodProviders?: InputMaybe<Array<SvodProviders>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InputMaybe<NewsType>>>;
  universe?: InputMaybe<Array<InputMaybe<NewsUniverse>>>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOperationArgs = {
  code: SpecialOperationCode;
  target?: InputMaybe<SpecialOperationTargetCode>;
};


export type QueryPersonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPersonListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthAnniversary?: InputMaybe<Scalars['String']['input']>;
  birthDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  birthYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  deathAnniversary?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['Int']['input']>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first: Scalars['Int']['input'];
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nameFirstChar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Array<PersonSorting>>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eanCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entity?: InputMaybe<Array<InputMaybe<NodeTypeProducts>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  relatedEntity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProgramArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProgramListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProgramSorting>>>;
};


export type QueryRecoMovieListArgs = {
  algo: MovieRecommendationAlgo;
  first: Scalars['Int']['input'];
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  autocomplete?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collection?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Genre>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SearchSorting>>>;
  provider?: InputMaybe<SearchProvider>;
  text: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<SearchTypes>>>;
};


export type QuerySearchTopListArgs = {
  autocomplete?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};


export type QuerySeasonArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySeasonListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SeasonSorting>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeriesArgs = {
  composedId?: InputMaybe<SeriesComposedIdType>;
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySeriesListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludeGenres?: InputMaybe<Array<InputMaybe<Genre>>>;
  excludeStatus?: InputMaybe<Array<InputMaybe<Status>>>;
  excludeType?: InputMaybe<Array<InputMaybe<SeriesType>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<SeriesFlagsType>;
  genres?: InputMaybe<Array<InputMaybe<Genre>>>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSeason?: InputMaybe<SeriesLastSeasonFilterType>;
  lastSeasonFilter?: InputMaybe<SeriesLastSeasonDatesFilterType>;
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeriesSorting>>>;
  pressRating?: InputMaybe<FilterRangeRating>;
  productionDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productionYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  releaseDateType?: InputMaybe<ReleaseDateFilterType>;
  releaseFilter?: InputMaybe<ReleaseFilterType>;
  releaseFlags?: InputMaybe<Array<BaseReleaseType>>;
  releaseFrom?: InputMaybe<Scalars['DateTime']['input']>;
  releaseTo?: InputMaybe<Scalars['DateTime']['input']>;
  runtime?: InputMaybe<IntRangeFilter>;
  scoreRating?: InputMaybe<FilterRangeRating>;
  seasonCount?: InputMaybe<IntRangeFilter>;
  seasonStartsFrom?: InputMaybe<Scalars['DateTime']['input']>;
  seasonStartsTo?: InputMaybe<Scalars['DateTime']['input']>;
  startsFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startsTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  svodFlags?: InputMaybe<Array<SvodFlags>>;
  svodProviders?: InputMaybe<Array<SvodProviders>>;
  tag?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InputMaybe<SeriesType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShowtimeArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['BigInt']['input']>;
};


export type QuerySocialMediaCategoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySocialMediaCategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SocialMedia>;
};


export type QuerySoundtrackListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Array<InputMaybe<NodeTypeSoundtracks>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsSoundtrackType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SoundtrackSorting>>>;
  productionDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productionYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryTagArgs = {
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  excludeScope?: InputMaybe<Array<TagScope>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSeoFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<TagSorting>>;
  relatedType?: InputMaybe<Array<InputMaybe<TagRelatedType>>>;
  scope?: InputMaybe<Array<TagScope>>;
};


export type QueryTheaterArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTheaterCircuitListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterChainSorting>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTheaterGroupArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTheaterGroupListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  movie?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterGroupSorting>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTheaterListArgs = {
  affiliation?: InputMaybe<TheaterAffiliation>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  branded?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  localization?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<CoordinateType>;
  loyaltyCard?: InputMaybe<Array<InputMaybe<LoyaltyCard>>>;
  network?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TheaterSorting>>>;
  projection?: InputMaybe<Array<InputMaybe<Projection>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Array<InputMaybe<TheaterService>>>;
  sound?: InputMaybe<Array<InputMaybe<Sound>>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTheaterShowtimeListArgs = {
  affiliation?: InputMaybe<TheaterAffiliation>;
  after?: InputMaybe<Scalars['String']['input']>;
  analyzer?: InputMaybe<Locale>;
  before?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comfort?: InputMaybe<Array<InputMaybe<Comfort>>>;
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsTheaterShowtimeType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<Array<InputMaybe<ProjectionFormat>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hasBooking?: InputMaybe<Scalars['Boolean']['input']>;
  hasFutureReleaseSoon?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreview?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<CoordinateType>;
  loyaltyCard?: InputMaybe<Array<InputMaybe<LoyaltyCard>>>;
  movie: Scalars['String']['input'];
  order?: InputMaybe<Array<InputMaybe<ShowtimeSorting>>>;
  picture?: InputMaybe<Array<InputMaybe<Picture>>>;
  projection?: InputMaybe<Array<InputMaybe<Projection>>>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Array<InputMaybe<TheaterService>>>;
  showtimeGetData?: InputMaybe<Scalars['Boolean']['input']>;
  sound?: InputMaybe<Array<InputMaybe<Sound>>>;
  techno?: InputMaybe<Array<InputMaybe<TechnoFlag>>>;
  theater?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  legacyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterDate?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['DateTime']['input']>;
  entitiesGenres?: InputMaybe<Array<InputMaybe<Genre>>>;
  entitiesTypes?: InputMaybe<Array<InputMaybe<EntityType>>>;
  entity?: InputMaybe<Array<MediaRelatedEntityTypes>>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeType?: InputMaybe<Array<InputMaybe<VideoType>>>;
  externalVideo?: InputMaybe<Scalars['Boolean']['input']>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<VideoFlags>;
  include?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VideoSorting>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  parentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  specialFilter?: InputMaybe<VideoSpecialFilter>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of items. */
export type RecoMovieConnection = {
  __typename?: 'RecoMovieConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<RecoMovieEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RecoMovieEdge = {
  __typename?: 'RecoMovieEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Movie>;
};

/** An advice of the redaction. */
export type Recommendation = {
  __typename?: 'Recommendation';
  /** Indicate if it's recommended for children. */
  forChildren?: Maybe<Scalars['Boolean']['output']>;
  /** A short description. */
  label?: Maybe<Scalars['String']['output']>;
};

/** User series status. */
export enum RelatedSeriesStatus {
  Followed = 'FOLLOWED',
  HavingProgression = 'HAVING_PROGRESSION',
  NotInterested = 'NOT_INTERESTED',
  NotReviewed = 'NOT_REVIEWED',
  /** Series having a rating on series level */
  Rating = 'RATING',
  /** Series having a rating on series or season level */
  RatingOnSeriesAndSeasons = 'RATING_ON_SERIES_AND_SEASONS',
  Seen = 'SEEN',
  WantToSee = 'WANT_TO_SEE'
}

/** Describes how entities are related to other entities. */
export type Relation = {
  __typename?: 'Relation';
  /** The other entity this entity is related to. */
  node?: Maybe<Node>;
  /** The type of the relation. */
  type?: Maybe<RelationType>;
};

export enum RelationType {
  /** This entity is was inspired by another entity. */
  InspiredBy = 'INSPIRED_BY',
  /** This entity is a remake of another entity. */
  RemakeOf = 'REMAKE_OF',
  /** This entity is a spin of (eg. it's based on the same universe) of another entity. */
  SpinOfFrom = 'SPIN_OF_FROM'
}

export type ReleaseBaseFlags = {
  __typename?: 'ReleaseBaseFlags';
  avod?: Maybe<Scalars['Boolean']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  globalWithoutDate?: Maybe<Scalars['Boolean']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  physical?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<ReleaseProvidersFlags>;
  svod?: Maybe<ReleaseSvodFlags>;
  television?: Maybe<Scalars['Boolean']['output']>;
  theater?: Maybe<Scalars['Boolean']['output']>;
  vod?: Maybe<Scalars['Boolean']['output']>;
  vodest?: Maybe<Scalars['Boolean']['output']>;
};

/** releaseFrom and releaseTo filters date types. */
export enum ReleaseDateFilterType {
  Vod = 'VOD',
  VodFirstRelease = 'VOD_FIRST_RELEASE'
}

/** Filter by releases company specificities */
export type ReleaseFilterDistributionCompanyFilter = {
  /** When provided, will only select releases limited to companies which name starts by the given letter. */
  firstLetter?: InputMaybe<Scalars['String']['input']>;
  /** When provided, will only select releases that were released this year OR linked to an entity having a production date for the supplied year. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum ReleaseFilterFlagValue {
  Exclusive = 'EXCLUSIVE',
  Original = 'ORIGINAL'
}

export enum ReleaseFilterPhysicalMaterialValue {
  Bluray = 'BLURAY',
  Dvd = 'DVD'
}

export enum ReleaseFilterStatusValue {
  Released = 'RELEASED',
  Upcoming = 'UPCOMING'
}

/** Filter by releases features */
export type ReleaseFilterType = {
  /** When provided, will only select releases limited to the specified companies. */
  companyLimitation?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When provided, will only select releases that were released after this date. */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** When provided, will only select releases that were released before this date. */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  distributionCompany?: InputMaybe<ReleaseFilterDistributionCompanyFilter>;
  /** When provided, will only select releases having one of the specified flags. */
  flags?: InputMaybe<Array<ReleaseFilterFlagValue>>;
  /** When provided, will only select the first release, regardless of its type. */
  isFirst?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided, will only select the first release of the specified type. */
  isFirstOfType?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided, will only select the last release, regardless of its type. */
  isLast?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided, will only select the last release of the specified type. */
  isLastOfType?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When provided, will only select releases of the specified physical type.
   *                     Can only be used with the "type: [PHYSICAL]" argument.
   */
  physicalMaterial?: InputMaybe<Array<ReleaseFilterPhysicalMaterialValue>>;
  /** When provided, will only select releases corresponding the the specified statuses. */
  status?: InputMaybe<Array<ReleaseFilterStatusValue>>;
  /** When provided, will only select releases of the specified type. */
  type?: InputMaybe<Array<ReleaseFilterTypeValue>>;
};

export enum ReleaseFilterTypeValue {
  Avod = 'AVOD',
  Physical = 'PHYSICAL',
  Replay = 'REPLAY',
  Svod = 'SVOD',
  Theater = 'THEATER',
  Tv = 'TV',
  Vod = 'VOD'
}

export type ReleaseFlags = {
  __typename?: 'ReleaseFlags';
  product?: Maybe<ReleaseProductFlags>;
  release?: Maybe<ReleaseBaseFlags>;
  showtime?: Maybe<ReleaseShowtimeFlags>;
  specialOps?: Maybe<ReleaseSpecialOpsFlags>;
  upcoming?: Maybe<ReleaseBaseFlags>;
};

/** An Allociné release */
export type ReleaseInterface = {
  /** An advice of the redaction. */
  advice?: Maybe<Scalars['String']['output']>;
  /** The area for this release */
  area?: Maybe<Scalars['String']['output']>;
  /** The official recommendation of CNC. */
  certificate?: Maybe<Certificate>;
  /** The company for which this release is limited to. */
  companyLimitation?: Maybe<Company>;
  /** The country of the release. */
  country?: Maybe<Country>;
  /** Some data related to this release. */
  data?: Maybe<Scalars['Json']['output']>;
  /**
   * The date of the release.
   * @deprecated No longer used. Will be remove soon. Use releaseDate instead.
   */
  date?: Maybe<Scalars['DateLimited']['output']>;
  /** The id of the release. */
  id: Scalars['ID']['output'];
  /**
   * The name of the release.
   * @deprecated Please use the 'releaseTags' field instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The date of the release. */
  releaseDate?: Maybe<PartialDate>;
  releaseTags?: Maybe<ReleaseTag>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export enum ReleaseMoveFilterTypeValue {
  Rerun = 'RERUN'
}

/** Filter by releases features */
export type ReleaseMovieFilterType = {
  /** When provided, will only select the first release, regardless of its type. */
  isFirst?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided, will only select the last releases of the specified types. */
  isLastOfType?: InputMaybe<Array<ReleaseMoveFilterTypeValue>>;
};

export type ReleaseOnlineFlags = {
  __typename?: 'ReleaseOnlineFlags';
  avod?: Maybe<Scalars['Boolean']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
  svod?: Maybe<Scalars['Boolean']['output']>;
  vod?: Maybe<Scalars['Boolean']['output']>;
  vodest?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleasePhysicalFlags = {
  __typename?: 'ReleasePhysicalFlags';
  bluray?: Maybe<Scalars['Boolean']['output']>;
  dvd?: Maybe<Scalars['Boolean']['output']>;
  global?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleaseProductFlags = {
  __typename?: 'ReleaseProductFlags';
  online?: Maybe<ReleaseOnlineFlags>;
  physical?: Maybe<ReleasePhysicalFlags>;
  provider?: Maybe<ReleaseProvidersFlags>;
};

export type ReleaseProvidersFlags = {
  __typename?: 'ReleaseProvidersFlags';
  avod?: Maybe<Array<Maybe<Company>>>;
  bluray?: Maybe<Array<Maybe<Company>>>;
  dvd?: Maybe<Array<Maybe<Company>>>;
  extra?: Maybe<ExtraProviderFlags>;
  replay?: Maybe<Array<Maybe<Company>>>;
  svod?: Maybe<Array<Maybe<Company>>>;
  television?: Maybe<Array<Maybe<Company>>>;
  vod?: Maybe<Array<Maybe<Company>>>;
  vodest?: Maybe<Array<Maybe<Company>>>;
};

export type ReleaseShowtimeFlags = {
  __typename?: 'ReleaseShowtimeFlags';
  playing?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleaseSpecialOpsFlags = {
  __typename?: 'ReleaseSpecialOpsFlags';
  club300?: Maybe<Scalars['Boolean']['output']>;
  emergence?: Maybe<Scalars['Boolean']['output']>;
  sponsoredAutocomplete?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleaseSvodFlags = {
  __typename?: 'ReleaseSvodFlags';
  adn?: Maybe<Scalars['Boolean']['output']>;
  amazonPrime?: Maybe<Scalars['Boolean']['output']>;
  appletv?: Maybe<Scalars['Boolean']['output']>;
  benshi?: Maybe<Scalars['Boolean']['output']>;
  canalplay?: Maybe<Scalars['Boolean']['output']>;
  disney?: Maybe<Scalars['Boolean']['output']>;
  exclusive?: Maybe<Scalars['String']['output']>;
  filmotv?: Maybe<Scalars['Boolean']['output']>;
  globoplay?: Maybe<Scalars['Boolean']['output']>;
  hbo?: Maybe<Scalars['Boolean']['output']>;
  hbo_go?: Maybe<Scalars['Boolean']['output']>;
  madelen?: Maybe<Scalars['Boolean']['output']>;
  movistar?: Maybe<Scalars['Boolean']['output']>;
  mycanal?: Maybe<Scalars['Boolean']['output']>;
  netflix?: Maybe<Scalars['Boolean']['output']>;
  ocs?: Maybe<Scalars['Boolean']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  salto?: Maybe<Scalars['Boolean']['output']>;
  sfrPlay?: Maybe<Scalars['Boolean']['output']>;
  sky?: Maybe<Scalars['Boolean']['output']>;
};

export type ReleaseTag = {
  __typename?: 'ReleaseTag';
  tagFlags?: Maybe<Array<ReleaseTagFlag>>;
  tagTypes?: Maybe<Array<ReleaseTagType>>;
};

export enum ReleaseTagFlag {
  Direct = 'DIRECT',
  Exclusive = 'EXCLUSIVE',
  LimitationPlatform = 'LIMITATION_PLATFORM',
  LimitationTheater = 'LIMITATION_THEATER',
  NotReleasedYet = 'NOT_RELEASED_YET',
  Original = 'ORIGINAL',
  Preview = 'PREVIEW',
  Rerun = 'RERUN'
}

/** The available release types. */
export enum ReleaseTagType {
  Online = 'ONLINE',
  OnlineAvod = 'ONLINE_AVOD',
  OnlineECinema = 'ONLINE_E_CINEMA',
  OnlineSvod = 'ONLINE_SVOD',
  OnlineVod = 'ONLINE_VOD',
  OnlineVodest = 'ONLINE_VODEST',
  Physical = 'PHYSICAL',
  PhysicalBluray = 'PHYSICAL_BLURAY',
  PhysicalDvd = 'PHYSICAL_DVD',
  Released = 'RELEASED',
  Replay = 'REPLAY',
  Television = 'TELEVISION',
  Theater = 'THEATER'
}

/** Filter users reviews by one rating. */
export enum ReviewRating {
  /** Only show reviews for rating equals to 5. */
  Five = 'FIVE',
  /** Only show reviews for rating equals to 4 or 4.5. */
  Four = 'FOUR',
  /** Only show reviews for rating equals to 1 or 1.5. */
  One = 'ONE',
  /** Only show reviews for rating equals to 3 or 3.5. */
  Three = 'THREE',
  /** Only show reviews for rating equals to 2 or 2.5. */
  Two = 'TWO',
  /** Only show reviews for rating equals to 0.5 (O can't be submit). */
  Zero = 'ZERO'
}

/** Filter users reviews by n floating ratings. */
export enum ReviewRatingFloat {
  Five = 'FIVE',
  Four = 'FOUR',
  FourHalf = 'FOUR_HALF',
  One = 'ONE',
  OneHalf = 'ONE_HALF',
  Three = 'THREE',
  ThreeHalf = 'THREE_HALF',
  Two = 'TWO',
  TwoHalf = 'TWO_HALF',
  Zero = 'ZERO',
  ZeroHalf = 'ZERO_HALF'
}

/** Filter user reviews by most negative / positive. */
export enum ReviewSentimentFilter {
  /** Shows all reviews, ignoring if they are positive or negative. */
  Both = 'BOTH',
  /** Only shows reviews that says something negative about the content (eg. rating < 2.5). */
  Negative = 'NEGATIVE',
  /** Only shows reviews that says something positive about the content. (eg. rating >= 2.5) */
  Positive = 'POSITIVE'
}

/** Sorting criteria for reviews. */
export enum ReviewSorting {
  /** Shows the newest reviews first. */
  Latest = 'LATEST',
  /** Shows the reviews that were the most approved by the community. */
  MostHelpful = 'MOST_HELPFUL',
  /** Shows the reviews with the worst rating first. */
  MostNegative = 'MOST_NEGATIVE',
  /** Shows the reviews with the best rating first. */
  MostPositive = 'MOST_POSITIVE',
  /** Show the reviews with the most user which write the more reviews. */
  MostReviews = 'MOST_REVIEWS',
  /** Show the reviews with the most subscribers for the review's user. */
  MostSubscribers = 'MOST_SUBSCRIBERS',
  /** Shows the oldest reviews first. */
  Oldest = 'OLDEST'
}

/** Status of a review. */
export enum ReviewStatus {
  Accepted = 'ACCEPTED',
  BeingChecked = 'BEING_CHECKED',
  Blocked = 'BLOCKED',
  Denied = 'DENIED',
  MustBeChecked = 'MUST_BE_CHECKED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Reported = 'REPORTED'
}

export type Rewind = {
  __typename?: 'Rewind';
  screens?: Maybe<Array<Maybe<RewindScreen>>>;
};

export type RewindScreen = {
  __typename?: 'RewindScreen';
  data?: Maybe<Scalars['Json']['output']>;
  entities?: Maybe<Array<Maybe<RewindScreenEntityList>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RewindScreenEntityList = {
  __typename?: 'RewindScreenEntityList';
  entities?: Maybe<Array<Maybe<Node>>>;
  identifier?: Maybe<Scalars['String']['output']>;
};

export enum SearchProvider {
  Legacy = 'LEGACY',
  New = 'NEW'
}

/** The search result. */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** The result is in the given collection. */
  inCollection?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the result. */
  label?: Maybe<Scalars['String']['output']>;
  /** The node itself. */
  node?: Maybe<Node>;
  /** The score for this result. */
  score?: Maybe<Scalars['Float']['output']>;
  /** The type of the node. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Sorting criteria for search. */
export enum SearchSorting {
  /** Results sorted by label in alphabetical order. */
  AlphabeticalLabel = 'ALPHABETICAL_LABEL',
  /** Results sorted by original label in alphabetical order. */
  AlphabeticalOriginalLabel = 'ALPHABETICAL_ORIGINAL_LABEL',
  /** Movies sorted by their latest release dates, most recent releases first (Only apply if type Movie is selected). */
  OrderLatestLastReleases = 'ORDER_LATEST_LAST_RELEASES',
  /** Movies sorted by their latest release dates, oldest releases first (Only apply if type Movie is selected). */
  OrderOldestLastReleases = 'ORDER_OLDEST_LAST_RELEASES',
  /** Results sorted by label in reverse alphabetical order. */
  ReverseAlphabeticalLabel = 'REVERSE_ALPHABETICAL_LABEL',
  /** Results sorted by original label in reverse alphabetical order. */
  ReverseAlphabeticalOriginalLabel = 'REVERSE_ALPHABETICAL_ORIGINAL_LABEL',
  /** No sort is applied. */
  Score = 'SCORE'
}

/** A list of companies. */
export type SearchTopCompany = {
  __typename?: 'SearchTopCompany';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Company>>;
};

/** The aggregated search result. */
export type SearchTopListResult = {
  __typename?: 'SearchTopListResult';
  companies?: Maybe<SearchTopCompany>;
  movies?: Maybe<SearchTopMovie>;
  news?: Maybe<SearchTopNews>;
  persons?: Maybe<SearchTopPerson>;
  programs?: Maybe<SearchTopProgram>;
  series?: Maybe<SearchTopSeries>;
  tags?: Maybe<SearchTopTag>;
  theaters?: Maybe<SearchTopTheaters>;
  videos?: Maybe<SearchTopVideo>;
};

/** A list of movies. */
export type SearchTopMovie = {
  __typename?: 'SearchTopMovie';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Movie>>;
};

/** A list of news. */
export type SearchTopNews = {
  __typename?: 'SearchTopNews';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<News>>;
};

/** A list of persons. */
export type SearchTopPerson = {
  __typename?: 'SearchTopPerson';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Person>>;
};

/** A list of programs. */
export type SearchTopProgram = {
  __typename?: 'SearchTopProgram';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Program>>;
};

/** A list of series. */
export type SearchTopSeries = {
  __typename?: 'SearchTopSeries';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Series>>;
};

/** A list of tags. */
export type SearchTopTag = {
  __typename?: 'SearchTopTag';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Tag>>;
};

/** A list of theaters. */
export type SearchTopTheaters = {
  __typename?: 'SearchTopTheaters';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Theater>>;
};

/** A list of videos. */
export type SearchTopVideo = {
  __typename?: 'SearchTopVideo';
  /** The amount of items. */
  count: Scalars['Int']['output'];
  /** The items searched for */
  items: Array<Maybe<Video>>;
};

/** Available type for searching. */
export enum SearchTypes {
  /** Search company type. */
  Company = 'Company',
  /** Search movie type. */
  Movie = 'Movie',
  /** Search news type. */
  News = 'News',
  /** Search person type. */
  Person = 'Person',
  /** Search program type. */
  Program = 'Program',
  /** Search link type. */
  SearchLink = 'SearchLink',
  /** Search series type. */
  Series = 'Series',
  /** Search tag type. */
  Tag = 'Tag',
  /** Search theater type. */
  Theater = 'Theater',
  /** Search video type. */
  Video = 'Video'
}

/** An Allociné series or program season. */
export type Season = Node & {
  __typename?: 'Season';
  /** The audiences of the season per country. */
  audience?: Maybe<Array<Maybe<Audience>>>;
  backlink?: Maybe<Backlink>;
  /** The people playing on this season. */
  cast?: Maybe<CastMemberConnection>;
  /** The newest comments added on this season, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The list of companies which worked in this production. */
  companies?: Maybe<Array<Maybe<SeriesCompany>>>;
  /** The people working on this season. */
  credits?: Maybe<CreditsConnection>;
  /** Technical informations about the season. */
  data?: Maybe<SeasonData>;
  /**
   * The end date of the season.
   * @deprecated Use endsAtPartial instead
   */
  endsAt?: Maybe<Scalars['DateLimited']['output']>;
  /** The end date of the season. */
  endsAtPartial?: Maybe<PartialDate>;
  /** The list of episodes in that season. */
  episodes?: Maybe<EpisodesConnection>;
  /** The id of the season. */
  id: Scalars['ID']['output'];
  /** The list of the images for this season. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The total amount of images this season has (including episodes). */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** The internal id of the season. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** News that are related to the current one. Up to 10. */
  news?: Maybe<Array<Maybe<News>>>;
  /** The total amount of news this season has. */
  newsCount?: Maybe<Scalars['Int']['output']>;
  /** Next season based on season number */
  nextSeason?: Maybe<Season>;
  /** The number of the season. */
  number?: Maybe<Scalars['Int']['output']>;
  /** The poster of the season. */
  poster?: Maybe<InternalImage>;
  /** Next season based on season number */
  previousSeason?: Maybe<Season>;
  /**
   * !!!!! DEPRECATED !!!!! Use relatedProducts instead.
   * @deprecated Use relatedProducts instead
   */
  products?: Maybe<Array<Maybe<Product>>>;
  /** The products related to this season. */
  relatedProducts?: Maybe<ProductsConnection>;
  releaseFlags?: Maybe<ReleaseFlags>;
  /** The list of the releases of this series. */
  releases?: Maybe<Array<Maybe<SeasonRelease>>>;
  /** The series of the season. */
  series?: Maybe<Series>;
  /**
   * The start date of the season.
   * @deprecated Use startsAtPartial instead
   */
  startsAt?: Maybe<Scalars['DateLimited']['output']>;
  /** The start date of the season. */
  startsAtPartial?: Maybe<PartialDate>;
  /** All stats for the season. */
  stats?: Maybe<SeasonStats>;
  /** The current status of the season. */
  status?: Maybe<Status>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the season, can be short or long (short by default). */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the season, on json format. */
  synopsis_json?: Maybe<BodyJson>;
  /** The tags of the season. */
  tags?: Maybe<TagCollection>;
  /** The update dates for this season. */
  updatedAt?: Maybe<EntityUpdateDate>;
  /** The list of the user reviews of this Season. */
  userReviews?: Maybe<UserReviewsConnection>;
  /** The aggregated counts list of the user reviews of this season. */
  userReviewsCount?: Maybe<UserReviewCounts>;
  /** The list of videos related to this season. */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The total amount of images this season has (including episodes). */
  videosCount?: Maybe<Scalars['Int']['output']>;
  /** The list of VOD/VODEST providers for the season. */
  vodProviders?: Maybe<Array<VodProviders>>;
};


/** An Allociné series or program season. */
export type SeasonBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};


/** An Allociné series or program season. */
export type SeasonCastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  castActivity?: InputMaybe<CastActivity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series or program season. */
export type SeasonCreditsArgs = {
  activity?: InputMaybe<PersonActivity>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonEpisodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EpisodeSorting>>>;
};


/** An Allociné series or program season. */
export type SeasonImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
  type?: InputMaybe<Array<ImageType>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonNewsArgs = {
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
};


/** An Allociné series or program season. */
export type SeasonProductsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonReleasesArgs = {
  country?: InputMaybe<CountryCode>;
};


/** An Allociné series or program season. */
export type SeasonSynopsisArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonUserReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  ratingList?: InputMaybe<Array<InputMaybe<ReviewRatingFloat>>>;
  sentiment?: InputMaybe<ReviewSentimentFilter>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonUserReviewsCountArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonVideosArgs = {
  externalVideo?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series or program season. */
export type SeasonVodProvidersArgs = {
  type?: InputMaybe<Array<VodProductType>>;
};

/** Technical data about seasons. */
export type SeasonData = {
  __typename?: 'SeasonData';
  /** Count of known episodes in the season (existing and coming). */
  episodeCount?: Maybe<Scalars['Int']['output']>;
  /** The rules of the season. */
  rules?: Maybe<EntityRules>;
};

/** An Allociné release for a series. */
export type SeasonRelease = Node & ReleaseInterface & {
  __typename?: 'SeasonRelease';
  /** An advice of the redaction. */
  advice?: Maybe<Scalars['String']['output']>;
  /** The area for this release */
  area?: Maybe<Scalars['String']['output']>;
  /** The official recommendation of CNC. */
  certificate?: Maybe<Certificate>;
  /** The list of companies who worked in this production. */
  companies: Array<EntityCompany>;
  /** The company for which this release is limited to. */
  companyLimitation?: Maybe<Company>;
  /** The country of the release. */
  country?: Maybe<Country>;
  /** Some data related to this release. */
  data?: Maybe<Scalars['Json']['output']>;
  /**
   * The date of the release.
   * @deprecated No longer used. Will be remove soon. Use releaseDate instead.
   */
  date?: Maybe<Scalars['DateLimited']['output']>;
  /** The id of the release. */
  id: Scalars['ID']['output'];
  /** The internal id of the release. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of the release.
   * @deprecated Please use the 'releaseTags' field instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The date of the release. */
  releaseDate?: Maybe<PartialDate>;
  releaseTags?: Maybe<ReleaseTag>;
  stringValue?: Maybe<Scalars['String']['output']>;
};


/** An Allociné release for a series. */
export type SeasonReleaseCompaniesArgs = {
  activity?: InputMaybe<Array<CompanyActivity>>;
};

/** Sorting criteria for season */
export enum SeasonSorting {
  /** Season sorted by number asc. */
  NumberAsc = 'NUMBER_ASC',
  /** Season sorted by number desc. */
  NumberDesc = 'NUMBER_DESC'
}

/** All stats about the season. */
export type SeasonStats = {
  __typename?: 'SeasonStats';
  /** Stats about ratings given by the users. */
  userRating?: Maybe<UserRatingsStats>;
  /** Stats about reviews given by the users. Note that ratings related to reviews are already aggregated into the userRating field */
  userReview?: Maybe<UserReviewsStats>;
};

/** A social action done by a user. */
export type SeenIt = SocialActionInterface & {
  __typename?: 'SeenIt';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Differents fields for seo purposes. */
export type Seo = {
  __typename?: 'Seo';
  /** Entity custom SEO alternate title. */
  alternateTitle?: Maybe<Scalars['String']['output']>;
  /** Information to know if the entity is browsable. */
  browsable?: Maybe<Scalars['Boolean']['output']>;
  /** Entity custom SEO description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Entity custom SEO title. */
  title?: Maybe<Scalars['String']['output']>;
};

export type SeoAbstractScope = {
  __typename?: 'SeoAbstractScope';
  movie: SeoAbstractScopeEntity;
  series: SeoAbstractScopeEntity;
};

export type SeoAbstractScopeEntity = {
  __typename?: 'SeoAbstractScopeEntity';
  description?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Differents fields for seo purposes. */
export type SeoNews = {
  __typename?: 'SeoNews';
  /** Information to know if the entity is hidden. */
  hidden?: Maybe<Scalars['Boolean']['output']>;
};

/** Differents fields for seo purposes. */
export type SeoTag = {
  __typename?: 'SeoTag';
  /** Entity custom SEO alternate title. */
  alternateTitle?: Maybe<Scalars['String']['output']>;
  /** Information to know if the entity is browsable. */
  browsable?: Maybe<Scalars['Boolean']['output']>;
  /** Entity custom SEO description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Information to know if the entity is seo ready. */
  friendly?: Maybe<Scalars['Boolean']['output']>;
  /** seo scope. */
  scope: SeoTagScope;
  /** Entity custom SEO title. */
  title?: Maybe<Scalars['String']['output']>;
  topRanking: Scalars['Boolean']['output'];
};

export type SeoTagScope = {
  __typename?: 'SeoTagScope';
  popularity: SeoAbstractScope;
  pressRating: SeoAbstractScope;
  ranking: SeoAbstractScope;
  userRating: SeoAbstractScope;
};

/** An Allociné series. */
export type Series = Node & {
  __typename?: 'Series';
  /** The best affinities of the series (based on the users, with social action (like it, seen it, etc...). */
  affinities?: Maybe<AnalogyConnection>;
  /** The series' spotify albums */
  albums?: Maybe<Array<Maybe<Soundtrack>>>;
  /** The audiences of the series per country. */
  audience?: Maybe<Array<Maybe<Audience>>>;
  backlink?: Maybe<Backlink>;
  /** All current broadcast for the series. */
  broadcast?: Maybe<Array<Maybe<Broadcast>>>;
  /** The people playing on this series based on current season. */
  cast?: Maybe<CastMemberConnection>;
  /** The list of clubs related to this series. */
  clubs?: Maybe<Array<Maybe<EntityClub>>>;
  /** The newest comments added on this series, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The list of companies which worked in this production. */
  companies?: Maybe<Array<Maybe<SeriesCompany>>>;
  /** The number of episodes existing in database */
  computedEpisodeCount?: Maybe<Scalars['Int']['output']>;
  /** The number of episodes existing in database */
  computedSeasonCount?: Maybe<Scalars['Int']['output']>;
  /** The list of nationalities to which this series is related to. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The cover of the series */
  cover?: Maybe<InternalImage>;
  /** The people working on this series. */
  credits?: Maybe<CreditsConnection>;
  /** The latest broadcasted season. */
  currentSeason?: Maybe<Season>;
  /** Technical data about series. */
  data?: Maybe<SeriesData>;
  /** The number of known episodes (existing and coming). */
  episodeCount?: Maybe<Scalars['Int']['output']>;
  /** The usual length of an episode. Special episodes can be shorter/longer. */
  episodeLength?: Maybe<Scalars['Duration']['output']>;
  /** The festival editions the series was selected in. */
  festivalEdition?: Maybe<FestivalEditionConnection>;
  /** Technical flags about series to have rapid information */
  flags?: Maybe<SeriesFlags>;
  /** The genres of the series, extracted from the tags property. */
  genres?: Maybe<Array<Maybe<Genre>>>;
  /** The id of the series. */
  id: Scalars['ID']['output'];
  /** The list of the images for this series. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The total amount of images this series has (including seasons and episodes). */
  imagesCount?: Maybe<Scalars['Int']['output']>;
  /** The internal id of the series. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The keywords of the series. */
  keywords?: Maybe<Scalars['String']['output']>;
  /** The most recent season having at least one VOD product (including the season episodes). */
  lastSeasonWithVod?: Maybe<Season>;
  /** The main Movie Release according to the defined priorities. */
  mainRelease?: Maybe<MainReleaseInfo>;
  /** News that are related to the current one. Up to 10. */
  news?: Maybe<Array<Maybe<News>>>;
  /** The total amount of news this series has. */
  newsCount?: Maybe<Scalars['Int']['output']>;
  /** Informations about the first broadcast of the series. */
  originalBroadcast?: Maybe<SeriesOriginalBroadcast>;
  /** The original title of the series. */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** The poster of the season. */
  poster?: Maybe<InternalImage>;
  /** The list of the press reviews of this Series. */
  pressReviews?: Maybe<PressReviewsConnection>;
  /**
   * !!!!! DEPRECATED !!!!! Use relatedProducts instead.
   * @deprecated Use relatedProducts instead
   */
  products?: Maybe<Array<Maybe<Product>>>;
  /** The products related to this series. */
  relatedProducts?: Maybe<ProductsConnection>;
  /** The related tags of the movie. */
  relatedTags?: Maybe<Array<Tag>>;
  /** The list of movies/series/seasons/... this series relates to. */
  relations?: Maybe<Array<Maybe<Relation>>>;
  releaseFlags?: Maybe<ReleaseFlags>;
  /** The list of the releases of this series. */
  releases?: Maybe<Array<Maybe<SeriesRelease>>>;
  /** The number of known seasons (existing and coming). */
  seasonCount?: Maybe<Scalars['Int']['output']>;
  /** The paginated seasons of the series. */
  seasons?: Maybe<SeasonsConnection>;
  /** The selections the series was selected in. */
  selection?: Maybe<FestivalSelectionConnection>;
  /**
   * !!!!! DEPRECATED !!!!! The selections the series was selected in.
   * @deprecated Use selection instead
   */
  selections?: Maybe<Array<Maybe<FestivalSelection>>>;
  /** Differents fields for seo purposes. */
  seo?: Maybe<Seo>;
  /** The best similarities of the series (based on metas of series (genre, actors, country, etc...)) */
  similarities?: Maybe<AnalogyConnection>;
  /**
   * The series' spotify soundtracks
   * @deprecated No longer used. You need to get the real architecture on albums endpoint. Will be remove soon.
   */
  soundtracks?: Maybe<Soundtrack>;
  /** All stats about the series. */
  stats?: Maybe<SeriesStats>;
  /** The current status of the series. */
  status?: Maybe<Status>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the series, can be short or long (short by default). */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The synopsis of the serie, on json format. */
  synopsis_json?: Maybe<BodyJson>;
  /** The tags of the series. */
  tags?: Maybe<TagCollection>;
  /** The title of the series. */
  title?: Maybe<Scalars['String']['output']>;
  /** Trending evolution of the daily rank. */
  trendingEvolution?: Maybe<Scalars['Int']['output']>;
  /** The trivias of the series. */
  trivias?: Maybe<TriviasConnection>;
  /** The current type of the series. */
  type?: Maybe<SeriesType>;
  /** The update dates for this series. */
  updatedAt?: Maybe<EntityUpdateDate>;
  userAffinity?: Maybe<SeriesUserAffinity>;
  /** The list of the user reviews of this Series. */
  userReviews?: Maybe<UserReviewsConnection>;
  /** The aggregated counts list of the user reviews of this series. */
  userReviewsCount?: Maybe<UserReviewCounts>;
  /** The list of videos related to this series. */
  videos?: Maybe<Array<Maybe<Video>>>;
  /** The total amount of videos this series has (including seasons and episodes). */
  videosCount?: Maybe<Scalars['Int']['output']>;
};


/** An Allociné series. */
export type SeriesAffinitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  released?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Array<InputMaybe<AnalogyType>>>;
  videoFilter?: InputMaybe<Array<InputMaybe<VideoType>>>;
  videoFilterOperator?: InputMaybe<Operator>;
};


/** An Allociné series. */
export type SeriesAlbumsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SoundtrackSorting>>>;
};


/** An Allociné series. */
export type SeriesBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};


/** An Allociné series. */
export type SeriesBroadcastArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series. */
export type SeriesCastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  castActivity?: InputMaybe<CastActivity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné series. */
export type SeriesCreditsArgs = {
  activity?: InputMaybe<PersonActivity>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<PositionDepartment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesFestivalEditionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<FilterDate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalEditionSorting>>>;
  startDate?: InputMaybe<FilterDate>;
};


/** An Allociné series. */
export type SeriesImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
  type?: InputMaybe<Array<ImageType>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesNewsArgs = {
  category?: InputMaybe<Array<InputMaybe<NewsCategory>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<NewsSorting>>>;
  tag?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An Allociné series. */
export type SeriesPressReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PressReviewsOrder>>;
};


/** An Allociné series. */
export type SeriesProductsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesRelatedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ProductSorting>>>;
  type?: InputMaybe<Array<InputMaybe<ProductType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesReleaseFlagsArgs = {
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesReleasesArgs = {
  country?: InputMaybe<CountryCode>;
};


/** An Allociné series. */
export type SeriesSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<SeriesSeasonFlags>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<SeasonSorting>>>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
};


/** An Allociné series. */
export type SeriesSelectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<FestivalSelectionSorting>>>;
};


/** An Allociné series. */
export type SeriesSelectionsArgs = {
  hasWon?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesSimilaritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<InputMaybe<AnalogyType>>>;
};


/** An Allociné series. */
export type SeriesSynopsisArgs = {
  long?: InputMaybe<Scalars['Boolean']['input']>;
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesTriviasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TriviaSorting>>>;
};


/** An Allociné series. */
export type SeriesUserReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReviewSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  ratingList?: InputMaybe<Array<InputMaybe<ReviewRatingFloat>>>;
  sentiment?: InputMaybe<ReviewSentimentFilter>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesUserReviewsCountArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné series. */
export type SeriesVideosArgs = {
  externalVideo?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityVideoSorting>>>;
  type?: InputMaybe<Array<InputMaybe<VideoType>>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeriesCompany = {
  __typename?: 'SeriesCompany';
  /** The activity of the company. */
  activity?: Maybe<Scalars['String']['output']>;
  /** The company. */
  company?: Maybe<Company>;
  /** The rank of the company for this series/season. */
  rank?: Maybe<Scalars['Int']['output']>;
};

/** Retrieve an entity by another id than Allocine, like IMDB, EIDR, ISAN */
export type SeriesComposedIdType = {
  /** The id of the entity. */
  id: Scalars['String']['input'];
  /** The provider of the id. */
  provider: AltProvider;
};

/** Technical data about series. */
export type SeriesData = {
  __typename?: 'SeriesData';
  /** List of alternative ids for the series. */
  alternativeIds?: Maybe<EntityAlternativeIds>;
  /** The universal unique identifier. */
  eidr?: Maybe<Scalars['String']['output']>;
  /** IMDb ID. */
  imdb?: Maybe<Scalars['String']['output']>;
  /** The international standard audiovisual number. */
  isan?: Maybe<Scalars['String']['output']>;
  /** The rules of the series. */
  rules?: Maybe<EntityRules>;
};

/** An Allociné series episode broadcast. */
export type SeriesEpisodeOriginalBroadcast = {
  __typename?: 'SeriesEpisodeOriginalBroadcast';
  /** The date at which the episode was broadcasted. */
  firstAiredDate?: Maybe<Scalars['DateLimited']['output']>;
};

/** Technical flags about series to have rapid information */
export type SeriesFlags = {
  __typename?: 'SeriesFlags';
  /** True if the series is coming soon on netflix. */
  comingSoonOnNetflix?: Maybe<Scalars['Boolean']['output']>;
  /** The list of clubs having a news related to the series. */
  hasClubNews?: Maybe<Scalars['Json']['output']>;
  /** True if the series has dvd release. */
  hasDvdRelease?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has at least one news. */
  hasNews?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has vod, svod or vodest. */
  hasOnlineProduct?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has vod release. */
  hasOnlineRelease?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has bluray or dvd. */
  hasPhysicalProduct?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has soundtrack. */
  hasSoundtrack?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has some trivia. */
  hasTrivia?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has vodest. */
  hasVodProduct?: Maybe<Scalars['Boolean']['output']>;
  /** The list of clubs that approved the series. */
  isClubApproved?: Maybe<Scalars['Json']['output']>;
  /** True if the series is coming soon without release dates. */
  isComingSoon?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series is only on netflix. */
  onlyNetflix?: Maybe<Scalars['Boolean']['output']>;
  /** True if the series has tv release. */
  tvRelease?: Maybe<Scalars['Boolean']['output']>;
};

export type SeriesFlagsType = {
  /** Filter list with series having an awaited season. */
  has_awaited_season?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have an editorial review */
  has_editorial_review?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has a physical product. */
  has_physical_product?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has a soundtrack. */
  has_soundtrack?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter series that have at least one trailer or teaser */
  has_trailer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with entity that has some trivia. */
  has_trivia?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided will list amazon prime's entities */
  is_amazon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter movies list that have been approved by a brand Club (Club300, Scream Club, etc.) */
  is_club_approved?: InputMaybe<EntityClubFlagType>;
  /** When provided will list Netflix's series */
  is_netflix?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with series coming with new season. */
  is_upcoming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter list with series coming with new season on TV. */
  renew_series_to_tv?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter series that have a season coming soon */
  season_upcoming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter series that have a season coming soon with at least one trailer or teaser */
  season_upcoming_has_trailer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SeriesLastSeasonDatesDateFilterType = {
  /** The date to start the range from. */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date to end the range to. */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Filter by last season (in progress or ended) starts/end dates */
export type SeriesLastSeasonDatesFilterType = {
  /** If true, will only return the series having only one season. */
  isFirstSeason?: InputMaybe<Scalars['Boolean']['input']>;
  /** The starts/ends dates to filter on. */
  startsAt?: InputMaybe<SeriesLastSeasonDatesDateFilterType>;
};

/** Filter by last season (in progress or ended) starts/end dates */
export type SeriesLastSeasonFilterType = {
  /** The date to start the range from (default: current date). */
  dateFrom: Scalars['DateTime']['input'];
  /** The amount of days after the season ending date to include in the result (default: 30 days). */
  range?: InputMaybe<Scalars['Int']['input']>;
};

/** An Allociné series. */
export type SeriesOriginalBroadcast = {
  __typename?: 'SeriesOriginalBroadcast';
  /** The original channel that broadcasted the series. */
  channel?: Maybe<Company>;
  /**
   * The date at which the first episode was broadcasted.
   * @deprecated This date is partial, use firstAiredDate instead
   */
  firstAired?: Maybe<Scalars['DateLimited']['output']>;
  /** The partial date at which the first episode was broadcasted. */
  firstAiredDate?: Maybe<PartialDate>;
  /**
   * The date at which the last episode was broadcasted.
   * @deprecated This date is partial, use lastAiredDate instead
   */
  lastAired?: Maybe<Scalars['DateLimited']['output']>;
  /** The partial date at which the last episode was broadcasted. */
  lastAiredDate?: Maybe<PartialDate>;
};

/** An Allociné release for a series. */
export type SeriesRelease = Node & ReleaseInterface & {
  __typename?: 'SeriesRelease';
  /** An advice of the redaction. */
  advice?: Maybe<Scalars['String']['output']>;
  /** The area for this release */
  area?: Maybe<Scalars['String']['output']>;
  /** The official recommendation of CNC. */
  certificate?: Maybe<Certificate>;
  /** The list of companies who worked in this production. */
  companies: Array<EntityCompany>;
  /** The company for which this release is limited to. */
  companyLimitation?: Maybe<Company>;
  /** The country of the release. */
  country?: Maybe<Country>;
  /** Some data related to this release. */
  data?: Maybe<Scalars['Json']['output']>;
  /**
   * The date of the release.
   * @deprecated No longer used. Will be remove soon. Use releaseDate instead.
   */
  date?: Maybe<Scalars['DateLimited']['output']>;
  /** The id of the release. */
  id: Scalars['ID']['output'];
  /** The internal id of the release. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of the release.
   * @deprecated Please use the 'releaseTags' field instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The date of the release. */
  releaseDate?: Maybe<PartialDate>;
  releaseTags?: Maybe<ReleaseTag>;
  stringValue?: Maybe<Scalars['String']['output']>;
};


/** An Allociné release for a series. */
export type SeriesReleaseCompaniesArgs = {
  activity?: InputMaybe<Array<CompanyActivity>>;
};

/** Filter series users reviews by one rating. */
export enum SeriesReviewRating {
  /** Only show reviews for rating equals to 5. */
  Five = 'FIVE',
  /** Only show reviews for rating equals to 4 or 4.5. */
  Four = 'FOUR',
  /** Only show series without rating. */
  None = 'NONE',
  /** Only show reviews for rating equals to 1 or 1.5. */
  One = 'ONE',
  /** Only show reviews for rating equals to 3 or 3.5. */
  Three = 'THREE',
  /** Only show reviews for rating equals to 2 or 2.5. */
  Two = 'TWO',
  /** Only show reviews for rating equals to 0.5 (O can't be submit). */
  Zero = 'ZERO'
}

/** Technical flags about series season to have rapid information */
export type SeriesSeasonFlags = {
  /** True if the season or its episodes has a linked cast. */
  has_cast?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the season or its episodes has a linked image. */
  has_image?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the season or its episodes has a linked video. */
  has_video?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the season has vod/vodest. */
  has_vod_product?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sorting criteria for series */
export enum SeriesSorting {
  /** Series sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Series sorted by their last season (having a status IN_PROGRESS OR ENDED) premiere date, most recent dates first. */
  LastSeasonPremiere = 'LAST_SEASON_PREMIERE',
  /** Series sorted by their SVOD release dates, most recent releases first. */
  LatestReleasesSvod = 'LATEST_RELEASES_SVOD',
  /** Series sorted by their VOD release dates, most recent releases first. */
  LatestReleasesVod = 'LATEST_RELEASES_VOD',
  /** Series sorted by popularity on a monthly basis. */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** No sort is applied. */
  None = 'NONE',
  /** Series sorted by their SVOD release dates, oldest releases first. */
  OldestReleasesSvod = 'OLDEST_RELEASES_SVOD',
  /** Series sorted by their VOD release dates, oldest releases first. */
  OldestReleasesVod = 'OLDEST_RELEASES_VOD',
  /** Series sorted by started date desc. */
  PremiereOriginal = 'PREMIERE_ORIGINAL',
  /** Series sorted by their press rank, best best rating on series first. */
  Press = 'PRESS',
  /** Series sorted by popularity on a three-monthly basis. */
  QuarterlyPopularity = 'QUARTERLY_POPULARITY',
  /** Series sorted by title in alphabetical reversed order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Series sorted by user rating score */
  Score = 'SCORE',
  /** Series sorted by their season's date coming to tv. */
  SeasonPremiere = 'SEASON_PREMIERE',
  /** Series sorted by the trend (evolution of the rank of daily visit). */
  Trend = 'TREND',
  /** Series sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** All stats about the series. */
export type SeriesStats = {
  __typename?: 'SeriesStats';
  /** An array of metrics for a given entity. */
  metric?: Maybe<StatsMetric>;
  /** Stats about reviews given by the press. */
  pressReview?: Maybe<PressReviewsStats>;
  /** Stats about ratings given by the users. */
  userRating?: Maybe<UserRatingsStats>;
  /** Stats about reviews given by the users. Note that ratings related to reviews are already aggregated into the userRating field */
  userReview?: Maybe<UserReviewsStats>;
  wantToSeeCount: Scalars['Int']['output'];
};

/** User series status. */
export enum SeriesStatus {
  Followed = 'FOLLOWED',
  HavingProgression = 'HAVING_PROGRESSION',
  NotInterested = 'NOT_INTERESTED',
  NotReviewed = 'NOT_REVIEWED',
  /** Series having a rating on series level */
  Rating = 'RATING',
  Seen = 'SEEN',
  WantToSee = 'WANT_TO_SEE'
}

export enum SeriesType {
  Manga = 'MANGA',
  Miniseries = 'MINISERIES',
  Series = 'SERIES'
}

/** Series affinity score for current user. */
export type SeriesUserAffinity = {
  __typename?: 'SeriesUserAffinity';
  affinityScore?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Array<UserAffinityScoreReason>>;
};

export type ServiceFacet = FacetValue & {
  __typename?: 'ServiceFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

export type Showtime = Node & {
  __typename?: 'Showtime';
  /** Showtime accessibility features */
  accessibility?: Maybe<Array<Maybe<Accessibility>>>;
  /** The comforts available in showtime */
  comfort?: Maybe<Array<Maybe<Comfort>>>;
  /** Technical information about the showtime. */
  data?: Maybe<ShowtimeData>;
  /** The diffusion version. */
  diffusionVersion?: Maybe<ShowtimeVersion>;
  /** The experience of the showtime */
  experience?: Maybe<Array<Maybe<Experience>>>;
  /**
   * The projection format.
   * @deprecated Use projection instead.
   */
  format?: Maybe<ProjectionFormat>;
  /** The id of the showtime. */
  id: Scalars['ID']['output'];
  /** The internal id of the showtime. */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** True if showtime is link on movies that is not in theater in the two showtime week but have showtime in future. */
  isFutureReleaseSoon?: Maybe<Scalars['Boolean']['output']>;
  /** True if showtime is preview. */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** True if showtime is displayed in theater in the first outing week of movie. */
  isWeeklyMovieOuting?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the showtime */
  languages?: Maybe<Array<Maybe<Language>>>;
  /** The picture of the showtime */
  picture?: Maybe<Array<Maybe<Picture>>>;
  /** The projection of the showtime */
  projection?: Maybe<Array<Maybe<Projection>>>;
  /** The theater screens related to this showtime. */
  screen?: Maybe<TheaterScreen>;
  /** !!! WARNING - The data in this endpoint are sensible and not accurate. You should not use them as long as this warning is present !!! The services available in showtime */
  service?: Maybe<Array<Maybe<TheaterService>>>;
  /** The diffusion sound of the showtime */
  sound?: Maybe<Array<Maybe<Sound>>>;
  /** The start date of the showtime (the hour is about the theater). */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** Technical information about the showtime. */
  tags: Array<Scalars['String']['output']>;
  /**
   * The projection techno.
   * @deprecated Use experience instead.
   */
  techno?: Maybe<Array<Maybe<TechnoFlag>>>;
  /** The delay between the indicated start date of the showtime and the actual beginning of the projection. */
  timeBeforeStart?: Maybe<Scalars['DateInterval']['output']>;
  /**
   * The projection language.
   * @deprecated This field is not longer used. Use diffusionVersion to have real version.
   */
  version?: Maybe<Language>;
};


export type ShowtimeTagsArgs = {
  filter?: InputMaybe<Array<TagsFilterType>>;
};

/** Technical data about showtimes. */
export type ShowtimeData = {
  __typename?: 'ShowtimeData';
  /** An array of ticketing reservation. */
  ticketing?: Maybe<Array<Maybe<Ticketing>>>;
};


/** Technical data about showtimes. */
export type ShowtimeDataTicketingArgs = {
  provider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<TicketingTypeEnum>>>;
};

/** Sorting criteria for movies */
export enum ShowtimeSorting {
  /** Sorted by movie title or theater name in alphabetical order. Using in theaterShowtimeList and movieShowtimeList. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort with the closest in space first. Only for theaterShowtimeList. */
  Closest = 'CLOSEST',
  /** Sort by group rank. Only available on theaterShowtimeList and when using group filter. */
  GroupRank = 'GROUP_RANK',
  /** No sort is applied. */
  None = 'NONE',
  /** Sorted by movie premieres. Only for movieShowtimeList. */
  Preview = 'PREVIEW',
  /** Sort by release date asc. */
  ReleaseDate = 'RELEASE_DATE',
  /** Sorted by movie title or theater name in reverse alphabetical order. Using in theaterShowtimeList and movieShowtimeList. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Sort by release date desc. */
  ReverseReleaseDate = 'REVERSE_RELEASE_DATE',
  /** Sort by showtime date asc. */
  ShowtimeDate = 'SHOWTIME_DATE',
  /** Sorted by movie with showtime in first week outing. Only for movieShowtimeList. */
  WeeklyOuting = 'WEEKLY_OUTING',
  /** Sort by popularity (weekly) of the movie. Only for movieShowtimeList. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** The available showtime diffusion version. */
export enum ShowtimeVersion {
  /** The showtime has not the same language than the movie. */
  Dubbed = 'DUBBED',
  /** The showtime has the same language than the movie and the country. */
  Local = 'LOCAL',
  /** The showtime has the same language than the movie but not the country. */
  Original = 'ORIGINAL'
}

export type ShowtimeWithParentsId = Node & {
  __typename?: 'ShowtimeWithParentsId';
  /** Showtime accessibility features */
  accessibility?: Maybe<Array<Maybe<Accessibility>>>;
  /** The comforts available in showtime */
  comfort?: Maybe<Array<Maybe<Comfort>>>;
  /** Technical information about the showtime. */
  data?: Maybe<ShowtimeData>;
  /** The diffusion version. */
  diffusionVersion?: Maybe<ShowtimeVersion>;
  /** The experience of the showtime */
  experience?: Maybe<Array<Maybe<Experience>>>;
  /**
   * The projection format.
   * @deprecated Use projection instead.
   */
  format?: Maybe<ProjectionFormat>;
  /** The id of the showtime. */
  id: Scalars['ID']['output'];
  /** The internal id of the showtime. */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** True if showtime is link on movies that is not in theater in the two showtime week but have showtime in future. */
  isFutureReleaseSoon?: Maybe<Scalars['Boolean']['output']>;
  /** True if showtime is preview. */
  isPreview?: Maybe<Scalars['Boolean']['output']>;
  /** True if showtime is displayed in theater in the first outing week of movie. */
  isWeeklyMovieOuting?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the showtime */
  languages?: Maybe<Array<Maybe<Language>>>;
  /** The movies broadcasted in the theater. */
  movie?: Maybe<Movie>;
  /** The picture of the showtime */
  picture?: Maybe<Array<Maybe<Picture>>>;
  /** The projection of the showtime */
  projection?: Maybe<Array<Maybe<Projection>>>;
  /** The theater screens related to this showtime. */
  screen?: Maybe<TheaterScreen>;
  /** !!! WARNING - The data in this endpoint are sensible and not accurate. You should not use them as long as this warning is present !!! The services available in showtime */
  service?: Maybe<Array<Maybe<TheaterService>>>;
  /** The diffusion sound of the showtime */
  sound?: Maybe<Array<Maybe<Sound>>>;
  /** The start date of the showtime (the hour is about the theater). */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** Technical information about the showtime. */
  tags: Array<Scalars['String']['output']>;
  /**
   * The projection techno.
   * @deprecated Use experience instead.
   */
  techno?: Maybe<Array<Maybe<TechnoFlag>>>;
  /** The theaters where the movie is showing. */
  theater?: Maybe<Theater>;
  /** The delay between the indicated start date of the showtime and the actual beginning of the projection. */
  timeBeforeStart?: Maybe<Scalars['DateInterval']['output']>;
  /**
   * The projection language.
   * @deprecated This field is not longer used. Use diffusionVersion to have real version.
   */
  version?: Maybe<Language>;
};


export type ShowtimeWithParentsIdTagsArgs = {
  filter?: InputMaybe<Array<TagsFilterType>>;
};

/** Fetches a social action given its ID */
export type SocialActionInterface = {
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Social links */
export type SocialLinks = {
  __typename?: 'SocialLinks';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  tumblr?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  vk?: Maybe<Scalars['String']['output']>;
  wechat?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

/** All type of social media. */
export enum SocialMedia {
  Avatar = 'AVATAR',
  Banner = 'BANNER'
}

/** A category of images for avatar and background. */
export type SocialMediaCategory = Node & {
  __typename?: 'SocialMediaCategory';
  /** The id of the SocialMediaCategory. */
  id: Scalars['ID']['output'];
  /** Images from this category filtered by type (SOCIAL_USER_AVATAR or SOCIAL_USER_BANNER). Defaults to the type from the parent list. */
  images?: Maybe<ImagesConnection>;
  /** The internal id of the SocialMediaCategory. */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** The name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The rank of the category for ordering. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Whether the category is sponsored or not. */
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tag of the category. */
  tag?: Maybe<SocialMedia>;
};


/** A category of images for avatar and background. */
export type SocialMediaCategoryImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  imageType?: InputMaybe<SocialMedia>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** All sound formats. */
export enum Sound {
  Atmos = 'ATMOS',
  Auro = 'AURO',
  Dolby_71 = 'DOLBY_71',
  Dubbed = 'DUBBED',
  MultiChannelSound = 'MULTI_CHANNEL_SOUND',
  S_51 = 'S_51',
  S_71 = 'S_71',
  Thx = 'THX'
}

export type SoundFacet = FacetValue & {
  __typename?: 'SoundFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  translation?: Maybe<GenericTagFacetType>;
};

/** A Spotify soundtrack for a series or a movie. */
export type Soundtrack = {
  __typename?: 'Soundtrack';
  /** The newest comments added on this soundtrack, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** The list of the albums. */
  disk?: Maybe<Array<Maybe<Disk>>>;
  /** The performers of the soundtrack. */
  performers?: Maybe<Array<Maybe<Person>>>;
  /** The related entities of the soundtrack */
  relatedEntities?: Maybe<Array<Maybe<Node>>>;
  /** The soundtrack's release date. */
  releasedAt?: Maybe<PartialDate>;
  /** The soundtrack's Spotify URL. */
  spotify?: Maybe<Scalars['String']['output']>;
  /** The soundtrack's title. */
  title?: Maybe<Scalars['String']['output']>;
};


/** A Spotify soundtrack for a series or a movie. */
export type SoundtrackCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A Spotify soundtrack for a series or a movie. */
export type SoundtrackRelatedEntitiesArgs = {
  type?: InputMaybe<Array<InputMaybe<NodeTypeSoundtracks>>>;
};

/** Sorting criteria for soundtracks */
export enum SoundtrackSorting {
  /** Sorted by soundtrack title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Sorted by date order. */
  Date = 'DATE',
  /** Sorted by linked entity popularity order. */
  EntityPopularity = 'ENTITY_POPULARITY',
  /** No sort is applied. */
  None = 'NONE',
  /** Sorted by popularity order. */
  Popularity = 'POPULARITY',
  /** Sorted by spotify rank order. */
  Rank = 'RANK',
  /** Sorted by soundtrack title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Sorted by reverse date order. */
  ReverseDate = 'REVERSE_DATE',
  /** Sorted by reverse linked entity popularity order. */
  ReverseEntityPopularity = 'REVERSE_ENTITY_POPULARITY',
  /** Sorted by reverse popularity order. */
  ReversePopularity = 'REVERSE_POPULARITY',
  /** Sorted by reverse spotify rank order. */
  ReverseRank = 'REVERSE_RANK'
}

/** Show special operations on entity. */
export type SpecialOperation = {
  __typename?: 'SpecialOperation';
  /** Will show all main operations for the entity. */
  main?: Maybe<Array<Maybe<MainSpecialOperation>>>;
  /** Will show all target operation witch entity is linked. */
  target?: Maybe<Array<Maybe<TargetSpecialOperation>>>;
};

/** The different codes for a special operation. */
export enum SpecialOperationCode {
  AqoaTopVod = 'AQOA_TOP_VOD',
  BannerHp = 'BANNER_HP',
  CanalHome = 'CANAL_HOME',
  ClassiqueHome = 'CLASSIQUE_HOME',
  Club300 = 'CLUB300',
  DisneyHome = 'DISNEY_HOME',
  DolbyHome = 'DOLBY_HOME',
  Emergence = 'EMERGENCE',
  EmergenceSvod = 'EMERGENCE_SVOD',
  FestivalSection = 'FESTIVAL_SECTION',
  FilmesOnline = 'FILMES_ONLINE',
  ImaxHome = 'IMAX_HOME',
  IndelebileHome = 'INDELEBILE_HOME',
  M6Home = 'M6_HOME',
  MacDonalds = 'MAC_DONALDS',
  MaxHome = 'MAX_HOME',
  MobileDday = 'MOBILE_DDAY',
  NetflixHome = 'NETFLIX_HOME',
  NetflixNews = 'NETFLIX_NEWS',
  NetflixSponsoredNews = 'NETFLIX_SPONSORED_NEWS',
  NetflixTab = 'NETFLIX_TAB',
  NovelasHome = 'NOVELAS_HOME',
  Popcorn = 'POPCORN',
  RollerHome = 'ROLLER_HOME',
  SponsoredAutocomplete = 'SPONSORED_AUTOCOMPLETE',
  SponsoredNews = 'SPONSORED_NEWS',
  Tf1Home = 'TF1_HOME',
  TicketAnchor = 'TICKET_ANCHOR',
  VideoSelectionGeneralPage = 'VIDEO_SELECTION_GENERAL_PAGE',
  VideoSelectionVideosHome = 'VIDEO_SELECTION_VIDEOS_HOME',
  VodHome = 'VOD_HOME'
}

/** The different codes for a target of special operation. */
export enum SpecialOperationTargetCode {
  CarouselItem = 'CAROUSEL_ITEM',
  Countdown = 'COUNTDOWN',
  HomepageNews_1 = 'HOMEPAGE_NEWS_1',
  HomepageNews_2 = 'HOMEPAGE_NEWS_2',
  HomepageNews_3 = 'HOMEPAGE_NEWS_3',
  HomepageRoller_1 = 'HOMEPAGE_ROLLER_1',
  HomepageRoller_2 = 'HOMEPAGE_ROLLER_2',
  HomepageRoller_3 = 'HOMEPAGE_ROLLER_3',
  HomepageRoller_4 = 'HOMEPAGE_ROLLER_4',
  HomepageRoller_5 = 'HOMEPAGE_ROLLER_5',
  HomepageRoller_6 = 'HOMEPAGE_ROLLER_6',
  HomepageRoller_7 = 'HOMEPAGE_ROLLER_7',
  HomepageRoller_8 = 'HOMEPAGE_ROLLER_8',
  HomepageRoller_9 = 'HOMEPAGE_ROLLER_9',
  HomepageRoller_10 = 'HOMEPAGE_ROLLER_10',
  Mainvideo = 'MAINVIDEO',
  MobileBottomBanner = 'MOBILE_BOTTOM_BANNER',
  News = 'NEWS',
  Othertrailers = 'OTHERTRAILERS',
  Playerfooter = 'PLAYERFOOTER',
  Playerlist = 'PLAYERLIST',
  Postroll = 'POSTROLL',
  SvodNews = 'SVOD_NEWS',
  SvodRoller = 'SVOD_ROLLER',
  TheaterPage = 'THEATER_PAGE'
}

export type StatsMetric = {
  __typename?: 'StatsMetric';
  advertising_videos?: Maybe<Scalars['Int']['output']>;
  /** The number of user votes indicating that this is helpful. */
  helpful_count?: Maybe<Scalars['Int']['output']>;
  /** The number of hits for this page. */
  hits?: Maybe<Scalars['Int']['output']>;
  /** The number of sessions. */
  sessions?: Maybe<Scalars['Int']['output']>;
  /** The number of starts on the video. */
  starts?: Maybe<Scalars['Int']['output']>;
  /** The number of user votes indicating that this is not helpful. */
  unhelpful_count?: Maybe<Scalars['Int']['output']>;
  /** The number of unique visitors who has seen this page. */
  unique_visitors?: Maybe<Scalars['Int']['output']>;
  /** The number  */
  videos?: Maybe<Scalars['Int']['output']>;
};

export enum Status {
  /** The series was cancelled. */
  Cancelled = 'CANCELLED',
  /** The series is over. */
  Ended = 'ENDED',
  /** The series is currently diffused or next season arrive soon. */
  InProgress = 'IN_PROGRESS',
  /** The pilot of the series is ready. */
  Pilot = 'PILOT',
  /** the series is being produced. */
  ToCome = 'TO_COME'
}

/** A social action done by a user. */
export type Subscribe = SocialActionInterface & {
  __typename?: 'Subscribe';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SvodFlags {
  /** only available from a svod provider */
  Exclusive = 'EXCLUSIVE',
  /** original creation of the svod provider */
  Original = 'ORIGINAL',
  /** Already available on svod provider */
  Released = 'RELEASED',
  /** Will be released on svod provider */
  Upcoming = 'UPCOMING'
}

export enum SvodProviders {
  Adn = 'ADN',
  AmazonPrime = 'AMAZON_PRIME',
  AppleTv = 'APPLE_TV',
  Benshi = 'BENSHI',
  Canalplay = 'CANALPLAY',
  Disney = 'DISNEY',
  FilmoTv = 'FILMO_TV',
  GloboPlay = 'GLOBO_PLAY',
  Hbo = 'HBO',
  HboGo = 'HBO_GO',
  Joyn = 'JOYN',
  M6 = 'M6',
  Madelen = 'MADELEN',
  MagentaTv = 'MAGENTA_TV',
  Max = 'MAX',
  Movistar = 'MOVISTAR',
  Mubi = 'MUBI',
  MyCanal = 'MY_CANAL',
  Netflix = 'NETFLIX',
  Ocs = 'OCS',
  Salto = 'SALTO',
  SfrPlay = 'SFR_PLAY',
  Sky = 'SKY',
  StarzPlay = 'STARZ_PLAY',
  Tf1Plus = 'TF1PLUS',
  TvNow = 'TV_NOW',
  UniversCine = 'UNIVERS_CINE'
}

/** A Tag, it contain a list of movies and series by theme */
export type Tag = Node & {
  __typename?: 'Tag';
  /** Technical data about tag. */
  data: TagData;
  /** The id of the tag. */
  id: Scalars['ID']['output'];
  /** The internal id of the tag. */
  internalId: Scalars['Int']['output'];
  /** The tag's name. */
  name: Scalars['String']['output'];
  /** The related entities of the tag. */
  relatedEntities?: Maybe<NodeConnection>;
  /** The scope of the tag if it has one. */
  scope?: Maybe<TagScope>;
  stringValue: Scalars['String']['output'];
  /** The tags of the tag */
  tags: TagCollection;
};


/** A Tag, it contain a list of movies and series by theme */
export type TagRelatedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Array<TagType>>;
};

/** A collection of tags. */
export type TagCollection = {
  __typename?: 'TagCollection';
  /** The list of the tags which are in this collection. */
  list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: 'TagConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Technical data about tag. */
export type TagData = {
  __typename?: 'TagData';
  /** Differents fields for seo purposes. */
  seo?: Maybe<SeoTag>;
};

/** An edge in a connection. */
export type TagEdge = {
  __typename?: 'TagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Tag>;
};

/** Related entities type on tag. */
export enum TagRelatedType {
  /** Filter tag by related entities type movie. */
  Movie = 'MOVIE',
  /** Filter tag by related entities type person. */
  Person = 'PERSON',
  /** Filter tag by related entities type series. */
  Series = 'SERIES'
}

export enum TagScope {
  Age = 'AGE',
  Provider = 'PROVIDER',
  Theme = 'THEME',
  Tracking = 'TRACKING'
}

/** Sorting criteria for news */
export enum TagSorting {
  /** Tag are sorted by reverse publication date. */
  LatestPublication = 'LATEST_PUBLICATION',
  /** Tag are sorted by monthly popularity */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** Tag are sorted by publication date. */
  OldestPublication = 'OLDEST_PUBLICATION',
  /** Tag are sorted by weekly popularity */
  WeeklyPopularity = 'WEEKLY_POPULARITY',
  /** Tag are sorted by yearly popularity */
  YearlyPopularity = 'YEARLY_POPULARITY'
}

/** Related entities type on tag. */
export enum TagType {
  /** Filter tag by related entities type movie. */
  Movie = 'MOVIE',
  /** Filter tag by related entities type person. */
  Person = 'PERSON',
  /** Filter tag by related entities type series. */
  Series = 'SERIES'
}

/** The available tags to show. */
export enum TagsFilterType {
  Comfort = 'COMFORT',
  Experience = 'EXPERIENCE',
  Languages = 'LANGUAGES',
  Picture = 'PICTURE',
  Projection = 'PROJECTION',
  Service = 'SERVICE',
  Sound = 'SOUND'
}

/** Show information about a target special operations on entity. */
export type TargetSpecialOperation = {
  __typename?: 'TargetSpecialOperation';
  /** The main operation data. */
  data?: Maybe<Scalars['Json']['output']>;
  /** The target operation end date. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The entity focused on the target operation. */
  entity?: Maybe<Node>;
  /** The target operation id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The main operation focused. */
  main?: Maybe<MainSpecialOperation>;
  /** The target operation rank. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The target operation start date. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The target of the operation. */
  value?: Maybe<Scalars['String']['output']>;
};

/** All projections techno flags. */
export enum TechnoFlag {
  Atmos = 'ATMOS',
  DolbyCinema = 'DOLBY_CINEMA',
  EclairColor = 'ECLAIR_COLOR',
  Ice = 'ICE',
  LightVibes = 'LIGHT_VIBES',
  T_4Dx = 'T_4DX'
}

/** An Allociné theater. */
export type Theater = Node & {
  __typename?: 'Theater';
  /** AccessLibre data (available for french theaters only) */
  accesLibre?: Maybe<AccesLibreData>;
  /** Show the closest restaurants to this theater. */
  closestRestaurants?: Maybe<Array<Maybe<TheaterClosestRestaurants>>>;
  /** The comforts available in theater */
  comfort?: Maybe<Array<Maybe<Comfort>>>;
  /** All company link to the theater. */
  companies?: Maybe<Array<Maybe<EntityCompany>>>;
  /** The coordinates of the theater. */
  coordinates?: Maybe<Coordinates>;
  /** The country of the theater. */
  country?: Maybe<Country>;
  /** The cover of the theater. */
  cover?: Maybe<InternalImage>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** The experience available in theater */
  experience?: Maybe<Array<Maybe<Experience>>>;
  /** The list of fares available in this theater. */
  fares?: Maybe<Array<Maybe<TheaterFare>>>;
  /** The theater feeds. */
  feeds?: Maybe<Array<Maybe<TheaterFeeds>>>;
  /** Technical flags about theater to have rapid information. */
  flags?: Maybe<TheaterFlags>;
  /** The different groups that theater has been related. */
  groups?: Maybe<Array<Maybe<Group>>>;
  /**
   * True if theater has showtimes.
   * @deprecated Use flags.hasPreview instead
   */
  hasPreview?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the theater. */
  id: Scalars['ID']['output'];
  /** The list of the images for this theater. */
  images?: Maybe<Array<Maybe<InternalImage>>>;
  /** The internal id of the theater. */
  internalId?: Maybe<Scalars['String']['output']>;
  /** The address of the theater. */
  location?: Maybe<Location>;
  /** The list of loyalty cards accepted in this theater. */
  loyaltyCards?: Maybe<Array<Maybe<LoyaltyCard>>>;
  /** The name of the theater. */
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The image of the theater. */
  poster?: Maybe<InternalImage>;
  /** The projection available in theater */
  projection?: Maybe<Array<Maybe<Projection>>>;
  /** The number of screens in the theater. */
  screenNumber?: Maybe<Scalars['Int']['output']>;
  /** The theater's screens. */
  screens?: Maybe<Array<Maybe<TheaterScreen>>>;
  /** The number of seat in the theater. */
  seatNumber?: Maybe<Scalars['Int']['output']>;
  /** !!! WARNING - The data in this endpoint are sensible and not accurate. You should not use them as long as this warning is present !!! The services available in theater */
  service?: Maybe<Array<Maybe<TheaterService>>>;
  /** Show all showtimes dates for this theater. */
  showtimesDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The sounds available in theater */
  sound?: Maybe<Array<Maybe<Sound>>>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the theater */
  tags?: Maybe<TagCollection>;
  /** Show information if the theater has a temporary closure and reason. */
  temporaryClosure?: Maybe<TheaterTemporaryClosureType>;
  /** The circuit of the theater. */
  theaterCircuits?: Maybe<Company>;
  /** The timezone of the theater. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** A list of public transportations which can be used to reach the theater. */
  transportations?: Maybe<Transportations>;
  url?: Maybe<Scalars['String']['output']>;
  urlShowtimes?: Maybe<Scalars['String']['output']>;
  urlShowtimesAlternate?: Maybe<Scalars['String']['output']>;
};


/** An Allociné theater. */
export type TheaterDescriptionArgs = {
  locale: Locales;
};


/** An Allociné theater. */
export type TheaterImagesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntityImageSorting>>>;
};


/** An Allociné theater. */
export type TheaterShowtimesDatesArgs = {
  comfort?: InputMaybe<Array<InputMaybe<Comfort>>>;
  country?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  experience?: InputMaybe<Array<InputMaybe<Experience>>>;
  format?: InputMaybe<Array<InputMaybe<ProjectionFormat>>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  hasFutureReleaseSoon?: InputMaybe<Scalars['Boolean']['input']>;
  picture?: InputMaybe<Array<InputMaybe<Picture>>>;
  projection?: InputMaybe<Array<InputMaybe<Projection>>>;
  service?: InputMaybe<Array<InputMaybe<TheaterService>>>;
  sound?: InputMaybe<Array<InputMaybe<Sound>>>;
  techno?: InputMaybe<Array<InputMaybe<TechnoFlag>>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
};

export type TheaterAffiliation = {
  /** The relation possible with the company */
  activity: TheaterCompanyActivity;
  /** The id of the company (Company:1234 in base64 encoded). */
  companyId: Scalars['String']['input'];
};

/** Sorting criteria for companies. */
export enum TheaterChainSorting {
  /** Sorted by company name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** No sort is applied. */
  None = 'NONE',
  /** Companies sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Sort companies by theaters count attached descendant. */
  ReverseTheaterCount = 'REVERSE_THEATER_COUNT',
  /** Sort companies by theaters count attached ascendant. */
  TheaterCount = 'THEATER_COUNT'
}

/** The closest restaurants for a given theater. */
export type TheaterClosestRestaurants = {
  __typename?: 'TheaterClosestRestaurants';
  /** The code of the restaurant. */
  code?: Maybe<Scalars['String']['output']>;
  /** The coordinates of the restaurant. */
  coordinates?: Maybe<Coordinates>;
  /** The deep link of the restaurant. */
  deepLink?: Maybe<Scalars['String']['output']>;
  /** The id of the restaurant. */
  id: Scalars['ID']['output'];
  /** The address of the restaurant. */
  localization?: Maybe<Location>;
  /** The mobile URL of the restaurant. */
  mobileUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the restaurant. */
  name?: Maybe<Scalars['String']['output']>;
  /** The opening hours of the restaurant. */
  openingHours?: Maybe<Array<Maybe<OpeningHours>>>;
  /** The reference of the restaurant. */
  reference?: Maybe<Scalars['Int']['output']>;
};

/** Relation possible with a company. */
export enum TheaterCompanyActivity {
  TheaterAffiliate = 'THEATER_AFFILIATE',
  TheaterChain = 'THEATER_CHAIN',
  TheaterOnlineTicketing = 'THEATER_ONLINE_TICKETING',
  TheaterPointOfSale = 'THEATER_POINT_OF_SALE',
  TheaterTradeGroup = 'THEATER_TRADE_GROUP'
}

/** A connection to a list of items. */
export type TheaterConnection = {
  __typename?: 'TheaterConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TheaterEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TheaterEdge = {
  __typename?: 'TheaterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Theater>;
};

/** The fares available in a theater. */
export type TheaterFare = {
  __typename?: 'TheaterFare';
  /** A comment about the fare. */
  comment?: Maybe<Scalars['String']['output']>;
  /** The internal id of the fare. */
  internalId?: Maybe<Scalars['String']['output']>;
  /** The name of the fare. */
  name?: Maybe<Scalars['String']['output']>;
  /** The price list for this fare. */
  prices?: Maybe<Array<Maybe<TheaterFarePrice>>>;
};

/** The prices for a given fare. */
export type TheaterFarePrice = {
  __typename?: 'TheaterFarePrice';
  /** The currency code for this price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The price formatted for the current locale. */
  displayPrice?: Maybe<Scalars['String']['output']>;
  /** The raw price value. */
  price?: Maybe<Scalars['String']['output']>;
  /** The theater screens this price is valid for. */
  screens?: Maybe<Array<Maybe<TheaterScreen>>>;
};

export enum TheaterFeedTypeEnum {
  Concert = 'CONCERT',
  Cycle = 'CYCLE',
  Exhibition = 'EXHIBITION',
  LateNightScreening = 'LATE_NIGHT_SCREENING',
  Preview = 'PREVIEW',
  Previewwithmovieteam = 'PREVIEWWITHMOVIETEAM',
  Specialoffer = 'SPECIALOFFER',
  Various = 'VARIOUS'
}

/** A theater feed. */
export type TheaterFeeds = {
  __typename?: 'TheaterFeeds';
  /** The feed's body. */
  body?: Maybe<Scalars['String']['output']>;
  /** The feed ending date. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The feed display end date */
  endsDisplayAt?: Maybe<Scalars['DateTime']['output']>;
  /** The feed's id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image of the feed. */
  poster?: Maybe<InternalImage>;
  /** The feed starting date. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The feed display start date */
  startsDisplayAt?: Maybe<Scalars['DateTime']['output']>;
  /** The feed's title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The feed type. */
  type?: Maybe<TheaterFeedTypeEnum>;
};

/** Technical flags about theater to have rapid information. */
export type TheaterFlags = {
  __typename?: 'TheaterFlags';
  /** True if the theater has showtime with url ticketing. */
  hasBooking?: Maybe<Scalars['Boolean']['output']>;
  /** True if the theater has some events on the planning. */
  hasFeed?: Maybe<Scalars['Boolean']['output']>;
  /** True if the theater has a list of movie that will be displayed on the following weeks (maximum 3 months). */
  hasFutureReleaseSoon?: Maybe<Scalars['Boolean']['output']>;
  /** True if the theater display movie before his outing day. */
  hasPreview?: Maybe<Scalars['Boolean']['output']>;
  /** True if the theater has some showtimes with some prices. */
  hasPrice?: Maybe<Scalars['Boolean']['output']>;
  /** Contains the number of movies displayed in the theater this next week. */
  moviesDisplayedNextWeekCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the number of movies displayed in the theater this week. */
  moviesDisplayedWeekCount?: Maybe<Scalars['Int']['output']>;
  /** Contains the number of previews for the theater. */
  previewCount?: Maybe<Scalars['Int']['output']>;
};

/** Sorting criteria for theaters group list. */
export enum TheaterGroupSorting {
  /** Theaters group sorted by name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Theaters group sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL'
}

/** An Allociné theater screen. */
export type TheaterScreen = Node & {
  __typename?: 'TheaterScreen';
  /** The accessibilities available for this screen */
  accessibility?: Maybe<Array<Maybe<Accessibility>>>;
  /** The comforts available for this screen */
  comfort?: Maybe<Array<Maybe<Comfort>>>;
  /** The experience available for this screen */
  experience?: Maybe<Array<Maybe<Experience>>>;
  /** True if a handicap access is available. */
  handicapAccess?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the theater screen. */
  id: Scalars['ID']['output'];
  /** The internal id of the screen. */
  internalId?: Maybe<Scalars['String']['output']>;
  /** The list of loyalty cards accepted in this theater. */
  loyaltyCards?: Maybe<Array<Maybe<LoyaltyCard>>>;
  /** The name of the theater screen. */
  name?: Maybe<Scalars['String']['output']>;
  /** The picture available for this screen */
  picture?: Maybe<Array<Maybe<Picture>>>;
  /** The projection available for this screen */
  projection?: Maybe<Array<Maybe<Projection>>>;
  /** The number of seats available in showtime room. */
  seatCount?: Maybe<Scalars['Int']['output']>;
  /** !!! WARNING - The data in this endpoint are sensible and not accurate. You should not use them as long as this warning is present !!! The services available for this screen */
  service?: Maybe<Array<Maybe<TheaterService>>>;
  /** The sound available for this screen */
  sound?: Maybe<Array<Maybe<Sound>>>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

/** All services. */
export enum TheaterService {
  Autism = 'AUTISM',
  CandyStore = 'CANDY_STORE',
  DisabledAccess = 'DISABLED_ACCESS',
  TheaterRestaurant = 'THEATER_RESTAURANT'
}

/** Will get a theater and showtimes aggregation by selected movie. */
export type TheaterShowtimeLeaf = {
  __typename?: 'TheaterShowtimeLeaf';
  /** The showtimes screened in the theater. */
  showtimes?: Maybe<Array<Maybe<Showtime>>>;
  /** The theaters where the movie is showing. */
  theater?: Maybe<Theater>;
};


/** Will get a theater and showtimes aggregation by selected movie. */
export type TheaterShowtimeLeafShowtimesArgs = {
  version?: InputMaybe<Array<InputMaybe<ShowtimeVersion>>>;
};

/** Sorting criteria for theaters */
export enum TheaterSorting {
  /** Sort theater by all time stats desc. */
  AllTimeStats = 'ALL_TIME_STATS',
  /** Theaters sorted by name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort with the closest in space first. */
  Closest = 'CLOSEST',
  /** Sort theater by daily stats desc. */
  DailyStats = 'DAILY_STATS',
  /** Sort with the farthest in space first. */
  Farthest = 'FARTHEST',
  /** Alias of FARTHEST. */
  Furthest = 'FURTHEST',
  /** Sort theater by monthly stats desc. */
  MonthlyStats = 'MONTHLY_STATS',
  /** Theaters sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Sort theaters by screen count descendant. */
  ReverseScreenCount = 'REVERSE_SCREEN_COUNT',
  /** Sort theaters by screen count ascendant. */
  ScreenCount = 'SCREEN_COUNT',
  /** Sort theater by weekly stats desc. */
  WeeklyStats = 'WEEKLY_STATS'
}

/** Sorting criteria for theaters */
export enum TheaterSortingLight {
  /** Sort theater by all time stats desc. */
  AllTimeStats = 'ALL_TIME_STATS',
  /** Theaters sorted by name in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Sort theater by daily stats desc. */
  DailyStats = 'DAILY_STATS',
  /** Sort theater by monthly stats desc. */
  MonthlyStats = 'MONTHLY_STATS',
  /** Theaters sorted by name in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Sort theaters by screen count descendant. */
  ReverseScreenCount = 'REVERSE_SCREEN_COUNT',
  /** Sort theaters by screen count ascendant. */
  ScreenCount = 'SCREEN_COUNT',
  /** Sort theater by weekly stats desc. */
  WeeklyStats = 'WEEKLY_STATS'
}

/** Show information if the theater has a temporary closure and reason. */
export type TheaterTemporaryClosureType = {
  __typename?: 'TheaterTemporaryClosureType';
  /** The temporary closure ended date. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reason of temporary closure. */
  message?: Maybe<Scalars['String']['output']>;
  /** The temporary closure started date. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ThemeFacet = FacetValue & {
  __typename?: 'ThemeFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The age which type match. */
  theme?: Maybe<Tag>;
};

export type ThemeTagFacet = FacetValue & {
  __typename?: 'ThemeTagFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The theme Tag3D which type match. */
  theme_tag?: Maybe<CustomType>;
};

/** The ticketing reservation url for desktop and mobile */
export type Ticketing = {
  __typename?: 'Ticketing';
  /** The provider of the ticketing URL. */
  provider?: Maybe<Scalars['String']['output']>;
  /** The type of the ticketing URL. */
  type?: Maybe<TicketingTypeEnum>;
  /** An array of URLs. */
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** The type of the ticketing URL. */
export enum TicketingTypeEnum {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type Track = {
  __typename?: 'Track';
  /** The track's duration. */
  duration?: Maybe<Scalars['Int']['output']>;
  /** The spotify id. */
  isrc?: Maybe<Scalars['String']['output']>;
  /** The track's name. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Differents fields for tracking purposes. */
export type TrackingData = {
  __typename?: 'TrackingData';
  /** VgWort tracking data. */
  vgwort?: Maybe<TrackingDataVgwort>;
};

/** WgWort tracking data. */
export type TrackingDataVgwort = {
  __typename?: 'TrackingDataVgwort';
  /** VgWort public key. */
  public?: Maybe<Scalars['String']['output']>;
};

/** A transportation line. */
export type TransportationLineType = {
  __typename?: 'TransportationLineType';
  /** The line coordinates. */
  coordinates?: Maybe<Coordinates>;
  /** The distance with the theater. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** The line name. */
  label?: Maybe<Scalars['String']['output']>;
  /** The line logo style. */
  style?: Maybe<TransportationStyleType>;
};

/** A transportation stop. */
export type TransportationStopType = {
  __typename?: 'TransportationStopType';
  /** The lines stopped at transportation. */
  lines?: Maybe<Array<Maybe<TransportationLineType>>>;
  /** The transportation stop name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The transportation stop type. */
  type?: Maybe<TransportationTypeEnum>;
};

/** The line style declaration. */
export type TransportationStyleType = {
  __typename?: 'TransportationStyleType';
  /** The background color in hex. */
  background?: Maybe<Scalars['String']['output']>;
  /** The color in hex. */
  color?: Maybe<Scalars['String']['output']>;
};

export enum TransportationTypeEnum {
  Bus = 'BUS',
  Coach = 'COACH',
  Ferry = 'FERRY',
  Localtrain = 'LOCALTRAIN',
  Metro = 'METRO',
  Railshuttle = 'RAILSHUTTLE',
  Rapidtransit = 'RAPIDTRANSIT',
  Train = 'TRAIN',
  Tramway = 'TRAMWAY'
}

/** The different transportation available in a list. */
export type Transportations = {
  __typename?: 'Transportations';
  list?: Maybe<Array<Maybe<TransportationStopType>>>;
};


/** The different transportation available in a list. */
export type TransportationsListArgs = {
  type?: InputMaybe<TransportationTypeEnum>;
};

/** A trivia, it contains some facts about movies, series, etc... */
export type Trivia = {
  __typename?: 'Trivia';
  /** The content of the trivia. */
  body?: Maybe<Scalars['String']['output']>;
  /** The content of the trivia on json format. */
  body_json?: Maybe<BodyJson>;
  /** The title of the trivia. */
  title?: Maybe<Scalars['String']['output']>;
};


/** A trivia, it contains some facts about movies, series, etc... */
export type TriviaBodyArgs = {
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A trivia, it contains some facts about movies, series, etc... */
export type TriviaTitleArgs = {
  strip?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Sorting criteria for trivias. */
export enum TriviaSorting {
  /** Trivias are sorted by modification date, most recent first. */
  Latest = 'LATEST',
  /** Trivias are sorted by modification date, oldest first. */
  Oldest = 'OLDEST',
  /** Trivias are sorted by rank. */
  Rank = 'RANK'
}

export type TypeFacet = FacetValue & {
  __typename?: 'TypeFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The type which type match. */
  type?: Maybe<CustomType>;
};

/** A social action done by a user. */
export type Unhelpful = SocialActionInterface & {
  __typename?: 'Unhelpful';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateUserCollectionInput = {
  /** The collection description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The collection GraphQL id. Used to update or delete a collection. */
  id: Scalars['String']['input'];
  /** The collection name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The collection visibility. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Different information about an url. */
export type Url = {
  __typename?: 'Url';
  /** Describe if link must be open in a new tab. */
  new_window?: Maybe<Scalars['Boolean']['output']>;
  /** The title of the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link of which the item refers. */
  url?: Maybe<Scalars['String']['output']>;
};

/** An Allociné User */
export type User = Node & {
  __typename?: 'User';
  /** Whether or not the user has agreed to receive advertising. */
  AdvertisingConsent?: Maybe<Scalars['Boolean']['output']>;
  /** User uploaded avatar URL. */
  avatar?: Maybe<Scalars['String']['output']>;
  /** The brand of the user. */
  brandId?: Maybe<Scalars['String']['output']>;
  /** The companies that the user has linked to their account. */
  companies?: Maybe<CompanyConnection>;
  /** The date when the user was created */
  creationDate?: Maybe<Scalars['DateTime']['output']>;
  /** User customization settings including avatar and banner. */
  customization?: Maybe<UserCustomization>;
  /** The email of the user */
  email?: Maybe<Scalars['String']['output']>;
  /** The gender of the user. */
  gender?: Maybe<Gender>;
  /** The id of the user */
  id: Scalars['ID']['output'];
  /** The internal id of the user */
  internalId?: Maybe<Scalars['String']['output']>;
  /** Whether or not the user is active */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** True if the user belongs to club300. */
  isClub300Member?: Maybe<Scalars['Boolean']['output']>;
  /** The legacy id of the user. */
  legacyId?: Maybe<Scalars['String']['output']>;
  /** User main avatar URL. */
  mainAvatar?: Maybe<Scalars['String']['output']>;
  /** The last date when the user was modified */
  modificationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The nickname of the user */
  nickname?: Maybe<Scalars['String']['output']>;
  /** An Allocine User Profile. */
  profile?: Maybe<Profile>;
  /** The user sharing preferences. */
  sharingPreferences?: Maybe<UserSharingPreferences>;
  /** Social information for this user. */
  social?: Maybe<UserSocialInformation>;
  /** Some stats about user. */
  stats?: Maybe<UserStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
};


/** An Allociné User */
export type UserCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** list of possible reasons for the absence of an affinity score */
export enum UserAffinityScoreReason {
  /** User has not confirm his email. */
  AccountNotActivated = 'ACCOUNT_NOT_ACTIVATED',
  /** User has already rated current movie. */
  AlreadyRated = 'ALREADY_RATED',
  /** User has not rated enough movies to be eligible for the calculation of the affinity score. */
  NotEnoughRatings = 'NOT_ENOUGH_RATINGS',
  /** API RECO enable to calculate affinity score. */
  OngoingAlgo = 'ONGOING_ALGO'
}

/** a user collection of movies, series ... */
export type UserCollection = Node & {
  __typename?: 'UserCollection';
  /** The date when the collection was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The collection description. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The entities of the current collection.
   * @deprecated From April 2020 on, this should be changed to UserEntityInterfaceConnection and entitiesWithInterface should be deprecated instead (see iOS adoption rates)
   */
  entities?: Maybe<UserEntityConnection>;
  /** The entities of the current collection. */
  entitiesWithInterface?: Maybe<UserEntityInterfaceConnection>;
  /** number of users following current collection */
  followersCount: Scalars['Int']['output'];
  /** The collection id. */
  id: Scalars['ID']['output'];
  /** The collection internal id. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** the number of movies in the collection */
  moviesCount?: Maybe<Scalars['Int']['output']>;
  /** The collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The user owning the collection. */
  owner?: Maybe<User>;
  /** The collection visibility. */
  public?: Maybe<Scalars['Boolean']['output']>;
  /** the number of series in the collection */
  seriesCount?: Maybe<Scalars['Int']['output']>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date when the collection was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** a user collection of movies, series ... */
export type UserCollectionEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** a user collection of movies, series ... */
export type UserCollectionEntitiesWithInterfaceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type UserCollectionConnection = {
  __typename?: 'UserCollectionConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserCollectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserCollectionEdge = {
  __typename?: 'UserCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserCollection>;
};

export type UserCollectionEntitiesInput = {
  /** The collection id. */
  id_collection: Scalars['String']['input'];
  /** The array of entities graphQl ids. */
  id_entities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserCollectionEntityPosition = {
  /** the entity id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The position of the entity (the id above). */
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCollectionReorderInput = {
  /** The collection name. */
  entities?: InputMaybe<Array<InputMaybe<UserCollectionEntityPosition>>>;
  /** The collection id. Used to update or delete a collection. */
  id_collection: Scalars['String']['input'];
};

export type UserConnections = {
  __typename?: 'UserConnections';
  /** The followees of this user */
  followees?: Maybe<UsersConnection>;
  /** The followers of this user */
  followers?: Maybe<UsersConnection>;
};


export type UserConnectionsFolloweesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legacyId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UserConnectionsFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legacyId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** User customization settings including avatar and banner. */
export type UserCustomization = {
  __typename?: 'UserCustomization';
  /** User main avatar with path, id and category. */
  mainAvatar?: Maybe<UserCustomizationImage>;
  /** User main banner with path, id and category. */
  mainBanner?: Maybe<UserCustomizationImage>;
};

/** User customization image with path, id and category. */
export type UserCustomizationImage = {
  __typename?: 'UserCustomizationImage';
  /** The category id of the image. */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** The internalId of the image. */
  internalId?: Maybe<Scalars['BigInt']['output']>;
  /** The path or URL of the image. */
  path?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type UserEntityConnection = {
  __typename?: 'UserEntityConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserEntityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserEntityEdge = {
  __typename?: 'UserEntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserEntityLeaf>;
};

/** A connection to a list of items. */
export type UserEntityInterfaceConnection = {
  __typename?: 'UserEntityInterfaceConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserEntityInterfaceEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserEntityInterfaceEdge = {
  __typename?: 'UserEntityInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserEntityLeafInterface>;
};

/** Returns an entity on which the user interacted. */
export type UserEntityLeaf = UserEntityLeafInterface & {
  __typename?: 'UserEntityLeaf';
  /** The list of social actions for this user and this entity. */
  actionList?: Maybe<Array<Maybe<SocialActionInterface>>>;
  /** The related entity of the social action. */
  entity?: Maybe<Node>;
  /** The user's Fan action on this entity. */
  fan?: Maybe<Fan>;
  /** The user's Helpful action on this entity. */
  helpful?: Maybe<Helpful>;
  /** The id of the UserEntityLeaf. */
  id?: Maybe<Scalars['String']['output']>;
  /** The user's NotInterested action on this entity. */
  notInterested?: Maybe<NotInterested>;
  /** The user's opinion on this entity. */
  opinion?: Maybe<Opinion>;
  /** The user's SeenIt action on this entity. */
  seenIt?: Maybe<SeenIt>;
  /** The user's Subscribe action on this entity. */
  subscribe?: Maybe<Subscribe>;
  /** The user's Unhelpful action on this entity. */
  unhelpful?: Maybe<Unhelpful>;
  /** The user's WantToSee action on this entity. */
  wantToSee?: Maybe<WantToSee>;
};

/** An entity on which the user interacted. */
export type UserEntityLeafInterface = {
  /** The list of social actions for this user and this entity. */
  actionList?: Maybe<Array<Maybe<SocialActionInterface>>>;
  /** The related entity of the social action. */
  entity?: Maybe<Node>;
  /** The user's Fan action on this entity. */
  fan?: Maybe<Fan>;
  /** The user's Helpful action on this entity. */
  helpful?: Maybe<Helpful>;
  /** The id of the UserEntityLeaf. */
  id?: Maybe<Scalars['String']['output']>;
  /** The user's NotInterested action on this entity. */
  notInterested?: Maybe<NotInterested>;
  /** The user's opinion on this entity. */
  opinion?: Maybe<Opinion>;
  /** The user's SeenIt action on this entity. */
  seenIt?: Maybe<SeenIt>;
  /** The user's Subscribe action on this entity. */
  subscribe?: Maybe<Subscribe>;
  /** The user's Unhelpful action on this entity. */
  unhelpful?: Maybe<Unhelpful>;
  /** The user's WantToSee action on this entity. */
  wantToSee?: Maybe<WantToSee>;
};

export type UserEpisodeSeen = {
  __typename?: 'UserEpisodeSeen';
  /** @deprecated Use id, title and number fields instead. */
  episode?: Maybe<Episode>;
  /** The episode's id. */
  id?: Maybe<Scalars['String']['output']>;
  /** The episode's number. */
  number?: Maybe<Scalars['Int']['output']>;
  /** Episode is seen or not. */
  seen?: Maybe<Scalars['Boolean']['output']>;
  /** The episode's title. */
  title?: Maybe<Scalars['String']['output']>;
};

export type UserFollowUserInput = {
  /** Internal or legacy id of the publisher. */
  id_publisher: Scalars['String']['input'];
  /** The id provider */
  provider?: InputMaybe<UserIdProvider>;
};

export enum UserIdProvider {
  Id = 'ID',
  Legacy = 'LEGACY'
}

/** A connection to a list of items. */
export type UserMovieConnection = {
  __typename?: 'UserMovieConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserMovieEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserMovieEdge = {
  __typename?: 'UserMovieEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserMovieLeaf>;
};

/** Returns a movie on which the user interacted. */
export type UserMovieLeaf = UserEntityLeafInterface & {
  __typename?: 'UserMovieLeaf';
  /** The list of social actions for this user and this entity. */
  actionList?: Maybe<Array<Maybe<SocialActionInterface>>>;
  /** The related entity of the social action. */
  entity?: Maybe<Node>;
  /** The user's Fan action on this entity. */
  fan?: Maybe<Fan>;
  /** The user's Helpful action on this entity. */
  helpful?: Maybe<Helpful>;
  /** The id of the UserEntityLeaf. */
  id?: Maybe<Scalars['String']['output']>;
  /** The movie on which the user performed a social action. */
  movie?: Maybe<Movie>;
  /** The user's NotInterested action on this entity. */
  notInterested?: Maybe<NotInterested>;
  /** The user's opinion on this entity. */
  opinion?: Maybe<Opinion>;
  /** The user's SeenIt action on this entity. */
  seenIt?: Maybe<SeenIt>;
  /** The user's Subscribe action on this entity. */
  subscribe?: Maybe<Subscribe>;
  /** The user's Unhelpful action on this entity. */
  unhelpful?: Maybe<Unhelpful>;
  /** The user's WantToSee action on this entity. */
  wantToSee?: Maybe<WantToSee>;
};

export type UserOpinionInput = {
  /** GraphQL entity Id. */
  id_entity: Scalars['String']['input'];
  /** The rating the user gave with this review. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** The content of the review. */
  review?: InputMaybe<Scalars['String']['input']>;
};

export type UserPreferencesInput = {
  /** Streaming companies ids */
  companiesStreaming?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Aggregated stats about user ratings. */
export type UserRatingsStats = {
  __typename?: 'UserRatingsStats';
  /** The amount of ratings for a given score range (default from min to max). */
  count?: Maybe<Scalars['Int']['output']>;
  /** The distribution of the ratings given by users. */
  distribution?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** The score, out of 10 by default, given by users. */
  score?: Maybe<Scalars['Float']['output']>;
};


/** Aggregated stats about user ratings. */
export type UserRatingsStatsCountArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


/** Aggregated stats about user ratings. */
export type UserRatingsStatsScoreArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRelatedEntities = {
  __typename?: 'UserRelatedEntities';
  /** Returns a list of movies on which the user interacted. */
  movies?: Maybe<UserMovieConnection>;
  /** Returns a list of reviews on which the user interacted, eventually filtered on a type. */
  reviews?: Maybe<UserEntityConnection>;
  /** Returns a list of series on which the user interacted. */
  series?: Maybe<UserSeriesConnection>;
  /** The top movies not impacted by given social actions of the current user. */
  unratedTopMovies?: Maybe<MoviesConnection>;
};


export type UserRelatedEntitiesMoviesArgs = {
  action?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  alreadyReleased?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<Array<InputMaybe<NodeType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  movieReleaseType?: InputMaybe<Array<InputMaybe<CustomReleaseType>>>;
  notAction?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  status?: InputMaybe<Array<InputMaybe<MovieStatus>>>;
};


export type UserRelatedEntitiesReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alreadyReleased?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<Array<InputMaybe<NodeType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  statuses?: InputMaybe<Array<InputMaybe<ReviewStatus>>>;
};


export type UserRelatedEntitiesSeriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<SeriesReviewRating>;
  status: Array<RelatedSeriesStatus>;
};


export type UserRelatedEntitiesUnratedTopMoviesArgs = {
  action?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  activities?: InputMaybe<Array<CompanyActivity>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  browsableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<InputMaybe<CountryCode>>>;
  editorialRating?: InputMaybe<FilterRangeRating>;
  editorialRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludeGenres?: InputMaybe<Array<InputMaybe<Genre>>>;
  excludeTypes?: InputMaybe<Array<InputMaybe<MovieType>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetsType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<MovieFlagsType>;
  forChildren?: InputMaybe<Scalars['Boolean']['input']>;
  genres?: InputMaybe<Array<InputMaybe<Genre>>>;
  globalUpdatedAt?: InputMaybe<GlobalUpdatedAtFilterType>;
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  localization?: InputMaybe<Scalars['Int']['input']>;
  minTheaters?: InputMaybe<Scalars['Int']['input']>;
  minTheatersProductFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  minTheatersTwoFloatingWeeks?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<MovieSorting>>>;
  physicalFlags?: InputMaybe<Array<PhysicalProductType>>;
  pressRating?: InputMaybe<FilterRangeRating>;
  pressRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  productionDecade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  productionYear?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  releaseDateType?: InputMaybe<MovieReleaseDateFilterType>;
  releaseFilter?: InputMaybe<ReleaseFilterType>;
  releaseFlags?: InputMaybe<Array<BaseReleaseType>>;
  releaseFrom?: InputMaybe<Scalars['DateTime']['input']>;
  releaseFromUs?: InputMaybe<Scalars['DateTime']['input']>;
  releaseTo?: InputMaybe<Scalars['DateTime']['input']>;
  releaseToUs?: InputMaybe<Scalars['DateTime']['input']>;
  runtime?: InputMaybe<IntRangeFilter>;
  scoreRating?: InputMaybe<FilterRangeRating>;
  scoreRatingCounter?: InputMaybe<FilterRangeRatingCounter>;
  specialFilter?: InputMaybe<MovieSpecialFilter>;
  svodFlags?: InputMaybe<Array<SvodFlags>>;
  svodProviders?: InputMaybe<Array<SvodProviders>>;
  tag?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InputMaybe<MovieType>>>;
  visaNumber?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** An Allociné user review. */
export type UserReview = Node & {
  __typename?: 'UserReview';
  /** The user who wrote the review. */
  author?: Maybe<User>;
  /** The content of the review */
  body?: Maybe<Scalars['String']['output']>;
  /** Whether the rating is certified or not. */
  certificationRating?: Maybe<CertificationRatingStatus>;
  /** The date when the review was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the user review. */
  id: Scalars['ID']['output'];
  /** The internal id of the user review. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The rating the user gave with this review. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** The related entity of the review. */
  relatedEntity?: Maybe<Node>;
  /** Some stats about metric. */
  stats?: Maybe<UserReviewStats>;
  /** The status of the review */
  status?: Maybe<ReviewStatus>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date when the review was updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Counts of user reviews. */
export type UserReviewCounts = {
  __typename?: 'UserReviewCounts';
  /** Number of user reviews with ratings equals to 5. */
  reviewsFive?: Maybe<Scalars['Int']['output']>;
  /** Number of user reviews with ratings in the range (>= 4, < 5). */
  reviewsFour?: Maybe<Scalars['Int']['output']>;
  /** Number of user reviews with ratings in the range (>= 1, < 2). */
  reviewsOne?: Maybe<Scalars['Int']['output']>;
  /** Number of user reviews with ratings in the range (>= 3, < 4). */
  reviewsThree?: Maybe<Scalars['Int']['output']>;
  /** Total number of user reviews. */
  reviewsTotal?: Maybe<Scalars['Int']['output']>;
  /** Number of user reviews with ratings in the range (>= 2, < 3). */
  reviewsTwo?: Maybe<Scalars['Int']['output']>;
  /** Number of user reviews with ratings in the range (>= 0, < 1). */
  reviewsZero?: Maybe<Scalars['Int']['output']>;
};

/** Some stats about metric. */
export type UserReviewStats = {
  __typename?: 'UserReviewStats';
  /** An array of metrics for a given entity. */
  metric?: Maybe<StatsMetric>;
};

/** Aggregated stats about user reviews. */
export type UserReviewsStats = {
  __typename?: 'UserReviewsStats';
  /** The amount of ratings for a given score range (default from min to max). */
  count?: Maybe<Scalars['Int']['output']>;
  /** The distribution of the reviews given by users. */
  distribution?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};


/** Aggregated stats about user reviews. */
export type UserReviewsStatsCountArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};

/** User seasons progression (%) */
export type UserSeasonsProgression = {
  __typename?: 'UserSeasonsProgression';
  episodesSeenStatus?: Maybe<Array<Maybe<UserEpisodeSeen>>>;
  /** the percentage of season seen by the user. */
  percent?: Maybe<Scalars['Float']['output']>;
  /** the season entity. */
  season?: Maybe<Season>;
};

/** A connection to a list of items. */
export type UserSeriesConnection = {
  __typename?: 'UserSeriesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserSeriesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserSeriesEdge = {
  __typename?: 'UserSeriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserSeriesLeaf>;
};

/** Returns a series on which the user interacted. */
export type UserSeriesLeaf = UserEntityLeafInterface & {
  __typename?: 'UserSeriesLeaf';
  /** The list of social actions for this user and this entity. */
  actionList?: Maybe<Array<Maybe<SocialActionInterface>>>;
  /** The related entity of the social action. */
  entity?: Maybe<Node>;
  /** The user's Fan action on this entity. */
  fan?: Maybe<Fan>;
  /** The user's Helpful action on this entity. */
  helpful?: Maybe<Helpful>;
  /** The id of the UserSeriesLeaf. */
  id?: Maybe<Scalars['String']['output']>;
  /** The user's NotInterested action on this entity. */
  notInterested?: Maybe<NotInterested>;
  /** The user's opinion on this entity. */
  opinion?: Maybe<Opinion>;
  /** User Progression for a Series */
  progression?: Maybe<UserSeriesProgression>;
  /** The user's SeenIt action on this entity. */
  seenIt?: Maybe<SeenIt>;
  /** The series on which the user performed a social action. */
  series?: Maybe<Series>;
  /** The user's Subscribe action on this entity. */
  subscribe?: Maybe<Subscribe>;
  /** The user's Unhelpful action on this entity. */
  unhelpful?: Maybe<Unhelpful>;
  /** The user's WantToSee action on this entity. */
  wantToSee?: Maybe<WantToSee>;
};

/** User series and seasons progression (%) and next episode. */
export type UserSeriesProgression = {
  __typename?: 'UserSeriesProgression';
  /** the global percentage of episodes seen by the user. */
  globalPercent?: Maybe<Scalars['Float']['output']>;
  /** Next episode to watch. */
  nextEpisode?: Maybe<Episode>;
  /** Count of unwatched episodes. */
  remainingEpisodes?: Maybe<Scalars['Int']['output']>;
  /** the seasons list. */
  seasons?: Maybe<Array<Maybe<UserSeasonsProgression>>>;
};

/** Activities available to be shared. */
export enum UserSharedActivityType {
  /** The user added, edited or deleted a collection. */
  Collection = 'COLLECTION',
  /** The user provided an emotion related to a video content. */
  Emote = 'EMOTE',
  /** The user indicated he is following a series. */
  FollowSeries = 'FOLLOW_SERIES',
  /** The user rated a video content. */
  Rate = 'RATE',
  /** The user wrote a review about a video content. */
  Review = 'REVIEW',
  /** The user indicated he saw a video content. */
  See = 'SEE',
  /** The user indicated he wants to see a video content. */
  WantToSee = 'WANT_TO_SEE'
}

export type UserSharingPreferences = {
  __typename?: 'UserSharingPreferences';
  /** Which activities from the user will be shared. */
  activities?: Maybe<Array<Maybe<UserSharedActivityType>>>;
};

export type UserSharingPreferencesInput = {
  /** Array of activities ENUM to be shared by the user. */
  activities?: InputMaybe<Array<InputMaybe<UserSharedActivityType>>>;
};

/** A connection to a list of items. */
export type UserSocialActionConnection = {
  __typename?: 'UserSocialActionConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserSocialActionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserSocialActionEdge = {
  __typename?: 'UserSocialActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserSocialActionLeaf>;
};

export type UserSocialActionInput = {
  /** Social action done by the user. */
  action: UserSocialClickType;
  /** Array of GraphQL entity Id. */
  id_entity: Array<Scalars['String']['input']>;
};

/** Return a list of all user's actions. */
export type UserSocialActionLeaf = {
  __typename?: 'UserSocialActionLeaf';
  /** The related action of the user. */
  action?: Maybe<SocialActionInterface>;
  /** The user who did the social action. */
  user?: Maybe<User>;
};

/** Sorting criteria for social actions */
export enum UserSocialActionSorting {
  /** Social actions are sorted by creation date. */
  Latest = 'LATEST',
  /** Movies sorted by their release dates, most recent releases first. */
  LatestReleases = 'LATEST_RELEASES',
  /** Social actions are sorted by popularity ascending. */
  MonthlyPopularityAsc = 'MONTHLY_POPULARITY_ASC',
  /** Social actions are sorted by popularity descending. */
  MonthlyPopularityDesc = 'MONTHLY_POPULARITY_DESC',
  /** Shows the reviews that were the most helpful. */
  MostHelpful = 'MOST_HELPFUL',
  /** Movies sorted by their release dates, oldest releases first. */
  OldestReleases = 'OLDEST_RELEASES',
  /** Social actions are sorted by rating ascending. */
  RatingAsc = 'RATING_ASC',
  /** Social actions are sorted by rating descending. */
  RatingDesc = 'RATING_DESC'
}

/** Available types for social actions. */
export enum UserSocialActionType {
  /** The user clicks on Facebook like button. */
  Facebooklike = 'FACEBOOKLIKE',
  /** The user clicks on Fan button. */
  Fan = 'FAN',
  /** The user began to follow a user. */
  Follow = 'FOLLOW',
  /** The user began to follow a collection. */
  FollowCollection = 'FOLLOW_COLLECTION',
  /** The user find another social action (by another user) helpful. */
  Helpful = 'HELPFUL',
  /** The user clicks on the "Not Interested" button. */
  Notinterested = 'NOTINTERESTED',
  /** Opinion contains the rating and the review a user gave. */
  Opinion = 'OPINION',
  /** Opinion contains juste the review a user gave. */
  Review = 'REVIEW',
  /** The user clicks on the "Seen It" button. */
  Seenit = 'SEENIT',
  /** The user reports a spoiler for running season. */
  Spoilerblocked = 'SPOILERBLOCKED',
  /** The user clicks on the "Subscribe" button. (Follow series, movies ... ) */
  Subscribe = 'SUBSCRIBE',
  /** The user find another social action (by another user) unhelpful. */
  Unhelpful = 'UNHELPFUL',
  /** The user clicks on the "Want To See" button. */
  Wanttosee = 'WANTTOSEE'
}

/** Available types for social actions. */
export enum UserSocialClickType {
  /** The user clicks on Facebook like button. */
  Facebooklike = 'FACEBOOKLIKE',
  /** The user clicks on Fan button. */
  Fan = 'FAN',
  /** The user find another social action (by another user) helpful. */
  Helpful = 'HELPFUL',
  /** The user clicks on the "Not Interested" button. */
  Notinterested = 'NOTINTERESTED',
  /** The user clicks on the "Seen It" button. */
  Seenit = 'SEENIT',
  /** The user reports a spoiler for running season. */
  Spoilerblocked = 'SPOILERBLOCKED',
  /** The user clicks on the "Subscribe" button. (Follow series, movies ... ) */
  Subscribe = 'SUBSCRIBE',
  /** The user find another social action (by another user) unhelpful. */
  Unhelpful = 'UNHELPFUL',
  /** The user clicks on the "Want To See" button. */
  Wanttosee = 'WANTTOSEE'
}

export type UserSocialInformation = {
  __typename?: 'UserSocialInformation';
  /** Return a list of all user's actions. */
  actions?: Maybe<UserSocialActionConnection>;
  /** List user collections */
  collections?: Maybe<UserCollectionConnection>;
  /** Returns a list of entities on which the user interacted. */
  entities?: Maybe<UserEntityConnection>;
  /** List of user collections followed by the current user */
  followedCollections?: Maybe<UserCollectionConnection>;
  /** Return a list of all user's followees actions. */
  followeesActions?: Maybe<UserSocialActionConnection>;
  /** Returns the followees average rating for the given entity */
  followeesAverageRating?: Maybe<Scalars['Float']['output']>;
  /** Any entities related to this user. */
  relatedEntities?: Maybe<UserRelatedEntities>;
  /** User rewind information. */
  rewind?: Maybe<Rewind>;
  /** A list of entities suggested to this user. */
  suggestedEntities?: Maybe<UserSuggestedEntities>;
  /** Returns a list of top active users that could be followed. */
  suggestedFollowees?: Maybe<UsersConnection>;
  /** The registered theaters for this user. */
  theaters?: Maybe<TheaterConnection>;
  /** All user connections. */
  userConnections?: Maybe<UserConnections>;
};


export type UserSocialInformationActionsArgs = {
  action?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<ReviewRating>;
};


export type UserSocialInformationCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSocialInformationEntitiesArgs = {
  action?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityType?: InputMaybe<Array<InputMaybe<NodeType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<ReviewRating>;
};


export type UserSocialInformationFollowedCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSocialInformationFolloweesActionsArgs = {
  action?: InputMaybe<Array<InputMaybe<UserSocialActionType>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserSocialActionSorting>>>;
  rating?: InputMaybe<ReviewRating>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type UserSocialInformationFolloweesAverageRatingArgs = {
  base?: InputMaybe<Scalars['Int']['input']>;
  entity: Scalars['String']['input'];
};


export type UserSocialInformationSuggestedFolloweesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSocialInformationTheatersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  internalId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSocialMediaInput = {
  /** The social media avatar. */
  id_avatar?: InputMaybe<Scalars['BigInt']['input']>;
  /** The social media banner. */
  id_banner?: InputMaybe<Scalars['BigInt']['input']>;
};

export type UserStats = {
  __typename?: 'UserStats';
  /** The total of ratings for this user. */
  total_ratings: Scalars['Int']['output'];
  /** The total reviews made by a user. */
  total_reviews: Scalars['Int']['output'];
  /** The total of subscribers for this user. */
  total_subscribers: Scalars['Int']['output'];
};

export type UserSuggestedEntities = {
  __typename?: 'UserSuggestedEntities';
  /** Returns a list of movies and series suggested for the user based on a collection items. */
  entitiesFromCollection?: Maybe<UserEntityInterfaceConnection>;
  /** Returns a list of movies suggested for the user. */
  movies?: Maybe<UserToMovieConnection>;
  /** Returns a list of movies suggested for the user based on a collection items. */
  moviesFromCollection?: Maybe<UserMovieConnection>;
  /** Returns a list of series suggested for the user. */
  series?: Maybe<UserToSeriesConnection>;
  /** Returns a list of series suggested for the user based on a collection items. */
  seriesFromCollection?: Maybe<UserSeriesConnection>;
};


export type UserSuggestedEntitiesEntitiesFromCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_collection: Scalars['String']['input'];
  inRandomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statusIsNot?: InputMaybe<Array<InputMaybe<MovieStatus>>>;
};


export type UserSuggestedEntitiesMoviesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  releasedInFuture?: InputMaybe<Scalars['Boolean']['input']>;
  statusIsNot: Array<InputMaybe<MovieStatus>>;
};


export type UserSuggestedEntitiesMoviesFromCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_collection: Scalars['String']['input'];
  inRandomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statusIsNot?: InputMaybe<Array<InputMaybe<MovieStatus>>>;
};


export type UserSuggestedEntitiesSeriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statusIsNot: Array<InputMaybe<SeriesStatus>>;
};


export type UserSuggestedEntitiesSeriesFromCollectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id_collection: Scalars['String']['input'];
  inRandomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statusIsNot?: InputMaybe<Array<InputMaybe<MovieStatus>>>;
};

export type UserTheaterInput = {
  /** theater Id. */
  id_theater: Scalars['String']['input'];
};

export type UserTicketCertificationInput = {
  /** GraphQL movie entity Id. */
  id_entity: Scalars['String']['input'];
  /** The ticket certification provider. */
  provider?: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type UserToMovieConnection = {
  __typename?: 'UserToMovieConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserToMovieEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserToMovieEdge = {
  __typename?: 'UserToMovieEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserToMovieLeaf>;
};

/** Returns a movie suggested to the user. */
export type UserToMovieLeaf = {
  __typename?: 'UserToMovieLeaf';
  /** list of movies suggested to the user. */
  movie?: Maybe<Movie>;
};

/** A connection to a list of items. */
export type UserToSeriesConnection = {
  __typename?: 'UserToSeriesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserToSeriesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserToSeriesEdge = {
  __typename?: 'UserToSeriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserToSeriesLeaf>;
};

/** Returns a series suggested to the user. */
export type UserToSeriesLeaf = {
  __typename?: 'UserToSeriesLeaf';
  /** list of series suggested to the user. */
  series?: Maybe<Series>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UsersEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type VersionFacet = FacetValue & {
  __typename?: 'VersionFacet';
  /** The aggregation value count. */
  doc_count: Scalars['Int']['output'];
  /** The aggregation value name. */
  key: Scalars['String']['output'];
  /** The experience which type match. */
  version?: Maybe<ShowtimeVersion>;
};

/** An Allociné Video. */
export type Video = Node & {
  __typename?: 'Video';
  /** Info about video if preroll and postroll are available */
  ads?: Maybe<VideoAds>;
  /** The code of the video. */
  code?: Maybe<Scalars['Int']['output']>;
  /** The newest comments added on this video, up to 50 elements. Directly use disqus API to get more of them. */
  comments?: Maybe<Array<Maybe<Comment>>>;
  /** @deprecated Use VideoProvider instead */
  dailymotion?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The description of the video. */
  description?: Maybe<Scalars['String']['output']>;
  /** The duration of the video. */
  duration?: Maybe<Scalars['String']['output']>;
  /** The files of the video. */
  files?: Maybe<Array<Maybe<VideoFile>>>;
  /** the video html */
  html?: Maybe<Scalars['String']['output']>;
  /** The id of the video. */
  id: Scalars['ID']['output'];
  /** The internal id of the video. */
  internalId?: Maybe<Scalars['String']['output']>;
  /** The language of the video */
  language?: Maybe<Language>;
  mySkreen?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The original description of the video. */
  originalDescription?: Maybe<Scalars['String']['output']>;
  /** The original title of the video. */
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** The providers of the video. */
  providers?: Maybe<VideoProvider>;
  /** The publication information of the video. */
  publication?: Maybe<Publication>;
  /** The related entities of the video */
  relatedEntities?: Maybe<Array<Maybe<Node>>>;
  /** The image snapshot of the video. */
  snapshot?: Maybe<InternalImage>;
  /** All stats about the video. */
  stats?: Maybe<VideoStats>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The tags of the video. */
  tags?: Maybe<TagCollection>;
  /** The title of the video. */
  title?: Maybe<Scalars['String']['output']>;
  /** The type of the video. */
  type?: Maybe<VideoType>;
  /** The universes of the video. */
  universes?: Maybe<Array<Maybe<VideoUniverse>>>;
  youtube?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** An Allociné Video. */
export type VideoCommentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** An Allociné Video. */
export type VideoFilesArgs = {
  format?: InputMaybe<Array<InputMaybe<VideoFormat>>>;
  quality?: InputMaybe<Array<InputMaybe<VideoQuality>>>;
};


/** An Allociné Video. */
export type VideoOriginalTitleArgs = {
  generated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Allociné Video. */
export type VideoRelatedEntitiesArgs = {
  type?: InputMaybe<Array<InputMaybe<MediaRelatedEntityTypes>>>;
};


/** An Allociné Video. */
export type VideoTitleArgs = {
  generated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains informations about the video preroll and postroll */
export type VideoAds = {
  __typename?: 'VideoAds';
  /** True is video must'nt have postroll */
  hasNoPostroll?: Maybe<Scalars['Boolean']['output']>;
  /** True is video must'nt have preroll */
  hasNoPreroll?: Maybe<Scalars['Boolean']['output']>;
};

/** The real files for a given video. They are meant to offer the same content in different formats/qualities. */
export type VideoFile = {
  __typename?: 'VideoFile';
  /** The format (M4V, MP4, ...) used to encode the video. */
  formats?: Maybe<Array<Maybe<VideoFormat>>>;
  /** The height of the video. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The quality (HIGH, LOW, MEDIUM...) used to encode the video. */
  quality?: Maybe<VideoQuality>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The full path where the file can be found. */
  url?: Maybe<Scalars['String']['output']>;
  /** The width of the video. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Technical flags about video to have rapid information */
export type VideoFlags = {
  /** True if the video has a movie with a first release released recently (< 1 month), or in the future (date or flagged as NotReleasedYet). */
  has_movie_released_recently_or_soon?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the video has a related season coming soon. */
  has_season_coming_soon?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the video has a related series coming soon. */
  has_series_coming_soon?: InputMaybe<Scalars['Boolean']['input']>;
};

/** All format which can be used to encode the video. */
export enum VideoFormat {
  /** XVID */
  AviXvid = 'AVI_XVID',
  /** FLV / H.264 */
  FlvH264 = 'FLV_H264',
  /** FLV / H.264, letterbox, legacy */
  FlvLetter = 'FLV_LETTER',
  /** m4v */
  M4V = 'M4V',
  /** MP4 / H.264 High Profile, for archive */
  Mp4Archive = 'MP4_ARCHIVE',
  /** H264 High Profile, with splashscreen */
  Mp4Hip = 'MP4_HIP',
  /** MP4 / H.264 High Profile, no splashscreen */
  Mp4HipRaw = 'MP4_HIP_RAW',
  /** MP4 / H.264 Baseline Profile, Low Complexity, with splashscreen */
  Mp4Lc = 'MP4_LC',
  /** MP4 / H.264 Baseline Profile, Low Complexity, no splashscreen */
  Mp4LcRaw = 'MP4_LC_RAW',
  /** MPEG-1 */
  Mpeg1 = 'MPEG1',
  /** MPEG-2 Main Profile */
  Mpeg2 = 'MPEG2',
  /** MPEG-2 720p */
  Mpeg2Theater = 'MPEG2_THEATER',
  /** WebM */
  Webm = 'WEBM',
  /** WMV9 */
  Wmv9 = 'WMV9'
}

/** The providers of the video. */
export type VideoProvider = {
  __typename?: 'VideoProvider';
  /** External Connatix embed of this video */
  connatix?: Maybe<ExternalVideoProvider>;
  /** External Dailymotion embed of this video */
  dailymotion?: Maybe<ExternalVideoProvider>;
};

/** All videos qualities available. */
export enum VideoQuality {
  /** High quality, but it's heavy. It corresponds to 720p. */
  High = 'HIGH',
  /** The highest quality, but it's the heaviest file. It's not often used. It corresponds to 1080p. */
  Highest = 'HIGHEST',
  /** The lowest quality, very light. It corresponds to 180p. */
  Low = 'LOW',
  /** An intermediate quality, fair ratio between size and image quality. It corresponds to 320p. */
  Medium = 'MEDIUM',
  /** Standard size, which should be used by default. It corresponds to 480p. */
  Standard = 'STANDARD'
}

/** Sorting criteria for videos */
export enum VideoSorting {
  /** Videos sorted by title in alphabetical order. */
  Alphabetical = 'ALPHABETICAL',
  /** Videos sorted by the selection of cms. */
  CmsRank = 'CMS_RANK',
  /** Videos sorted by popularity on a daily J-1. */
  DailyPopularity = 'DAILY_POPULARITY',
  /** Videos are sorted by added date desc. */
  Latest = 'LATEST',
  /** Videos sorted by popularity on a monthly basis. */
  MonthlyPopularity = 'MONTHLY_POPULARITY',
  /** Videos are sorted by added date. */
  Oldest = 'OLDEST',
  /** Videos sorted by their rank. */
  Rank = 'RANK',
  /** Videos sorted by title in reverse alphabetical order. */
  ReverseAlphabetical = 'REVERSE_ALPHABETICAL',
  /** Videos sorted by popularity on a weekly basis. */
  WeeklyPopularity = 'WEEKLY_POPULARITY'
}

/** Some custom videos filters with complexs algorithms. */
export enum VideoSpecialFilter {
  /** Select some video from movies or series that do have a SVOD release. */
  SvodReleasedEntities = 'SVOD_RELEASED_ENTITIES',
  /** Select the top videos which are the most viewed and whose the movie is coming on theaters. */
  TopVideos = 'TOP_VIDEOS'
}

/** All stats about the video. */
export type VideoStats = {
  __typename?: 'VideoStats';
  /** An array of metrics for a given entity. */
  metric?: Maybe<StatsMetric>;
};

export enum VideoType {
  /** Advertising is a video form of marketing communication that employs an openly sponsored, nonpersonal message to promote or sell a product, service or idea. */
  Advertising = 'ADVERTISING',
  /** A full movie or a full series episode. */
  Complete = 'COMPLETE',
  /** Credits are a list of the cast and crew of a particular motion picture, television program, or video game. */
  Credits = 'CREDITS',
  EmergenceCarouselVideo = 'EMERGENCE_CAROUSEL_VIDEO',
  /** A video excerpt. */
  Excerpt = 'EXCERPT',
  /** Featurette is a term used in the American film industry to designate a film usually of three reels in length, or about 24–40 minutes in running time, thus longer than a two-reel short subject but shorter than a feature film. */
  Featurette = 'FEATURETTE',
  /** The first minutes of a movie or a series episode. */
  FirstMinutes = 'FIRST_MINUTES',
  /** A video of an interview. */
  Interview = 'INTERVIEW',
  /** A video where a moviegoer (a person who goes to the cinema, especially on a regular basis) gives his feedback. */
  MoviegoerReactions = 'MOVIEGOER_REACTIONS',
  /** An online user review is a video where a user from the community, gives his feedback and feelings about various topics (movies, tv show, ...). */
  OnlineUserReview = 'ONLINE_USER_REVIEW',
  /** A parody mashup combines multiple pre-existing video sources in a parodic way into a unified video. The video sources usually have no discernible relation with each other. */
  ParodyMashup = 'PARODY_MASHUP',
  /** A video of a report. */
  SpecialReport = 'SPECIAL_REPORT',
  /** Their purpose is less to tell the audience about a movie's content than simply to let them know that the movie is coming up in the near future, and to add to the hype of the upcoming release. */
  Teaser = 'TEASER',
  /** A trailer is an advertisement, usually in the form of a brief excerpt or string of excerpts, for a media work. */
  Trailer = 'TRAILER',
  /** A trailer stream. */
  TrailerStream = 'TRAILER_STREAM',
  /** A tv program is a segment of content intended for broadcast on over-the-air, cable television, or Internet television, other than a commercial, trailer, or any other segment of content not serving as attraction for viewership. It may be a single production, or more commonly, a series of related productions (also called a television show). */
  TvProgram = 'TV_PROGRAM',
  /** Video clips are short clips of video, usually part of a longer recording. The term is also more loosely used to mean any short video less than the length of a traditional television program. */
  VideoClip = 'VIDEO_CLIP',
  /** A trailer for a video game. */
  VideoGameTrailer = 'VIDEO_GAME_TRAILER'
}

/** An AlloCiné Video Universes. */
export enum VideoUniverse {
  GenericTvactu = 'GENERIC_TVACTU',
  Global = 'GLOBAL'
}

/** All formats of VOD product. */
export enum VodProductType {
  /** Video on demand (display) (VOD) are systems which allow users to select and watch/listen to video or audio content such as movies and TV shows when they choose to, rather than having to watch at a specific broadcast time. */
  Vod = 'VOD',
  /** Video on demand electronic sales through (VODEST) which allow users to buy the video definitively. */
  Vodest = 'VODEST'
}

/** A list of the VOD/VODEST providers for a season with their lowest price. */
export type VodProviders = {
  __typename?: 'VodProviders';
  /** The company concerned. */
  company?: Maybe<Company>;
  /** The currency in which is the price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The price with it currency. */
  displayPrice?: Maybe<Scalars['String']['output']>;
  /** The lowest price. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The number of products listed in the category. */
  productsCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<VodProductType>;
};

/** A social action done by a user. */
export type WantToSee = SocialActionInterface & {
  __typename?: 'WantToSee';
  /** The date this action was submitted at first. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the social action. */
  id: Scalars['ID']['output'];
  /** The internal id of the social action. */
  internalId?: Maybe<Scalars['Int']['output']>;
  /** The related entity of the social action. */
  relatedEntity?: Maybe<Node>;
  stringValue?: Maybe<Scalars['String']['output']>;
  /** The date this action was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type AnalogyConnection = {
  __typename?: 'analogyConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AnalogyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AnalogyEdge = {
  __typename?: 'analogyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Analogy>;
};

/** A connection to a list of items. */
export type CastMemberConnection = {
  __typename?: 'castMemberConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CastMemberEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type CastMemberConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CastMemberEdge = {
  __typename?: 'castMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CastMember>;
};

/** A connection to a list of items. */
export type CityConnection = {
  __typename?: 'cityConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CityEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CityEdge = {
  __typename?: 'cityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<City>;
};

/** A connection to a list of items. */
export type CompanyConnection = {
  __typename?: 'companyConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'companyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

/** A connection to a list of items. */
export type CreditsConnection = {
  __typename?: 'creditsConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CreditsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CreditsEdge = {
  __typename?: 'creditsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreditsMember>;
};

/** A connection to a list of items. */
export type EpisodesConnection = {
  __typename?: 'episodesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<EpisodesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type EpisodesEdge = {
  __typename?: 'episodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Episode>;
};

/** A connection to a list of items. */
export type FestivalConnection = {
  __typename?: 'festivalConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FestivalEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FestivalEdge = {
  __typename?: 'festivalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Festival>;
};

/** A connection to a list of items. */
export type FilmographyConnection = {
  __typename?: 'filmographyConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FilmographyEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type FilmographyEdge = {
  __typename?: 'filmographyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<FilmographyEntry>;
};

export type GenericTagFacetType = {
  __typename?: 'genericTagFacetType';
  /** The type's name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The type's tag. */
  tag?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type GroupConnection = {
  __typename?: 'groupConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<GroupEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type GroupEdge = {
  __typename?: 'groupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Group>;
};

/** A connection to a list of items. */
export type ImagesConnection = {
  __typename?: 'imagesConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ImagesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type ImagesConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ImagesEdge = {
  __typename?: 'imagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InternalImage>;
};

/** A connection to a list of items. */
export type ImagesSocialMediaCategoryConnection = {
  __typename?: 'imagesSocialMediaCategoryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ImagesSocialMediaCategoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ImagesSocialMediaCategoryEdge = {
  __typename?: 'imagesSocialMediaCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SocialMediaCategory>;
};

/** A connection to a list of items. */
export type LocalizationConnection = {
  __typename?: 'localizationConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<LocalizationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type LocalizationEdge = {
  __typename?: 'localizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Localization>;
};

/** A connection to a list of items. */
export type MovieShowtimeByTheaterListConnection = {
  __typename?: 'movieShowtimeByTheaterListConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MovieShowtimeByTheaterListEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type MovieShowtimeByTheaterListEdge = {
  __typename?: 'movieShowtimeByTheaterListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MovieShowtimeLeaf>;
};

/** A connection to a list of items. */
export type MoviesByTheaterListConnection = {
  __typename?: 'moviesByTheaterListConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MoviesByTheaterListEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type MoviesByTheaterListEdge = {
  __typename?: 'moviesByTheaterListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MovieByTheaterLeaf>;
};

/** A connection to a list of items. */
export type MoviesConnection = {
  __typename?: 'moviesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MoviesEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type MoviesEdge = {
  __typename?: 'moviesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Movie>;
};

/** A connection to a list of items. */
export type NewsConnection = {
  __typename?: 'newsConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<NewsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type NewsConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type NewsEdge = {
  __typename?: 'newsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<News>;
};

/** A connection to a list of items. */
export type NodeConnection = {
  __typename?: 'nodeConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<NodeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type NodeConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type NodeEdge = {
  __typename?: 'nodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Node>;
};

/** A connection to a list of items. */
export type PersonsCollaborationConnection = {
  __typename?: 'personsCollaborationConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PersonsCollaborationEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type PersonsCollaborationEdge = {
  __typename?: 'personsCollaborationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PersonCollaboration>;
};

/** A connection to a list of items. */
export type PersonsConnection = {
  __typename?: 'personsConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PersonsEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PersonsEdge = {
  __typename?: 'personsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Person>;
};

/** A connection to a list of items. */
export type PressReviewsConnection = {
  __typename?: 'pressReviewsConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PressReviewsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type PressReviewsConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type PressReviewsEdge = {
  __typename?: 'pressReviewsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PressReview>;
};

/** A connection to a list of items. */
export type ProductsConnection = {
  __typename?: 'productsConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ProductsEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type ProductsConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ProductsEdge = {
  __typename?: 'productsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

/** A connection to a list of items. */
export type ProgramConnection = {
  __typename?: 'programConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ProgramEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProgramEdge = {
  __typename?: 'programEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Program>;
};

/** A connection to a list of items. */
export type ProgramEpisodesConnection = {
  __typename?: 'programEpisodesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ProgramEpisodesEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProgramEpisodesEdge = {
  __typename?: 'programEpisodesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProgramEpisode>;
};

/** A connection to a list of items. */
export type ProgramSeasonsConnection = {
  __typename?: 'programSeasonsConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ProgramSeasonsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProgramSeasonsEdge = {
  __typename?: 'programSeasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProgramSeason>;
};

/** A connection to a list of items. */
export type SearchResultsConnection = {
  __typename?: 'searchResultsConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<SearchResultsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SearchResultsEdge = {
  __typename?: 'searchResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SearchResult>;
};

/** A connection to a list of items. */
export type SeasonsConnection = {
  __typename?: 'seasonsConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<SeasonsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SeasonsEdge = {
  __typename?: 'seasonsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Season>;
};

/** A connection to a list of items. */
export type SeriesConnection = {
  __typename?: 'seriesConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<SeriesEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SeriesEdge = {
  __typename?: 'seriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Series>;
};

/** A connection to a list of items. */
export type SoundtrackConnection = {
  __typename?: 'soundtrackConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<SoundtrackEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SoundtrackEdge = {
  __typename?: 'soundtrackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Soundtrack>;
};

/** A connection to a list of items. */
export type TheaterShowtimeByMovieListConnection = {
  __typename?: 'theaterShowtimeByMovieListConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TheaterShowtimeByMovieListEdge>>>;
  /** Facets are ES aggregation. Represent the available filter in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type TheaterShowtimeByMovieListEdge = {
  __typename?: 'theaterShowtimeByMovieListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TheaterShowtimeLeaf>;
};

/** A connection to a list of items. */
export type TriviasConnection = {
  __typename?: 'triviasConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TriviasEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type TriviasConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type TriviasEdge = {
  __typename?: 'triviasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Trivia>;
};

/** A connection to a list of items. */
export type UserReviewsConnection = {
  __typename?: 'userReviewsConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserReviewsEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type UserReviewsConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type UserReviewsEdge = {
  __typename?: 'userReviewsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserReview>;
};

/** A connection to a list of items. */
export type VideosConnection = {
  __typename?: 'videosConnection';
  backlink?: Maybe<Backlink>;
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<VideosEdge>>>;
  /** Facets are ES aggregations which represent the available filters in ES. */
  facets?: Maybe<Array<Maybe<Facets>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


/** A connection to a list of items. */
export type VideosConnectionBacklinkArgs = {
  label?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type VideosEdge = {
  __typename?: 'videosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Video>;
};

export type CertifyUserTicketEntityFragment_Author_Fragment = { __typename: 'Author', id: string };

export type CertifyUserTicketEntityFragment_Carousel_Fragment = { __typename: 'Carousel', id: string };

export type CertifyUserTicketEntityFragment_Company_Fragment = { __typename: 'Company', id: string };

export type CertifyUserTicketEntityFragment_EditorialReview_Fragment = { __typename: 'EditorialReview', id: string };

export type CertifyUserTicketEntityFragment_EntityClub_Fragment = { __typename: 'EntityClub', id: string };

export type CertifyUserTicketEntityFragment_Episode_Fragment = { __typename: 'Episode', title?: string | null, id: string };

export type CertifyUserTicketEntityFragment_Festival_Fragment = { __typename: 'Festival', id: string };

export type CertifyUserTicketEntityFragment_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string };

export type CertifyUserTicketEntityFragment_InternalImage_Fragment = { __typename: 'InternalImage', id: string };

export type CertifyUserTicketEntityFragment_Movie_Fragment = { __typename: 'Movie', title?: string | null, id: string, poster?: { __typename?: 'InternalImage', path?: string | null } | null, flags?: { __typename?: 'MovieFlags', isComingSoon?: boolean | null, hasShowtime?: boolean | null } | null, releases?: Array<{ __typename?: 'MovieRelease', releaseDate?: { __typename?: 'PartialDate', date?: string | null } | null } | null> | null };

export type CertifyUserTicketEntityFragment_MovieRelease_Fragment = { __typename: 'MovieRelease', id: string };

export type CertifyUserTicketEntityFragment_News_Fragment = { __typename: 'News', id: string };

export type CertifyUserTicketEntityFragment_Person_Fragment = { __typename: 'Person', id: string };

export type CertifyUserTicketEntityFragment_PressReview_Fragment = { __typename: 'PressReview', id: string };

export type CertifyUserTicketEntityFragment_Product_Fragment = { __typename: 'Product', id: string };

export type CertifyUserTicketEntityFragment_Program_Fragment = { __typename: 'Program', title?: string | null, id: string };

export type CertifyUserTicketEntityFragment_ProgramEpisode_Fragment = { __typename: 'ProgramEpisode', id: string };

export type CertifyUserTicketEntityFragment_ProgramSeason_Fragment = { __typename: 'ProgramSeason', id: string };

export type CertifyUserTicketEntityFragment_Season_Fragment = { __typename: 'Season', number?: number | null, status?: Status | null, id: string, data?: { __typename?: 'SeasonData', rules?: { __typename?: 'EntityRules', rating?: { __typename?: 'EntityRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null };

export type CertifyUserTicketEntityFragment_SeasonRelease_Fragment = { __typename: 'SeasonRelease', id: string };

export type CertifyUserTicketEntityFragment_Series_Fragment = { __typename: 'Series', title?: string | null, id: string, originalBroadcast?: { __typename?: 'SeriesOriginalBroadcast', firstAiredDate?: { __typename?: 'PartialDate', date?: string | null } | null } | null };

export type CertifyUserTicketEntityFragment_SeriesRelease_Fragment = { __typename: 'SeriesRelease', id: string };

export type CertifyUserTicketEntityFragment_Showtime_Fragment = { __typename: 'Showtime', id: string };

export type CertifyUserTicketEntityFragment_ShowtimeWithParentsId_Fragment = { __typename: 'ShowtimeWithParentsId', id: string };

export type CertifyUserTicketEntityFragment_SocialMediaCategory_Fragment = { __typename: 'SocialMediaCategory', id: string };

export type CertifyUserTicketEntityFragment_Tag_Fragment = { __typename: 'Tag', id: string };

export type CertifyUserTicketEntityFragment_Theater_Fragment = { __typename: 'Theater', id: string };

export type CertifyUserTicketEntityFragment_TheaterScreen_Fragment = { __typename: 'TheaterScreen', id: string };

export type CertifyUserTicketEntityFragment_User_Fragment = { __typename: 'User', id: string };

export type CertifyUserTicketEntityFragment_UserCollection_Fragment = { __typename: 'UserCollection', id: string };

export type CertifyUserTicketEntityFragment_UserReview_Fragment = { __typename: 'UserReview', id: string };

export type CertifyUserTicketEntityFragment_Video_Fragment = { __typename: 'Video', id: string };

export type CertifyUserTicketEntityFragmentFragment = CertifyUserTicketEntityFragment_Author_Fragment | CertifyUserTicketEntityFragment_Carousel_Fragment | CertifyUserTicketEntityFragment_Company_Fragment | CertifyUserTicketEntityFragment_EditorialReview_Fragment | CertifyUserTicketEntityFragment_EntityClub_Fragment | CertifyUserTicketEntityFragment_Episode_Fragment | CertifyUserTicketEntityFragment_Festival_Fragment | CertifyUserTicketEntityFragment_FestivalEdition_Fragment | CertifyUserTicketEntityFragment_InternalImage_Fragment | CertifyUserTicketEntityFragment_Movie_Fragment | CertifyUserTicketEntityFragment_MovieRelease_Fragment | CertifyUserTicketEntityFragment_News_Fragment | CertifyUserTicketEntityFragment_Person_Fragment | CertifyUserTicketEntityFragment_PressReview_Fragment | CertifyUserTicketEntityFragment_Product_Fragment | CertifyUserTicketEntityFragment_Program_Fragment | CertifyUserTicketEntityFragment_ProgramEpisode_Fragment | CertifyUserTicketEntityFragment_ProgramSeason_Fragment | CertifyUserTicketEntityFragment_Season_Fragment | CertifyUserTicketEntityFragment_SeasonRelease_Fragment | CertifyUserTicketEntityFragment_Series_Fragment | CertifyUserTicketEntityFragment_SeriesRelease_Fragment | CertifyUserTicketEntityFragment_Showtime_Fragment | CertifyUserTicketEntityFragment_ShowtimeWithParentsId_Fragment | CertifyUserTicketEntityFragment_SocialMediaCategory_Fragment | CertifyUserTicketEntityFragment_Tag_Fragment | CertifyUserTicketEntityFragment_Theater_Fragment | CertifyUserTicketEntityFragment_TheaterScreen_Fragment | CertifyUserTicketEntityFragment_User_Fragment | CertifyUserTicketEntityFragment_UserCollection_Fragment | CertifyUserTicketEntityFragment_UserReview_Fragment | CertifyUserTicketEntityFragment_Video_Fragment;


export type CertifyUserTicketEntityFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type CertifyUserTicketSocialActionFragment_Fan_Fragment = { __typename: 'Fan', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_Follow_Fragment = { __typename: 'Follow', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_Helpful_Fragment = { __typename: 'Helpful', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_NotInterested_Fragment = { __typename: 'NotInterested', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_Opinion_Fragment = { __typename: 'Opinion', id: string, updatedAt?: any | null, content?: { __typename?: 'OpinionReview', rating?: number | null, certificationRating?: CertificationRatingStatus | null, review?: string | null, status?: ReviewStatus | null } | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_SeenIt_Fragment = { __typename: 'SeenIt', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_Subscribe_Fragment = { __typename: 'Subscribe', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_Unhelpful_Fragment = { __typename: 'Unhelpful', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragment_WantToSee_Fragment = { __typename: 'WantToSee', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type CertifyUserTicketSocialActionFragmentFragment = CertifyUserTicketSocialActionFragment_Fan_Fragment | CertifyUserTicketSocialActionFragment_Follow_Fragment | CertifyUserTicketSocialActionFragment_Helpful_Fragment | CertifyUserTicketSocialActionFragment_NotInterested_Fragment | CertifyUserTicketSocialActionFragment_Opinion_Fragment | CertifyUserTicketSocialActionFragment_SeenIt_Fragment | CertifyUserTicketSocialActionFragment_Subscribe_Fragment | CertifyUserTicketSocialActionFragment_Unhelpful_Fragment | CertifyUserTicketSocialActionFragment_WantToSee_Fragment;


export type CertifyUserTicketSocialActionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type CertifyUserTicketUserEntityLeafFragment_UserEntityLeaf_Fragment = { __typename?: 'UserEntityLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & CertifyUserTicketEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & CertifyUserTicketEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & CertifyUserTicketEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & CertifyUserTicketEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & CertifyUserTicketEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & CertifyUserTicketEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & CertifyUserTicketEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & CertifyUserTicketEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & CertifyUserTicketEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & CertifyUserTicketEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & CertifyUserTicketEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & CertifyUserTicketEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & CertifyUserTicketEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & CertifyUserTicketEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & CertifyUserTicketEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & CertifyUserTicketEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & CertifyUserTicketEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & CertifyUserTicketEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & CertifyUserTicketEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & CertifyUserTicketEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & CertifyUserTicketEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & CertifyUserTicketEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & CertifyUserTicketEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & CertifyUserTicketEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & CertifyUserTicketEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & CertifyUserTicketEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & CertifyUserTicketEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & CertifyUserTicketEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & CertifyUserTicketEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & CertifyUserTicketEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & CertifyUserTicketEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & CertifyUserTicketEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & CertifyUserTicketSocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & CertifyUserTicketSocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & CertifyUserTicketSocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & CertifyUserTicketSocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & CertifyUserTicketSocialActionFragment_SeenIt_Fragment
  ) | null };

export type CertifyUserTicketUserEntityLeafFragment_UserMovieLeaf_Fragment = { __typename?: 'UserMovieLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & CertifyUserTicketEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & CertifyUserTicketEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & CertifyUserTicketEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & CertifyUserTicketEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & CertifyUserTicketEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & CertifyUserTicketEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & CertifyUserTicketEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & CertifyUserTicketEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & CertifyUserTicketEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & CertifyUserTicketEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & CertifyUserTicketEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & CertifyUserTicketEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & CertifyUserTicketEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & CertifyUserTicketEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & CertifyUserTicketEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & CertifyUserTicketEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & CertifyUserTicketEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & CertifyUserTicketEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & CertifyUserTicketEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & CertifyUserTicketEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & CertifyUserTicketEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & CertifyUserTicketEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & CertifyUserTicketEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & CertifyUserTicketEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & CertifyUserTicketEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & CertifyUserTicketEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & CertifyUserTicketEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & CertifyUserTicketEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & CertifyUserTicketEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & CertifyUserTicketEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & CertifyUserTicketEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & CertifyUserTicketEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & CertifyUserTicketSocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & CertifyUserTicketSocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & CertifyUserTicketSocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & CertifyUserTicketSocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & CertifyUserTicketSocialActionFragment_SeenIt_Fragment
  ) | null };

export type CertifyUserTicketUserEntityLeafFragment_UserSeriesLeaf_Fragment = { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & CertifyUserTicketEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & CertifyUserTicketEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & CertifyUserTicketEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & CertifyUserTicketEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & CertifyUserTicketEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & CertifyUserTicketEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & CertifyUserTicketEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & CertifyUserTicketEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & CertifyUserTicketEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & CertifyUserTicketEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & CertifyUserTicketEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & CertifyUserTicketEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & CertifyUserTicketEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & CertifyUserTicketEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & CertifyUserTicketEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & CertifyUserTicketEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & CertifyUserTicketEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & CertifyUserTicketEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & CertifyUserTicketEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & CertifyUserTicketEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & CertifyUserTicketEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & CertifyUserTicketEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & CertifyUserTicketEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & CertifyUserTicketEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & CertifyUserTicketEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & CertifyUserTicketEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & CertifyUserTicketEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & CertifyUserTicketEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & CertifyUserTicketEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & CertifyUserTicketEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & CertifyUserTicketEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & CertifyUserTicketEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & CertifyUserTicketSocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & CertifyUserTicketSocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & CertifyUserTicketSocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & CertifyUserTicketSocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & CertifyUserTicketSocialActionFragment_SeenIt_Fragment
  ) | null };

export type CertifyUserTicketUserEntityLeafFragmentFragment = CertifyUserTicketUserEntityLeafFragment_UserEntityLeaf_Fragment | CertifyUserTicketUserEntityLeafFragment_UserMovieLeaf_Fragment | CertifyUserTicketUserEntityLeafFragment_UserSeriesLeaf_Fragment;


export type CertifyUserTicketUserEntityLeafFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type CertifyUserTicketMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  brandCountry?: InputMaybe<CountryCode>;
}>;


export type CertifyUserTicketMutation = { __typename?: 'Mutation', certifyUserTicket: { __typename?: 'MutationOutput', userEntityLeaf?: (
      { __typename?: 'UserEntityLeaf' }
      & CertifyUserTicketUserEntityLeafFragment_UserEntityLeaf_Fragment
    ) | (
      { __typename?: 'UserMovieLeaf' }
      & CertifyUserTicketUserEntityLeafFragment_UserMovieLeaf_Fragment
    ) | (
      { __typename?: 'UserSeriesLeaf' }
      & CertifyUserTicketUserEntityLeafFragment_UserSeriesLeaf_Fragment
    ) | null } };

export type RemoveFavoriteTheaterMutationVariables = Exact<{
  theaterId: Scalars['String']['input'];
}>;


export type RemoveFavoriteTheaterMutation = { __typename?: 'Mutation', deleteUserTheater?: { __typename?: 'Theater', id: string } | null };

export type AddFavoriteTheaterMutationVariables = Exact<{
  theaterId: Scalars['String']['input'];
}>;


export type AddFavoriteTheaterMutation = { __typename?: 'Mutation', addUserTheater?: { __typename?: 'Theater', internalId?: string | null, name?: string | null } | null };

export type GetUserTheatersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserTheatersQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', social?: { __typename?: 'UserSocialInformation', theaters?: { __typename?: 'TheaterConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'TheaterEdge', node?: { __typename?: 'Theater', internalId?: string | null, name?: string | null } | null } | null> | null } | null } | null } | null } | null };

export type UserOpinionEntityFragment_Author_Fragment = { __typename: 'Author', id: string };

export type UserOpinionEntityFragment_Carousel_Fragment = { __typename: 'Carousel', id: string };

export type UserOpinionEntityFragment_Company_Fragment = { __typename: 'Company', id: string };

export type UserOpinionEntityFragment_EditorialReview_Fragment = { __typename: 'EditorialReview', id: string };

export type UserOpinionEntityFragment_EntityClub_Fragment = { __typename: 'EntityClub', id: string };

export type UserOpinionEntityFragment_Episode_Fragment = { __typename: 'Episode', title?: string | null, id: string };

export type UserOpinionEntityFragment_Festival_Fragment = { __typename: 'Festival', id: string };

export type UserOpinionEntityFragment_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string };

export type UserOpinionEntityFragment_InternalImage_Fragment = { __typename: 'InternalImage', id: string };

export type UserOpinionEntityFragment_Movie_Fragment = { __typename: 'Movie', title?: string | null, id: string, poster?: { __typename?: 'InternalImage', path?: string | null } | null, flags?: { __typename?: 'MovieFlags', isComingSoon?: boolean | null, hasShowtime?: boolean | null } | null, releases?: Array<{ __typename?: 'MovieRelease', releaseDate?: { __typename?: 'PartialDate', date?: string | null } | null } | null> | null };

export type UserOpinionEntityFragment_MovieRelease_Fragment = { __typename: 'MovieRelease', id: string };

export type UserOpinionEntityFragment_News_Fragment = { __typename: 'News', id: string };

export type UserOpinionEntityFragment_Person_Fragment = { __typename: 'Person', id: string };

export type UserOpinionEntityFragment_PressReview_Fragment = { __typename: 'PressReview', id: string };

export type UserOpinionEntityFragment_Product_Fragment = { __typename: 'Product', id: string };

export type UserOpinionEntityFragment_Program_Fragment = { __typename: 'Program', title?: string | null, id: string };

export type UserOpinionEntityFragment_ProgramEpisode_Fragment = { __typename: 'ProgramEpisode', id: string };

export type UserOpinionEntityFragment_ProgramSeason_Fragment = { __typename: 'ProgramSeason', id: string };

export type UserOpinionEntityFragment_Season_Fragment = { __typename: 'Season', number?: number | null, status?: Status | null, id: string, data?: { __typename?: 'SeasonData', rules?: { __typename?: 'EntityRules', rating?: { __typename?: 'EntityRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null };

export type UserOpinionEntityFragment_SeasonRelease_Fragment = { __typename: 'SeasonRelease', id: string };

export type UserOpinionEntityFragment_Series_Fragment = { __typename: 'Series', title?: string | null, id: string, originalBroadcast?: { __typename?: 'SeriesOriginalBroadcast', firstAiredDate?: { __typename?: 'PartialDate', date?: string | null } | null } | null };

export type UserOpinionEntityFragment_SeriesRelease_Fragment = { __typename: 'SeriesRelease', id: string };

export type UserOpinionEntityFragment_Showtime_Fragment = { __typename: 'Showtime', id: string };

export type UserOpinionEntityFragment_ShowtimeWithParentsId_Fragment = { __typename: 'ShowtimeWithParentsId', id: string };

export type UserOpinionEntityFragment_SocialMediaCategory_Fragment = { __typename: 'SocialMediaCategory', id: string };

export type UserOpinionEntityFragment_Tag_Fragment = { __typename: 'Tag', id: string };

export type UserOpinionEntityFragment_Theater_Fragment = { __typename: 'Theater', id: string };

export type UserOpinionEntityFragment_TheaterScreen_Fragment = { __typename: 'TheaterScreen', id: string };

export type UserOpinionEntityFragment_User_Fragment = { __typename: 'User', id: string };

export type UserOpinionEntityFragment_UserCollection_Fragment = { __typename: 'UserCollection', id: string };

export type UserOpinionEntityFragment_UserReview_Fragment = { __typename: 'UserReview', id: string };

export type UserOpinionEntityFragment_Video_Fragment = { __typename: 'Video', id: string };

export type UserOpinionEntityFragmentFragment = UserOpinionEntityFragment_Author_Fragment | UserOpinionEntityFragment_Carousel_Fragment | UserOpinionEntityFragment_Company_Fragment | UserOpinionEntityFragment_EditorialReview_Fragment | UserOpinionEntityFragment_EntityClub_Fragment | UserOpinionEntityFragment_Episode_Fragment | UserOpinionEntityFragment_Festival_Fragment | UserOpinionEntityFragment_FestivalEdition_Fragment | UserOpinionEntityFragment_InternalImage_Fragment | UserOpinionEntityFragment_Movie_Fragment | UserOpinionEntityFragment_MovieRelease_Fragment | UserOpinionEntityFragment_News_Fragment | UserOpinionEntityFragment_Person_Fragment | UserOpinionEntityFragment_PressReview_Fragment | UserOpinionEntityFragment_Product_Fragment | UserOpinionEntityFragment_Program_Fragment | UserOpinionEntityFragment_ProgramEpisode_Fragment | UserOpinionEntityFragment_ProgramSeason_Fragment | UserOpinionEntityFragment_Season_Fragment | UserOpinionEntityFragment_SeasonRelease_Fragment | UserOpinionEntityFragment_Series_Fragment | UserOpinionEntityFragment_SeriesRelease_Fragment | UserOpinionEntityFragment_Showtime_Fragment | UserOpinionEntityFragment_ShowtimeWithParentsId_Fragment | UserOpinionEntityFragment_SocialMediaCategory_Fragment | UserOpinionEntityFragment_Tag_Fragment | UserOpinionEntityFragment_Theater_Fragment | UserOpinionEntityFragment_TheaterScreen_Fragment | UserOpinionEntityFragment_User_Fragment | UserOpinionEntityFragment_UserCollection_Fragment | UserOpinionEntityFragment_UserReview_Fragment | UserOpinionEntityFragment_Video_Fragment;


export type UserOpinionEntityFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SocialActionFragment_Fan_Fragment = { __typename: 'Fan', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_Follow_Fragment = { __typename: 'Follow', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_Helpful_Fragment = { __typename: 'Helpful', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_NotInterested_Fragment = { __typename: 'NotInterested', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_Opinion_Fragment = { __typename: 'Opinion', id: string, updatedAt?: any | null, content?: { __typename?: 'OpinionReview', rating?: number | null, certificationRating?: CertificationRatingStatus | null, review?: string | null, status?: ReviewStatus | null } | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_SeenIt_Fragment = { __typename: 'SeenIt', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_Subscribe_Fragment = { __typename: 'Subscribe', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_Unhelpful_Fragment = { __typename: 'Unhelpful', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragment_WantToSee_Fragment = { __typename: 'WantToSee', id: string, updatedAt?: any | null, relatedEntity?: { __typename: 'Author', id: string } | { __typename: 'Carousel', id: string } | { __typename: 'Company', id: string } | { __typename: 'EditorialReview', id: string } | { __typename: 'EntityClub', id: string } | { __typename: 'Episode', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'InternalImage', id: string } | { __typename: 'Movie', id: string } | { __typename: 'MovieRelease', id: string } | { __typename: 'News', id: string } | { __typename: 'Person', id: string } | { __typename: 'PressReview', id: string } | { __typename: 'Product', id: string } | { __typename: 'Program', id: string } | { __typename: 'ProgramEpisode', id: string } | { __typename: 'ProgramSeason', id: string } | { __typename: 'Season', id: string } | { __typename: 'SeasonRelease', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesRelease', id: string } | { __typename: 'Showtime', id: string } | { __typename: 'ShowtimeWithParentsId', id: string } | { __typename: 'SocialMediaCategory', id: string } | { __typename: 'Tag', id: string } | { __typename: 'Theater', id: string } | { __typename: 'TheaterScreen', id: string } | { __typename: 'User', id: string } | { __typename: 'UserCollection', id: string } | { __typename: 'UserReview', id: string } | { __typename: 'Video', id: string } | null };

export type SocialActionFragmentFragment = SocialActionFragment_Fan_Fragment | SocialActionFragment_Follow_Fragment | SocialActionFragment_Helpful_Fragment | SocialActionFragment_NotInterested_Fragment | SocialActionFragment_Opinion_Fragment | SocialActionFragment_SeenIt_Fragment | SocialActionFragment_Subscribe_Fragment | SocialActionFragment_Unhelpful_Fragment | SocialActionFragment_WantToSee_Fragment;


export type SocialActionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserEntityLeafFragment_UserEntityLeaf_Fragment = { __typename?: 'UserEntityLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & UserOpinionEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & UserOpinionEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & UserOpinionEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & UserOpinionEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & UserOpinionEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & UserOpinionEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & UserOpinionEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & UserOpinionEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & UserOpinionEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & UserOpinionEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & UserOpinionEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & UserOpinionEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & UserOpinionEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & UserOpinionEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & UserOpinionEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & UserOpinionEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & UserOpinionEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & UserOpinionEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & UserOpinionEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & UserOpinionEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & UserOpinionEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & UserOpinionEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & UserOpinionEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & UserOpinionEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & UserOpinionEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & UserOpinionEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & UserOpinionEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & UserOpinionEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & UserOpinionEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & UserOpinionEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & UserOpinionEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & UserOpinionEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & SocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & SocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & SocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & SocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & SocialActionFragment_SeenIt_Fragment
  ) | null };

export type UserEntityLeafFragment_UserMovieLeaf_Fragment = { __typename?: 'UserMovieLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & UserOpinionEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & UserOpinionEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & UserOpinionEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & UserOpinionEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & UserOpinionEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & UserOpinionEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & UserOpinionEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & UserOpinionEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & UserOpinionEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & UserOpinionEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & UserOpinionEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & UserOpinionEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & UserOpinionEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & UserOpinionEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & UserOpinionEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & UserOpinionEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & UserOpinionEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & UserOpinionEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & UserOpinionEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & UserOpinionEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & UserOpinionEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & UserOpinionEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & UserOpinionEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & UserOpinionEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & UserOpinionEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & UserOpinionEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & UserOpinionEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & UserOpinionEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & UserOpinionEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & UserOpinionEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & UserOpinionEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & UserOpinionEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & SocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & SocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & SocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & SocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & SocialActionFragment_SeenIt_Fragment
  ) | null };

export type UserEntityLeafFragment_UserSeriesLeaf_Fragment = { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: (
    { __typename?: 'Author' }
    & UserOpinionEntityFragment_Author_Fragment
  ) | (
    { __typename?: 'Carousel' }
    & UserOpinionEntityFragment_Carousel_Fragment
  ) | (
    { __typename?: 'Company' }
    & UserOpinionEntityFragment_Company_Fragment
  ) | (
    { __typename?: 'EditorialReview' }
    & UserOpinionEntityFragment_EditorialReview_Fragment
  ) | (
    { __typename?: 'EntityClub' }
    & UserOpinionEntityFragment_EntityClub_Fragment
  ) | (
    { __typename?: 'Episode' }
    & UserOpinionEntityFragment_Episode_Fragment
  ) | (
    { __typename?: 'Festival' }
    & UserOpinionEntityFragment_Festival_Fragment
  ) | (
    { __typename?: 'FestivalEdition' }
    & UserOpinionEntityFragment_FestivalEdition_Fragment
  ) | (
    { __typename?: 'InternalImage' }
    & UserOpinionEntityFragment_InternalImage_Fragment
  ) | (
    { __typename?: 'Movie' }
    & UserOpinionEntityFragment_Movie_Fragment
  ) | (
    { __typename?: 'MovieRelease' }
    & UserOpinionEntityFragment_MovieRelease_Fragment
  ) | (
    { __typename?: 'News' }
    & UserOpinionEntityFragment_News_Fragment
  ) | (
    { __typename?: 'Person' }
    & UserOpinionEntityFragment_Person_Fragment
  ) | (
    { __typename?: 'PressReview' }
    & UserOpinionEntityFragment_PressReview_Fragment
  ) | (
    { __typename?: 'Product' }
    & UserOpinionEntityFragment_Product_Fragment
  ) | (
    { __typename?: 'Program' }
    & UserOpinionEntityFragment_Program_Fragment
  ) | (
    { __typename?: 'ProgramEpisode' }
    & UserOpinionEntityFragment_ProgramEpisode_Fragment
  ) | (
    { __typename?: 'ProgramSeason' }
    & UserOpinionEntityFragment_ProgramSeason_Fragment
  ) | (
    { __typename?: 'Season' }
    & UserOpinionEntityFragment_Season_Fragment
  ) | (
    { __typename?: 'SeasonRelease' }
    & UserOpinionEntityFragment_SeasonRelease_Fragment
  ) | (
    { __typename?: 'Series' }
    & UserOpinionEntityFragment_Series_Fragment
  ) | (
    { __typename?: 'SeriesRelease' }
    & UserOpinionEntityFragment_SeriesRelease_Fragment
  ) | (
    { __typename?: 'Showtime' }
    & UserOpinionEntityFragment_Showtime_Fragment
  ) | (
    { __typename?: 'ShowtimeWithParentsId' }
    & UserOpinionEntityFragment_ShowtimeWithParentsId_Fragment
  ) | (
    { __typename?: 'SocialMediaCategory' }
    & UserOpinionEntityFragment_SocialMediaCategory_Fragment
  ) | (
    { __typename?: 'Tag' }
    & UserOpinionEntityFragment_Tag_Fragment
  ) | (
    { __typename?: 'Theater' }
    & UserOpinionEntityFragment_Theater_Fragment
  ) | (
    { __typename?: 'TheaterScreen' }
    & UserOpinionEntityFragment_TheaterScreen_Fragment
  ) | (
    { __typename?: 'User' }
    & UserOpinionEntityFragment_User_Fragment
  ) | (
    { __typename?: 'UserCollection' }
    & UserOpinionEntityFragment_UserCollection_Fragment
  ) | (
    { __typename?: 'UserReview' }
    & UserOpinionEntityFragment_UserReview_Fragment
  ) | (
    { __typename?: 'Video' }
    & UserOpinionEntityFragment_Video_Fragment
  ) | null, opinion?: (
    { __typename?: 'Opinion' }
    & SocialActionFragment_Opinion_Fragment
  ) | null, wantToSee?: (
    { __typename?: 'WantToSee' }
    & SocialActionFragment_WantToSee_Fragment
  ) | null, helpful?: (
    { __typename?: 'Helpful' }
    & SocialActionFragment_Helpful_Fragment
  ) | null, unhelpful?: (
    { __typename?: 'Unhelpful' }
    & SocialActionFragment_Unhelpful_Fragment
  ) | null, seenIt?: (
    { __typename?: 'SeenIt' }
    & SocialActionFragment_SeenIt_Fragment
  ) | null };

export type UserEntityLeafFragmentFragment = UserEntityLeafFragment_UserEntityLeaf_Fragment | UserEntityLeafFragment_UserMovieLeaf_Fragment | UserEntityLeafFragment_UserSeriesLeaf_Fragment;


export type UserEntityLeafFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type GetUserOpinionQueryVariables = Exact<{
  entityIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  brandCountry?: InputMaybe<CountryCode>;
}>;


export type GetUserOpinionQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', social?: { __typename?: 'UserSocialInformation', entities?: { __typename?: 'UserEntityConnection', edges?: Array<{ __typename?: 'UserEntityEdge', node?: (
              { __typename?: 'UserEntityLeaf' }
              & UserEntityLeafFragment_UserEntityLeaf_Fragment
            ) | null } | null> | null } | null } | null } | null } | null };

export type AddUserOpinionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  brandCountry?: InputMaybe<CountryCode>;
}>;


export type AddUserOpinionMutation = { __typename?: 'Mutation', addUserOpinion: { __typename?: 'MutationOutput', userEntityLeaf?: (
      { __typename?: 'UserEntityLeaf' }
      & UserEntityLeafFragment_UserEntityLeaf_Fragment
    ) | (
      { __typename?: 'UserMovieLeaf' }
      & UserEntityLeafFragment_UserMovieLeaf_Fragment
    ) | (
      { __typename?: 'UserSeriesLeaf' }
      & UserEntityLeafFragment_UserSeriesLeaf_Fragment
    ) | null } };

export type UpdateUserOpinionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  brandCountry?: InputMaybe<CountryCode>;
}>;


export type UpdateUserOpinionMutation = { __typename?: 'Mutation', updateUserOpinion: { __typename?: 'MutationOutput', userEntityLeaf?: (
      { __typename?: 'UserEntityLeaf' }
      & UserEntityLeafFragment_UserEntityLeaf_Fragment
    ) | (
      { __typename?: 'UserMovieLeaf' }
      & UserEntityLeafFragment_UserMovieLeaf_Fragment
    ) | (
      { __typename?: 'UserSeriesLeaf' }
      & UserEntityLeafFragment_UserSeriesLeaf_Fragment
    ) | null } };

export type DeleteUserOpinionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type DeleteUserOpinionMutation = { __typename?: 'Mutation', deleteUserOpinion: { __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null } | { __typename?: 'UserMovieLeaf', id?: string | null } | { __typename?: 'UserSeriesLeaf', id?: string | null } | null } };

export type GetUserRewindQueryVariables = Exact<{
  releaseFrom: Scalars['DateTime']['input'];
  releaseTo: Scalars['DateTime']['input'];
}>;


export type GetUserRewindQuery = { __typename?: 'Query', movieList?: { __typename?: 'moviesConnection', edges?: Array<{ __typename?: 'moviesEdge', node?: (
        { __typename?: 'Movie' }
        & UserRewindMovieFragmentFragment
      ) | null } | null> | null } | null, seriesList?: { __typename?: 'seriesConnection', edges?: Array<{ __typename?: 'seriesEdge', node?: (
        { __typename?: 'Series' }
        & UserRewindSeriesFragmentFragment
      ) | null } | null> | null } | null, me?: { __typename?: 'Me', user?: (
      { __typename?: 'User', social?: (
        { __typename?: 'UserSocialInformation' }
        & UserRewindFragmentFragment
      ) | null }
      & UserRewindMeFragmentFragment
    ) | null } | null };

export type UserRewindPersonFragmentFragment = { __typename: 'Person', id: string, firstName?: string | null, lastName?: string | null, picture?: { __typename?: 'InternalImage', path?: string | null } | null };


export type UserRewindPersonFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindMovieFragmentFragment = { __typename: 'Movie', id: string, internalId?: number | null, title?: string | null, poster?: { __typename: 'InternalImage', path?: string | null } | null, credits?: { __typename: 'creditsConnection', edges?: Array<{ __typename: 'creditsEdge', node?: { __typename: 'CreditsMember', person?: { __typename: 'Person', firstName?: string | null, lastName?: string | null } | null, position?: { __typename: 'Position', name?: PersonActivity | null } | null } | null } | null> | null } | null, stats?: { __typename?: 'MovieStats', wantToSeeCount: number } | null };


export type UserRewindMovieFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindSeriesFragmentFragment = { __typename: 'Series', id: string, internalId?: number | null, title?: string | null, poster?: { __typename: 'InternalImage', path?: string | null } | null, credits?: { __typename: 'creditsConnection', edges?: Array<{ __typename: 'creditsEdge', node?: { __typename: 'CreditsMember', person?: { __typename: 'Person', firstName?: string | null, lastName?: string | null } | null, position?: { __typename: 'Position', name?: PersonActivity | null } | null } | null } | null> | null } | null };


export type UserRewindSeriesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindEntityFragment_Author_Fragment = { __typename?: 'Author' };

export type UserRewindEntityFragment_Carousel_Fragment = { __typename?: 'Carousel' };

export type UserRewindEntityFragment_Company_Fragment = { __typename?: 'Company' };

export type UserRewindEntityFragment_EditorialReview_Fragment = { __typename?: 'EditorialReview' };

export type UserRewindEntityFragment_EntityClub_Fragment = { __typename?: 'EntityClub' };

export type UserRewindEntityFragment_Episode_Fragment = { __typename?: 'Episode' };

export type UserRewindEntityFragment_Festival_Fragment = { __typename?: 'Festival' };

export type UserRewindEntityFragment_FestivalEdition_Fragment = { __typename?: 'FestivalEdition' };

export type UserRewindEntityFragment_InternalImage_Fragment = { __typename?: 'InternalImage' };

export type UserRewindEntityFragment_Movie_Fragment = (
  { __typename?: 'Movie' }
  & UserRewindMovieFragmentFragment
);

export type UserRewindEntityFragment_MovieRelease_Fragment = { __typename?: 'MovieRelease' };

export type UserRewindEntityFragment_News_Fragment = { __typename?: 'News' };

export type UserRewindEntityFragment_Person_Fragment = (
  { __typename?: 'Person' }
  & UserRewindPersonFragmentFragment
);

export type UserRewindEntityFragment_PressReview_Fragment = { __typename?: 'PressReview' };

export type UserRewindEntityFragment_Product_Fragment = { __typename?: 'Product' };

export type UserRewindEntityFragment_Program_Fragment = { __typename?: 'Program' };

export type UserRewindEntityFragment_ProgramEpisode_Fragment = { __typename?: 'ProgramEpisode' };

export type UserRewindEntityFragment_ProgramSeason_Fragment = { __typename?: 'ProgramSeason' };

export type UserRewindEntityFragment_Season_Fragment = { __typename?: 'Season' };

export type UserRewindEntityFragment_SeasonRelease_Fragment = { __typename?: 'SeasonRelease' };

export type UserRewindEntityFragment_Series_Fragment = (
  { __typename?: 'Series' }
  & UserRewindSeriesFragmentFragment
);

export type UserRewindEntityFragment_SeriesRelease_Fragment = { __typename?: 'SeriesRelease' };

export type UserRewindEntityFragment_Showtime_Fragment = { __typename?: 'Showtime' };

export type UserRewindEntityFragment_ShowtimeWithParentsId_Fragment = { __typename?: 'ShowtimeWithParentsId' };

export type UserRewindEntityFragment_SocialMediaCategory_Fragment = { __typename?: 'SocialMediaCategory' };

export type UserRewindEntityFragment_Tag_Fragment = { __typename?: 'Tag' };

export type UserRewindEntityFragment_Theater_Fragment = { __typename?: 'Theater' };

export type UserRewindEntityFragment_TheaterScreen_Fragment = { __typename?: 'TheaterScreen' };

export type UserRewindEntityFragment_User_Fragment = { __typename?: 'User' };

export type UserRewindEntityFragment_UserCollection_Fragment = { __typename?: 'UserCollection' };

export type UserRewindEntityFragment_UserReview_Fragment = { __typename?: 'UserReview' };

export type UserRewindEntityFragment_Video_Fragment = { __typename?: 'Video' };

export type UserRewindEntityFragmentFragment = UserRewindEntityFragment_Author_Fragment | UserRewindEntityFragment_Carousel_Fragment | UserRewindEntityFragment_Company_Fragment | UserRewindEntityFragment_EditorialReview_Fragment | UserRewindEntityFragment_EntityClub_Fragment | UserRewindEntityFragment_Episode_Fragment | UserRewindEntityFragment_Festival_Fragment | UserRewindEntityFragment_FestivalEdition_Fragment | UserRewindEntityFragment_InternalImage_Fragment | UserRewindEntityFragment_Movie_Fragment | UserRewindEntityFragment_MovieRelease_Fragment | UserRewindEntityFragment_News_Fragment | UserRewindEntityFragment_Person_Fragment | UserRewindEntityFragment_PressReview_Fragment | UserRewindEntityFragment_Product_Fragment | UserRewindEntityFragment_Program_Fragment | UserRewindEntityFragment_ProgramEpisode_Fragment | UserRewindEntityFragment_ProgramSeason_Fragment | UserRewindEntityFragment_Season_Fragment | UserRewindEntityFragment_SeasonRelease_Fragment | UserRewindEntityFragment_Series_Fragment | UserRewindEntityFragment_SeriesRelease_Fragment | UserRewindEntityFragment_Showtime_Fragment | UserRewindEntityFragment_ShowtimeWithParentsId_Fragment | UserRewindEntityFragment_SocialMediaCategory_Fragment | UserRewindEntityFragment_Tag_Fragment | UserRewindEntityFragment_Theater_Fragment | UserRewindEntityFragment_TheaterScreen_Fragment | UserRewindEntityFragment_User_Fragment | UserRewindEntityFragment_UserCollection_Fragment | UserRewindEntityFragment_UserReview_Fragment | UserRewindEntityFragment_Video_Fragment;


export type UserRewindEntityFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindScreenFragmentFragment = { __typename: 'RewindScreen', name?: string | null, data?: any | null, entities?: Array<{ __typename: 'RewindScreenEntityList', identifier?: string | null, entities?: Array<(
      { __typename?: 'Author' }
      & UserRewindEntityFragment_Author_Fragment
    ) | (
      { __typename?: 'Carousel' }
      & UserRewindEntityFragment_Carousel_Fragment
    ) | (
      { __typename?: 'Company' }
      & UserRewindEntityFragment_Company_Fragment
    ) | (
      { __typename?: 'EditorialReview' }
      & UserRewindEntityFragment_EditorialReview_Fragment
    ) | (
      { __typename?: 'EntityClub' }
      & UserRewindEntityFragment_EntityClub_Fragment
    ) | (
      { __typename?: 'Episode' }
      & UserRewindEntityFragment_Episode_Fragment
    ) | (
      { __typename?: 'Festival' }
      & UserRewindEntityFragment_Festival_Fragment
    ) | (
      { __typename?: 'FestivalEdition' }
      & UserRewindEntityFragment_FestivalEdition_Fragment
    ) | (
      { __typename?: 'InternalImage' }
      & UserRewindEntityFragment_InternalImage_Fragment
    ) | (
      { __typename?: 'Movie' }
      & UserRewindEntityFragment_Movie_Fragment
    ) | (
      { __typename?: 'MovieRelease' }
      & UserRewindEntityFragment_MovieRelease_Fragment
    ) | (
      { __typename?: 'News' }
      & UserRewindEntityFragment_News_Fragment
    ) | (
      { __typename?: 'Person' }
      & UserRewindEntityFragment_Person_Fragment
    ) | (
      { __typename?: 'PressReview' }
      & UserRewindEntityFragment_PressReview_Fragment
    ) | (
      { __typename?: 'Product' }
      & UserRewindEntityFragment_Product_Fragment
    ) | (
      { __typename?: 'Program' }
      & UserRewindEntityFragment_Program_Fragment
    ) | (
      { __typename?: 'ProgramEpisode' }
      & UserRewindEntityFragment_ProgramEpisode_Fragment
    ) | (
      { __typename?: 'ProgramSeason' }
      & UserRewindEntityFragment_ProgramSeason_Fragment
    ) | (
      { __typename?: 'Season' }
      & UserRewindEntityFragment_Season_Fragment
    ) | (
      { __typename?: 'SeasonRelease' }
      & UserRewindEntityFragment_SeasonRelease_Fragment
    ) | (
      { __typename?: 'Series' }
      & UserRewindEntityFragment_Series_Fragment
    ) | (
      { __typename?: 'SeriesRelease' }
      & UserRewindEntityFragment_SeriesRelease_Fragment
    ) | (
      { __typename?: 'Showtime' }
      & UserRewindEntityFragment_Showtime_Fragment
    ) | (
      { __typename?: 'ShowtimeWithParentsId' }
      & UserRewindEntityFragment_ShowtimeWithParentsId_Fragment
    ) | (
      { __typename?: 'SocialMediaCategory' }
      & UserRewindEntityFragment_SocialMediaCategory_Fragment
    ) | (
      { __typename?: 'Tag' }
      & UserRewindEntityFragment_Tag_Fragment
    ) | (
      { __typename?: 'Theater' }
      & UserRewindEntityFragment_Theater_Fragment
    ) | (
      { __typename?: 'TheaterScreen' }
      & UserRewindEntityFragment_TheaterScreen_Fragment
    ) | (
      { __typename?: 'User' }
      & UserRewindEntityFragment_User_Fragment
    ) | (
      { __typename?: 'UserCollection' }
      & UserRewindEntityFragment_UserCollection_Fragment
    ) | (
      { __typename?: 'UserReview' }
      & UserRewindEntityFragment_UserReview_Fragment
    ) | (
      { __typename?: 'Video' }
      & UserRewindEntityFragment_Video_Fragment
    ) | null> | null } | null> | null };


export type UserRewindScreenFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindFragmentFragment = { __typename: 'UserSocialInformation', rewind?: { __typename: 'Rewind', screens?: Array<(
      { __typename?: 'RewindScreen' }
      & UserRewindScreenFragmentFragment
    ) | null> | null } | null };


export type UserRewindFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserRewindMeFragmentFragment = { __typename?: 'User', creationDate?: any | null, isClub300Member?: boolean | null, mainAvatar?: string | null, nickname?: string | null, stats?: { __typename?: 'UserStats', total_reviews: number, total_ratings: number, total_subscribers: number } | null };


export type UserRewindMeFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type GetSocialMediaCategoriesWithImagesQueryVariables = Exact<{
  type: SocialMedia;
  imagesFirst: Scalars['Int']['input'];
}>;


export type GetSocialMediaCategoriesWithImagesQuery = { __typename?: 'Query', socialMediaCategoryList?: { __typename?: 'imagesSocialMediaCategoryConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'imagesSocialMediaCategoryEdge', cursor: string, node?: { __typename?: 'SocialMediaCategory', id: string, internalId?: any | null, name?: string | null, tag?: SocialMedia | null, sponsored?: boolean | null, rank?: number | null, images?: { __typename?: 'imagesConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'imagesEdge', node?: { __typename?: 'InternalImage', id: string, internalId?: any | null, path?: string | null, endDate?: any | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type SetUserSocialCustomizationMutationVariables = Exact<{
  input: UserSocialMediaInput;
}>;


export type SetUserSocialCustomizationMutation = { __typename?: 'Mutation', setUserSocialCustomization: { __typename?: 'User', id: string, customization?: { __typename?: 'UserCustomization', mainAvatar?: { __typename?: 'UserCustomizationImage', internalId?: any | null, categoryId?: number | null, path?: string | null } | null, mainBanner?: { __typename?: 'UserCustomizationImage', internalId?: any | null, categoryId?: number | null, path?: string | null } | null } | null } };

export type GetMeCustomizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeCustomizationQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', customization?: { __typename?: 'UserCustomization', mainAvatar?: { __typename?: 'UserCustomizationImage', internalId?: any | null, categoryId?: number | null, path?: string | null } | null, mainBanner?: { __typename?: 'UserCustomizationImage', path?: string | null, internalId?: any | null, categoryId?: number | null } | null } | null } | null } | null };

export type GetAllNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', id: number, title: string, type?: NotificationType | null } | null> | null };

export type GetCollectionEntitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  collectionId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetCollectionEntitiesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', collections?: { __typename?: 'UserCollectionConnection', edges?: Array<{ __typename?: 'UserCollectionEdge', node?: (
              { __typename?: 'UserCollection', entitiesWithInterface?: { __typename?: 'UserEntityInterfaceConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'UserEntityInterfaceEdge', node?: { __typename?: 'UserEntityLeaf' } | (
                    { __typename?: 'UserMovieLeaf' }
                    & UserMovieLeafFragmentFragment
                  ) | (
                    { __typename?: 'UserSeriesLeaf' }
                    & UserSeriesLeafFragmentFragment
                  ) | null } | null> | null } | null }
              & CollectionFragmentFragment
            ) | null } | null> | null } | null } | null } | null } | null };

export type GetFollowedCollectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFollowedCollectionsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', collections?: { __typename?: 'UserCollectionConnection', totalCount?: number | null } | null, followedCollections?: { __typename?: 'UserCollectionConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'UserCollectionEdge', node?: (
              { __typename?: 'UserCollection' }
              & CollectionCoverFragmentFragment
            ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null } | null } | null };

export type GetPersonalCollectionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPersonalCollectionsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', followedCollections?: { __typename?: 'UserCollectionConnection', totalCount?: number | null } | null, collections?: { __typename?: 'UserCollectionConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'UserCollectionEdge', node?: (
              { __typename?: 'UserCollection' }
              & CollectionCoverFragmentFragment
            ) | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null } | null } | null };

export type GetMovieSuggestionsForCollectionQueryVariables = Exact<{
  movieId: Scalars['String']['input'];
  idsToExclude: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetMovieSuggestionsForCollectionQuery = { __typename?: 'Query', movie?: { __typename?: 'Movie', affinities?: { __typename?: 'analogyConnection', edges?: Array<{ __typename?: 'analogyEdge', node?: { __typename?: 'Analogy', entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
            { __typename?: 'Movie' }
            & MovieFragmentFragment
          ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null } | null };

export type GetSeriesSuggestionsForCollectionQueryVariables = Exact<{
  seriesId: Scalars['String']['input'];
  idsToExclude: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type GetSeriesSuggestionsForCollectionQuery = { __typename?: 'Query', series?: { __typename?: 'Series', affinities?: { __typename?: 'analogyConnection', edges?: Array<{ __typename?: 'analogyEdge', node?: { __typename?: 'Analogy', entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
            { __typename?: 'Series' }
            & SeriesFragmentFragment
          ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null } | null };

export type SearchEntitiesForCollectionQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type SearchEntitiesForCollectionQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', inCollection?: boolean | null, node?: { __typename: 'Author' } | { __typename: 'Carousel' } | { __typename: 'Company' } | { __typename: 'EditorialReview' } | { __typename: 'EntityClub' } | { __typename: 'Episode' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'InternalImage' } | (
          { __typename: 'Movie' }
          & MovieFragmentFragment
          & MovieReleasesFragmentFragment
          & MovieDirectionFragmentFragment
        ) | { __typename: 'MovieRelease' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'PressReview' } | { __typename: 'Product' } | { __typename: 'Program' } | { __typename: 'ProgramEpisode' } | { __typename: 'ProgramSeason' } | { __typename: 'Season' } | { __typename: 'SeasonRelease' } | (
          { __typename: 'Series' }
          & SeriesFragmentFragment
          & SeriesReleasesFragmentFragment
          & SeriesDirectorFragmentFragment
        ) | { __typename: 'SeriesRelease' } | { __typename: 'Showtime' } | { __typename: 'ShowtimeWithParentsId' } | { __typename: 'SocialMediaCategory' } | { __typename: 'Tag' } | { __typename: 'Theater' } | { __typename: 'TheaterScreen' } | { __typename: 'User' } | { __typename: 'UserCollection' } | { __typename: 'UserReview' } | { __typename: 'Video' } | null } | null } | null> | null } | null };

export type GetFollowNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFollowNumbersQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', userConnections?: { __typename?: 'UserConnections', followees?: { __typename?: 'UsersConnection', totalCount?: number | null } | null, followers?: { __typename?: 'UsersConnection', totalCount?: number | null } | null } | null } | null } | null } | null };

export type NodeOfFolloweesActionsFragmentFragment = { __typename?: 'UserSocialActionLeaf', user?: { __typename?: 'User', id: string, legacyId?: string | null, nickname?: string | null, customization?: { __typename?: 'UserCustomization', mainAvatar?: { __typename?: 'UserCustomizationImage', path?: string | null } | null } | null } | null, action?: { __typename: 'Fan', id: string, createdAt?: any | null, updatedAt?: any | null } | { __typename: 'Follow', id: string, createdAt?: any | null, updatedAt?: any | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User', id: string, legacyId?: string | null, nickname?: string | null } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename: 'Helpful', id: string, createdAt?: any | null, updatedAt?: any | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | (
      { __typename?: 'UserReview' }
      & ActionReviewFragmentFragment
    ) | { __typename?: 'Video' } | null } | { __typename: 'NotInterested', id: string, createdAt?: any | null, updatedAt?: any | null } | (
    { __typename: 'Opinion', id: string, createdAt?: any | null, updatedAt?: any | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
      { __typename?: 'Movie' }
      & ActionMovieFragmentFragment
    ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
      { __typename?: 'Season' }
      & ActionSeasonFragmentFragment
    ) | { __typename?: 'SeasonRelease' } | (
      { __typename?: 'Series' }
      & ActionSeriesFragmentFragment
    ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null }
    & ReviewFragmentFragment
  ) | { __typename: 'SeenIt', id: string, createdAt?: any | null, updatedAt?: any | null } | { __typename: 'Subscribe', id: string, createdAt?: any | null, updatedAt?: any | null } | { __typename: 'Unhelpful', id: string, createdAt?: any | null, updatedAt?: any | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | (
      { __typename?: 'UserReview' }
      & ActionReviewFragmentFragment
    ) | { __typename?: 'Video' } | null } | { __typename: 'WantToSee', id: string, createdAt?: any | null, updatedAt?: any | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
      { __typename?: 'Movie' }
      & ActionMovieFragmentFragment
    ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
      { __typename?: 'Series' }
      & ActionSeriesFragmentFragment
    ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null };


export type NodeOfFolloweesActionsFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type GetFolloweesActionsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetFolloweesActionsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', userConnections?: { __typename?: 'UserConnections', followees?: { __typename?: 'UsersConnection', totalCount?: number | null } | null, followers?: { __typename?: 'UsersConnection', totalCount?: number | null } | null } | null, followeesActions?: { __typename?: 'UserSocialActionConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserSocialActionEdge', node?: (
              { __typename?: 'UserSocialActionLeaf' }
              & NodeOfFolloweesActionsFragmentFragment
            ) | null } | null> | null } | null } | null } | null } | null };

export type GetMyFolloweesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMyFolloweesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', userConnections?: { __typename?: 'UserConnections', followers?: { __typename?: 'UsersConnection', totalCount?: number | null } | null, followees?: { __typename?: 'UsersConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'UsersEdge', node?: (
                { __typename?: 'User' }
                & SocialUserFragmentFragment
              ) | null } | null> | null } | null } | null } | null } | null } | null };

export type GetMyFollowersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  currentUserId: Scalars['String']['input'];
}>;


export type GetMyFollowersQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', userConnections?: { __typename?: 'UserConnections', followees?: { __typename?: 'UsersConnection', totalCount?: number | null } | null, followers?: { __typename?: 'UsersConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'UsersEdge', node?: (
                { __typename?: 'User', social?: { __typename?: 'UserSocialInformation', userConnections?: { __typename?: 'UserConnections', followers?: { __typename?: 'UsersConnection', totalCount?: number | null } | null } | null } | null }
                & SocialUserFragmentFragment
              ) | null } | null> | null } | null } | null } | null } | null } | null };

export type GetMoviesSeenQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<UserSocialActionType>> | InputMaybe<UserSocialActionType>>;
  order?: InputMaybe<UserSocialActionSorting>;
  rating?: InputMaybe<ReviewRating>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetMoviesSeenQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', wantToSee?: { __typename?: 'UserMovieConnection', totalCount?: number | null } | null, moviesSeen?: { __typename?: 'UserMovieConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserMovieEdge', node?: { __typename?: 'UserMovieLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type SearchMoviesSeenQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type SearchMoviesSeenQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', node?: { __typename: 'Author' } | { __typename: 'Carousel' } | { __typename: 'Company' } | { __typename: 'EditorialReview' } | { __typename: 'EntityClub' } | { __typename: 'Episode' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'InternalImage' } | (
          { __typename: 'Movie' }
          & MovieFragmentFragment
          & MovieReleasesFragmentFragment
          & MovieDirectionFragmentFragment
        ) | { __typename: 'MovieRelease' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'PressReview' } | { __typename: 'Product' } | { __typename: 'Program' } | { __typename: 'ProgramEpisode' } | { __typename: 'ProgramSeason' } | { __typename: 'Season' } | { __typename: 'SeasonRelease' } | { __typename: 'Series' } | { __typename: 'SeriesRelease' } | { __typename: 'Showtime' } | { __typename: 'ShowtimeWithParentsId' } | { __typename: 'SocialMediaCategory' } | { __typename: 'Tag' } | { __typename: 'Theater' } | { __typename: 'TheaterScreen' } | { __typename: 'User' } | { __typename: 'UserCollection' } | { __typename: 'UserReview' } | { __typename: 'Video' } | null } | null } | null> | null } | null };

export type GetMoviesWantToSeeQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  releaseType?: InputMaybe<Array<InputMaybe<CustomReleaseType>> | InputMaybe<CustomReleaseType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetMoviesWantToSeeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', moviesSeen?: { __typename?: 'UserMovieConnection', totalCount?: number | null } | null, wantToSee?: { __typename?: 'UserMovieConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserMovieEdge', node?: { __typename?: 'UserMovieLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
                  { __typename?: 'Movie', releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', vod?: boolean | null } | null } | null }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & UserAffinityFragment_Movie_Fragment
                ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetUnreviewedMoviesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreviewedMoviesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', movies?: { __typename?: 'UserMovieConnection', edges?: Array<{ __typename?: 'UserMovieEdge', node?: { __typename?: 'UserMovieLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type SearchMovieQueryVariables = Exact<{
  types?: InputMaybe<Array<InputMaybe<SearchTypes>> | InputMaybe<SearchTypes>>;
  text: Scalars['String']['input'];
  brandCountry: CountryCode;
}>;


export type SearchMovieQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', node?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
          { __typename?: 'Movie' }
          & MovieFragmentFragment
          & MovieDirectionFragmentFragment
          & MovieReleasesFragmentFragment
        ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null };

export type GetMoviesReviewsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<UserSocialActionSorting>;
  rating?: InputMaybe<ReviewRating>;
  statuses: Array<InputMaybe<ReviewStatus>> | InputMaybe<ReviewStatus>;
  brandCountry: CountryCode;
}>;


export type GetMoviesReviewsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', seriesReviews?: { __typename?: 'UserEntityConnection', totalCount?: number | null } | null, moviesReviews?: { __typename?: 'UserEntityConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserEntityEdge', node?: { __typename?: 'UserEntityLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
                  { __typename?: 'Movie', data?: { __typename?: 'MovieData', productionYear?: number | null } | null }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & ReviewFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetUnreviewedSeriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreviewedSeriesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', series?: { __typename?: 'UserSeriesConnection', edges?: Array<{ __typename?: 'UserSeriesEdge', node?: { __typename?: 'UserSeriesLeaf', series?: (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                ) | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type SearchSeriesQueryVariables = Exact<{
  types?: InputMaybe<Array<InputMaybe<SearchTypes>> | InputMaybe<SearchTypes>>;
  text: Scalars['String']['input'];
  brandCountry: CountryCode;
}>;


export type SearchSeriesQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', node?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
          { __typename?: 'Series' }
          & SeriesFragmentFragment
          & SeriesReleasesFragmentFragment
          & SeriesDirectorFragmentFragment
        ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null };

export type GetSeriesReviewsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<UserSocialActionSorting>;
  rating?: InputMaybe<ReviewRating>;
  statuses: Array<InputMaybe<ReviewStatus>> | InputMaybe<ReviewStatus>;
  brandCountry: CountryCode;
}>;


export type GetSeriesReviewsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', moviesReviews?: { __typename?: 'UserEntityConnection', totalCount?: number | null } | null, seriesReviews?: { __typename?: 'UserEntityConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserEntityEdge', node?: { __typename?: 'UserEntityLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
                  { __typename?: 'Season', startsAt?: any | null }
                  & SeasonFragmentFragment
                ) | { __typename?: 'SeasonRelease' } | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesReleasesFragmentFragment
                ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & ReviewFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetSeriesSeenQueryVariables = Exact<{
  order: UserSocialActionSorting;
  rating?: InputMaybe<SeriesReviewRating>;
  status: Array<RelatedSeriesStatus> | RelatedSeriesStatus;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSeriesSeenQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', allSeriesSeen?: { __typename?: 'UserSeriesConnection', totalCount?: number | null } | null, wantToSee?: { __typename?: 'UserSeriesConnection', totalCount?: number | null } | null, series?: { __typename?: 'UserSeriesConnection', edges?: Array<{ __typename?: 'UserSeriesEdge', node?: { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, progression?: (
                  { __typename?: 'UserSeriesProgression' }
                  & ProgressionFragmentFragment
                ) | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null, subscribe?: { __typename?: 'Subscribe', id: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null } | null } | null } | null };

export type SearchSeriesSeenQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type SearchSeriesSeenQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', node?: { __typename: 'Author' } | { __typename: 'Carousel' } | { __typename: 'Company' } | { __typename: 'EditorialReview' } | { __typename: 'EntityClub' } | { __typename: 'Episode' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'InternalImage' } | { __typename: 'Movie' } | { __typename: 'MovieRelease' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'PressReview' } | { __typename: 'Product' } | { __typename: 'Program' } | { __typename: 'ProgramEpisode' } | { __typename: 'ProgramSeason' } | { __typename: 'Season' } | { __typename: 'SeasonRelease' } | (
          { __typename: 'Series' }
          & SeriesFragmentFragment
          & SeriesReleasesFragmentFragment
          & SeriesDirectorFragmentFragment
        ) | { __typename: 'SeriesRelease' } | { __typename: 'Showtime' } | { __typename: 'ShowtimeWithParentsId' } | { __typename: 'SocialMediaCategory' } | { __typename: 'Tag' } | { __typename: 'Theater' } | { __typename: 'TheaterScreen' } | { __typename: 'User' } | { __typename: 'UserCollection' } | { __typename: 'UserReview' } | { __typename: 'Video' } | null } | null } | null> | null } | null };

export type GetSeriesWantToSeeQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetSeriesWantToSeeQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', seriesSeen?: { __typename?: 'UserSeriesConnection', totalCount?: number | null } | null, wantToSee?: { __typename?: 'UserSeriesConnection', totalCount?: number | null, edges?: Array<{ __typename?: 'UserSeriesEdge', node?: { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesCompanyReleasesFragmentFragment
                  & UserAffinityFragment_Series_Fragment
                ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null } | null } | null } | null };

export type GetMovieShowtimesQueryVariables = Exact<{
  movieId: Scalars['String']['input'];
  theaterIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMovieShowtimesQuery = { __typename?: 'Query', theaterShowtimeList?: { __typename?: 'theaterShowtimeByMovieListConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'theaterShowtimeByMovieListEdge', node?: { __typename?: 'TheaterShowtimeLeaf', theater?: { __typename?: 'Theater', id: string, internalId?: string | null, name?: string | null, theaterCircuits?: { __typename?: 'Company', internalId?: number | null, name?: string | null } | null, location?: { __typename?: 'Location', city?: string | null, region?: string | null } | null } | null, showtimes?: Array<{ __typename?: 'Showtime', id: string, internalId?: any | null, startsAt?: any | null, diffusionVersion?: ShowtimeVersion | null, projection?: Array<Projection | null> | null, experience?: Array<Experience | null> | null, isPreview?: boolean | null, tags: Array<string>, data?: { __typename?: 'ShowtimeData', ticketing?: Array<{ __typename?: 'Ticketing', urls?: Array<string | null> | null } | null> | null } | null } | null> | null } | null } | null> | null } | null };

export type GetTheatersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTheatersQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename: 'User', id: string, social?: { __typename?: 'UserSocialInformation', theaters?: { __typename?: 'TheaterConnection', edges?: Array<{ __typename: 'TheaterEdge', node?: (
              { __typename?: 'Theater' }
              & TheaterFragmentFragment
            ) | null } | null> | null } | null } | null } | null } | null };

export type GetTheatersMoviesQueryVariables = Exact<{
  theaterIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  brandCountry: CountryCode;
}>;


export type GetTheatersMoviesQuery = { __typename?: 'Query', movieByTheaterList?: { __typename?: 'moviesByTheaterListConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'moviesByTheaterListEdge', node?: { __typename?: 'MovieByTheaterLeaf', movie?: (
          { __typename?: 'Movie' }
          & MovieFragmentFragment
          & MovieReleasesFragmentFragment
        ) | null } | null } | null> | null } | null };

export type SearchTheatersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type SearchTheatersQuery = { __typename?: 'Query', search?: { __typename?: 'searchResultsConnection', edges?: Array<{ __typename?: 'searchResultsEdge', node?: { __typename?: 'SearchResult', node?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | (
          { __typename?: 'Theater' }
          & TheaterFragmentFragment
        ) | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null } | null> | null } | null };

export type GetMovieQueryVariables = Exact<{
  movieId?: InputMaybe<Scalars['String']['input']>;
  brandCountry: CountryCode;
}>;


export type GetMovieQuery = { __typename?: 'Query', movie?: (
    { __typename?: 'Movie' }
    & MovieFragmentFragment
    & MovieReleasesFragmentFragment
    & MovieDirectionFragmentFragment
  ) | null };

export type GetEntityToReviewQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  brandCountry: CountryCode;
}>;


export type GetEntityToReviewQuery = { __typename?: 'Query', node?: { __typename: 'Author' } | { __typename: 'Carousel' } | { __typename: 'Company' } | { __typename: 'EditorialReview' } | { __typename: 'EntityClub' } | { __typename: 'Episode' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'InternalImage' } | (
    { __typename: 'Movie', title?: string | null, id: string, internalId?: number | null, flags?: { __typename?: 'MovieFlags', isComingSoon?: boolean | null, hasShowtime?: boolean | null } | null, data?: { __typename?: 'MovieData', rules?: { __typename?: 'MovieRules', rating?: { __typename?: 'MovieRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null }
    & MovieReleasesFragmentFragment
  ) | { __typename: 'MovieRelease' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'PressReview' } | { __typename: 'Product' } | { __typename: 'Program' } | { __typename: 'ProgramEpisode' } | { __typename: 'ProgramSeason' } | { __typename: 'Season', id: string, number?: number | null, data?: { __typename?: 'SeasonData', rules?: { __typename?: 'EntityRules', rating?: { __typename?: 'EntityRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null, series?: { __typename?: 'Series', id: string, internalId?: number | null, title?: string | null, seasons?: { __typename?: 'seasonsConnection', edges?: Array<{ __typename?: 'seasonsEdge', node?: { __typename?: 'Season', id: string, number?: number | null, status?: Status | null } | null } | null> | null } | null } | null } | { __typename: 'SeasonRelease' } | (
    { __typename: 'Series', id: string, internalId?: number | null, title?: string | null, status?: Status | null, seasonCount?: number | null, seasons?: { __typename?: 'seasonsConnection', edges?: Array<{ __typename?: 'seasonsEdge', node?: { __typename?: 'Season', id: string, number?: number | null, status?: Status | null } | null } | null> | null } | null, data?: { __typename?: 'SeriesData', rules?: { __typename?: 'EntityRules', rating?: { __typename?: 'EntityRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null }
    & SeriesReleasesFragmentFragment
  ) | { __typename: 'SeriesRelease' } | { __typename: 'Showtime' } | { __typename: 'ShowtimeWithParentsId' } | { __typename: 'SocialMediaCategory' } | { __typename: 'Tag' } | { __typename: 'Theater' } | { __typename: 'TheaterScreen' } | { __typename: 'User' } | { __typename: 'UserCollection' } | { __typename: 'UserReview' } | { __typename: 'Video' } | null };

export type GetUserEntityReviewsQueryVariables = Exact<{
  entityId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetUserEntityReviewsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', actions?: { __typename?: 'UserSocialActionConnection', edges?: Array<{ __typename?: 'UserSocialActionEdge', node?: { __typename?: 'UserSocialActionLeaf', action?: { __typename?: 'Fan' } | { __typename?: 'Follow' } | { __typename?: 'Helpful' } | { __typename?: 'NotInterested' } | (
                { __typename?: 'Opinion', content?: { __typename?: 'OpinionReview', status?: ReviewStatus | null } | null }
                & ReviewFragmentFragment
              ) | { __typename?: 'SeenIt' } | { __typename?: 'Subscribe' } | { __typename?: 'Unhelpful' } | { __typename?: 'WantToSee' } | null } | null } | null> | null } | null } | null } | null } | null };

export type GetCurrentSeriesWithProgressQueryVariables = Exact<{
  seriesId: Scalars['String']['input'];
}>;


export type GetCurrentSeriesWithProgressQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', series?: { __typename?: 'UserSeriesConnection', edges?: Array<{ __typename?: 'UserSeriesEdge', node?: { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, progression?: { __typename?: 'UserSeriesProgression', seasons?: Array<{ __typename?: 'UserSeasonsProgression', percent?: number | null, season?: { __typename?: 'Season', id: string, internalId?: number | null, number?: number | null, series?: { __typename?: 'Series', id: string, title?: string | null } | null } | null, episodesSeenStatus?: Array<{ __typename?: 'UserEpisodeSeen', id?: string | null, title?: string | null, seen?: boolean | null } | null> | null } | null> | null } | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetUserSuggestedSeriesQueryVariables = Exact<{
  filters: Array<InputMaybe<SeriesStatus>> | InputMaybe<SeriesStatus>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetUserSuggestedSeriesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', suggestedEntities?: { __typename?: 'UserSuggestedEntities', series?: { __typename?: 'UserToSeriesConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserToSeriesEdge', node?: { __typename?: 'UserToSeriesLeaf', series?: (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesCompanyReleasesFragmentFragment
                  & SeriesDirectorFragmentFragment
                ) | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetTop250MoviesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetTop250MoviesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', relatedEntities?: { __typename?: 'UserRelatedEntities', unratedTopMovies?: { __typename?: 'moviesConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'moviesEdge', node?: (
                { __typename?: 'Movie' }
                & MovieFragmentFragment
                & MovieReleasesFragmentFragment
                & MovieDirectionFragmentFragment
              ) | null } | null> | null } | null } | null } | null } | null } | null };

export type GetUserSuggestedMoviesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetUserSuggestedMoviesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', suggestedEntities?: { __typename?: 'UserSuggestedEntities', movies?: { __typename?: 'UserToMovieConnection', edges?: Array<{ __typename?: 'UserToMovieEdge', node?: { __typename?: 'UserToMovieLeaf', movie?: (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & MovieDirectionFragmentFragment
                ) | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null } | null } | null };

export type GetWantToSeeSuggestedMoviesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type GetWantToSeeSuggestedMoviesQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', suggestedEntities?: { __typename?: 'UserSuggestedEntities', movies?: { __typename?: 'UserToMovieConnection', edges?: Array<{ __typename?: 'UserToMovieEdge', node?: { __typename?: 'UserToMovieLeaf', movie?: (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & MovieDirectionFragmentFragment
                ) | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null } | null } | null };

export type RemoveNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveNotificationMutation = { __typename?: 'Mutation', removeNotification?: { __typename: 'Notification', id: number } | null };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename: 'Notification', id: number, title: string, type?: NotificationType | null } | null> | null };

export type GetFolloweesSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFolloweesSuggestionsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', suggestedFollowees?: { __typename?: 'UsersConnection', edges?: Array<{ __typename?: 'UsersEdge', node?: (
              { __typename?: 'User' }
              & SocialUserFragmentFragment
            ) | null } | null> | null } | null } | null } | null } | null };

export type GetEntitiesFromCollectionsQueryVariables = Exact<{
  collectionId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  inRandomOrder?: InputMaybe<Scalars['Boolean']['input']>;
  statusIsNot?: InputMaybe<Array<InputMaybe<MovieStatus>> | InputMaybe<MovieStatus>>;
  brandCountry: CountryCode;
}>;


export type GetEntitiesFromCollectionsQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, social?: { __typename?: 'UserSocialInformation', suggestedEntities?: { __typename?: 'UserSuggestedEntities', entitiesFromCollection?: { __typename?: 'UserEntityInterfaceConnection', edges?: Array<{ __typename?: 'UserEntityInterfaceEdge', node?: { __typename?: 'UserEntityLeaf', id?: string | null, entity?: (
                  { __typename?: 'Author' }
                  & UserAffinityFragment_Author_Fragment
                ) | (
                  { __typename?: 'Carousel' }
                  & UserAffinityFragment_Carousel_Fragment
                ) | (
                  { __typename?: 'Company' }
                  & UserAffinityFragment_Company_Fragment
                ) | (
                  { __typename?: 'EditorialReview' }
                  & UserAffinityFragment_EditorialReview_Fragment
                ) | (
                  { __typename?: 'EntityClub' }
                  & UserAffinityFragment_EntityClub_Fragment
                ) | (
                  { __typename?: 'Episode' }
                  & UserAffinityFragment_Episode_Fragment
                ) | (
                  { __typename?: 'Festival' }
                  & UserAffinityFragment_Festival_Fragment
                ) | (
                  { __typename?: 'FestivalEdition' }
                  & UserAffinityFragment_FestivalEdition_Fragment
                ) | (
                  { __typename?: 'InternalImage' }
                  & UserAffinityFragment_InternalImage_Fragment
                ) | (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & UserAffinityFragment_Movie_Fragment
                ) | (
                  { __typename?: 'MovieRelease' }
                  & UserAffinityFragment_MovieRelease_Fragment
                ) | (
                  { __typename?: 'News' }
                  & UserAffinityFragment_News_Fragment
                ) | (
                  { __typename?: 'Person' }
                  & UserAffinityFragment_Person_Fragment
                ) | (
                  { __typename?: 'PressReview' }
                  & UserAffinityFragment_PressReview_Fragment
                ) | (
                  { __typename?: 'Product' }
                  & UserAffinityFragment_Product_Fragment
                ) | (
                  { __typename?: 'Program' }
                  & UserAffinityFragment_Program_Fragment
                ) | (
                  { __typename?: 'ProgramEpisode' }
                  & UserAffinityFragment_ProgramEpisode_Fragment
                ) | (
                  { __typename?: 'ProgramSeason' }
                  & UserAffinityFragment_ProgramSeason_Fragment
                ) | (
                  { __typename?: 'Season' }
                  & UserAffinityFragment_Season_Fragment
                ) | (
                  { __typename?: 'SeasonRelease' }
                  & UserAffinityFragment_SeasonRelease_Fragment
                ) | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesReleasesFragmentFragment
                  & UserAffinityFragment_Series_Fragment
                ) | (
                  { __typename?: 'SeriesRelease' }
                  & UserAffinityFragment_SeriesRelease_Fragment
                ) | (
                  { __typename?: 'Showtime' }
                  & UserAffinityFragment_Showtime_Fragment
                ) | (
                  { __typename?: 'ShowtimeWithParentsId' }
                  & UserAffinityFragment_ShowtimeWithParentsId_Fragment
                ) | (
                  { __typename?: 'SocialMediaCategory' }
                  & UserAffinityFragment_SocialMediaCategory_Fragment
                ) | (
                  { __typename?: 'Tag' }
                  & UserAffinityFragment_Tag_Fragment
                ) | (
                  { __typename?: 'Theater' }
                  & UserAffinityFragment_Theater_Fragment
                ) | (
                  { __typename?: 'TheaterScreen' }
                  & UserAffinityFragment_TheaterScreen_Fragment
                ) | (
                  { __typename?: 'User' }
                  & UserAffinityFragment_User_Fragment
                ) | (
                  { __typename?: 'UserCollection' }
                  & UserAffinityFragment_UserCollection_Fragment
                ) | (
                  { __typename?: 'UserReview' }
                  & UserAffinityFragment_UserReview_Fragment
                ) | (
                  { __typename?: 'Video' }
                  & UserAffinityFragment_Video_Fragment
                ) | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, entity?: (
                  { __typename?: 'Author' }
                  & UserAffinityFragment_Author_Fragment
                ) | (
                  { __typename?: 'Carousel' }
                  & UserAffinityFragment_Carousel_Fragment
                ) | (
                  { __typename?: 'Company' }
                  & UserAffinityFragment_Company_Fragment
                ) | (
                  { __typename?: 'EditorialReview' }
                  & UserAffinityFragment_EditorialReview_Fragment
                ) | (
                  { __typename?: 'EntityClub' }
                  & UserAffinityFragment_EntityClub_Fragment
                ) | (
                  { __typename?: 'Episode' }
                  & UserAffinityFragment_Episode_Fragment
                ) | (
                  { __typename?: 'Festival' }
                  & UserAffinityFragment_Festival_Fragment
                ) | (
                  { __typename?: 'FestivalEdition' }
                  & UserAffinityFragment_FestivalEdition_Fragment
                ) | (
                  { __typename?: 'InternalImage' }
                  & UserAffinityFragment_InternalImage_Fragment
                ) | (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & UserAffinityFragment_Movie_Fragment
                ) | (
                  { __typename?: 'MovieRelease' }
                  & UserAffinityFragment_MovieRelease_Fragment
                ) | (
                  { __typename?: 'News' }
                  & UserAffinityFragment_News_Fragment
                ) | (
                  { __typename?: 'Person' }
                  & UserAffinityFragment_Person_Fragment
                ) | (
                  { __typename?: 'PressReview' }
                  & UserAffinityFragment_PressReview_Fragment
                ) | (
                  { __typename?: 'Product' }
                  & UserAffinityFragment_Product_Fragment
                ) | (
                  { __typename?: 'Program' }
                  & UserAffinityFragment_Program_Fragment
                ) | (
                  { __typename?: 'ProgramEpisode' }
                  & UserAffinityFragment_ProgramEpisode_Fragment
                ) | (
                  { __typename?: 'ProgramSeason' }
                  & UserAffinityFragment_ProgramSeason_Fragment
                ) | (
                  { __typename?: 'Season' }
                  & UserAffinityFragment_Season_Fragment
                ) | (
                  { __typename?: 'SeasonRelease' }
                  & UserAffinityFragment_SeasonRelease_Fragment
                ) | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesReleasesFragmentFragment
                  & UserAffinityFragment_Series_Fragment
                ) | (
                  { __typename?: 'SeriesRelease' }
                  & UserAffinityFragment_SeriesRelease_Fragment
                ) | (
                  { __typename?: 'Showtime' }
                  & UserAffinityFragment_Showtime_Fragment
                ) | (
                  { __typename?: 'ShowtimeWithParentsId' }
                  & UserAffinityFragment_ShowtimeWithParentsId_Fragment
                ) | (
                  { __typename?: 'SocialMediaCategory' }
                  & UserAffinityFragment_SocialMediaCategory_Fragment
                ) | (
                  { __typename?: 'Tag' }
                  & UserAffinityFragment_Tag_Fragment
                ) | (
                  { __typename?: 'Theater' }
                  & UserAffinityFragment_Theater_Fragment
                ) | (
                  { __typename?: 'TheaterScreen' }
                  & UserAffinityFragment_TheaterScreen_Fragment
                ) | (
                  { __typename?: 'User' }
                  & UserAffinityFragment_User_Fragment
                ) | (
                  { __typename?: 'UserCollection' }
                  & UserAffinityFragment_UserCollection_Fragment
                ) | (
                  { __typename?: 'UserReview' }
                  & UserAffinityFragment_UserReview_Fragment
                ) | (
                  { __typename?: 'Video' }
                  & UserAffinityFragment_Video_Fragment
                ) | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, entity?: (
                  { __typename?: 'Author' }
                  & UserAffinityFragment_Author_Fragment
                ) | (
                  { __typename?: 'Carousel' }
                  & UserAffinityFragment_Carousel_Fragment
                ) | (
                  { __typename?: 'Company' }
                  & UserAffinityFragment_Company_Fragment
                ) | (
                  { __typename?: 'EditorialReview' }
                  & UserAffinityFragment_EditorialReview_Fragment
                ) | (
                  { __typename?: 'EntityClub' }
                  & UserAffinityFragment_EntityClub_Fragment
                ) | (
                  { __typename?: 'Episode' }
                  & UserAffinityFragment_Episode_Fragment
                ) | (
                  { __typename?: 'Festival' }
                  & UserAffinityFragment_Festival_Fragment
                ) | (
                  { __typename?: 'FestivalEdition' }
                  & UserAffinityFragment_FestivalEdition_Fragment
                ) | (
                  { __typename?: 'InternalImage' }
                  & UserAffinityFragment_InternalImage_Fragment
                ) | (
                  { __typename?: 'Movie' }
                  & MovieFragmentFragment
                  & MovieReleasesFragmentFragment
                  & UserAffinityFragment_Movie_Fragment
                ) | (
                  { __typename?: 'MovieRelease' }
                  & UserAffinityFragment_MovieRelease_Fragment
                ) | (
                  { __typename?: 'News' }
                  & UserAffinityFragment_News_Fragment
                ) | (
                  { __typename?: 'Person' }
                  & UserAffinityFragment_Person_Fragment
                ) | (
                  { __typename?: 'PressReview' }
                  & UserAffinityFragment_PressReview_Fragment
                ) | (
                  { __typename?: 'Product' }
                  & UserAffinityFragment_Product_Fragment
                ) | (
                  { __typename?: 'Program' }
                  & UserAffinityFragment_Program_Fragment
                ) | (
                  { __typename?: 'ProgramEpisode' }
                  & UserAffinityFragment_ProgramEpisode_Fragment
                ) | (
                  { __typename?: 'ProgramSeason' }
                  & UserAffinityFragment_ProgramSeason_Fragment
                ) | (
                  { __typename?: 'Season' }
                  & UserAffinityFragment_Season_Fragment
                ) | (
                  { __typename?: 'SeasonRelease' }
                  & UserAffinityFragment_SeasonRelease_Fragment
                ) | (
                  { __typename?: 'Series' }
                  & SeriesFragmentFragment
                  & SeriesReleasesFragmentFragment
                  & UserAffinityFragment_Series_Fragment
                ) | (
                  { __typename?: 'SeriesRelease' }
                  & UserAffinityFragment_SeriesRelease_Fragment
                ) | (
                  { __typename?: 'Showtime' }
                  & UserAffinityFragment_Showtime_Fragment
                ) | (
                  { __typename?: 'ShowtimeWithParentsId' }
                  & UserAffinityFragment_ShowtimeWithParentsId_Fragment
                ) | (
                  { __typename?: 'SocialMediaCategory' }
                  & UserAffinityFragment_SocialMediaCategory_Fragment
                ) | (
                  { __typename?: 'Tag' }
                  & UserAffinityFragment_Tag_Fragment
                ) | (
                  { __typename?: 'Theater' }
                  & UserAffinityFragment_Theater_Fragment
                ) | (
                  { __typename?: 'TheaterScreen' }
                  & UserAffinityFragment_TheaterScreen_Fragment
                ) | (
                  { __typename?: 'User' }
                  & UserAffinityFragment_User_Fragment
                ) | (
                  { __typename?: 'UserCollection' }
                  & UserAffinityFragment_UserCollection_Fragment
                ) | (
                  { __typename?: 'UserReview' }
                  & UserAffinityFragment_UserReview_Fragment
                ) | (
                  { __typename?: 'Video' }
                  & UserAffinityFragment_Video_Fragment
                ) | null, opinion?: (
                  { __typename?: 'Opinion' }
                  & OpinionFragmentFragment
                ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | null } | null> | null } | null } | null } | null } | null } | null };

export type GetEntityOpinionQueryVariables = Exact<{
  entityId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetEntityOpinionQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', social?: { __typename?: 'UserSocialInformation', entities?: { __typename?: 'UserEntityConnection', edges?: Array<{ __typename?: 'UserEntityEdge', node?: { __typename?: 'UserEntityLeaf', opinion?: (
                { __typename?: 'Opinion' }
                & OpinionFragmentFragment
              ) | null } | null } | null> | null } | null } | null } | null } | null };

export type CollectionFragmentFragment = { __typename?: 'UserCollection', id: string, internalId?: number | null, name?: string | null, description?: string | null, seriesCount?: number | null, moviesCount?: number | null, followersCount: number, owner?: { __typename?: 'User', id: string, legacyId?: string | null } | null };


export type CollectionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type CollectionCoverFragmentFragment = { __typename?: 'UserCollection', id: string, internalId?: number | null, name?: string | null, description?: string | null, seriesCount?: number | null, moviesCount?: number | null, followersCount: number, owner?: { __typename?: 'User', id: string, legacyId?: string | null, nickname?: string | null } | null, entities?: { __typename?: 'UserEntityConnection', edges?: Array<{ __typename?: 'UserEntityEdge', node?: { __typename?: 'UserEntityLeaf', entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', id: string, poster?: { __typename?: 'InternalImage', path?: string | null } | null, releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null, upcoming?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null } | null } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', id: string, poster?: { __typename?: 'InternalImage', path?: string | null } | null, releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null, upcoming?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null } | null } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | null } | null> | null } | null };


export type CollectionCoverFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type EntityFragmentFragment = { __typename?: 'UserEntityLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string, content?: { __typename?: 'OpinionReview', rating?: number | null } | null } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
    { __typename?: 'Movie' }
    & MovieFragmentFragment
    & MovieReleasesFragmentFragment
  ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
    { __typename?: 'Series' }
    & SeriesFragmentFragment
    & SeriesReleasesFragmentFragment
  ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null };


export type EntityFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserMovieLeafFragmentFragment = { __typename?: 'UserMovieLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string, content?: { __typename?: 'OpinionReview', rating?: number | null } | null } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
    { __typename?: 'Movie' }
    & MovieFragmentFragment
    & MovieReleasesFragmentFragment
  ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null };


export type UserMovieLeafFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserSeriesLeafFragmentFragment = { __typename?: 'UserSeriesLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string, content?: { __typename?: 'OpinionReview', rating?: number | null } | null } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
    { __typename?: 'Series' }
    & SeriesFragmentFragment
  ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null };


export type UserSeriesLeafFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type EpisodeFragmentFragment = { __typename?: 'Episode', internalId?: number | null, title?: string | null };


export type EpisodeFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type MovieFragmentFragment = { __typename?: 'Movie', id: string, internalId?: number | null, title?: string | null, poster?: { __typename?: 'InternalImage', path?: string | null } | null, releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null, upcoming?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null } | null, data?: { __typename?: 'MovieData', productionYear?: number | null, rules?: { __typename?: 'MovieRules', rating?: { __typename?: 'MovieRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null };


export type MovieFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type MovieReleasesFragmentFragment = { __typename?: 'Movie', releases?: Array<{ __typename?: 'MovieRelease', releaseDate?: { __typename?: 'PartialDate', date?: string | null, precision?: string | null } | null, releaseTags?: { __typename?: 'ReleaseTag', tagTypes?: Array<ReleaseTagType> | null } | null } | null> | null };


export type MovieReleasesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type MovieDirectionFragmentFragment = { __typename?: 'Movie', credits?: { __typename?: 'creditsConnection', edges?: Array<{ __typename?: 'creditsEdge', node?: { __typename?: 'CreditsMember', person?: (
          { __typename?: 'Person' }
          & PersonFragmentFragment
        ) | null } | null } | null> | null } | null };


export type MovieDirectionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ActionMovieFragmentFragment = (
  { __typename?: 'Movie', synopsis?: string | null, stats?: { __typename?: 'MovieStats', userRating?: { __typename?: 'UserRatingsStats', score?: number | null } | null } | null }
  & MovieFragmentFragment
  & MovieReleasesFragmentFragment
);


export type ActionMovieFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type OpinionFragmentFragment = { __typename?: 'Opinion', id: string, internalId?: number | null, content?: { __typename?: 'OpinionReview', rating?: number | null, certificationRating?: CertificationRatingStatus | null } | null, relatedEntity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null };


export type OpinionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type PersonFragmentFragment = { __typename?: 'Person', id: string, lastName?: string | null, firstName?: string | null };


export type PersonFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ProgressionFragmentFragment = { __typename?: 'UserSeriesProgression', globalPercent?: number | null, remainingEpisodes?: number | null, seasons?: Array<{ __typename?: 'UserSeasonsProgression', season?: { __typename?: 'Season', id: string } | null } | null> | null };


export type ProgressionFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ReviewFragmentFragment = { __typename?: 'Opinion', id: string, internalId?: number | null, content?: { __typename?: 'OpinionReview', rating?: number | null, updatedAt?: any | null, status?: ReviewStatus | null, review?: string | null, helpfulCount?: number | null, unhelpfulCount?: number | null, certificationRating?: CertificationRatingStatus | null } | null };


export type ReviewFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ActionReviewFragmentFragment = { __typename?: 'UserReview', author?: { __typename?: 'User', legacyId?: string | null, nickname?: string | null } | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
    { __typename?: 'Movie' }
    & ActionMovieFragmentFragment
  ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
    { __typename?: 'Season' }
    & SeasonFragmentFragment
    & SeasonReleaseFragmentFragment
  ) | { __typename?: 'SeasonRelease' } | (
    { __typename?: 'Series' }
    & ActionSeriesFragmentFragment
  ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null };


export type ActionReviewFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeasonFragmentFragment = { __typename?: 'Season', id: string, internalId?: number | null, number?: number | null, poster?: { __typename?: 'InternalImage', path?: string | null } | null, series?: (
    { __typename?: 'Series' }
    & SeriesFragmentFragment
  ) | null };


export type SeasonFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeasonReleaseFragmentFragment = { __typename?: 'Season', startsAtPartial?: { __typename?: 'PartialDate', date?: string | null, precision?: string | null } | null };


export type SeasonReleaseFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ActionSeasonFragmentFragment = { __typename?: 'Season', internalId?: number | null, number?: number | null, startsAtPartial?: { __typename?: 'PartialDate', date?: string | null, precision?: string | null } | null, series?: (
    { __typename?: 'Series' }
    & ActionSeriesFragmentFragment
  ) | null };


export type ActionSeasonFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeriesFragmentFragment = { __typename?: 'Series', id: string, internalId?: number | null, title?: string | null, status?: Status | null, poster?: { __typename?: 'InternalImage', path?: string | null } | null, releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null, upcoming?: { __typename?: 'ReleaseBaseFlags', svod?: { __typename?: 'ReleaseSvodFlags', original?: string | null, exclusive?: string | null } | null } | null } | null, data?: { __typename?: 'SeriesData', rules?: { __typename?: 'EntityRules', rating?: { __typename?: 'EntityRatingRules', has_mandatory_review?: boolean | null } | null } | null } | null };


export type SeriesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeriesReleasesFragmentFragment = { __typename?: 'Series', releases?: Array<{ __typename?: 'SeriesRelease', releaseDate?: { __typename?: 'PartialDate', date?: string | null, precision?: string | null } | null, releaseTags?: { __typename?: 'ReleaseTag', tagTypes?: Array<ReleaseTagType> | null } | null } | null> | null };


export type SeriesReleasesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeriesCompanyReleasesFragmentFragment = { __typename?: 'Series', releases?: Array<{ __typename?: 'SeriesRelease', releaseDate?: { __typename?: 'PartialDate', date?: string | null, precision?: string | null } | null, releaseTags?: { __typename?: 'ReleaseTag', tagTypes?: Array<ReleaseTagType> | null } | null, companies: Array<{ __typename?: 'EntityCompany', company?: { __typename?: 'Company', name?: string | null } | null }> } | null> | null };


export type SeriesCompanyReleasesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SeriesDirectorFragmentFragment = { __typename?: 'Series', credits?: { __typename?: 'creditsConnection', edges?: Array<{ __typename?: 'creditsEdge', node?: { __typename?: 'CreditsMember', person?: (
          { __typename?: 'Person' }
          & PersonFragmentFragment
        ) | null } | null } | null> | null } | null };


export type SeriesDirectorFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type ActionSeriesFragmentFragment = (
  { __typename?: 'Series', synopsis?: string | null, stats?: { __typename?: 'SeriesStats', userRating?: { __typename?: 'UserRatingsStats', score?: number | null } | null } | null }
  & SeriesFragmentFragment
  & SeriesReleasesFragmentFragment
);


export type ActionSeriesFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type SocialUserFragmentFragment = { __typename?: 'User', id: string, legacyId?: string | null, nickname?: string | null, customization?: { __typename?: 'UserCustomization', mainAvatar?: { __typename?: 'UserCustomizationImage', path?: string | null } | null } | null, stats?: { __typename?: 'UserStats', total_reviews: number, total_subscribers: number, total_ratings: number } | null };


export type SocialUserFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type TheaterFragmentFragment = { __typename: 'Theater', id: string, internalId?: string | null, name?: string | null, theaterCircuits?: { __typename?: 'Company', poster?: { __typename?: 'InternalImage', path?: string | null } | null } | null, poster?: { __typename: 'InternalImage', path?: string | null } | null, location?: { __typename: 'Location', city?: string | null, zip?: string | null, address?: string | null } | null };


export type TheaterFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UserAffinityFragment_Author_Fragment = { __typename?: 'Author' };

export type UserAffinityFragment_Carousel_Fragment = { __typename?: 'Carousel' };

export type UserAffinityFragment_Company_Fragment = { __typename?: 'Company' };

export type UserAffinityFragment_EditorialReview_Fragment = { __typename?: 'EditorialReview' };

export type UserAffinityFragment_EntityClub_Fragment = { __typename?: 'EntityClub' };

export type UserAffinityFragment_Episode_Fragment = { __typename?: 'Episode' };

export type UserAffinityFragment_Festival_Fragment = { __typename?: 'Festival' };

export type UserAffinityFragment_FestivalEdition_Fragment = { __typename?: 'FestivalEdition' };

export type UserAffinityFragment_InternalImage_Fragment = { __typename?: 'InternalImage' };

export type UserAffinityFragment_Movie_Fragment = { __typename?: 'Movie', userAffinity?: { __typename?: 'MovieUserAffinity', reason?: Array<UserAffinityScoreReason> | null, affinityScore?: number | null } | null };

export type UserAffinityFragment_MovieRelease_Fragment = { __typename?: 'MovieRelease' };

export type UserAffinityFragment_News_Fragment = { __typename?: 'News' };

export type UserAffinityFragment_Person_Fragment = { __typename?: 'Person' };

export type UserAffinityFragment_PressReview_Fragment = { __typename?: 'PressReview' };

export type UserAffinityFragment_Product_Fragment = { __typename?: 'Product' };

export type UserAffinityFragment_Program_Fragment = { __typename?: 'Program' };

export type UserAffinityFragment_ProgramEpisode_Fragment = { __typename?: 'ProgramEpisode' };

export type UserAffinityFragment_ProgramSeason_Fragment = { __typename?: 'ProgramSeason' };

export type UserAffinityFragment_Season_Fragment = { __typename?: 'Season' };

export type UserAffinityFragment_SeasonRelease_Fragment = { __typename?: 'SeasonRelease' };

export type UserAffinityFragment_Series_Fragment = { __typename?: 'Series', userAffinity?: { __typename?: 'SeriesUserAffinity', reason?: Array<UserAffinityScoreReason> | null, affinityScore?: number | null } | null };

export type UserAffinityFragment_SeriesRelease_Fragment = { __typename?: 'SeriesRelease' };

export type UserAffinityFragment_Showtime_Fragment = { __typename?: 'Showtime' };

export type UserAffinityFragment_ShowtimeWithParentsId_Fragment = { __typename?: 'ShowtimeWithParentsId' };

export type UserAffinityFragment_SocialMediaCategory_Fragment = { __typename?: 'SocialMediaCategory' };

export type UserAffinityFragment_Tag_Fragment = { __typename?: 'Tag' };

export type UserAffinityFragment_Theater_Fragment = { __typename?: 'Theater' };

export type UserAffinityFragment_TheaterScreen_Fragment = { __typename?: 'TheaterScreen' };

export type UserAffinityFragment_User_Fragment = { __typename?: 'User' };

export type UserAffinityFragment_UserCollection_Fragment = { __typename?: 'UserCollection' };

export type UserAffinityFragment_UserReview_Fragment = { __typename?: 'UserReview' };

export type UserAffinityFragment_Video_Fragment = { __typename?: 'Video' };

export type UserAffinityFragmentFragment = UserAffinityFragment_Author_Fragment | UserAffinityFragment_Carousel_Fragment | UserAffinityFragment_Company_Fragment | UserAffinityFragment_EditorialReview_Fragment | UserAffinityFragment_EntityClub_Fragment | UserAffinityFragment_Episode_Fragment | UserAffinityFragment_Festival_Fragment | UserAffinityFragment_FestivalEdition_Fragment | UserAffinityFragment_InternalImage_Fragment | UserAffinityFragment_Movie_Fragment | UserAffinityFragment_MovieRelease_Fragment | UserAffinityFragment_News_Fragment | UserAffinityFragment_Person_Fragment | UserAffinityFragment_PressReview_Fragment | UserAffinityFragment_Product_Fragment | UserAffinityFragment_Program_Fragment | UserAffinityFragment_ProgramEpisode_Fragment | UserAffinityFragment_ProgramSeason_Fragment | UserAffinityFragment_Season_Fragment | UserAffinityFragment_SeasonRelease_Fragment | UserAffinityFragment_Series_Fragment | UserAffinityFragment_SeriesRelease_Fragment | UserAffinityFragment_Showtime_Fragment | UserAffinityFragment_ShowtimeWithParentsId_Fragment | UserAffinityFragment_SocialMediaCategory_Fragment | UserAffinityFragment_Tag_Fragment | UserAffinityFragment_Theater_Fragment | UserAffinityFragment_TheaterScreen_Fragment | UserAffinityFragment_User_Fragment | UserAffinityFragment_UserCollection_Fragment | UserAffinityFragment_UserReview_Fragment | UserAffinityFragment_Video_Fragment;


export type UserAffinityFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type AddUserTheaterMutationVariables = Exact<{
  theaterId: Scalars['String']['input'];
}>;


export type AddUserTheaterMutation = { __typename?: 'Mutation', addUserTheater?: (
    { __typename?: 'Theater' }
    & TheaterFragmentFragment
  ) | null };

export type AddNotificationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  type: NotificationType;
}>;


export type AddNotificationMutation = { __typename?: 'Mutation', addNotification?: { __typename: 'Notification', id: number, title: string, type?: NotificationType | null } | null };

export type RemoveANotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveANotificationMutation = { __typename?: 'Mutation', removeNotification?: { __typename: 'Notification', id: number } | null };

export type RemoveUserTheaterMutationVariables = Exact<{
  theaterId: Scalars['String']['input'];
}>;


export type RemoveUserTheaterMutation = { __typename?: 'Mutation', deleteUserTheater?: { __typename?: 'Theater', id: string, internalId?: string | null, name?: string | null } | null };

export type UnfollowCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
}>;


export type UnfollowCollectionMutation = { __typename?: 'Mutation', unfollowUserCollection?: { __typename?: 'UserCollection', id: string } | null };

export type AddEntitiesToCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  entityIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  entitiesNumber?: InputMaybe<Scalars['Int']['input']>;
  brandCountry: CountryCode;
}>;


export type AddEntitiesToCollectionMutation = { __typename?: 'Mutation', addUserCollectionEntities?: (
    { __typename?: 'UserCollection', entitiesWithInterface?: { __typename?: 'UserEntityInterfaceConnection', edges?: Array<{ __typename?: 'UserEntityInterfaceEdge', node?: { __typename?: 'UserEntityLeaf' } | (
          { __typename?: 'UserMovieLeaf' }
          & UserMovieLeafFragmentFragment
        ) | (
          { __typename?: 'UserSeriesLeaf' }
          & UserSeriesLeafFragmentFragment
        ) | null } | null> | null } | null }
    & CollectionFragmentFragment
  ) | null };

export type AddNotInterestedMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddNotInterestedMutation = { __typename?: 'Mutation', addUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, notInterested?: { __typename?: 'NotInterested', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, notInterested?: { __typename?: 'NotInterested', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, notInterested?: { __typename?: 'NotInterested', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | null }> };

export type AddPersonalCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id_entities?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AddPersonalCollectionMutation = { __typename?: 'Mutation', addUserCollection?: (
    { __typename?: 'UserCollection' }
    & CollectionCoverFragmentFragment
  ) | null };

export type AddSeenItMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddSeenItMutation = { __typename?: 'Mutation', addUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null }> };

export type AddWantToSeeMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  brandCountry: CountryCode;
}>;


export type AddWantToSeeMutation = { __typename?: 'Mutation', addUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie', releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', vod?: boolean | null } | null } | null }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
        & UserAffinityFragment_Movie_Fragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie', releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', vod?: boolean | null } | null } | null }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
        & UserAffinityFragment_Movie_Fragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie', releaseFlags?: { __typename?: 'ReleaseFlags', release?: { __typename?: 'ReleaseBaseFlags', vod?: boolean | null } | null } | null }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
        & UserAffinityFragment_Movie_Fragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null }> };

export type DeleteOpinionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOpinionMutation = { __typename?: 'Mutation', deleteUserOpinion: { __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, opinion?: { __typename?: 'Opinion', id: string } | null } | null } };

export type FollowSeriesMutationVariables = Exact<{
  seriesId: Scalars['String']['input'];
  brandCountry: CountryCode;
}>;


export type FollowSeriesMutation = { __typename?: 'Mutation', addUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, progression?: (
        { __typename?: 'UserSeriesProgression' }
        & ProgressionFragmentFragment
      ) | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
        & SeriesCompanyReleasesFragmentFragment
        & UserAffinityFragment_Series_Fragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null }> };

export type FollowUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type FollowUserMutation = { __typename?: 'Mutation', addUserFollowUser: { __typename?: 'Follow', id: string, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | { __typename?: 'Series' } | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | (
      { __typename?: 'User' }
      & SocialUserFragmentFragment
    ) | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } };

export type RemoveEntitiesFromCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  entitiesIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveEntitiesFromCollectionMutation = { __typename?: 'Mutation', deleteUserCollectionEntities?: { __typename?: 'UserCollection', id: string } | null };

export type RemovePersonalCollectionMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
}>;


export type RemovePersonalCollectionMutation = { __typename?: 'Mutation', deleteUserCollection?: { __typename: 'UserCollection', id: string } | null };

export type DeleteSeenItMutationVariables = Exact<{
  entityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteSeenItMutation = { __typename?: 'Mutation', deleteUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, seenIt?: { __typename?: 'SeenIt', id: string } | null } | null }> };

export type RemoveWantToSeeMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type RemoveWantToSeeMutation = { __typename?: 'Mutation', deleteUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null, entity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', title?: string | null, internalId?: number | null, id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } | null }> };

export type UnfollowSeriesMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
}>;


export type UnfollowSeriesMutation = { __typename?: 'Mutation', deleteUserSocialAction: Array<{ __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, subscribe?: { __typename?: 'Subscribe', id: string } | null, entity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | { __typename?: 'Movie' } | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | { __typename?: 'Season' } | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series', status?: Status | null }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null } | null }> };

export type UnfollowUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type UnfollowUserMutation = { __typename?: 'Mutation', deleteUserFollowUser: { __typename?: 'Follow', id: string, relatedEntity?: { __typename?: 'Author', id: string } | { __typename?: 'Carousel', id: string } | { __typename?: 'Company', id: string } | { __typename?: 'EditorialReview', id: string } | { __typename?: 'EntityClub', id: string } | { __typename?: 'Episode', id: string } | { __typename?: 'Festival', id: string } | { __typename?: 'FestivalEdition', id: string } | { __typename?: 'InternalImage', id: string } | { __typename?: 'Movie', id: string } | { __typename?: 'MovieRelease', id: string } | { __typename?: 'News', id: string } | { __typename?: 'Person', id: string } | { __typename?: 'PressReview', id: string } | { __typename?: 'Product', id: string } | { __typename?: 'Program', id: string } | { __typename?: 'ProgramEpisode', id: string } | { __typename?: 'ProgramSeason', id: string } | { __typename?: 'Season', id: string } | { __typename?: 'SeasonRelease', id: string } | { __typename?: 'Series', id: string } | { __typename?: 'SeriesRelease', id: string } | { __typename?: 'Showtime', id: string } | { __typename?: 'ShowtimeWithParentsId', id: string } | { __typename?: 'SocialMediaCategory', id: string } | { __typename?: 'Tag', id: string } | { __typename?: 'Theater', id: string } | { __typename?: 'TheaterScreen', id: string } | { __typename?: 'User', id: string } | { __typename?: 'UserCollection', id: string } | { __typename?: 'UserReview', id: string } | { __typename?: 'Video', id: string } | null } };

export type MutationResponseFragmentFragment = { __typename?: 'MutationOutput', userEntityLeaf?: { __typename?: 'UserEntityLeaf', id?: string | null, opinion?: (
      { __typename?: 'Opinion', content?: { __typename?: 'OpinionReview', updatedAt?: any | null, status?: ReviewStatus | null, review?: string | null, helpfulCount?: number | null, unhelpfulCount?: number | null, certificationRating?: CertificationRatingStatus | null } | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
        & SeasonReleaseFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null }
      & OpinionFragmentFragment
    ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | { __typename?: 'UserMovieLeaf', id?: string | null, opinion?: (
      { __typename?: 'Opinion', content?: { __typename?: 'OpinionReview', updatedAt?: any | null, status?: ReviewStatus | null, review?: string | null, helpfulCount?: number | null, unhelpfulCount?: number | null, certificationRating?: CertificationRatingStatus | null } | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
        & SeasonReleaseFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null }
      & OpinionFragmentFragment
    ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | { __typename?: 'UserSeriesLeaf', id?: string | null, opinion?: (
      { __typename?: 'Opinion', content?: { __typename?: 'OpinionReview', updatedAt?: any | null, status?: ReviewStatus | null, review?: string | null, helpfulCount?: number | null, unhelpfulCount?: number | null, certificationRating?: CertificationRatingStatus | null } | null, relatedEntity?: { __typename?: 'Author' } | { __typename?: 'Carousel' } | { __typename?: 'Company' } | { __typename?: 'EditorialReview' } | { __typename?: 'EntityClub' } | { __typename?: 'Episode' } | { __typename?: 'Festival' } | { __typename?: 'FestivalEdition' } | { __typename?: 'InternalImage' } | (
        { __typename?: 'Movie' }
        & MovieFragmentFragment
        & MovieReleasesFragmentFragment
      ) | { __typename?: 'MovieRelease' } | { __typename?: 'News' } | { __typename?: 'Person' } | { __typename?: 'PressReview' } | { __typename?: 'Product' } | { __typename?: 'Program' } | { __typename?: 'ProgramEpisode' } | { __typename?: 'ProgramSeason' } | (
        { __typename?: 'Season' }
        & SeasonFragmentFragment
        & SeasonReleaseFragmentFragment
      ) | { __typename?: 'SeasonRelease' } | (
        { __typename?: 'Series' }
        & SeriesFragmentFragment
      ) | { __typename?: 'SeriesRelease' } | { __typename?: 'Showtime' } | { __typename?: 'ShowtimeWithParentsId' } | { __typename?: 'SocialMediaCategory' } | { __typename?: 'Tag' } | { __typename?: 'Theater' } | { __typename?: 'TheaterScreen' } | { __typename?: 'User' } | { __typename?: 'UserCollection' } | { __typename?: 'UserReview' } | { __typename?: 'Video' } | null }
      & OpinionFragmentFragment
    ) | null, wantToSee?: { __typename?: 'WantToSee', id: string } | null } | null };


export type MutationResponseFragmentFragmentVariables = Exact<{ [key: string]: never; }>;

export type UpdateOpinionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  isReview: Scalars['Boolean']['input'];
  brandCountry: CountryCode;
}>;


export type UpdateOpinionMutation = { __typename?: 'Mutation', updateUserOpinion: (
    { __typename?: 'MutationOutput' }
    & MutationResponseFragmentFragment
  ) };

export type AddOpinionMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
  review?: InputMaybe<Scalars['String']['input']>;
  isReview: Scalars['Boolean']['input'];
  brandCountry: CountryCode;
}>;


export type AddOpinionMutation = { __typename?: 'Mutation', addUserOpinion: (
    { __typename?: 'MutationOutput' }
    & MutationResponseFragmentFragment
  ) };

export type UpdatePersonalCollectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePersonalCollectionMutation = { __typename?: 'Mutation', updateUserCollection?: (
    { __typename?: 'UserCollection' }
    & CollectionCoverFragmentFragment
  ) | null };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', me?: { __typename?: 'Me', user?: { __typename?: 'User', id: string, internalId?: string | null, nickname?: string | null, email?: string | null, gender?: Gender | null, profile?: { __typename?: 'Profile', birthDate?: any | null } | null, customization?: { __typename?: 'UserCustomization', mainAvatar?: { __typename?: 'UserCustomizationImage', path?: string | null } | null, mainBanner?: { __typename?: 'UserCustomizationImage', path?: string | null } | null } | null } | null } | null };
